function Tlanslator(dictionary) {
  this.dictionary = dictionary;
}
var t0tRAnSLATEwItH =
  "tilik=jenguk:tilik=menjenguk:mbebedhag=memburu:mbedhag=memburu:bebedhag=berburu:beburu=berburu:munyermunyer=berputar-putar:mubengmubeng=berputar-putar:munyengmunyeng=berputar-putar:munyeng-munyeng=berputarputar:munyer=berputar:munyeng=berputar:mubeng=berputar:ngragati=mengongkosi:mbandhani=membiayai:ngragadi=mengongkosi:koprasi=koperasi:montore=motornya:montorku=motorku:montormu=motormu:timbali=panggili:ditimbali=dipanggil:kadose=sepertinya:mayar=ringan:nggenjot=menggowes:dibayangake=dibayangkan:nuding=menuding:ngowah=memodifikasi:sing duwe=pemilik:ukuran=berukuran:milihe=memilihnya:nggenjot=mengayuh:penyebabe=penyebabnya:sanuli=seketika:nuli=cepat:lulange=kulitnya :wonga=seorang pun:pangrekasane=penderitanya:pangrekasa=penderita:lulang=kulit :mubarang=sesuatu:napakasmani=menandatangani:awak =berperawakan:duwe tato=bertato:hasrat =berhasrat:kobong=terpanggang:digedhekake=dibesarkan:campur =bergaul:ngajari=mengedukasi:ngukir=mengukir:untung =beruntung:slamet =selamatlah:seumpamine=seandainya:sedalan=sejalan:nyingkirake=menghabisi:anggep=anggap:sengit =kebencian:diandhegake=diberhentikan:dientekake=dihabiskan:mungsuhi=memusuhi:pasulayan=perseteruan:sengitku=marahku:sengitmu=marahmu:ngglegek=menggelegak:mbendung=membendung:kebendung=terbendung:nggaya=berpenampilan:nalika=tatkala:nugel=mematahkan:apa maneh=jangankan:ketandhur=tertanam:nyetuske=mencetuskan:nyetuske=menyetuskan:ngrakit=merakit:diledakake=diledakkan:ngira-ira=memerhitungkan:makmurake=memakmurkan:angus=gosong:nahas=naas:kekancan=bersahabat:kaucap=terkatakan:mbah kakunge=kakeknya:mbah putrine=neneknya:campur=berbaur:kuciwane=kecewanya:marisi=mewariskan:ketipu=tertipu:pisah =berpisah:nyisipke=menyelipkan:mrene=kemari:gegeme=genggamannya:duwe tekad=bertekad:rudu=perdebatan:rudu=debat:madhangi=menerangi:nguripake=mengaktifkan:nginakake=menghinakan:duwe kersa=berkehendak:ditugelake=dipatahkan:kahanan=kondisi:mengkene=beginilah:nitik=menitik:katitik=tertitik:reda =mereda:katone=nampaknya:muliha=pulanglah:tansaha=senantiasalah:lawa=kelelawar:imbas =berimbas:sinambetan=bersambungan:mertal=menerjemahkan:pandhemi=pandemi:gegandhengan=berhubungan:panyature=penuturnya :penduduke=penduduknya:kunaning=kuna :mertahanke=memertahankan:bedhane=bedanya:bedha=beda:sadhurunge=sebelumnya:sesambetan=berkaitan:piwelinge=nasehatnya:weling=nasehat:umpetumpetan=sembunyi-sembunyi:umpet-umpetan=sembunyisembunyi:ngatur=mengelola:tapakasmanan=bertandatangan:slenggarakake=selenggarakan:rawuhe=kehadiran:dheweke=dialah:kapasitas=berkapasitas:saksuwene=selamanya:diilangi=dihilangkan:didayakake=didayagunakan:ndayakake=mendayagunakan:wongtuwa=orangtua:pener=tepat:nguwatirake=mengkhawatirkan:oyot=akar:panglantare=penghantarnya:panglantar=penghantar:ndudut=menarik :ditrepake=diterapkan:dhosene=dosennya:dhosen=dosen:lelandhesan=berdasarkan:kaleksana=terlaksana:kaleksanane=terlaksananya:lamun=bila:kabiji=ternilai:takonake=tanyakan:bakenne=bakunya :cawisake=menyajikan:cawis=tertata rapi:kekarepanmu=harapanmu:kekarepanku=harapanku:kekarepanmu=kemauanmu:kekarepanku=kemauanku:ben=biarlah:crewet=cerewet:dirugikake=dirugikan:enake=lezatnya:enak=lezat:kenaken=keenakan:mantu=menantu:areng=arang:arenge=arangnya:ngemut=mengemut:ngemut=emut:tombone=obatnya:tambane=obatnya:ngobrol=mengobrol:diluweh=dibiarkan:wedhang=minuman:srupatsruput=seruputi:srupat-sruput=seruputi:sesuksesuk=besok-besok:sesuk-sesuk=besokbesok:kleru=keliru:atawa=atau:nana=ada:linggane=dasarnya:panyengkuyunge=penyemangatnya:panyengkuyung=pendukung:alialine=cincinnya:ali-aline=cincinnya:aliali=cincin:ali-ali=cincin:marikake=memulihkan:aniayane=penganiayaannya:aniaya=penganiayaan:duwe dosa=berdosa:dituduhake=dituduhkan:manggang=memanggang:dicekaki=diperpendek:anggo=kenakan:mbalang=melontarkan:mbalang=melontar:mbalang=melempar:mbalang=melemparkan:panyatur=penutur:ndewakake=mendewakan:nggambarake=mengilustrasikan:tumpuk-tumpuk=bertumpuktumpuk:numpuke=menumpuknya:numpuk=menumpuk:tetumpukan=bertumpukan:mroses=memroses:tembangan =lagulagu:ngundhu=mengunduh:sedyakake=sediakan:nggawe ala=memerburuk:surat-suratan=suratmenyurat:dialingi=dihalangi:muji=memujikan:liwat=melintas:mbonceng=membonceng:digegerake=dihebohkan:mangan=menyantap:nyuwara=bersuara:dicekak=disimpulkan:diringkes=diringkas:ringkesan=ringkasan:cekakan=kesimpulan:cekakan=simpulan:medeni=menyeramkan:medeni=seram:selarik=sebaris:melu-melu=mengekor:ketulis=tercantum:mesthine=hendaknya:dilombakake=diperlombakan:nggambarake=menggambarkan:ngenteni=menantinantikan:ngenteni=menantinanti:nyenengi=menggembirakan:nyenengi=membahagiakan:digayuhake=dicitacitakan:digayuhake=dicita-citakan:seneng=berbahagia:duwe bojo=beristri:duwe bojo=beristrikan:seneng=gembira:seneng=kegembiraan:tegese=tegasnya:tegese=ketegasannya:tindakake=laksanakan:kebagusan=kebenaran:mateni=menewaskan:peser=pusar:baguse=tampannya:bagus=tampan:duwe pitulung=berjasa:dicritakake=dikisahkan:diwenehi=dikaruniai:kawinane=pernikahannya:critane=kisahnya:kuwi=tuh:terusan=lanjutan:terusane=kelanjutannya:terusan=kelanjutan:mesen=memesan:waniwani=berani-berani:wani-wani=beraniberani:waniwanine=berani-beraninya:wani-wanine=beraniberaninya:ayu =kecantikan:nglunturake=melunturkan:ayu-ayu=cantikcantik:ayuayu=cantik-cantik:ngguyoni=menertawakan:njerit=teriak:persiji=persatu:adaptasi =beradaptasi:sak kaya kuwi=sebegitunya:senajan=walaupun:kakunge=lelakinya:kipa-kipa=ogahogahan:kipakipa=ogah-ogahan:judheg=kehabisan akal:istilahe=istilahnya:kepetung=terhitung:kancamu=sahabatmu:kancaku=sahabatku:sadulurmu=saudaramu:sadulurku=saudaraku:kanca=sobat:kungkume=berendamnya:kungkum=berendam:ageage=segera:ngiringi aku=menyertaiku:ngiringi kowe=menyertaimu:ngiringine=menyertainya:ngiringi=menyertai:tansah=senantiasa:asringasringa=sering-seringlah:asring-asringa=seringseringlah:disurasakake=dimaksudkan:nggebug=memukul:ngulurake=mengulurkan:menehake=menyodorkan:ilere=airliurnya:ilere=air liurnya:iler=airliur:iler=air liur:monikake=membunyikan:didokoke=diletakkan:dokok=letakkan:ngucap=melafal:lah=donk:apa maneh=lagipula:tementemen=sungguh-sungguh:temen-temen=sungguhsungguh:duwe prestasi=berprestasi:melua=ikutilah:melua=ikutlah:nyenengine=menyukainya:klompok=berkelompok:akehakeha=banyak-banyaklah:akeh-akeha=banyakbanyaklah:disenengi=disuka:nundhane=menundanya:nundhanundha=menunda-nunda:nundha-nundha=menundanunda nundha=menunda:njiwit=mencubit:kinasih=tersayang:nrimaku=menerimaku:nrima aku=menerimaku:nrimamu=menerimamu:nrimane=menerimanya:rewanganmu=bantuanmu:rewanganku=bantuanku:anggepa=anggaplah:curang =kecurangan:dora=berbohong:apalke=hafalkan:tawakake=tawarkanlah:takonana=bertanyalah:mangkel=kekesalan:kengeselake=melelahkan:diutamakake=diprioritaskan:duweni=miliki:gayuhane=pencapaiannya:gayuhan=pencapaian:cocogake=sesuaikan:dibarengi=diiringi:rencana=perencanaan:menyang ndi-ndi=kemanamana:keserange=terserangnya:keserang=terserang:ngringkihi=memerlemah:meksa=memporsir:meksa=memorsir:wektune=waktunya:kerjane=kerjaannya:guyon=becanda:guyonan=becandaan:ngendhani=hindari:wengi-wengi=malemmalem:wengi-wengi=malammalam:wengiwengi=malam-malam:ramene=berisiknya:rame=berisik:perhatikake=perhatikan:mipile=bertahapnya:mipil=bertahap:bocah-bocah=kanakkanak:bocah=kanak:dioyak=dikejar:dioyak-oyak=dikejarkejar:dioyakoyak=dikejar-kejar:duwene=kepunyaannya:duwene=kepunyaan:katujokake=tertujukan:wulangan-wulangane=pelajaranpelajarannya:wulanganwulangane=pelajaran-pelajarannya:wulangan-wulangan=pelajaranpelajaran:wulanganwulangan=pelajaran-pelajaran:klas=kelas:ayahane=naungannya:ayahan=naungan:diayahi=dinaungi:ngayahi=menaungi:latare=latarnya:kanthong-kanthong=kantongkantong:kanthongkanthong=kantong-kantong:pasarean=peristirahatan:disarekake=diistirahatkan :umate=umatnya:ditetapke=ditetapkan:ditetepke=ditetapkan:laladan-laladan=daerahdaerah:laladanlaladan=daerah-daerah:netepke=menetapkan:dijumenengake=didirikan:kasultanan=kesultanan:numpes=menumpas:dawuh=titah:ndawuhake=menitahkan:mbalela=membangkang:rerusuh=kekacauan:peprentahan=berperintahan:gelare=gelarnya:mantune=menantunya:disebarke=disebarkan:kedheseg=terdesak:sacedhake=dekatnya:njenengi=menamai:punjering=akarnya :yasan-yasane=bangunanbangunannya:yasanyasane=bangunan-bangunannya:yasan-yasan=bangunanbangunan:yasanyasan=bangunan-bangunan:dipacakake=dipilah:karesidhenan=karesidenan:lemahe=tanahnya:sebabe=sebabnya:wanagiri=wonogiri:ngendiendi=mana-mana:pemandhangan=pemandangan:pawatesane=perbatasannya:pawatesan=perbatasan:sakiduling=sebelah selatannya:kedhu=kedu:sakidulwetane=sebelah tenggaranya:mangetan=ke timur:sawetawis=kira-kira:padesan=pedesaan:padesan=perdesaan:ngambah=merambah:jumenenging=berdirinya:ngresmekake=meresmikan:mbabad=membabat:mrintahake=memerintahkan:mrentahake=memerintahkan:katetepan=ketetapan:pembageyane=pembagiannya:pembageyan=pembagian:kakuwasane=kekuasaannya:prajanjene=perjanjiannya:prajanjen=perjanjian:madege=berdirinya:cerbon=cirebon:dhiskusidhiskusi=diskusi-diskusi:dhiskusi-dhiskusi=diskusidiskusi:nandurake=menanamkan:ngoyod=mengakar:kebek semangat=berapiapi:njembrengake=membentangkan:njembreng=membentang:ngangel-angeli=menyusahkan:terlalu=kelewat:senengan=sukaan:nyawijekake=memersatukan:sanadyan=bilapun:ngungkuli=mendominasi:ngreok=raup:direoke=diraupnya:direok=diraup:ngreoke=meraupnya:ngreok=meraup:dicompar-campur=dicampuraduk:dicompar-campurake=dicampuradukkan:jaka=jejaka:pamrentahan=pemerintahan:kawates=terbatas:pemerentahan=pemerintahan:pemerentah=pemerintah:glombang=gelombang:ngantem=menghantam:njeblug=meledak:lintune=gantinya :ningali=melihat:dipasangake=dipasangkan:sumugi=semoga:katur=terucap:pepadha=sesama:giyat=giat:sesrawungan=saling sapa:katuran=terhatur:brayat=khalayak:gladhen=pelatihan:nasiyonal=nasional:kabusek=terhapus:sauruting=seurutan :lelakon=perbuatan:internasiyonal=internasional:kaadol=terjual:dinuga=diduga :cinolong=tercuri :kacolong=tercuri:kacolonge=tercurinya:prunggu=perunggu:tinggalaning=peninggalan :iji=buah :colongjupuk=curi-ambil:musiyum=museum:duwe ijin=berlisensi:kahanane=keberadaannya:marisi=mewarisi:mbangune=membangunnya:ngganti=mengevaluasi:panuku=pembeli:diraketake=direkatkan:dipatenake=dipatenkan:ngetrepi=merangkai:mikir-mikir=memertimbangkan:ngilang=menghilang:ngijoli=menukarkan:menehi inspirasine=menginspirasinya:nggawe=memroduksi:diurubake=dinyalakan:nancep=menancap:diprodhuksi=diproduksi:digawe=diproduksi:sarining=sari :siasiakake=sia-siakan:sia-siakake=siasiakan:wong-wong=khalayak:esemake=menyunggingkan:rampungake=rampungkan:utamakake=utamakan:kerjakake=kerjakan:duwe awak=bertubuh:ethokethoke=pura-puranya:ethok-ethoke=purapuranya:ethokethok=pura-pura:ethok-ethok=purapura:nekakake=hadirkan:cedhak-cedhakan=berdekatan:kemah=berkemah:nyambungake=mengkoneksikan:nyambungake=mengoneksikan:praktekake=praktikkan:cekelcekelane=pegangannya:cekel-cekelane=pegangannya:cekelane=pegangannya:ragade=biayanya:ragad=biaya:ora-orane=tidaktidaknya:oraorane=tidak-tidaknya:saoraorane=setidaknya:saora-orane=setidaknya:sumpeg=sumpek:kokpegat=kauceraikan:takpegat=kuceraikan:dakpegat=kuceraikan:kokpegat=kaucerai:takpegat=kucerai:dakpegat=kucerai:pegat=cerai:diduweni=dipunyai:komentar =berkomentar:konsultasi =berkonsultasi:ngajokake =mengemukakan:kebayangbayang=terbayang-bayang:kebayang-bayang=terbayangbayang:kebayang=terbayang:digabungake=dikolaborasikan:rembug=mendiskusikan:internetan=berinternet:wenehane=penyampaiannya:wenehan=penyampaian:salahku =kesalahanku:salahmu =kesalahanmu:njaluko=mintalah:manthuk-manthuk=menganggukangguk:manthukmanthuk=mengangguk-angguk:manthuk=mengangguk:onthakanthuk=angguk-angguk:onthak-anthuk=anggukangguk:kangene=rindunya:kangeni=rindui:kangen=rindu:sapasapamu=siapa-siapamu:sapa-sapamu=siapasiapamu:sapasapaku=siapa-siapaku:sapa-sapaku=siapasiapaku:mateni=membantai:ngelege=menelannya:ngeleg=menelan:ketemu=bersua:ambyar=buyar:ambyare=buyarnya:apa iya=mungkinkah:macakake=membacakan:dumukdumukan=bersentuhan:dumuk-dumukan=bersentuhan:gegermu=punggungmu:gegerku=punggungku:taksendhekake=kusandarkan:daksendhekake=kusandarkan:disendhekake=disandarkan:nyendhekake=menyandarkan:sendhekake=sandarkan:manggungake=mementaskan:dipanggungake=dipanggungkan:rondha=meronda:pamitake=memamitkan:crita=berkisah:resula=keluh:sambate=keluhnya:sayah=kelelahan:mrangguli=menemui:kepengin=tergerak:enjing=pagi:paringane=pemberiannya:murakabi=berguna:mugia=semogalah:ngregengake=meramaikan:kawontenake=terlaksana:tuduhake=tunjukin:ramene=serunya:njajal=menjajal:ndelengi=melihati:ndelengi=lihatin:mandegake=berhentikan:mandegake=berhentiin:ngandegake=memberhentiin:ngandegake=memberhentikan:nyekolakake=menyekolahkan:siap-siap=bersiap:paling panas=terpanas:amarga=kerana:padu =pertengkaran:ribut =kericuhan:interaksi =berinteraksi:mrihatinake=memrihatinkan:nglingkupi=melingkupi:wutah=meluap:diakibatke=diakibatkan:tresna asih=percintaan:nikmati=menikmati:duwe lambang=berlambangkan:disenengine=disukainya:disenengi=disukai:ngambunge=menciumnya:nyia-nyiakake=menyianyiakan:ulem=pemanggilan:investasi =berinvestasi:sesorah =berpidato:ngajeng=depan:jro=dalam:kaserep=terserap:karipta=tercipta:njejegake=menegakkan:lodhang=luang:nyruwangi=menyoraki:dioprasekake=dioprasikan:dioperasekake=dioperasikan:belet=lumpur:blethok=lumpur:gumuke=bukitnya:pangilone=cerminnya:gumuk=bukit:pangilon=cermin:makam=pemakaman:kuwasane=kuasanya:kuwasane=berkuasanya:kuwasa=kuasa:kuwasa=berkuasa:tabah=ketabahan:sajerojerone:sedalam-dalamnya:sajero-jerone:sedalamdalamnya:sajero=sedalam:nyuling=menyuling:nyandhing=menyanding:ngendhang=mengendang:takwenehi=kuberi:dakwenehi=kuberi:kapinujon=kebetulan:nyemangati=menyemangati:isinisin=malu-malu:isin-isin=malumalu:ngliput=meliput:driji-drijine=jarijemarinya:driji-driji=jarijemari:driji-drijine=jarijarinya:drijidrijine=jari-jarinya:driji-driji=jarijari:drijidriji=jari-jari:drijine=jemarinya:driji=jemari:panganggone=pemakainya:talinan=bertali:oleh lah=bolehlah:uji =beruji:nganakake=menghelatnya:nganakake=menghelat:bandhingane=perbandingan:bandhingane=perbandingannya:paling murahe=termurahnya:paling murah=termurah:keliwat=terlampau:mriksa=mengecek:nampung=mengakomodasi:nampung=mengakomodir:panyerat=penulisan:panyerate=penulisannya:cepengan=pegangan:ageman=pakaian:agem=pakai:diagem=dipakai:tuwuk=kenyang:duwe kuwalitas=berkualitas:diadepine=dihadapinya:ngukur=mengukur:mung=cuman:piweling=nasehat:tengah-tengahe=tengahtengahnya:tengahtengahe=tengah-tengahnya:artane=uangnya:arta=uang:wiwiting=mulanya:tengga=tunggu:tenggani=tunggui:ngilone=bercerminnya:ngilone=berkacanya:ngilo=bercermin:ngilo=berkaca:teges=tegas:nindakake=mengimplementasikan:nyepeng=berpegang:nyekel=berpegang:tanggal=tertanggal:direncanakake=direncanakan:ditargeti=ditargetkan:nebak=memrediksi:pitulungane=pertolongannya:kasangsarane=kesengsaraannya:kasangsaran=kesengsaraan:mitulungine=menolongnya:klakone=terlaksananya:klakon=terlaksana:kaparingan=mendapatkan:marahmarah=muring-muring:marah-marah=muringmuring:njungkele=terjungkalnya:njungkel=terjungkal:mbacutake=melanjutkan:trima=terima:jumeneng=berdiam:nyirnakake=melenyapkan:nuju=menuju :nggebyur=mencebur:sasedhulur=bersaudara:putraning=putra :kepulisiane=kepolisiannya:kepulisian=kepolisian:ngususake=mengkhususkan:esuk-esuk=berpagipagi:ngumandangake=mengumandangkan:takbir =bertakbir:urune=kontribusinya:setujune=persetujuannya:mburune=memburunya:mburu=memburu:urune=berkontribusinya:urun=berkontribusi:jajala=cobalah:njajala=cobalah:kaparengake=terbolehkan:ditargetake=ditargetkan:ditargetke=ditargetkan:ngantongi=mengantongi:tiba=terjatuh:menehi krungu=memerdengarkan:ngowahe=meralatnya:ngowah=meralat:saya alon=melambat:dedora=bualan:njalari=memicu:nyabute=mencabutnya:nyabut=mencabut:kejeron=kedalaman:sartakake=sertakan:praktek=praktik:dituding=ditunjuk:kudu=diharuskan:nyepeti=mengakselerasi:ancang-ancang=berancangancang:ancangancang=berancang-ancang:nundhak=berjenjang:mbeset=menyayat:pados=cari:ngupadine=mencarinya:tambahi=tambahin:suwun=makasih:surasa=maksud:sababe=sababnya:jawine=jawanya:arasarasen=jemu:aras-arasen=jemu:memeng=ogah-ogahan:wangsul=kembali:dospundi=bagaimana:obah=peubahan:ngimbangi=mengimbangi:diduwenine=dimilikinya:njelasi=memerjelas:dirumuske=dirumuskan:nyaring=menyaring:paling anyar=terupdate:ngobahine=merevisinya:ngobah=merevisi:perkara=permasalahan:njawakake=menjawakan:nyimpang=menyimpang:nandure=menanamnya:moto=memotret:pira=brp:ngaku=mengeklaim";

const terjemahan = function (translate_options, kotakkalimat) {
  let hasilFungsiGan = "";
  if (
    translate_options == "jawakeindonesia" ||
    translate_options == "indonesiakejawa"
  ) {
    var passageToTranslate = " " + kotakkalimat + " ";
    var charsPerLine = kotakkalimat.cols;

    {
      var haboC = translate_options;
      if (haboC == "indonesiakejawa") {
        var key1 = 1;
        var key2 = 0;
      }
      if (haboC == "jawakeindonesia") {
        var key1 = 0;
        var key2 = 1;
      }
      var dictionaryAsText =
        "nututi=menuruti:ngoceh=mengoceh:cobi=coba :ngoten=gitu:nyedhaki=mendekati:nyedhak=mendekat:kunduran=terundur:trek=truk:dean=mungkin:ndean=mungkin:nglamare=meminangnya:nglamar=meminang:bukakake=bukakan:pas=bertepatan:temen=keseriusan:ongkang-ongkang=bersantaisantai:pandum=pemberian:ditingali=dilihat:" +
        t0tRAnSLATEwItH +
        ":menyang ngarepe=kedepannya:kudu=diharuskan:rahajeng=selamat:sedhela=sesaat:bobo=tidur:bobok=bobol:bledhug=dentum:bledug=anak gajah:ditiliki=ditilik:sadulur-sadulur=saudarasaudara:sadulursadulur=saudara-saudara:kelimpah=terlimpah:enem=belia:enom=belia:runtungan=beruntun:kakangkakange=kakak-kakaknya:kakang-kakange=kakakkakaknya:kancakanca=kawan-kawan:kanca-kanca=kawankawan:pinuju=menjelang:totoan=memertaruhkan:ngaboti=memberatkan:kaya kuwi=betapa:diwurungake=diurungkan:penthil=puting:marsudi=belajar:wening=bening:wening=jernih:kacek=selisih:nyandhang=menyandang:taunsaka=tahun saka:ninggal=meninggal:nyobi=mencoba:digantos=diganti:nglampahi=menjalani:sawatawis=antara:ngandap=bawah:ditepang=dikenal:kelebon=kerasukan:kelebon=kesurupan:kelebon=kemasukan:ditanggepi=ditanggapi:paling amba=terluas:nduwurke=meninggikan:kaya-kaya=seakanakan:kaya=seakan:warang=garang:rai=wajah:raiku=wajahku:raimu=wajahmu:surupe=senjanya:surup=senja:semengko=sekarang:samengko=sekarang:adohadoh=jauh-jauh:adoh-adoh=jauhjauh:digawene=dibuatnya:nyandhang=menyandang:merlakokake=memerlakukan:ngrewangine=membantunya:mrograme=memrogramnya:mrogram=memrogram:keangelan=kesukaran:keangelane=kesukarannya:ndhasarine=mendasarinya:engko=nanti:sepisana=sekalipun:paling ganas=terganas:keciptane=terciptanya:samberane=sambarannya:nyambere=menyambarnya:disambere=disambarnya:kepenuhine=terpenuhinya:samberan=sambaran:nyamber=menyambar:disamber=disambar:kepenuhi=terpenuhi:gumludhug=gemuruh:gludhug=guruh:gumludhug=menggelegar:nunjang=menunjang:anguse=hangusnya:angus=hangus:kapiran=tersiasia:kapiran=tersia-sia:ngrotasine=merotasinya:ngrotasi=merotasi:isukisuk=pagi-pagi:isuk-isuk=pagipagi:pacitane=kudapannya:duduhe=kuahnya:duduhan=berkuah:pacitan=kudapan:utange=hutangnya:utang=hutang:eman-eman=disayangkan:ngudukake=mengharuskan:konsentrasi=berkonsentrasi:nyartani=menyertakan:pegaweane=pekerjaanya:nglamar=melamar:nyontokake=mencontohkan:ngenengake=menenangkan:tekaa=tibalah:memperdalam=njeroni:kacithak=tercetak:diedumake=dibagikan:naskahe=naskahnya:kapenginan=keinginan:ajeneng=bernama:keciliken=terlalu kecil:kacipta=tercipta:celukan=panggilan:dioprasikake=dioperasikan:diadepake=dihadapkan:diadhepake=dihadapkan:nyuwun=memohon:sijiloro=satu-dua:siji-loro=satudua:alit-alit=kecilkecil:alitalit=kecil-kecil:lingsir=terlewat:dimartabatake=dimartabatkan:panuju=menuju:gumregahe=bangkitnya:njenggeleke=tersentaknya:njenggirate=tersentaknya:gumregah=bangkit:njenggelek=tersentak:njenggirat=tersentak:panutupe=penutupnya:jlentrehe=ulasnya:diparengake=dibolehkan:ujare=katanya:jagading=dunia:kawitane=berawalnya:kawitan=berawal:nyabet=menyabet:sajege=sejak:diajab=diharapkan:ngajab=berharap:dibadhe=ditebak:dibadhek=ditebak:badhek=tebak:badhek=terka:pawakan=perawakan:pawakane=perawakannya:luruse=lurusnya:kulite=kulitnya:nggumuni=mengesankan:keluwihen=berlebihan:lungsed=lusuh:dicekethem=digenggam:cekethem=genggam:nyekethem=menggenggam:digegem=digenggam:gegem=genggam:nggegem=menggenggam:dicenthelake=digantungkan:dicanthelake=digantungkan:dicenthel=dikait:dicanthel=dikait:diwarahi=diajari:nyunting=menyunting:dipriksa=diperiksa:keakses=terakses:dibageni=dibagikan:kegabung=terintegrasi:keakses:terakses:melas=bersimpati:koar=berkoar:jajakake=jajakan:ina=hina:anggere=asalkan:paksakake=paksakan:dibacutake=dilanjutkan:bacutake=lanjutkan:banjurake=lanjutkan:gepok=paut:tukar padu=berselisih:padudon=perselisihan:sinaosa=meskipun:kendel=diam:bokbilih=barangkali:miyarsa=mendapati:ngolehi=mendapati:daktulis=kutulis:koktulis=kautulis:karepane=inginnya:karepe=inginnya:nyeleksi=menyeleksi:munggahake=menaikkan:sewetara=sementara:pepalang=rintangan:impen-impen=impianimpian:impenimpen=impian-impian:nambal=menambal:temboke=temboknya:nyilihi=meminjamkan:nyilihi=meminjami:nyilih=meminjam:katindakake=terlaksanakan:mbangkitake=membangkitkan:nggolekake=mencarikan:ngolihake=mendapatkan:sakubenge=sekelilingnya:sakubeng=sekeliling:ndongeng=mendongeng:nyempatake=menyempatkan:ngaji=mengaji:nyisihake=menyisihkan:secuil=sedikit:ngorbanake=mengorbankan:ndhelok=menonton:marnanine=mewarnainya:marnani=mewarnai:sepanggone=setempatnya:sepanggon=setempat:ngadhekake=mendirikan:dhewek=sendiri:kanthonge=kantongnya:diceblokake=ditancapkan:wiwite=awalnya:manggahi=mengukuhkan:panggahi=kukuhkan:ngajar=mengajar:katrima=diterima:durunge=belumnya:awale=awalnya:garwa=pasangan :ngadhekake=menahkodai:ngadhehake=menahkodai:sukalila=sukarela:mein=memberi:iringan=samping:kiye=ini:sekitare=sekitarnya:ndeke=punya:disediakake=disediakan:ngresmikake=meresmikan:kepencute=terpikatnya:kepencut=terpikat:nulung=menolong:kangelan=kesusahan:ngapusi=berdusta:kamemperane=kemiripannya:kamemperan=kemiripan:balii=bali :sing nduwe=pemiliknya:nyengitine=membencinya:laline=nyenyaknya:nyapu=menyapu:turon=terbaring:turon=tiduran:gegodhongan=dedaunan:karepe=terserah:artikake=artikan:liane=lainnya:ari=kalau:disedyakake=disediakan:beda=berlainan:mambune=baunya:jenazahe=jenazahnya:mayite=jenazahnya:mayit=jenazah:dimarekake=disembuhkan:sakite=sakitnya:entengentengan=habis-habisan:entekentekan=habis-habisan:entek-entekan=habishabisan:kakangadhi=kakak-adik:kakang-adhi=kakakadik:dijanjikake=dijanjikan:ngutus=mengutus:nglewati=melewati:boyongan=pindahan:rampoke=rampoknya:nyingkir=menyingkir:ngadepi=menghadapi:dikuasani=dikuasai:tlatah-tlatah=wilayahwilayah:tlatahtlatah=wilayah-wilayah:kesumate=kesumatnya:dimakamake=dimakamkan:keningapa=kenapa:kenengapa=kenapa:geneya=kenapa:pesthekake=pastikan:mupakatan=bermusyawarah:rembagan=bermusyawarah:rembugan=bermusyawarah:rembag=bermusyawarah:rembug=bermusyawarah:ndawuhi=memerintahkan:mrentah=memerintahkan:ngereh=memerintahkan:adhem=dingin:atis=dingin:gedheggedheg=geleng-geleng:dililakake=diikhlaskan :diluputake=disalahkan:bandhane=hartanya:bandha=harta:niyate=niatnya:ngancam=mengancam:ngrampok=merampok:sandhal=sandal:sepira=berapa:semonoa=sebegitu pun:patiya=terlalu :cawe-cawe=bantubantu:cawecawe=bantu-bantu:colong=curi:gendheng=sinting:mangkele=sebalnya:disangoni=diberi uang saku:ditambakake=diobati:ditambani=diobati:dingapura=dimaafkan:diapura=dimaafkan:sidane=jadinya:dikendelake=didiamkan:pandelengane=penglihatannya:pandelengan=penglihatan:benten-benten=lainlain:bentenbenten=lain-lain:diantemi=dipukuli:kajenge=hendaknya :pating=pada :karu-karuwan=karukaruan:karukaruwan=karu-karuan:penyonyo=lebamlebam:penyonyo=lebam-lebam:pakra=bagus:meruhi=memerlihatkan:dibanda=diborgol(diikat):banda=borgol(ikat):teng=ke|di:nika=itu:mendhet=mengambil:ngindhakindhik:indhakindhik=mengincar:ngincer=mengincar:emperane=terasnya:emper=teras:empere=terasnya:cendhela=jendela:jendhela=jendela:inceng=intai:sewau=tadi:ngaten=begini:terusna=teruskan:terusake=teruskan:mila=nakanya:munggel=memotong:ngetok=memotong:nugel=memotong:sedya=sedia:awon=buruk:sakanca=serombongan :sajak=kayak:dikantheni=dengan :sumimpen=tersimpan:manggakake=memersilakan:dhik=dik:mangga=silakan:sora=keras :ndhodhog=mengetuk :kejawi=kecuali:kecalan=kehilangan:punapadene=apabila:mbotene=tidaknya:kacemplung=tercebur:saestu=sungguh:tumraping=layaknya:ngasta=memegang:kersaa=setujulah:ical=ilang:tatakrami=tata krama:mangsulake=mengembalikan:ngendikane=bicaranya:kirang=kurang :ngrika=sana:ngriku=situ:ngriki=sini:mriksani=melihat:netra=mata :netrane=matanya :paringake=berikan:adhuh=aduh:segawon=anjing:mungel=bunyi :nyrempet=menyerempet:onthel=ontel:sepedhah=sepeda:kereng=garang:kantenan=karuan:saupami=seumpama:nom-noman=pemudapemuda:nemneman=pemuda-pemuda:mucalake=mengajarkan:sanyatane=senyatanya:lebet=masuk|dalam:kadoskados=bagai :dintene=harinya:ngengingi=mengenai:tigang=tiga :patosa=terlalu :patos=terlalu :jagi=jaga :maos=membaca:abot sisih=berpihak:rikat=cepat:kaanggo=terpakai:adhedhasar=berbasis:duwe irah-irahan=bertajuk:tetuwane=ketuanya:tetuwa=ketua:sajake=sepertinya:sesok=besok:mboseni=membosankan:ditingkatake=ditingkatkan:ndhidhike=mendidiknya:ndhidhik=mendidik:ramene=maraknya:rame=marak:kepinggirake=terpinggirkan:mudhune=menurunnya:ngalangi=menghalangi:mudhun=penurunan:dikancani=ditemani:mung=sematamata:lesane=lisannya:tatu=luka:tatune=lukanya:prigele=terampilnya:prigel=terampil:mungsuhan=bermusuhan:sabrangan=berseberangan:balangbalangan=lempar-lemparan:balang-balangan=lemparlemparan:balang-balangan=berlemparlemparan:balang-balangan=berlemparan:antemanteman=berpukul-pukulan:antem-anteman=berpukulpukulan:antem-anteman=berpukulan:pada mabur=beterbangan:manuk-manuk=burungburung:manukmanuk=burung-burung:adol =berjual:tutu =bertumbuk:giling =bergiling:cukuran=bercukur:kathokan=bercelana:klamben=berbaju:ketiban=kejatuhan:ketiup=tertiup:paling mulya=termulia:paling sempurna=tersempurna:paling sugih=terkaya:dialah=dheweke:keombe=terminum:kepidek=terinjak:kecithak=tercetak:pidek=injak:dipidek=diinjak:kepidek=terpijak:dening aku=olehku:dening kowe=olehmu:deninge=olehnya:nyuduk=menusuk:nyewu=menyeribu:pada putih=memutih:pada kisut=mengisut:meneng=membisu:pada teka=berdatangan:mbujang=membujang:nyuket=merumput:ngesup=mengesup:numis=menumis:mancing=memancing:munggahe=meningkatnya:bali =berpulang:pating slebar=berserakan:dluwang-dluwang=kertaskertas:gorengen=gorenglah:tirisake=tiriskan:rata =merata:pisan-pisan=sesekali:ditutu=ditumbuk:tuang =tuangkan:nyampurake=mencampurkan:misuhi=memaki:trike=truknya:trik=truk:panyebar=penyebar:nyadran=berziarah:nyadran=ziarah:rombongan =berombongan:wirawiri=hilir-mudik:wira-wiri=hilirmudik:diramekake=dimeriahkan:mresepe=terserapnya:mresep=terserap:paling akehe=terbanyaknya:paling akeh=terbanyak:njabarake=menjabarkan:macakake=membacakan|meriaskan:nyesuaikake=menyesuaikan:nalekake=ikatkan:panacad=olok-olok:pamirenge=pendengarnya:pamireng=pendengar:rambute=rambutnya:pemicara=pembicara:nindaki=melakukan:ajakajak=mengajak:idheku=ideku:idhemu=idemu:idhene=idenya:idhe=ide:pidhato=pidato:sesorahe=pidatonya:sesorah=pidato:baen=saja:maning=lagi:keadhang=terhadang:ngadhang=menghadang:diadhang=dihadang:diadhangake=dihadangkan:adhang=hadang:meteng=hamil:kaya dene=sepertihal:kaya dene=sepertihalnya:kesuwun=terima kasih:pada =padaa:ring=di/ke:kambi=dengan:ambi=dengan:keneng=kena:kenang=kena:kening=kena:isun=aku:saapik=sebaik:puter=putar:ayo =kuy:ayo =yuk:ditumpese=dibantainya:ditumpes=dibantai:logate=logatnya:klentu=keliru:ditakoni=ditanyain:disengojo=disengaja :sengojo=sengaja :maturake=mengucap:sedanten=semua:ketiga =ketigga:semono=segitu:milihake=memilihkan:pratelanpratelane=bagian-bagiannya:pratelan-pratelane=bagianbagiannya:pratelanpratelan=bagian-bagian:pratelan-pratelan=bagianbagian:sesambungan=bertalian:kawangun=terbentuk:madhakake=menyamakan:diwulangake=diajarkan:diakenn=diaku:ngakenn=mengaku:kakenn=kaku :mbangkang=membangkang:nglamun=melamun:dongane=doanya:didongakake=didoakan:ndongakake=mendoakan:dititihine=dinaikinya:dititihi=dinaiki:katulise=tertulisnya:digawe-gawene=direkayasanya:digawe-gawe=direkayasa:gawe-gawene=rekayasanya:gawe-gawe=rekayasa:lunjak-lunjakan=lonjakan:jaga-jaga=mengantisipasi:dianakake=diberlakukan:nganakake=berlakukan:nganakake=memberlakukan:pakewuh=sungkan:kenging=boleh:gawagawa=bawa-bawa:gawa-gawa=bawabawa:wedine=takutnya:siyang=siang:warsa=tahun :bakenn=baku :sakupami=seumpama:cekake=pendeknya:simpenan=simpanan:nggentine=menggantinya:nggenti=mengganti:embokembok=ibu-ibu:emboke=ibunya :embok=ibu :presidhene=presidennya:thok=doang:nuwun=terima kasih:makaten=demikian:dasa=puluh :musna=musnah:kintunake=kirimkan:sareng=bersama:ngintunake=mengirimkan:tumapake=menapaknya:tumapak=menapak:didhawuhake=diperintahkan:kakintune=terkirimnya:kakintun=terkirim:kintunane=kirimannya:kintunan=kiriman:chatetan=catatan:kaendhahan=keindahan:mbalik=berbalik:akirakir=akhir-akhir:dhinosaurus=dinosaurus:prelune=perlunya:kepangan=termakan:kaolahe=terolahnya:kaolah=terolah:diperlokake=diperlukan:diwedharake=dijelasin:ngedusi=memandikan:ngadusi=memandikan:wajibe=wajibnya:tumekane=sampainya:tumeka=sampai:mbasuh=membasuh:ngratakake=meratakan:mboh=entah:mbuh=entah:nekani=menghampiri:nekanine=menghampirinya:lawuhe=laukpauknya:lawuh=laukpauk:lungane=kepergian:ngadhepe=menghadapnya:ngadhep=menghadap:rame=berbondong:lumampah=berjalan:miwaha=memuliakan:miwaha=muliakan:mahargya=menghargai:rayakake=rayakan:sumangga=marilah:kari=ketertinggalan:paraning=menuju ke:parane=menuju ke:lebeting=dalam:jawahe=hujannya:jawah=hujan:rumiyin=dahulu:anggadhahi=mempunyai:nggadhahi=mempunyai:panyurung=pendorong:tonggaking=tonggak :enteni=tungguin:dedeg-pangadege=posturnya:dedeg-pangadeg=postur:dedegpangadege=perawakannya:dedegpangadeg=perawakan:dedeg-pangadege=perawakane:dedeg-pangadeg=perawakan:nglawuhi=menaruhi lauk:dilawuhi=ditaruhi lauk:lawuh=lauk:lawuhe=lauknya:wagune=janggalnya:wagu=janggal:nyampur=mengaduk:tilik=menilik:ngomonge=berbicaranya:prasajane=kesederhanaannya:saapik=sebagus:pertembung=perkata:wewulanan=berbulanbulan:wewulanan=berbulan-bulan:maneka-warna=keanekaragaman:maneka-warna=keragaman:prasaja=kesederhanaan:mlengkung=melengkung:plengkung=lengkung:mrambat=merambat:dhewe-dhewe=masingmasing:dadi tilaran=terwariskan:pangerten=pemahaman:kalestarikake=terlestarikan:ping pindho-pindho=berkalikali:leluhure=leluhurnya:kuloning=barat:loring=utara:wetaning=timur:kiduling=selatan:bubukaning=pembuka:nyongate=mencuatnya:kecongat=tercuat:nyongat=mencuat:tanggung jawabe=pertanggungjawabannya:tanggung jawab=pertanggungjawaban:merangine=memeranginya:merangi=memerangi:duwe komitmen=berkomitmen:dikurangine=diminimalisirnya:dikurangi=diminimalisir:rerusuhan=kerusuhan:dikrubuti=dikerubuti:dikrubut=dikeroyok:pating krubut=berkerubutan:pating krubut=berkerubut:kedlemok=ternoda:mbuka=mengungkap:diprentah=ditugaskan:nyebarake=menebarkan:dimaknani=dimaknai:ngrukunake=merukunkan:isining=isi :anyar-anyar =anyarbaru:gumrobyos=bercucuran:wingking=belakang:mriki=ke sini:mugimugi=semoga:mugi-mugi=semoga:bekta=bawa:mireng=dengar:ngebut=mengebut:genjot=gowes:kasesane=terburu-burunya:kasesa=terburu-buru:katindhakan=dilakukan:kosokan=menggosok:wastani=juluki:andhuke=handuknya:andhuk=handuk:mencolot=melompat:enjange=paginya:enjang=pagi:tilem=tidur:dugi=sampai:melek=terjaga:sedane=meninggalnya:leklekane=begadangnya:lek-lekane=begadangnya:leklekan=begadang:lek-lekan=begadang:lingsem=malu:kadadosane=kejadiannya:kadadosan=kejadian:nyalahi=menyalahi:ngirit=menghemat:ngindhani=mengindahkan:duwe jarak=berjarak:cilakane=celakanya:adoh-adohan=berjauhan:adoh-adohan=berjauhjauhan:adohadohan=berjauh-jauhan:padha-padha=saling:pandengan=bertatap:pandengan=bertatapan:duwe potensi=berpotensi:ngatur=mengontrol:menetake=merepresi:nindhesine=menindasinya:nindhese=menindasnya:nindhesi=menindasi:nindhes=menindas:keselubung=terselubung:dikarepi=dikehendakin:nyangkut=menyangkut:owahowahan=perubahan-perubahan:owah-owahan=perubahanperubahan:pucukan=berujung:nganggep=beranggapan:pracayakake=percayakan:pracaya=percaya:kencot=lapar:parentah-parentahe=perintahperintahnya:parentahparentahe=perintah-perintahnya:parentah-parentah=perintahperintah:parentahparentah=perintah-perintah:dakjajal=kucoba:kokjajal=kaucoba:kaya=seolaholah:kaya=seolah:pangaruhe=berpengaruhnya:pangaruh=berpengaruh:diucapake=dilafalkan:dienggo=dipakai:pang=cabang:labelake=melabelkan:duwitku=uangku:duwitmu=uangmu:durene=duriannya:duren=durian:rak=tak:ngapunten=maaf:subasita=tatakrama :nilarake=meninggalkan:nilar=meninggalkan:kesesa=terburu-buru:kesusu=terburuburu:selak=bergegas:lebete=dalamnya:maringake=memberikan:punapa=apa :menapa=apa :rosa=kuat :nggledhag=jatuh:sareh=sabar :renea=kesinilah:renea=kemarilah:diasta=dipegang:dikulinakake=dibiasakan:ngolahngalih=berpindah-pindah:ngolah-ngalih=berpindahpindah:gedhe-gedhe=besarbesar:gedhegedhe=besar-besar:yasanku=bangunanku:yasanmu=bangunanmu:ngrigonngrigoni=merecoki:ngrigoni=merecoki:pepanas=panaspanasan:pepanas=berpanaspanasan:pepanas=berpanas-panasan:tulisa=tuliskanlah:duwe peran=berperan:tumuti=turuti:tumuti=ikuti:nuntut=menuntut:gumantunge=bergantungnya:gumantung=bergantung:peksan=paksaan:sabrange=seberangnya:sabrang=seberang:telukake=taklukan:telukake=taklukkan:teluk=takluk:ditelukake=ditaklukan:nelukake=menaklukan:ditelukake=ditaklukkan:nelukake=menaklukkan:ono=ada:ngising=berak:niyat=berniat:nyekel=menyentuh:maculi=mencangkuli:dipaculi=dicangkuli:dipacul=dicangkul:pacule=cangkulnya:pacul=cangkul:duwe tenaga=bertenaga:kendhone=kendornya:kendhone=kendurnya:kendho=kendor:kendho=kendur:panggawen=pembuatan:gawean =palsu:tirone=tiruannya:tiron=tiruan:ditresnani=dikasihi:kowe lah=engkaulah:diangenangene=dikhayalkannya:diangenangen=dikhayalkan:diangen-angen=dikhayalkan:tinresnan=tercinta:katresnane=kecintaannya:katresnan=kecintaan:kesupen=lupa:kasarasan=kesehatan:nyukakake=memberikan:wilujeng=selamat:krana=karena:kerana=karena:mbeneri=membenarkan:nglakoni=menunaikan:sitik-sitik=dikitdikit:sitiksitik=dikit-dikit:nemoni kowe:menemuimu:nemoni aku=menemuiku:mesakake=mengasihani:mesakake=kasihani:melas=kasihan:welas=belas:dangune=lamanya:lamine=lamanya:dangu=lama:lami=lama:dalem=saya:marekake=menyembuhkan:niyat=niat:pungkasane =padaakhirnya:tamtu =tentulah:iring-iringan=beriringan:nyelarasake=menyelaraskan:dicontokake=dicontohkan:niliki=menengok:rada akeh=sedikitbanyak:sawetara=pelbagai:derese=derasnya:deres=deras:disalahake=disalahkan:dikampanyekake=dikampanyekan:ngiblat =berkiblat:njalma=menjelma:gampang =kemudahan:rada=cenderung:alon=laun:numutine=mengikutinya:disia-siakake=disiasiakan:disiasiakake=disia-siakan:ngungkit-ungkite=mengungkitungkitnya:ngungkitungkite=mengungkit-ungkitnya:ngungkite=mengungkitnya:ngungkit-ungkit=mengungkitungkit:ngungkitungkit=mengungkit-ungkit:ngungkit=mengungkit:sapisan-pisan=sekalikali:sapisanpisan=sekali-kali:dielingake=diingatkan:nenangi=menggugah:mentingake=mengedepankan:digedheni=dikedepankan:pentingake=kedepankan:dinyatakake=dikemukakan:diwedharake=diuraikan:kepriye=bagaimanakah:dipikirake=dipikirkan:ngaturake matur nuwun=berterimakasih:ngelingake=menyadarkan:tengahing=tengah :sadayaning=semua :pangapura=maafkan:sadherek=saudara:kerono=karena:mbesuk=besok:mbesukiki=besok:besukiki=besok:ngge=untuk:buktekake=buktikan:tindak=pergi:kasugihane=kekayaannya:ngungkuli=melebihi :raine=wajahnya:raine=mukanya:kepeksa=terpaksa:pepakan=perlengkapan:mungsuhe=musuhnya:sawong=seorang:dipangarepi=dikedepani:nempatake=memposisikan:mlesede=melesetnya:mlesed=meleset:ngenalake=ngenalin:nempiling=menampar:buthak=botak:ngarepe aku=hadapanku:ngarepe kowe=hadapanmu:ngarepe=hadapannya:njelasake=menjelaskan:dijabarake=dijabarkan:diwedeni=ditakuti:patitis=tepat :lugu= asli:gawe pinter=cerdaskan:ngusung=mengusung:kesimpen=terarsip:kabehe:menyeluruh:dikuwatine=diperkuatnya:dikuwati=diperkuat:ususe=ususnya:midhangetake=mendengarkan:midhanget=mendengar:kathahkathah=banyak-banyak:kathah-kathah=banyakbanyak:mugi=semoga:siyam=puasa:meksa=memaksakan:dipeksa=dipaksakan:mipil siji siji=satupersatu:ngresmeni=meresmikan:micara=berbicara:blaka=blakblakan:blaka=blak-blakan:kapungkasan=diakhiri:negesi=menegaskan:senadyan=meski:diajeni=dihargai:diuwongake=diorangkan:diremehake=diremehkan:disepelekake=disepelekan:nyepelekake=menyepelekan:urus=menghiraukan:ditugel=dipotong:nyolok=mencolok:pengin ngerti=keingintahuan:kapusan=terkecoh:jejeg=tegak:dikarepi=dikehendaki:sambi=selingi:nyambine=menyelinginya:disambine=diselinginya:nyambi=menyelingi:disambi=diselingi:duwe markas=bermarkas:duwe rencana=berencana:nekade=nekatnya:nekad=nekat:gesek =gesekk:dhisik=terdahulu:aja=janganlah:perang =peperangan:mbiyak=menyibak:ngandhegake=menghentikan:ngendheg=menghentikan:mandhegake=menghentikan:ngandheg=menghentikan:andheg=hentikan:perang =berperang:ngakehi=memerbanyak:siyam =berpuasa:mudhune=turunnya:sasine=bulannya:ing endi=dimana:panggonan=kediaman:sasisasi=bulan-bulan:wulanwulan=bulan-bulan=wulan-wulan=bulanbulan:diharamake=diharamkan:jlentreh=ulas:ngulete=menggeliatnya:ngulet=menggeliat:saapikapike=sebaik-baiknya:saapik-apike=sebaikbaiknya:sakapikapike=sebaik-baiknya:sakapik-apike=sebaikbaiknya:dhele=kedelai:tembe=barusan:ngombene=meminumnya:diombe=diminum:alone=lemotnya:alon=lemot:alone=pelannya:alone=lambannya:alone=lambatnya:alon=lamban:alon=lambat:digawekake=dibuatin:digawekake=dibikinin:dicepeti=dipercepat:kegedhene=kebesarannya:kegedhen=kebesaran:genine=apinya:pepadang=penerang:pepadhang=penerang:murupe=menyalanya:murube=menyalanya:mbenjang=besok :syafangate=syafaatnya :syafangat=syafaat :pambuka=pembuka:ajengajeng=harap:suwenge=antingantingnya:suweng=antinganting:suwenge=anting-antingnya:suweng=anting-anting:rawuh=hadir:daktakon=kutanya:koktakon=kautanya:mbayari=membayari:sunggan=paku beling:kesungga=terkena paku beling:mbudhalake=memberangkatkan:ngangkatake=mengangkatkan:panggonaning=tempat :pangirime=pengirimnya:pangirimane=pengirimannya:pangirim=pengirim:pangiriman=pengiriman:dhisik=dini:slametake=selamatkan:nyedhakake=mendekatkan:lebonan=masukan:gumedhene=sombongnya:gumedhe=sombong:nyalah-nyalahake=menyalahnyalahkan:nyalahnyalahake=menyalah-nyalahkan:maido=menyalahkan:nyacad=memburukkan:dijukut=diambil:karangkep=terangkap:kawuwuhan=kebubuhan:kawuwuhe=terbubuhnya:kawuwuhi=terbubuhi:kawuwuh=terbubuh:karana=karena:kasumurupan=terlihat:sempalane=patahannya:sempalaning=patahan:sempalan=patahan:rerangkening=rangkaian:rerangken=rangkaian:kemu=kumurkumur:kemu=berkumur:bedhile=senapannya:bedhil=senapan:nyerep=menyerap:remen-remene=sukasukanya:remenremene=suka-sukanya:lodheh=lodeh:kaatasi=teratasi:ajeg=monoton:dingertekake=diberi pengertian:pawiyatan=tempat mengabdi:jlentrehana=jelaskan:slaras=selaras :wangsulana=jawablah:pitakonane=pertanyaannya:pitakonan=pertanyaan:kapan wae=kapanpun:rembug=bahas:layangake=melayangkan:mletheking=merekahnya:sambate=mengeluhnya:sambat=mengeluh:damare=pelitanya:damar=pelita:idepe=bulumatanya:idepe=bulu matanya:idep=bulumata:idep=bulu mata:pamit=izin:pamite=izinnya:kadadeyane=terjadinya:ngati-ati=kehatihatian:diiringi=disertai:gunemane=pembicaraannya:guneman=pembicaraan:diguyoni=ditertawakan:seneng=kebahagiaan:kuliah=berkuliah:rantow=rantau:rasa-rasa=sensasisensasi:nglangkahake=menginjakkan:dieling-eling=diingat:dieling-elinge=diingatingatnya:dielingelinge=diingat-ingatnya:dieling-eling=diingatingat:dielingeling=diingat-ingat:lesan=objek:geganepe=pelengkapnya:geganep=pelengkap:dituduhake=ditunjukan:ngeling-eling=mengenang:dipocapake=dipertuturkan:sedinadina=keseharian:sadinadina=keseharian:sakdinadina=keseharian:sakdina-dina=keseharian:pasanga=pasanglah:ketikake=ketikkan:saranke=rekomendasikan:imbang=berimbang:dimaksimalake=dimaksimalkan:ngowahe=merubahnya:ngowah=merubah:dikebaki=dipenuhi:ngawale=mengawalnya:ngawal=mengawal:nyaranke=merekomendasikan:dowo=panjang:jowo=jawa :mergo=karena:rodo=agak:rodok=agak:positipe=positifnya:positip=positif:uncalake=lontarkan:dipanuti=ditaati:diputusake=diputuskan:terus =melulu:duwe pasangan=berpasangan:undhaundhine=sebayanya:sakpantarane=sebayanya:manggone=menetapnya:manggon=menetap:ngilangi=menghilangkan:kadonyan=keduniaan:kadonyan=keduniawian:nepsu=nafsu:pamrihe=pamrihnya:nguciwakake=mengecewakan:clemongane=celetukannya:clemongan=celetukan:tuture=tuturnya:kepara=bahkan:dhampar=rel:nengenake=mementingkan:pengarep=pemimpin:andum=bagi-bagi:diconto=dicontoh:apusapus=tipu-tipu:apus-apus=tiputipu:nyilakani=membahayakannya:nyilakani=membahayakan:kaweruhe=pengerahuannya:kaweruh=pengerahuan:kalakone=terlaksananya:kalakon=terlaksana:madhahi=mewadahi:pamawas=sudut pandang:modhale=modalnya:modhal=modal:ngatonake=memerlihatkan:dibuktikake=dibuktikan:pangarsa=pemimpin :wenang=berwenang:kedokumentasikake=terdokumentasikan:duwe pendapat=berpendapat:ngenalake=memopulerkan:lagi kadadeyane=berlangsungnya:kadadeyan=berlangsung:tenane=benarkah:luntur =memudar:gawe rugi=merugikan:macem-maceme=beragamnya:macem-macem=beragam:kokbuwang=kaubuang:dakbuwang=kubuang:mbuwang kowe=membuangmu:mbuwang aku=membuangku:ngambung kowe=menciummu:ngambung aku=menciumku:miwiti=menginisiasi:ndi wae=manapun:ngoyak=mengejar:sak =saku:ngugemi=memegang :dakugemi=kupegang :diugemi=dipegang :abab=hawa nafas:amung=cuma:pambukane=pembukanya:wirang=kapok:ancemane=ancamannya:anceman=ancaman:mateni=mematikan:nangkring=bertengger:ngumpulake=mengoleksi:tanding =bertanding:mbobol=membobol:duwe peluang=berpeluang:ngemas=mengemas:slasa=selasa:tambahan=penambahan:pantes=layak:layang-layange=suratsuratnya:layanglayange=surat-suratnya:layang-layang=suratsurat:layanglayang=surat-surat:kagiyatan-kagiyatane=kegiatankegiatannya:kagiyatankagiyatane=kegiatan-kegiatannya:kagiyatan-kagiyatan=kegiatankegiatan:kagiyatankagiyatan=kegiatan-kegiatan:mingsere=bergesernya:mingser=bergeser:kasesel=terselip:ketuwang=tertuang:dibandhingake=dibanding:nganggo kebaya=berkebaya:welasan=belasan:kliwat=terlewatkan:temonine=jumpainya:temoni=jumpai:tinggalake=tinggalkan:ketutupi=tertutupi:katutupi=tertutupi:kalalekake=terlupakan:ngulik=mengulik:ngulik-ulike=menguliknya:ngulik-ulik=mengulik:menehi=memberinya:nerjemahake=menterjemahkan:ninggale=meninggalnya:nyonya=nyonya:mangane=melahapnya:mangan=melahap:ngenyam=mengenyam:rinci=detail:utarakake=utarakan:ruwangan=ruangan:kepungkur=kebelakang:barep=sulung:keturon=ketiduran:direbutake=direbutkan:direbutake=diperebutkan:ngutipe=mengutipnya:ngutip=mengutip:mutusake=putuskan:ngakune=mengklaimnya:ngaku=mengklaim:nglenggang=melenggang:mborong=memborong:udakarane=kira-kiranya:udakara=kira-kira:srawungi=sapa :wiwitaning=awal :pusate=pusatnya:ngijoli=menukar:disumbangake=disumbangkan:ngubungake=menghubungkan:protokole=protokolnya:kaubung=terhubung:dikubur =dimakamkan:mangkat =meninggaldunia:geleme=bersedianya:gelem=bersedia:pangajape=harapannya:pangarep-arepe=harapannya:duwe bojo=beristerikan:liyane =liyaya:pungkasane=terakhirnya:nginspirasi=menginspirasi:bahase=bahasnya:kampuse=kampusnya:daerahe=daerahnya:krana=karena:batesan=batasan:nyimpulke=menyimpulkan:kolome=kolomnya:dhesember=desember:diamote=dimuatnya:diamot=dimuat:ngemaneman=menyayangi:ngeman-eman=memanjakan:rawuhe=hadirnya:nyetele=menyetelnya:ngrambahe=merambahnya:nyetel=menyetel:ngrambah=merambah:nganyarine=pembaruannya:nganyari=pembaruan:mbadhek=menerka:digawe=ditelurkan:cilik-cilik=kecilkecil:cilikcilik=kecil-kecil:kekancan=berkawan:nggiling=menggiling:dipepeni=dijemuri:dipepene=dijemurnya:dipepe=dijemur:dikempalake=dikumpulkan:panyimpenane=penyimpanannya:panyimpenan=penyimpanan:sekule=nasinya:sekul=nasi:regine=harganya:regi=harga:ndamele=buatnya:beaya=biaya :salajenge=selanjutnya:limrahe=lumrahnya :limrah=lumrah :kapentingane=kepentingannya:kapentingan=kepentingan:ngalirake=mengalirkan:panggenan=tempat:kapanggih=ditemukan:pamanggihe=penemuannya:siti=tanah:cekapan=cukupan :cekap=cukup :adhaptasine=adaptasinya:adhaptasi=adaptasi:dibentenake=dibedakan:awrat=berat:prodhusene=produsennya:prodhusen=produsen:ngekspor=mengekspor:dagangake=perdagangkan:didagangake=diperdagangkan:perdhagangane=perdagangannya:prodhuksine=produksinya:perdhagangan=perdagangan:prodhuksi=produksi:wose=berasnya :uwose=berasnya :wos=beras :uwos=beras :berase=berasnya:nyekapi=mencukupi:nyukupi=mencukupi:wigatos=penting:pantun=padi:banyoni=mengairi:mbanyoni=mengairi:wayah-wayah=waktuwaktu:wayahwayah=waktu-waktu:nadhah=menadah:tadhah=tadah:menehi bebungah=menghadiahi:saingane=bersaingnya:saingan=bersaing:adhedasar=mengacu:kayane=agaknya:kabeh=kesemua:dikumpulake=dihimpun:duwe oyod=berakar:dicepeti=dilejitkan:dithukulake=ditumbuhkan:menehi bebungah=menghadiahkan:wiwit=mulai:ngrasakke=merasakan:kuran=quran:pitulung=pertolongan:rajaning=raja :ratuning=ratu :muga=semoga:pertalan=bagian:peparing=memberi:agami=agama :anganut=menganut:asmaning=nama :kajeng=hendak:dilimpahake=dilimpahkan:dipracaya=dipercaya :kekajengane=kehendaknya:kekajengan=kehendak:tuladhaning=contoh :panyipta=pencipta:indhonesiyah=indonesia :kesohore=tersohornya:katingale=terlihatnya:kesohor=tersohor:katingal=terlihat:munculake=memunculkan:gegayutane=berkenaannya:gegayutan=berkenaan:larangan=mahalan:didhunake=diturunkan:kisahake=kisahkan:tinembung=kata-kata:ditegasake=ditegaskan:yiku=yaitu:mbahas=membahas:dimudhunake=diturunkan:dipudhunake=diturunkan:mandheg-mandheg=berhentiberhenti:mandhegmandheg=berhenti-berhenti:polo=otak:iklime=iklimnya:mangsane=iklimnya:nular=menular:marai=membuat :ngorong=haus:mbuange=membuangnya:mbuang=membuang:murup=menyala:batere=baterai:keselen=kecapekan:maragake=menjadikan:mambu=bau:bosok=busuk:klenger=pingsan:diwuwurake=ditaburkan:dititeni=ditandai :dileboni=dimasuki:nemplek=menempel:diluru=dicari:bathang=bangkai:mateni=membunuh:kakurangane=kekurangannya:ngendhalekan=mengandalkan:titen=teliti :mbasmi=membasmi:mungsuhing=musuh:jinisjinising=jenis-jenis:manak=beranak :pakanane=makanannya:gladhak=geladak:kulawarganing=keluarga:medhal=keluar:pamaosan=pembacaan:kertu=kartu:disade=dijual:didadosake=dijadikan:wewangun=bentuk :dimupangatake=dipergunakan:blabag=papan :mupangatake=menggunakan:pamuterane=pemutarannya:pamuteran=pemutaran:panjarwane=penjelasannya:panjarwa=penjelasan:njarwakake=menjelaskan:dijarwakake=dijelaskan:tiliki=lihat:ngetange=menghitungnya:ngetang=menghitung:ngetunge=menghitungnya:ngetung=menghitung:pamroses=pemroses:kagunakake=tergunakan:pegaweane=pekerjaannya:pagaweyane=pekerjaannya:gaweane=buatannya:pangrusak=perusak:sapanunggale=sebagainya:sanes-sanese=lainlainnya:sanessanese=lain-lainnya:sanes-sanes=lainlain:sanessanes=lain-lain:kabetahan=kebutuhan:didamel=dibuat:padintenane=hariannya:padintenan=harian:kemawon=saja:dimangertosi=dimengerti:ditampine=diterimanya:ditampane=diterimanya:ditampi=diterima:narjemahake=menerjemahkan:prentah-prentah=perintahperintah:prentahprentah=perintah-perintah:piyambakpiyambak=sendiri-sendiri:piyambak-piyambak=sendirisendiri:damel=buat:kekontrole=terkontrolnya:kadamele=terbuatnya:pangertosane=pengertiannya:kekontrol=terkontrol:kadamel=terbuat:pangertosan=pengertian:kabantu=terbantu:raimu=mukamu:raiku=mukaku:rai=muka:suburing=suburnya :obahing=ubahnya :katumpuk=tertumpuk:grombolane=gerombolannya:nggrombole=menggerombolnya:nyigare=membelahnya:grombolan=gerombolan:nggrombol=menggerombol:nyigar=membelah:dibrongsong=dibungkus :diblongsong=dibungkus :naleni=mengikat:gampang=kemudahan :mangerteni=pahami:kasigar=terbelah:papane=letaknya:rumah tangga=rumahtangga:dibusak=dihapuskan:dibusek=dihapuskan:sutresnane=pecintanya:wekdal-wekdal=waktuwaktu:wekdalwekdal=waktu-waktu:wektu-wektu=waktuwaktu:wektuwektu=waktu-waktu:ngguroni=menggurui:semanten=sebegitu:tuwin=dan juga:semerepi=lihat:kalayan=dengan:nyariyosake=menceritakan:ngginakake=menggunakan:pamiyarsa=pemirsa:pamiyarsane=pemirsanya:nuladha=mencontoh:penggalihe=pikirannya:dhumateng=kepada :sapunika=sekarang:kageser=tergeser:dangu-dangu=lamalama:dangudangu=lama-lama:majenging=maju :lampahe=jalannya:kairing=seiring:lsp=dsb:suwanten=suara:arupi=berupa:gesange=hidupnya:mangertosi=ketahui:raosake=rasakan:tingali=lihat:wewangunan=bangunanbangunan:wewangunan=bangunan-bangunan:kasenian-kaseniane=keseniankeseniannya:kaseniankaseniane=kesenian-keseniannya:kasenian-kasenian=keseniankesenian:kaseniankasenian=kesenian-kesenian:kaseniane=keseniannya:kasenian=kesenian:kawastanan=dibilang:asil-asile=hasilhasilnya:asilasile=hasil-hasilnya:asil-asil=hasilhasil:asilasil=hasil-hasil:kasil-kasile=hasilhasilnya:kasilkasile=hasil-hasilnya:kasil-kasil=hasilhasil:kasilkasil=hasil-hasil:warni=warna:panggihi=temui:dibanjurake=dilanjut:parone=separuhnya:paro=separuh:krajankrajane=kerajaan-kerajaannya:krajan-krajane=kerajaankerajaannya:krajankrajan=kerajaan-kerajaan:krajan-krajan=kerajaankerajaan:munjer=memusat:maabad-abad=berabadabad:maabadabad=berabad-abad:pulitis=politis:sawetane=timurnya:sakidule=selatannya:sakulone=baratnya:salore=utaranya:cinten=cina :nyeritakake=menceritakan:sumingkir=menyingkir:majapait=majapahit:nguasani=menguasai:jinisjinise=jenis-jenisnya:jinis-jinise=jenisjenisnya:jinisjinis=jenis-jenis:jinis-jinis=jenisjenis:winates=sebatas:ngomonge=mengucapnya:irisana=irislah:satugel=sepenggal:sandhuwure=di atasnya:entek-entekan=habishabisan:entekentekan=habis-habisan:ngemutemut=mengingat-ingat:ngemut-emut=mengingatingat:sajagad=sealam:montor=motor:kemareman=kepuasan:nglanggar=melanggar:resiking=bersih :sakarepe=seinginnya:apese=sialnya:apes=sial:sakpira=seberapa:tenanan=sungguhan:ngumpulake=menghimpun:nembe=barulah:urut =berurutan:paling kuwat=terkuat:ngentengke=meringankan:diparingake=diberikan:ngendhog=bertelur:abdhi=abdi:ketata=tertata:kendhal=kendal:dhatarane=datarannya:dhataran=dataran:ciut=sempit:kapadhetan=kepadatan:dilibatake=dilibatkan:nyuksesake=menyukseskan:ngutarakake=mengutarakan:kenalan =berkenalan:nuangake=menuangkan:dietung=dibilang:bakat=talenta:nduwe =mempunya:dirawuhi=dihadiri:sempeti=sempatin:sempeti=sempatkan:nyoblos=menyoblos:nyoblos=mencoblos:golek=nyari:diwajibake=diwajibkan:kaluwihanku=kelebihanku:kaluwihanmu=kelebihanmu:kaluwihane=kelebihannya:nganceme=mengancamnya:ngancem=mengancam:kuwatirku=cemasku:kuwatirmu=cemasmu:kuwatire=cemasnya:kuwatir=cemas:kaya mengkono=sedemikian:ngenesake=mengenaskan:tutupke=tutupkan:pirang-pirang=bervariasi:utamakake=prioritaskan:nguripake=menghidupkan:dhuwe=punya:nyajikake=menyajikan:mungkasi=mengahiri:mungkasi=mengakhiri:sandhang=sandang:dedunga=berdoa:sedhekahe=sedekahnya:sedhekah=sedekah:pertapan=pertapaan:kinasihan=mengasihi:mratandhani=menandai:diuripake=dihidupkan:nenangi=membangunkan :ginarisake=digariskan:kalorone=keduanya:kodrate=kodratnya:gegambarane=gambarannya:gegambaran=gambaran:disigare=dibelahnya:disigar=dibelah:ili=alir:iline=mengalirnya:masyarakate=masyarakatnya:panggawean=pekerjaan:kepleset=terpeleset:urute=urutnya:ngati=hati :ngetuk=keluar :diasilake=dihasilkan:kasembadan=terwujud:nyenyuwun=meminta:tertamtu=tertentu:bubare=bubarnya:penyuwunan=permintaan:karep=ingin:ngalap=memanfaatkan :kasampurnane=kesempurnaannya:kasampurnan=kesempurnaan:sinigare=dibelahnya:sinigar=dibelah:tambah amba=meluas:endhepe=rendahnya:didawani=diperpanjang:selanjute=selanjutnya:makake=makna :gunemane=obrolannya:teknike=tehniknya:unike=uniknya:sejen=lain:ulere=ulatnya:uler=ulat:gumunan=mudah kagum:nggumunan=mudah kagum:ngidake=menginjaknya:ngidak=menginjak:wirawirine=mondar-mandirnya:wira-wirine=mondarmandirnya:wirawiri=mondar-mandir:wira-wiri=mondarmandir:nggeser=menggeser:seneng-seneng=bersenangsenang:sigaran=belahan:remene=gemarnya:remen=gemar:dolanan=mainmain:wong-wonge=orangorangnya:wongwonge=orang-orangnya:ngambu=membaui:ambung=cium:nile-nilene=nilainilainya:nilenilene=nilai-nilainya:nile-nile=nilainilai:nilenile=nilai-nilai:pesenane=pesanannya:pesenan=pesanan:ngertine=mengertinya:mlayune=berlarinya:mlayu=berlari:dhistrike=distriknya:dhistrik=distrik:dibalikake=dikembalikan:dikuwasani=dikuasai:panulise=penulisnya:nyugihi=memerkaya:klimputan=gugup:kapetung=terbilang:sakcuil=sesedikit:ngancani=menemani:ngrancange=merancangnya:ngrancang=merancang:njenengake=menamainya:njenengake=menamakan:entuk=peroleh:nggubahe=menggubahnya:ndugane=menduganya:nduga=menduga:nyinaonine=memelajarinya:duwe inti=berintikan:kandha=bercakap:kandha=bercakapcakap:gonta-ganti=berubahubah:nawan=menawan:diwarisake=diwariskan:agama =keagamaan:kurangluwih=kurang lebih:kurang luwih=kuranglebih:duwe isi=berisikan:nglakonine=menggelutinya:nglakoni=menggeluti:kasunyatankasunyatane=fakta-faktanya:kasunyatan-kasunyatane=faktafaktanya:kasunyatan-kasunyatan=faktafakta:kasunyatankasunyatan=fakta-fakta:kasunyatan-kasunyatan=kenyataankenyataan:kasunyatankasunyatan=kenyataan-kenyataan:kasunyatane=faktanya:kasunyatan=fakta:kahanane=situasinya:kahanan=situasi:kapungkur=lampau:sesambungan=berhubungan:ringkese=ringkasnya:ringkes=ringkas:malah=justru:nggawe piala aku=mencelakaiku:nggawe piala kowe=mencelakaimu:nggawe piala kaene=mencelakainya:nggawe piala=mencelakai:sembranaku=cerobohku:sembranamu=cerobohmu:sembranane=cerobohnya:sembrana=ceroboh:senengku=kesenanganku:senengmu=kesenanganmu:senengku=senangku:senengmu=senangmu:senenge=kesenangannya:seneng=kesenangan:panjalukku=permohonanku:panjalukmu=permohonanmu:panjaluke=permohonannya:panjaluk=permohonan:adhimu=adikmu:adhiku=adikku:diwolakwalike=dibolak-baliknya:diwolak-walike=dibolakbaliknya:diwolakwalik=dibolak-balik:diwolak-walik=dibolakbalik:seselan=sisipan:diucapake=dilafazkan:diwujudake=direalisasi:diwujudake=direalisasikan:ngelake=hausnya:ngelak=haus:jorke=biarkan:dijorke=dibiarkan:dijarna=dibiarkan:mbisikake=membisikkan:nyawange=memandangnya:ajarke=ajarkan:ora =ga:ora=gak:mlayua=larilah:mlayuku=lariku:mlayumu=larimu:mlayune=larinya:mlayu-mlayune=larilarinya:mlayumlayune=lari-larinya:mlayu-mlayu=larilari:mlayumlayu=lari-lari:mlayu=lari:target =menargetkan:kaserat=bertuliskan:diterapake=diterapkan:ngoordinasekake=mengoordinasikan:kawinatesan=keterbatasan:dipublikasekake=dipublikasikan:indhustrine=industrinya:indhustri=industri:wewales=balasan:diwalese=dibalasnya:diwales=dibalas:ngrekam=merekam:diwakilke=diwakilkan:ana uga=adapula:kang =nan:kalepatane=kesalahannya :kalepatan=kesalahan :kekirangan=kekurangan :kakurangan=kekurangan:oleh =beroleh:matine =binasanya:mati =binasa:edane=gilanya:kentere=hanyutnya:kenter=hanyut:banget=sangatlah:nindaklanjuti=menindaklanjuti:diedarke=diedarkan:dianakake=dilangsungkan:diterangke=diterangkan:kecegah=terhindarkan:pasisiran=pesisiran:mbatik=membatik:nandhesake=menekankan:diutamakake=diutamakan:mojokake=menyudutkan:nutupi=menutupi:paling enom=termuda:congore=moncongnya:congor=moncong:kalebu=disertakan:seakeh-akehe=sebanyakbanyaknya:seakehakehe=sebanyak-banyaknya:saakeh-akehe=sebanyakbanyaknya:saakehakehe=sebanyak-banyaknya:nyengkuyung=dukung:sesuk=keesokan:koordinasi=berkoordinasi:ngusahakake=usahakan:ngertine=setahu:karepe=maunya:pracaya=meyakini:ngolehake=membiarkan:ngolehake=membolehkan:kabehing=semua :sakbubare=setelah :ndhalang=mendalang:regengregeng=ramai-ramai:rengengrengeng=ramai-ramai:ndhasari=mendasari:helem=helm:kasil=capaian:nayangake=menayangkan:nggladhi=melatih:sumangga=silakan:untuku=gigiku:prothol=copot:diwangsuli=dijawab:diplesedake=dipelesetkan:laraning=sakit :ngrumangsani=merasakan :gemuyu=tersenyum:gumuyu=tersenyum:keprungune=terdengarnya:keprungu=terdengar:talese=talesnya:mangkel=jengkel:mangkel=sebal:anyele=marahnya:anyel=marah:pinercaya=percaya :kuciwaning=kecewa:mangsuli=membalas:cekatceket=sigap:cekat-ceket=sigap:gaweyanmu=kerjaanmu:klelatklelet=lelet:klelat-klelet=lelet:rampung-rampung=selesaiselesai:rampungrampung=selesai-selesai:kekarepan=kemauan:enggal-enggal=cepatcepat:enggalenggal=cepat-cepat:trenginase=cekatannya:trenginas=cekatan:marga=karena:ndhuwurane=atasannya:andhahane=bawahannya:kabenerane=kebenerannya:kabeneran=kebeneran:ngendaleni=mengendalikan:diucapke=diomongkan:kelodhangane=kesempatannya:kelodhangan=kesempatan:dikarepi=diingini:dikarepke=diinginkan:kepranan=tersentuh hati:amalah=malah :wantah=lugu:ngentekke=menghabiskan:nyawisi=menawari:glali=gulali:nyemoni=menyindir:disemoni=disindiri:disemoni=disindir:mudheng=mudeng:mudheng=paham :dhawuhe=perintahnya:njaplak=menjiplak:turunan=mencontek:muridmuride=murid-muridnya:murid-muride=muridmuridnya:muride=muridnya:pepeling=pengingat:pasemon=satire:pasemon=satir:pasemon=penyindiran:diseseli=disisipkan:diseseli=disisipi:selaselaning=sela-sela:maedahi=berfaedah:runtiking=marah :runtik=marah :cuwa=kecewa:gela=teriris hati:anjalareni=sebabkan:anjalarani=sebabkan:regenge=ramainya :regeng=ramai :dirungu=didengar:njalari=sebabkan:jalari=sebabkan:sranta=sabar :saranta=sabar :celathu=celetuk:ditrepke=diterapkan:dipraktekke=dipraktikkan:apadene=apabila:memulang=mengajar:mindhere=mindernya:mindher=minder:pangaruhe=pangaruhnya:kawicaksanane=kebijaksanaannya:kalungguhane=kedudukannya:selaras=sesuai:musarawahe=musyarawahnya:musarawah=musyarawah:ningkahan=pernikahan:piterange=keterangannya:nglimputi=meliputi:awates=berbatas:muter=memutar:bolong=berlubang:dikeluhake=dikeluhkan:nyambungake=mengubungkan:nggawa=mengangkut:dipamerake=dipamerkan:masarake=memasarkan:ngrawat=merawat:ngrawate=merawatnya:dikenakake=dikenakan:nggetunine=menyesalinya:nggetuni=menyesali:nguciwani=mengecewakan:amarga=dikarnakan:kokgawe=kaubuat:dakgawe=kubuat:kacampur=tercampur:simbah=kakek:simbah=nenek:simbah=kakek/nenek:mahami=memahami:ngertosi=memahami:ngerteni=memahami:ngertos=mengerti:kapajang=terpampang:pengaruhi=memengaruhi:diwedharake=dipaparkan:kawedhar=terpapar:wedharake=paparkan:tekan=sampaisampai:tekan=sampai-sampai:ngajarake=mengajarkan:jerong=dalam :sawijing=satu :dileske=dileskan:nari=menari:latiane=latihannya:latian=latihan:cekelan=pegangan:sujarahe=sejarahnya:sujarah=sejarah:mesti=pasti:kadhung=terlanjur:mandeke=berhentinya:mandek=berhenti:wegah=segan :wegah=ogah:sumringah=riang:ageng=besar:beksan=tarian:janjane=sebetulnya:makiline=mewakilinya:makili=mewakili:kanca-kancamu=temantemanmu:kancakancamu=teman-temanmu:kancakancane=teman-temannya:kanca-kancane=temantemannya:parentahe=perintahnya:prentahe=perintahnya:dhaftar=daftar:pepanthan=macam :antuk=dapat:pangajap=harapan:ngaturake=mengucap:pangandikan=ucapan:paring=beri:saut-sautan=bersautsautan:sautsautan=bersaut-sautan:banter=keras :pratandha=pertanda:nabuh=menabuh:mlethek=merekah:mletheke=merekahnya:nguripi=menghidupi:kaajab=harap:kapiji=dinilai:slomprete=terompetnya:slompret=terompet:nyumet=menyulut:adicarane=acaranya:adicara=acara:saindhenge=seputarannya:tukutuku=beli-beli:tuku-tuku=belibeli:suwidak=enam puluh:ping=kali :takone=tanyanya:takoke=tanyanya:kareme=tenggelamnya:karem=tenggelam:gumebyar=semarak:mapag=menyongsong:mapag=menjemput:ngarepku=depanku:ngarepmu=depanmu:manut kowe=menurutmu:manut aku=menurutku:nggawe kowe=membuatmu:nggawe aku=membuatku:mboyong=memboyong:ditumuti=diikuti:panggunaanpanggunaan=penggunaan-penggunaan:panggunaan-panggunaan=penggunaanpenggunaan:panggunaan=penggunaan:ngudhar rasa=curhat:mbatalake=menganulir:ngesahake=mengesahkan:ketarik=tertarik:sakandel=setebal:jahata=jahatlah:paling saiki=terkini:kamardekane=kemerdekaannya:kamardekan=kemerdekaan:tansoyo=semakin:sansoyo=semakin:dibanggakake=dibanggakan:ketunane=kerugiannya:ketunan=kerugian:katunane=kerugiannya:katunan=kerugian:nem=enam :rubuh=roboh:rubuhe=robohnya:barengan=bersamaan:sakudune=seharusnya:sambunge=sambungnya:nglakoke=melakukan:regedane=kotorannya:regedan=kotoran:mreike=meliburkan:ngrendem=merendam:kerendem=terendam:direndem=direndam:rendem=rendam:pringe=bambunya:pring=bambu:sacacah=berjumlah:sacacah=sejumlah:kawaca=terbaca:katangkep=tertangkap:angenangene=angan-angannya:angen-angene=anganangannya:angenangen=angan-angan:angen-angen=anganangan:candhicandhine=candi-candinya:candhi-candhine=candicandinya:candhicandhi=candi-candi:candhi-candhi=candicandi:madhepe=menghadapnya:indhuke=induknya:indhuk=induk:semedhi=semedi:satengahe=setengahnya:diyasa=didirikan:wangunane=bangunannya:wangunan=bangunan:panggon=tempat:ngibadahe=ibadahnya:ngibadah=ibadah:njerum=mendekam:kliling=keliling:mengingsor=ke bawah:mendhuwur=ke atas:miringe=miringnya:nanjak=menanjak:kaistimewaane=keistimewaannya:kaistimewaan=keistimewaan:ketitik=nampak:katitik=nampak:dhahare=makannya:dhahar=makan:ngantuke=mengantuknya:ngantuk=mengantuk:padusane=pemandiannya:padusan=pemandian:mlampah=berjalan:pegel-pegele=pegalpegalnya:pegelpegele=pegal-pegalnya:pegel-pegel=pegalpegal:pegelpegel=pegal-pegal:pegel=pegal:dingge=dipakai:dinggo=dipakai:segering=segar :sakiwa-tengen=sekirikanan:sakiwatengen=sekiri-kanan:kiwatengene=kiri-kanannya:kiwa-tengene=kirikanannya:kiwatengen=kiri-kanan:kiwa-tengen=kirikanan:sesawangane=pemandangannya:sesawangan=pemandangan:sayahe=capenya:sayahe=capeknya:sayah=cape:sayah=capek:kasebarsebar=tersebar:kasebar-sebar=tersebar:mapane=posisinya:sakupenge=sekelilingnya:kupenge=kelilingnya:umah=rumah:tepate=tepatnya:mekarake=memekarkan:krenteging=hasrat:krentege=hasratnya:krenteg=hasrat:kretege=jembatannya:kreteg=jembatan:ngudari=mengupas:wewatakan=perwatakan:wulangan=pelajaran:ukarane=kalimatnya:mudhun=menurun:ndeleng=menatap:nunggu kowe=menantimu:nunggu aku=menantiku:nglebokake=menginput:ngrambahe=menjelajahinya:anane=keberadaan:ngajak aku=mengajakku:ngajak kowe=mengajakmu:ngleluri=lestarikan:nglatihe=melatihnya:nglatih=melatih:mutung=ngambek:mutung=mengambek:misuh=mengumpat:misuh=mencaci:nggrentes=menggerutu:kentengan=kehabisan:sapantare=seusianya:sapantar=seusia:rikuhe=canggungnya:rikuh=canggung:samisami=sama-sama:sami-sami=samasama:sami=sama:badhe=mau:mbenjing=esok:menawi=jikalau:langkung-langkung=lebihlebih:langkunglangkung=lebih-lebih:mbentenake=membedakan:kados=seperti:leres=benar:seratane=tulisannya:malih=lagi:nyambut gawea=kerjalah:nyambut gawea=bekerjalah:ngundange=mengundangnya:kaya=serasa:wis=dah:adhiadhi=adik-adik:adhi-adhi=adikadik:idam-idamake=idamidamkan:idamidamake=idam-idamkan:pangkoning=pangkuan:pangkone=pangkuannya:pangkon=pangkuan:awune=abunya:awu=abu:dipendhem=dipendam:dipendheme=dipendamnya:surak=bersorak:ngleluri=melestarikan:nguriuri=melestarikan:nguri-uri=melestarikan:nyedulurake=menyaudarakan:paseduluran=persaudaraan:nyengkuyungan=mendukungi:kaiket=terikat:njerone=dalamnya:nerapake=menerapkan:nalika bali=sekembalinya:mangaribawani=membujuk:nglaksanakake=melaksanakan:ngleksanakake=melaksanakan:diwartakake=diberitakan:utowo=atau:cetheke=dangkalnya:cethek=dangkal:diancurke=dihancurkan:diwudani=ditelanjangi:mudani=menelanjangi:wudane=telanjangnya:wuda=telanjang:kaluwarga=keluarga:non-pamarentah=nonpemerintah:nonpamarentah=non-pemerintah:apalan=hafalan:dibabar=dibahas:mbabare=membahasnya:mbabar=membahas:sakpiturute=sebagainya:sakwise=setelah:merem=terpejam:angel-angel=susahsusah:angelangel=susah-susah:kawigatene=perhatiannya:sakdurunge=sebelumnya:moco=membaca:diarahake=diarahkan:menehake=menyerahkan:mblokir=memblokir:panjaluke=pintanya:panjaluk=pinta:dikuwatirake=dikhawatirkan:dikuwatirake=dikawatirkan:dirampungake=dirampungkan:weruhe=lihatnya:keselkesel=capek-capek:kesel-kesel=capekcapek:kesele=capeknya:kesel=capek:ribut =berpolemik:nyambut gawe=berprofesi:ngademake=mendinginkan:ribut-ribut=kegaduhan:paling anyar=terbaru:kadhang=acap:undhaundhi=sebaya:undha-undhi=sebaya:didunungi=didiami:meneng-meneng=diamdiam:menengmeneng=diam-diam:menenge=diamnya:meneng=diam:critacritane=kisah-kisahnya:crita-critane=kisahkisahnya:critacrita=kisah-kisah:crita-crita=kisahkisah:nguncali=melempari:pandhemen=pecinta:kaca mripat=kacamata:dibuktekake=dibuktikan:baris =barisan:sandhangane=berpakaiannya:sandhangan=berpakaian:sandhangane=pakaiannya:sandhangan=pakaian:kajelasane=kejelasannya:kajelasan=kejelasan:awake=tubuhnya:awak=tubuh:watesane=batasannya:watesan=batasan:dibolabali=diulang-ulang:dibola-bali=diulangulang:dibolanbalen=diulang-ulang:dibolan-balen=diulangulang:menggak-menggok=zigzag:menggakmenggok=zig zag:mbunder=melingkar:dedonga=berdoa:majibake=mewajibkan:nguwajibake=mewajibkan:pasarta=peserta:mulangake=mengajarkan:unggahungguhing=adabnya:babaran=keluaran:saknyatane=kenyataannya:anakanake=anak-anaknya:anak-anake=anakanaknya:sinaune=belajarnya:dipadakake=disamakan:apameneh=apalagi:rumangsane=berasanya:krasa=berasa:rumangsane=berasa :kandhane=ceritanya:sakliyane=selain:diapali=dihafali:nasibe=nasibnya:wasis=ahli:kluwarga=keluarga:ngraketake=merekatkan:pikirake=pikirkan:ora=nggak:dawadawane=panjang-panjangnya:dawa-dawane=panjangpanjangnya:dawadawa=panjang-panjang:dawa-dawa=panjangpanjang:ngrasakake=merasai:tumanen=berkutu:jenengjenenge=nama-namanya:jeneng-jenenge=namanamanya:jenengjeneng=nama-nama:jeneng-jeneng=namanama:mbalikake=membalikkan:tambah =bertambah:lampahake=jalankan:ngadopsi=mengadopsi:pambeda=pembeda:pambedan=pembedaan:panjalukan=permintaan:kaisi:ngunggah=mengunggah:ngluwihi=melebihi:ngramu=meramu:tenan=beneran:saakeh=sebanyak:pintere=mahirnya:pinter=mahir:buwangbuwang=buang-buang:buwang-buwang=buangbuang:diuripke=dihidupkan:ngamalake=mengamalkan:conto=semisal:kaisolire=terisolirnya:kaisolir=terisolir:liya-liya=lainlain:liyaliya=lain-lain:paling endhep=terendah:kali-kaline=sungaisungainya:kalikaline=sungai-sungainya:kali-kali=sungaisungai:kalikali=sungai-sungai:saamba=selebar:diwenehake=diserahkan:peksa=paksa:kandhakandha=bilang-bilang:kandha-kandha=bilangbilang:kok-eman=kausayang:dak-eman=kusayang:laku=perbuatan:sumusul=menyusul :gegamane=senjatanya:lelana=berkelana:pinggiring=pinggir :sasedulur=bersaudara:dhawuhing=perintah :nyusuri=menyusuri:caritakake=kisahkan:nyaritakake=mengisahkan:diuter=diputar:iki =berikut:mangga=silahkan:mangga=silakan:sengkuyung=bersemangat:sengkuyung=semangat:pimpinane=pemimpinnya:pimpinan=pemimpin:panggedhene=pimpinannya:panggedhene=pemimpinnya:panggedhe=pimpinan:panggedhe=pemimpin:diramekake=diramaikan:ngramekake=meramaikan:sapendak=seminggu:age-agea=segeralah:mandhegani=mengetuai:mlumpate=melompatnya:mlumpati=melompati:mlumpat=melompat:koktempuh=kautempuh:daktempuh=kutempuh:nempuhe=menempuhnya:nempuh=menempuh:dilampahake=dijalankan:inpormasine=informasinya:inpormasi=informasi:omah-omah=menikah:paling tuwa=tertua:krasa=terasakan:majokake=memajukan:magepokan=berkaitan:magepokan=berpautan:ijolijolan=bertukar:ijol-ijolan=bertukar:ijol=tukar:ijolan=menukar:pangopenan=perawatan:ningkat=meningkat:contone=misalkan:nglayani=melayani:jaga =berjaga:kenalake=kenalkan:ngenalake=perkenalkan:ngenalake=mengenalkan:dikenalake=diperkenalkan:dikenalake=dikenalkan:anggonku=sewaktu aku:anggonmu=sewaktu kamu:keplayu=terbirit:dakkandhakake=kuceritakan:kokkandhakake=kauceritakan:halalake=halalkan:dihalalake=dihalalkan:dilengserake=dilengserkan:ngerti=tahukah:dirapalake=dirapalkan:samedeni=seseram:ditembangake=dinyanyikan:tekamu=datangmu:tekaku=datangku:tekamu=hadirmu:tekaku=hadirku:awit=berawal:wiwiti=awali:wareg=kenyang:toli=dan juga:kaprungune=terdengarnya:kaprungu=terdengar:ngalir=mengalir:sabubare=sehabis:neliti=meneliti:nyoba=mencoba:guwa=goa:temokake=temukan:nakokake=menanyakan:cilikan=kecilkecilan:cilikan=kecil-kecilan:krungune=mendengarnya:ngelih =memindah:duduh=kuah:ngertine=setaunya:ngertine=setau:njelehi=menjemukan:ngandelake=memercayakan:ngandel=percaya:dialeke=dialeknya:kelase=kelasnya:panginepane=penginapannya:panginepan=penginapan:yakui=yaitu:sepur=kereta api:mergane=sebabnya:donyane=dunianya:paneliten=penelitian:piwulangan=pengajaran:sajenis=sejenis:sajenise=sejenisnya:anggitan-anggitane=karangankarangannya:anggitananggitane=karangan-karangannya:anggitan-anggitan=karangankarangan:anggitananggitan=karangan-karangan:khususe=khususnya:mogamoga=semoga :nyisipke=menyisipkan:dendaman=pendendam:mumpuni=cakap:diparagakake=diperagakan:mrantasi=menyelesaikan:pandulu=pandangan:pandulune=pandangannya:tumprap=untuk:sipate=sifatnya:pandhangan=pandangan:pandhengan=pandangan:dirembug=dibahas:anggitane=karangannya:pangitungane=penghitungannya:pangitungan=penghitungan:pangetungane=penghitungannya:pangetungan=penghitungan:dipertimbangake=dipertimbangkan:paling gedhe=terbesar:paling cedhak=terdekat:paling cedhake=terdekatnya:bathi=keuntungan:ditekakake=didatangkan:ditekakake=dihadirkan:suwasana=nuansa:njajale=mencobanya:nyerang=menyerang:wedhar=papar:wedhar=beber:wedharake=beberkan:ngowahine=mengubahnya:age-age=sesegera:matengake=mematangkan:dibiji=dinilai:memper=menyerupai:ngawinake=mengawinkan:sadhuwurdhuwere=setinggi-tingginya:sadhuwur-dhuwere=setinggitingginya:ngerti=tahukan:mudhuna=turunlah:ngumpetake=merahasiakan:diumpetake=dirahasiakan:nylametake=menyelamatkan:ramane=ayahnya:endahendah=indah-indah:ndherekake=mengikuti:sungkawa=sedih:kabukten=terbukti:ndakwa=mendakwa:dienengake=didiamkan:imbuhe=imbuhnya:njaban=seluar:didhidhike=dididiknya:didhidhik=dididik:ditertibake=ditertibkan:satemene=sebetulnya:temtu=tentu:nggeret=menggered:ngidinake=mengizinkan:ngijinake=mengizinkan:ngalangalangi=menghalang-halangi:ngalang-alangi=menghalanghalangi:meksa=memaksa:ngemis=mengemis:seda=meninggal:emane=sayangnya:temenan=betulan:tenan=betulan:nyauri=menyaur:penyakite=penyakitnya:ngadhep=menghadap:wusanane=akhirnya:klawan=dengan:ajejuluk=berjuluk:ewon=ribuan :sasuwene=selamanya:mapan=bertempat:andhile=andilnya:uwal=lepas:syiare=syiarnya:klebu=termasuk:pirsa=tahu :karomahe=karomahnya:pasareyan=peristirahatan:gumanti=berganti:angslup=terbenam:nyedaki=mendekati:lumakuning=berjalannya :krungune=terdengarnya:krungu=terdengar:leren=beristirahat:ngadhepine=menghadapinya:guyone=leluconnya:guyon=lelucon:sapisana =bangetpun:linandhesane=berlandaskannya:linandhesan=berlandaskan:ngerenine=mengerikannya:nanganine=menanganinya:ngereni=mengerikan:nangani=menangani:nggo kae=untuknya:paling wigati=terpenting:ngesuk=esok:sagegem=segenggam:rewangane=bantuannya:laporake=laporkan:walike=baliknya:walik=balik:tipi=tivi:tipi=televisi:ndandanine=memerbaiknya:sapa wae=siapapun:ngesuk=besok:duwe irah-irahan=berjudul:paling dhuwur=tertinggi:ngrenggut=merenggut:watukwatuk=terbatuk-batuk:watuk-watuk=terbatukbatuk:dijaluke=dimintanya:nelpun=menelefon:wenehi ngerti=beritahu:ngalah=mengalah:kacampur=bercampur:kencenge=eratnya:kenceng=erat:ditlateni=dicermati:nelateni=mencermati:nelateni=mencermati:nlateni=menelateni:nelateni=nlateni=menelateni:nelateni=menelateni:mandhegani=memimpin:pakempalan=perkumpulan:kempalan=kumpulan:saweneh=beberapa:kaamote=dimuatnya:dimot=dimuat:pakaryane=pekerjaannya:kapracaya=terpercaya:kapracaya=tepercaya:kompetisi =berkompetisi:uga=pun:melu=terlibat:balekutha=balaikota:bale =balai:mutermuter=berkeliling:muter-muter=berkeliling:mugamuga=mudah-mudahan:muga-muga=mudahmudahan:tekani=datangi:nekani=mendatangi:poto=berfoto:salaman=bersalaman:ampiri=sambangi:ngampiri=menyambangi:kulino=terbiasa:sembrono=sembarangan:wewayang=bayangan:biso=bisa :kegodha=tergoda:ra=tak:kadung=telanjur:nggempure=menggempurnya:nggempur=menggempur:nyambungake=menjembatani:nyambungake=menyambungkan:maturnuwun=terima kasih:dipusatake=dipusatkan:nibakake=menjatuhkan:wateswatese=batas-batasnya:wates-watese=batasbatasnya:wateswates=batas-batas:wates-wates=batasbatas:siji =seorang:ngarep=hadapan:mengku=memangku:mangku=memangku:diolehake=dibolehkan:diolehake=diperbolehkan:wedhuse=kambingnya:wedhus=kambing:pangreksan=pemeliharaan:kadhaftar=terdaftar:kalungguhan=kedudukan:diadegake=didirikan:yasan=bangunan:nguwatake=memerkuat:paling apike=terbaiknya:paling apik=terbaik:ngarepake=mengharapkan:kasusastran=kesusastraan:omongane=perkataannya:sembrana=sembarangan:saawak=sebadan:sakojur=sekujur:lumantar=lewat:kasusune=tersusunnya:kasusun=tersusun:tlagane=telaganya:tlaga=telaga:nyakup=mencakup:kejaba=kecuali:ngedarake=mengedarkan:gaman=senjata:mati =terbunuh:nyalonake=mencalonkan:menengmeneng=diam-diam:meneng-meneng=diamdiam:nganggo=mengenakan:manggoni=menghuni:nggoreng=menggoreng:kakagetan=keterkejutan:ngalihake=mengalihkan:kebongkare=terbongkarnya:kebongkar=terbongkar:kagete=terkejutnya:kaget=terkejut:petenge=gelapnya:peteng=kegelapan :blingsatan=belingsatan:ngagetake=mengejutkan:ngagetake=mengagetkan:nakokake=memertanyakan:golek=pencarian:awutawutan=berantakan:awut-awutan=berantakan:uwohe=berbuahnya:uwoh=berbuah:mbebayanine=berbahayanya:mbebayani=berbahaya:gothot=berotot:wangsa=bangsa:panguwasane=penguasanya:dipapanake=ditempatkan:pusere=pusatnya:puser=pusat:magrong=megah:ewoning=ribuan:jagat=semesta:sajagat=sedunia:barabudhure=borobudurnya:barabudhur=borobudur:kapernahe=terposisinya:kapernah=terposisi:wewaton=patokan:pesthi=pasti:mesthine=pastinya:ditrima=diterima:kliwatan=kelewatan:kliwat=terlewat:diendhani=dihindari:kapindo=kedua:manten=pengantin:mantene=pengantinnya:dipara=dibagi:diliwati=dilewati:andhane=tangganya:andha=tangga:undhakan=undakan:tlundhagan=undakan:undhakundhakane=undak-undakannya:undhak-undhakane=undakundakannya:undhakundhakan=undak-undakan:undhak-undhakan=undakundakan:tanggung jawabe=tanggungjawabnya:tanggung jawab=tanggungjawab:kawigatene=kepentingannya:kawigaten=kepentingan:sepurane=maaf:ngaleh=berpindah:nggo=bagi:mbukak=membuka:ingsun=aku:jenengmu=namamu:jenengku=namaku:lalikake=lupakan:lalekake=lupakan:nglalikake=melupakan:sliramu=dirimu:tresnamu=cintamu:tresnaku=cintaku:jerite=jeritnya:wewengkon-wewengkone=wilayahwilayahnya:wewengkonwewengkone=wilayah-wilayahnya:wewengkon-wewengkon=wilayahwilayah:wewengkonwewengkon=wilayah-wilayah:saenggon=setempat:njagani=menjagai:oretoretane=corat-coretnya:oret-oretane=coratcoretnya:oret-oretan=coratcoret:oretoretan=corat-coret:lupute=salahnya :luput=salah :kaluputane=kesalahannya:nganyarine=membaharuinya:kaluputan=kesalahan:nganyari=membaharui:cumawis=tersedia:pengracike=peraciknya:pengracik=peracik:ngapikine=memercantiknya:ngapikine=memerbagusnya:ngapiki=memercantik:ngapiki=memerbagus:kuwatake=kuatkan:dikuwatake=dikuatkan:nguwatake=menguatkan:uwis=sudah:kepenake=nyamannya:kepenak=nyaman:keamanane=keamanannya:gegerak=bergerak:disaine=desainnya:nlusurine=menelusurinya:nlusuri=menelusuri:pandhemene=penggemarnya:pandhemene=penyukanya:pandhemen=penggemar:pandhemen=penyuka:kejaba=kecuali:nggampangi=memermudah:sithik=dikit:su=njing:saenggonenggone=sembarang tempat:saenggonenggon=sembarang tempat:mahamantri=perdana menteri:awangun=berbentuk:dinggokake=dipakaikan:dinggone=dipakainya:dunyane=dunianya:dunya=dunia:pindhahe=pindahnya:dipindhahe=dipindahnya:pindhah=pindah:dipindhah=dipindah:mara=ke:ndhekne=dianya:merdheka=merdeka:merdhekakake=merdekakan:dimerdhekakake=dimerdekakan:mardhekakake=merdekakan:dimardhekakake=dimerdekakan:mardikakake=merdekakan:dimardikakake=dimerdekakan:dheklarasikake=deklarasikan:didheklarasikake=dideklarasikan:ujur=bujur:geografise=geografisnya:weruhi=perlihatkan:karawuhan=kedatangan:brisbane=brisbane:melbourne=melbourne:kumpulake=kumpulkan:ngumpule=berkumpulnya:ngumpul=berkumpul:makumpule=berkumpulnya:makumpul=berkumpul:fedherasine=federasinya:fedherasi=federasi:dibukak=dibuka:ukumanku=hukumanku:ukumanmu=hukumanmu:ukumane=hukumannya:ukuman=hukuman:akoni=akui:saparone=separuhnya:saparo=separuh:panjelajahan=penjelajahan:panjelajah=penjelajah:warigaluh=pencari ikan:amek=mencari:didunungi=ditempati:dharatandharatan=daratan-daratan:dharatan-dharatan=daratandaratan:dharatane=daratannya:dharatan=daratan:tanggane=tetangganya:ostrali=australia:cures=punah:pranala=tautan:pasulayan=pertentangan:diidhentifikasi=diidentifikasi:sakulawargane=sekeluarganya:sakulawarga=sekeluarga:kayadene=seperti halnya:sepisanan=pertama:penuture=penuturnya:suku =kaki:kasuse=kasusnya:bentuke=bentuknya:wangunwangune=bentuk-bentuknya:wangun-wangune=bentukbentuknya:wangunwangun=bentuk-bentuk:wangun-wangun=bentukbentuk:wangune=bentuknya:wangun=bentuk:ndadra=jabar :ngetrepake=mengaplikasikan:nrapake=menerapkan:ngetrepake=menerapkan:ngecakake=menerapkan:lumrah=wajar:lumrah=umum :akir=akhir:yasa=membuat:sajaman=satu zaman:sing-sing=tidaktidak:singsing=tidak-tidak:mau=tadi:susastrane=sastranya:susastra=sastra:ngapalane=menghafalnya:ngapal=menghafal:ngapalake=menghafalkan:apalake=hafalkan:apale=hafalnya:apal=hafal:diapalake=dihafalkan:kabuka=terbuka:tutuk=mulut:ndawakake=memanjangkan:dawakake=panjangkan:didawakake=dipanjangkan:griya=rumah:yuswa=usia:mandeg=berhenti:cupet=sempit:olehe=kalau :surute=surutnya:prabedane=perbedaannya:ngelmuwan=ilmuwan:ngelmiah=ilmiah:elmiyah=ilmiah:ngelmiyah=ilmiah:nyepakake=memersiapkan:jangkep=lengkap:eropah=eropa:bakokake=bakukan:nandhingi=menandingi:sejarahe=sejarahnya:ramerame=ramai-ramai:rame-rame=ramairamai:rame-ramene=ramairamainya:rameramene=ramai-ramainya:rame-rame=beramairamai:ramerame=beramai-ramai:ramene=ramainya:rame=ramai:tuman=nglunjak:tuman=keterusan:owahane=perubahannya:owahowahane=perubahannya:owahowahan=perubahan:nglestarekake=melestarikan:adhedasar=berdasar:nyencang=mencancang:nyancang=mencancang:ngrembaka=berkembang:meneka=beraneka:papuwa=papua:kapulowan=kepulauan:kanggonane=kegunaannya:kanggonan=kegunaan:mbayar=membayar:ndeleng=pandang:deleng=pandang:marentah=memerintah:ngakon=memerintah:saubenging=sekeliling :kabangun=terbangun:kabangun=terdiri:soksokan=sering:sok-sokan=sering:saikine=sekarangnya:sekabehing=semua :pakebonan=perkebunan:kuwate=kuatnya:sangsaya=semakin:pangwasanan=penguasaan:didamaiake=didamaikan:dibubarake=dibubarkan:biyene=dulunya:indhiya=hindia:hindhia=hindia:njajahe=menjajahnya:njajah=menjajah:jarwa=arti :jarwane=artinya:ngenjange=besoknya:ngenjang=besok:kuliyahe=kuliahnya:kuliyah=kuliah:ngandhani=memberitahu:diboncengake=diboncengkan:apamaneh=apalagi:sapiturute=sebagainya:sasampune=sesudah:kajawi=kecuali:mekaten=demikian:kareben=agar:saupama=seumpama:satunggal=satu :kagandheng=tergandeng:digandheng=digandeng:gandheng=gandeng:nggandhenge=menggandengnya:nggandheng=menggandeng:ginane=gunanya:diwastani=dijuluki:ndhaptar=mendaftar:dhaptare=daftarnya:dhaptar=daftar:mijet=memijat:dipijet=dipijat:pijet=pijat:menet=menekan:melune=keikurtsertaan:melune=ikutnya:sanadyan=kendati:tuan rumah=tuanrumah:tukar padu=bertengkar:ketabrak=tertabrak:minteri=memerdayai:mbebodho=memerdayai:kuwalikan=kebalikan:keminter=sok pintar:terjemahe=terjemahnya:mboten=tidak:medal=keluar:dadia=jadilah:takon=nanya:sumedhiyane=tersedianya:sumedhiya=tersedia:tilpon=telepon:modhele=modelnya:modhel=model:joged=tari:bathine=keuntungannya:mbandhani=membiayai:bludag=membludak:mbludag=membludak:nyang=ke:diparani=disinggahi:diparani=didatangi:pangeram=penggemar:pangerame=penggemarnya:idholane=idolanya:idhola=idola:kondang=terkenal:puteran=putaran:nyanyi=menyanyi:panitya=panitia:pindhahpindhah=pindah-pindah:pindhah-pindhah=pindahpindah:wadhah=wadah:lokete=loketnya:papan-papan=tempattempat:papanpapan=tempat-tempat:ndhirikake=mendirikan:tumrape=layaknya:genah=bagus:bebuka=kata pengantar:nyebute=menyebutnya:nyebut=menyebut:nggantine=menggantinya:asate=surutnya:asat=surut:dilaporake=dilaporkan:sadurunge=semulanya:sadurunge=semula:enteke=habisnya:ditunggonine=ditungguinya:ditunggoni=ditunggui:dientenine=ditunggunya:dienteni=ditunggu:entheng-entheng=ringanringan:enthengentheng=ringan-ringan:dienthengi:diringankan:enthenge=ringannya:entheng=ringan:liya-liyane =liyalainnya:saimbang=seimbang:ngentukake=mendapatkan:bandha=harta:kawaspadane=kewaspadaannya:kawaspadan=kewaspadaan:kasaimbangane=keseimbangannya:kasaimbangan=keseimbangan:sumbere=sumbernya:kliwatan=kelewatan:tuwaku=tuaku:tuwamu=tuamu:ngelih=lapar|memindah:lelaku=perilaku:diadohi=dijauhi:nuding=menunjuk:alane=buruknya:saliyane=selainnya:nelesine=membasahinya:nelesi=membasahi:tuduhake=perlihatkan:dituduhake=diperlihatkan:dituduhake=ditunjukkan:nggatekake kowe=memerhatikanmu:nggatekake aku=memerhatikanku:ngopeni kowe=mengasuhmu:ngopeni aku=mengasuhku:ngopenine=mengasuhnya:ngopeni=mengasuh:nglangkahake=melangkahkan:nglangkahine=melangkahinya:nglangkahe=melangkahnya:nglangkahi=melangkahi:nglangkah=melangkah:sampeyan=dikau:kawangsul=terjawab:dianyari=diperbarui:mesthi=mutlak:sawelah=sebelah:uniuni=bunyi-bunyi:uni-uni=bunyibunyi:wong tuwa=orangtua:nepungake=memerkenalkan:tetaunan =bertahuntahun:tetaunan=bertahun-tahun:prakara-prakarane=persoalanpersoalannya:prakaraprakarane=persoalan-persoalannya:prakara-prakara=persoalanpersoalan:prakaraprakara=persoalan-persoalan:numbuhkembangake=menumbuhkembangkan:ngilangake=menghilangkan:tiru-tiru=meniru:panjatake=panjatkan:mangkelake=menjengkelkan:mangkelake=menyebalkan:amane=hamanya:amaamane=hama-hamanya:ama-amane=hamahamanya:amaama=hama-hama:ama-ama=hamahama:ama=hama:patrap=perlakuan:dipacaki=dihiasi:ning aku=padaku:ning kowe=padamu:piyambake=beliau:sadhuwur=setinggi:wite=pohonnya:pinaringan=mendapatkan:kalairake=terlahir:sumadulur=persaudaraan:nyilikake=mengecilkan:asorake=rendahkan:ngasorake=merendahkan:saya=kian:nyawangi=memandangi:gumun=terkesima:ambu=berbau:ngetokake=menampakkan:jerone=kedalamannya:memper=kesamaan:kaya=bagai:karo=dg:tetilarane=peninggalannya:tilarane=tinggalannya:tetilaran=peninggalan:tilaran=tinggalan:balia=kembalilah:ngajak=mengajak:metua=keluarlah:dakladeni=kuladeni:kokladeni=kauladeni:wedharan=pembahasan:medharake=bahas:medharake=menjabarkan:netra=mata:katimbalan=terpanggil:majua=majulah:dipaesi=diriasi:dipaesi=dirias:macak=berhias:rebutan=berebut:dialihake=dialihkan:sawise=sesudah:dijawakake=dijawakan:asmane=namanya:namine=namanya:nami=nama:benere=betulnya:bener=betul:bujele=tumpulnya:bujel=tumpul:segarane=lautannya:segarane=lautnya:ndalune=malamnya:dalune=malamnya:lautan=segara:laut=segara:ndalu=malam:dalu=malam:weruh kae=melihatnya:karo=dgn:kuwe=itu:sampeyan=engkau:antenge=kalemnya :anteng=kalem :perete=kasapnya:peret=kasap:beton=biji nangka:saemper=seserambi:saemper=seteras:melok=menor:melokmelok=menor:melok-melok=menor:sangu=berbekal:sangu=bekal:sangu=berbekal :ngemong=menjaga:macak=merias:pacakan=riasan:atiatine=hati-hatinya:ati-atine=hatihatinya:galihe=perasaannya :galih=perasaan :kepinterane=kepintarannya:kepinteran=kepintaran:ngangsune=menimbanya:kranjange=keranjangnya:kranjang=keranjang:bebasane=peribahasanya:bebasan=peribahasa:rujake=rujaknya:bibite=induknya:bibit=induk:dhondhonge=kedondongnya:dhondhong=kedondong:soko=dari:awiting=mulainya:witing=mulainya:awite=mulainya:nglayang=melayang:nglayange=melayangnya:kontul=kuntul:tapake=jejaknya:tapak=jejak:goleka=carilah:lenge=lubang sarangnya:leng=lubang sarang:ngemuline=menyelimutinya:kemule=selimutnya:unenunene=bebunyiannya:unen-unene=bebunyiannya:ngemuli=menyelimuti:kemul=selimut:unenunen=bebunyian:unen-unen=bebunyian:tetembungane=katakatanya:tetembungane=kata-katanya:ngedan=menggila:ngliwet=masak nasi:ngluyur=berkeliaran:ngluyurr=berkeliarannya:ngluyura=berkeliaranlah:mring=ke:gatra=bait:tibaning=jatuhnya:ajeg=tetap:ajeg=ajek:sadhela=sejenak:suwe-suwe =lamaalama:suwe-suwe =lamaakelamaan:digawekake=dibuatkan:beredhare=beredarnya :kababare=beredarnya:beredhar=beredar :urun=andil :ngetik=mengetik:dhaerah=daerah:telpun=telepon:peradhabane=peradabannya:kondhang=terkenal:penggawean=pekerjaan:ijazahe=ijazahnya:pengarange=pengarangnya:pucuke=puncaknya:berjuwang=berjuang:hadhiyahe=hadiahnya:hadhiyah=hadiah:kacathete=tercatatnya:kacathet=tercatat:tinuladha=dicontoh:mbumboni=membumbui:dibumboni=dibumbui:samak=sampul:sakedhap=sekejap:asring-asring=seringsering:asringasring=sering-sering:pakewuh=sungkansungkan:pakewuh=sungkan-sungkan:ngresulane=mengeluhnya:ngresula=mengeluh:barengbareng=bersama-sama:bareng-bareng=bersamasama:lestarine=abadinya:lestari=abadi:lemu-lemu=gemukgemuk:lemulemu=gemuk-gemuk:gawekake=buatkan:gawekake =buatin:wangi=harum:wangine=harumnya:ambu=aroma:ambune=aromanya:tukune=belinya:nukune=membelinya:nukokake=membelikan:sepedha=sepeda:ditukokake=dibelikan:ngimpikake=impikan:ngimpine=impiannya:ngimpi=impian:upamakake=ibaratkan:upamane=ibaratnya:upama=ibarat:diupamakake=diibaratkan:butuhake=butuhkan:ketemune=berjumpanya:ketemu=berjumpa:akune=sayanya:njeroni=mendalami:jeroni=dalami:raketake=akrabkan:rakete=akrabnya:lemune=gemuknya:lemu=gemuk:karo kae=dengannya:mendhem=memendam:mikul=memikul:anyaranyar=baru-baru:anyar-anyar=barubaru:dalanan=jalanan:nrobos=menerobos:ndekem=mendekam:kaya=bagaikan:ketemune=diketemukannya:ketemu=diketemukan:situse =konosnya:situs =konos:mangkono uga=begitupun:pindhah=beralih:nerbitake=menerbitkan:nekakake=menghadirkan:dakgawa=kubawa:pateni=bunuh:krasan=betah:kuthaku=kotaku:kuthamu=kotamu:nggodha=menggoda:kebagiyan=kebagian :kanca-kancaku=temantemanku:kancakancaku=teman-temanku:jupuk=ambil:samubarange=sesuatunya:samubarang=sesuatu:suwi-suwi=lamalama:suwisuwi=lama-lama:suwi=lama:suwe-suwe=lamalama:suwesuwe=lama-lama:delehake=taruh:eling-eling=ingatingat:elingeling=ingat-ingat:tak=ku :dak=ku :maune=tadinya:waune=tadinya:diceluk=dipanggil:mersiapake=memersiapkan:panguripan=penghidupan:paite=pahitnya:pait=pahit:sedhelasedhela=sebentar-sebentar:sedhela-sedhela=sebentarsebentar:resik-resik=bersihbersih:resikresik=bersih-bersih:macul=mencangkul:ditakoni=ditanyai:resepe=resepnya:rakyate=rakyatnya:ndulang=menyuapi:nadyan=meski:pratelane=penjelasan:rawuhe=datangnya:naliti=meneliti:nyathet aku=mencatatku:nyathet kowe=mencatatmu:nyathete=mencatatnya:nyathet=mencatat:kapribadene=kepribadiannya:kapribaden=kepribadian:mratelake=menjelaskan:didhaptarake=didaftarkan:ndhaptarake=mendaftarkan:nyalah=menyalah:dilakokake=dilakukan:nanggapine=menanggapinya:nanggepine=menanggapinya:nanggapi=menanggapi:nanggepi=menanggapi:ngormatine=menghormatinya:ngurmatine=menghormatinya:ngormati=menghormati:nginfeksine=menginfeksinya:nginfeksi=menginfeksi:mesthine=mestinya:ndhukunge=mendukungnya :ndhukung=mendukung :nyatetake=mencatatkan:ngobatine=mengobatinya:nambanine=mengobatinya:ngobati=mengobati:nambani=mengobati:nyumbange=menyumbangnya:nyumbang=menyumbang:paukumane=penghukumannya:paukuman=penghukuman:merhatikake=memerhatikan:nganggo=memainkan:dinggo=dimainkan:dinggo=dipakai:ditularake=ditularkan:dikorbanake=dikorbankan:saprene=sekarang :dikendalenine=dikendalikannya:dikendaleni=dikendalikan:nyalahake=menyalahkan:kaadilane=keadilannya:kasedhiyane=tersedianya:kaadilan=keadilan:kasedhiya=tersedia:nantange=menantangnya:nentange=menentangnya:nantang=menantang:nentang=menentang:saindenging=seluruhnya :akhire=akhirnya:nyathetake=mencatatkan:njalani=menjalani:dijadwalake=dijadwalkan:nimbaline=memanggilnya:nimbali=memanggil:netesake=meneteskan:cepeta=cepatlah:eling=ingat:nglali =ngelupa:eluhku =airmataku:eluhmu =airmatamu:eluhe =airmatanya:eluh =airmata:eluhe=air matanya:eluh=air mata:nglali=melupa:jarene=katanya :kemutane=teringatnya:kemutan=teringat:nimpa=menimpa:kunjarane=penjaranya:kunjara=penjara:sedelane=sebentarnya:sedela=sebentar:sadelane=sebentarnya:sadela=sebentar:sedhelane=sebentarnya:sedhela=sebentar:sadhelane=sebentarnya:sadhela=sebentar:netes=menetes:ngeterke=mengantarkan:balik=kembali:ditinggalake=ditinggalkan:ninggalake=ninggalin:ninggalake=meninggalkan:endine=mananya:mbutakake=membutakan:tratene=teratainya:trate=teratai:tapane=bertapanya:dipencloki=dihinggapi:mencloke=hinggapnya:menclok=hinggap:lalere=lalatnya:laler=lalat:dhekepe=peluknya:didhekepe=dipeluknya:ndhekepe=memeluknya:dhekep=peluk:didhekep=dipeluk:nyikep=memeluk:didumake=dibagibagikan:didumake=dibagi-bagikan:didum=dibagibagi:didum=dibagi-bagi:mecahake=memecahkan:diramekake=disemarakkan:iwak bakare=ikanbakarnya:iwak bakar=ikanbakar:petene=petainya:pete=petai:dicawisake=dihidangkan:ucul=terlepas:sudut =sudutt:sekadar =sekedar:tandhani=cirikan:ditandhani=dicirikan:ngalamine=mengalaminya:diutarakake=diutarakan:manfaat =bermanfaat:sekalian =bangetan:sekalian =bangetgus:ngapa=ngapain:aku =gue:ngrasakake=ngerasain:dipastikake=dipastiin:susule=susulnya:disusule=disusulnya:nyusule=menyusulnya:nyusul=menyusul:uculake=lepaskan:nguculake=melepaskan:nguculake=melepas:kanteben=keberatan:ditangkarake=ditangkarkan:njegrak=jabrik :tinentu=tertentu:thuntheng=legam:itheng=hitam:adon=aduan:swarane=suaranya:dingune=dipeliharanya:dingu=dipelihara:daginge=dagingnya:dimupangatake=dimanfaatkan:kluruke=kukuruyuknya:kluruk=kukuruyuk:garudha=elang:ngentekake=menghabiskan:santap=santapan :sumadiya=tersedia:wulune=bulunya:wulu=bulu:jalune=tajinya :jalu=taji :pabedan=perbedaan:keperlone=keperluannya:kaperlone=keperluannya:keperlon=keperluan:nyediyakake=menyediakan:nelakake=menjelaskan:mandhule=mandulnya:mandhul=mandul:cerake=dekatnya:pangendhoge=petelurnya:pangendhoge=penelurnya:pangendhog=petelur:pangendhog=penelur:ingone=peliharaannya:ingoningone=peliharaannya:ingon-ingone=peliharaannya:ingon=peliharaan:ingoningon=peliharaan:ingon-ingon=peliharaan:kopen=terpelihara:diingune=dipeliharanya:diingu=dipelihara:lindune =gempabuminya:lindune=gempanya:ditimbulake=ditimbulkan:nuduhake=menunjukan:sambele=sambalnya:sambel=sambal:nyana=menyangka:unggahungguhing=adab:unggahungguhe=adabnya:unggahungguh=adab:unggah-ungguhe=adabnya:unggah-ungguh=adab:terusane=selanjutnya:sakanane=seadanya:kaanane=keadaannya:gawegawe=mengada-ada:gawe-gawe=mengadaada:anakalane=adakalanya:anakala=adakala:anaana=ada-ada:ana-ana=adaada:nggatekake=acuhkan:nggatekake=acuh:preduline=pedulinya:preduli=peduli:ora mlebune=absennya:ora mlebu=absen:sah=absah:budhugen=lepra:prabote=perabotannya:prabot=perabotan:pirantine=perkakasnya:piranti=perkakas:lengganan=abonemen:lengganan=langganan:ora normale=abnormalnya:ora normal=abnormal:ngawulane=mengabdinya:ngabdine=mengabdinya:ngawula=mengabdi:ngabdi=mengabdi:kawulane=hambanya:kawula=hamba:kawula=abdi:kawulane=abdinya:mas=abang:mas=bang:nglirwakake=mengabaikan:dilirwakake=diabaikan:lirwakake=abaikan:lirwa=abai:hawa =abab:hawane =ababnya:manahmu=benakmu:manahku=benakku:duwe kesane=terkesannya:duwe kesan=terkesan:sebatane=sebutannya:sebatan=sebutan:bolonganbolongane=lubang-lubangnya:bolongan-bolongane=lubanglubangnya:bolonganbolongan=lubang-lubang:bolongan-bolongan=lubanglubang:bolong-bolonge=berlubanglubangnya:bolongbolonge=berlubang-lubangnya:bolong-bolong=berlubanglubang:bolongbolong=berlubang-lubang:bolongane=lubangnya:bolongan=lubang:kaukir=terukir:duite=uangnya:duit=uang:duwite=uangnya:duwit=uang:gambare=gambarnya:korine=pintunya:kori=pintu:saubenge=sekelilingnya:sakubengane=sekelilingnya:sabensaben=setiap:pasagi=persegi:astamiwane=istimewanya:astamiwa=istimewa:ngelompokake=mengelompokkan:nglompokake=mengelompokkan:diapite=diapitnya:ngapite=mengapitnya:ngapit=mengapit:kanyata=ternyata:karawate=terawatnya:karawat=terawat:bongkot=pangkal:bongkote=pangkalnya:ketatah=terukir:ditatahe=diukirnya:ditatah=diukir:tatahane=ukirannya:tatahan=ukiran:dipiranteni=dipirantikan:dijangkepi=dilengkapi:ngetrap=terpasang:ngisore=bawahnya:kapapar=terpapar:kapapare=terpaparnya:cahyane=cahayanya:cahya=cahaya:mancarake=memancarkan:witwitane=pohon-pohonnya:witwitane=pepohonannya:wit-witane=pohonpohonnya:wit-witane=pepohonannya:witwitan=pohon-pohon:witwitan=pepohonan:wit-witan=pohonpohon:wit-witan=pepohonan:nekuknekuk=menekuk-nekuk:nekuk-nekuk=menekuknekuk:ngandud=mengandung:kaasal=berasal:pendhudhuk=penduduk:pandhudhuk=penduduk:panemone=penemuannya:panemon=penemuan:pundhi-pundhi=pundipundi:pundhipundhi=pundi-pundi:bledheg=guntur:jisim=jasad:mbiyene=dahulunya:ngrujuke=merujuknya:ngrujuk=merujuk:candhine=candinya:candhi=candi:ngapa=mengapa:mesthekake=memastikan:ping pirang-pirang=berulangkali:manipulasi =memanipulasi:nganalisis=menganalisis:ngartikake=mengartikan:nglukisake=melukiskan:dipandeng=dipandang:artikulasikake=artikulasikan:diartikulasikake=diartikulasikan:kaya =semacam:samaceme=semacamnya:didokumentasikake=didokumentasikan:ngrumangsanine=menyadarinya:isi =berisi:katrampilan-katrampilan=keterampilanketerampilan:katrampilankatrampilan=keterampilan-keterampilan:katrampilane=keterampilannya:katrampilan=keterampilan:asringe=seringkalinya:asring=seringkali:nguntungake=menguntungkan:nduwenine=memilikinya:rumangsani=menyadari:menggok=membelok:menggokake=membelokkan:penggokake=belokkan:nyetirine=menyetirinya:nyetiri=menyetiri:nyetire=menyetirnya:nyetir=menyetir:pindhahake=pindahkan:dipindhahake=dipindahkan:mindhahake=mentransferkan:njalanake=mengoperasikan:ngrancang=mendesain:pakulinan=kebiasaankebiasaan:wenehi ngerti=menginformasikan:nalikane=manakalanya:nalika=manakala:apa-apane=sesuatunya:apa-apa=sesuatu:manahe=benaknya:manah=benak:nemploke=melekatnya:nemplok=melekat:banjur=lantas:tumindaki=menindaki:tumindak=menindak:diterusake=diteruskan:dikombinasikake=dikombinasikan:ngenaline=mengenalinya:ngenali=mengenali:gampange=mudahnya:bebayane=bahayanya:bebaya=bahaya:ijolan=pertukaran:ijolane=pertukarannya:ijolan=bertukar:ijolane=bertukarnya:disetujoni=disetujui:diwujudake=diwujudkan:araning=nama :pajege=pajaknya:pajeg=pajak:saweg=sedang:njujugake=menghantarkan:jujugake=hantarkan:ngeterake=mengantarkan:ngeter=mengantar:diter=diantar:diterake=diantarkan:kesede=malasnya:kesed=malas:pitakonmu=pertanyaanmu:pitakonku=pertanyaanku:ajokake=ajukan:jlentrehake=jelaskan:njlentrehake=menjelaskan:tuwo=tua :kagunaane=kegunaannya:kagunaan=kegunaan:dikurmatine=dihormatinya:dikurmati=dihormati:sakpadha=sesama:miduweni=mempunyai:jenise=jenisnya:katahe=banyaknya:katah=banyak:pengini=inginkan:ngasahe=mengasahnya:ngasah=mengasah:kesele=letihnya:kesel=letih:macemmaceme=macam-macamnya:macem-maceme=macammacamnya:macemmacem=macam-macam:macem-macem=macammacam:jejerake=jejerkan:dijejerake=dijejerkan:digepengake=dipipihkan:santene=santannya:santen=santan:trigune=terigunya:trigu=terigu:glepunge=tepungnya:glepung=tepung:ngembang=berkembang:nyabrang=menyebrang:bledhek=petir:ketahan=tertahan:njunjung=menjunjung:diuculake=dilepaskan:kecekel=tertangkap:anyarku=baruku:anyarmu=barumu:lungaa=pergilah:ngomong=bicara:nyopot=mencopot:ditangkep=ditangkap:moga=smoga:ngapurani=memaafkan:wadyabalane=bala tentaranya:wadyabala=bala tentara:diubengi=dikelilingi:dipateni=dibunuh:manawa=jikalau:sakku=sakuku:segampang=semudah:dibebasake=dibebaskan:pungkasan=akhir :mbebasake=membebaskan:kawentare=termasyhurnya:kawentar=termasyhur:numpas=menumpas:kaisare=kaisarnya:godhongan=daunan:dumununge=berposisinya:dumunung=berposisi:umure=usianya:mengko=mendatang:adhepadhepan=berhadapan:adhep-adhepan=berhadapan:nyicipine=mencicipinya:nyicipi=mencicipi:nembuse=menembusnya:nembus=menembus:andelane=andalannya:andelan=andalan:ngimpine=mimpinya:ngimpine=bermimpinya:ngimpi=bermimpi:apa =apakah:diragukake=diragukan:dhuwure=tingginya:putuputune=cucu-cucunya:putu-putune=cucucucunya:putune=cucunya:putuputu=cucu-cucu:putu-putu=cucucucu:putu=cucu:ucule=lepasnya:ucul=lepas:nglebonine=memasukinya:ngleboni=memasuki:mbayangake=membayangkan:sejeseje=berbeda-beda:seje-seje=berbedabeda:rana-rene=sanasini:ranarene=sana-sini:gampangake=mudahkan:nggampangake=memudahkan:manute=menurutnya:diekspresikake=diekspresikan:ujare=urainya:terangake=terangkan:nampunge=menampungnya:nampung=menampung:sumelang=gelisah:sumelange=gelisahnya:saderenge=sebelumnya:kagabunge=tergabungnya:kagabung=tergabung:kuwatire=khawatirnya:kuwatir=khawatir:ditakoki=ditanyai:karine=keterlambatan:ditakoki=ditanya:ditakoni=ditanya:kacepeng=terpegang:dicepenge=dipegangnya:dicekele=dipegangnya:dicepeng=dipegang:dicekel=dipegang:kayane=sepertinya:pintere=pintarnya:pinter=pintar:ditekani=didatangi:nyorot=menyorot:kapetung=terhitung:ngrealisasikake=merealisasikan:nawakake=menawarkan:ngenteni=menantikan:sapasapa=siapa-siapa:sapa-sapa=siapasiapa:sinten=siapa:sopo=siapa:kaleh=dengan:opo=apa :rungokake=dengar:nggugu=memercayai:wungkal=batu asah:tumungkule=menunduknya:tumungkul=menunduk:ndungkluke=merunduknya:ndungkluk=merunduk:njerumusake=menjerumuskan:jerumusake=jerumuskan:dijerumusake=dijerumuskan:digdaya=sakti:nyesatake=menyesatkan:sesatake=sesatkan:disesatake=disesatkan:tegesteges=arti-arti:teges-teges=artiarti:tegestegese=arti-artinya:teges-tegese=artiartinya:tembungtembung=kata-kata:tembung-tembung=katakata:dicithake=dicetaknya:nyithake=mencetaknya:nyithak=mencetak:cithak=cetak:dicithak=dicetak:nyengiti=membenci:disengiti=dibenci:pokoke=pokoknya:melumelu=ikut-ikutan:melu-melu=ikutikutan:sengit aku=membenciku:sengit kowe=membencimu:pamisahan=pemisahan:piro=berapa :ngakoni=mengakui:dirasakake=dirasakan:pitakone=tanyanya:pitakon=pertanyaan:pemodhalan=pemodalan:pamodhalan=pemodalan:ngerteni=mengetahui:cathethane=catatannya:cathethan=catatan:sewulane=sebulannya:sawulane=sebulannya:sewulan=sebulan:sawulan=sebulan:ditakokake=ditanyakan:gegayuhane=citacitanya:gegayuhane=cita-citanya:gegayuhan=citacita:gegayuhan=cita-cita:nggoda=menggoda:gawe=bikin:jajal=cobain:upama=andaikan:digantungake=digantungkan:nggantungake=menggantungkan:nggumantungake=menggantungkan:balbalan=sepak bola:bal-balan=sepakbola:kalah =kekalahan:diandhegake=dihentikan:adhepi=hadapi:ngalahake=mengalahkan:kalahe=kalahnya:dikalahake=dikalahkan:mandhege=terhentinya:mandheg=terhenti:kasingkire=tersingkirnya:kasingkir=tersingkir:kesandhunge=tersandungnya:kesandhung=tersandung:mlajune=melajunya:mlaju=melaju:nglakonine=melakoninya:nglakoni=melakoni:njamu=menjamu:miwitine=memulainya:miwiti=memulai:ngimpi=mimpi:paling abote=terberatnya:paling abot=terberat:iwake=ikannya:kawewengkonan=kewilayahan:kacilakane=kecelakaannya:kacilakan=kecelakaan:kegiyatane=kegiatannya:kegiyatan=kegiatan:kamanungsane=kemanusiaannya:kamanungsan=kemanusiaan:pangungsene=pengungsiannya:pangungsen=pengungsian:nanggulangi=menanggulangi:undhangundhang=undang-undang:undhang-undhang=undangundang:katertibane=ketertibannya:kaamanane=keamanannya:katertiban=ketertiban:kaamanan=keamanan:mbantu=membantu:pendukunge=pendukungnya:kakuatan=kekuatan:memberdayakake=memberdayakan:tapel=tapal:ngamanake=mengamankan:obahan=pergerakan:ngatasi=mengatasi:nglindhungi kowe=melindungimu:nglindhungi aku=melindungiku:nglindungine=melindunginya:nglindhungine=melindunginya:nglindungi=melindungi:nglindhungi=melindungi:kautuhan=keutuhan:mertahanake=memertahankan:kadhaulatan=kedaulatan:katentuan=ketentuan:kukum=hukum:nganut=menganut:kawicaksanan=kebijaksanaan:nuruti=menuruti:kadidik=terdidik:kalatih=terlatih:sadhuwure=atasnya:sulaya=bertentangan:sulayani=menentangi:nyulayani=menentangi:ngayahi=menjalankan:tugase=tugasnya:njejegake=mengokohkan:diresmekake=diresmikan:pungkasane=akhirnya:panganggep=anggapan:ngreksa=menjaga:disiapake=disiapkan:parentah=perintah:ngisore=bawahnya:punjere=sentralnya:punjer=sentral:kaprajuritan=keprajuritan:madeg=berdiri :diwengku=dipangku :sakbenere=sebenarnya:umumake=umumkan:diumumake=diumumkan:nggantekake=menggantikan:diwengku=dipangku :tapakasmane=tandatangannya:tapakasma=tandatangan:tapakasmani=tandatangani:ditapakasmani=ditandatangani:disahake=disahkan:disahke=disahkan:kapulisene=kepolisiannya:kapulisen=kepolisian:digabungake=digabungkan:bingung=kebingungan:mbubrah=mengacaukan:njumbuhake=menyesuaikan:ngundang=mengundang:dibutuhake=dibutuhkan:rudu=debat:diperdebatake=diperdebatkan:diwadhani=dijuluki:madhani=menjuluki:madhani =menyamai:tandani=tandai:tandhani=tandai:nandhani=menandai:ngolehake=mengizinkan:mungkinake=memungkinkan:simpen=simpan:terjemahake=terjemahkan:ngoreksine=mengoreksinya:ngoreksi=mengoreksi:kasurung=terdorong:sinaoni=pelajari:sinauni=pelajari:rapikake=rapikan:nyediakake=menyediakan:nyedyakake=menyediakan:ngowah=mengedit:rewangan=bantuan:lebokake=masukkan:ngisi=mengisi:andhap asore=rendahhatinya:andhap asor=rendahhati:apik atine=baikhatinya:apik ati=baikhati:ngrespone=meresponnya:ngrespon=merespon:alesanmu=alasanmu:alesanku=alasanku:alesane=alasannya:alesan=alasan:wenehi=berikan:dhukungan=dukungan:dhukungane=dukungannya:sengkuyungan=dukungan:sengkuyungane=dukungannya:nuruti=menuruti:nemtokake=menentukan:sumebare=menyebarnya:dituladhanine=diteladaninya:nuladhanine=meneladaninya:dituladhani=diteladani:nuladhani=meneladani:prilakune=perilakunya:prilaku=perilaku:pendhukunge=pendukungnya:pendhukung=pendukung:satriyane=satrianya:satriya=satria:pesene=pesannya:pralambang=perlambang:urmat=hormat:kajujuran=kejujuran:kasabaran=kesabaran:sajerone=sedalamnya:ditujokake=ditujukan:ditujukake=ditujukan:pathokan=patokan:kakandhut=terkandung:kandhutan=kandungan:dak =takk:dilestarekake=dilestarikan:priya=pria:kalodhangane=kesempatannya:kalodhangan=kesempatan:panulisane=penulisannya:panulisan=penulisan:prabedane=perbedaannya:prabedan=perbedaan:sejene=perbedaannya:tradhisionale=tradisionalnya:tradhisional=tradisional:samulihe=sepulangnya:kerawuhan=kedatangan:bebungah=hadiah:nomnoman=pemuda:nom-noman=pemuda:ngandarake=memberitahukan:ngandharake=memberitahukan:diadani=diadakan:maneh =laggi:ndesak=mendesak:ngadu-adu=menghasut:mbatalake=membatalkan:dialangi=dihalanghalangi:dialangi=dihalang-halangi:dialangalangi=dihalang-halangi:ngusire=mengusirnya:ngrebute=merebutnya:ngusir=mengusir:ngrebut=merebut:sawiyar=seluas:saamba=seluas:sawiyare=seluasnya:saambane=seluasnya:sajembare=seluasnya:sajembar=seluas:mbiwara=mengumumkan:ngumumake=mengumumkan:kapeksan=terpaksa:kapeksa=terpaksa:seratan=tulisan:samestine=semestinya:kapilih=terpilih:kamuliaan=kemuliaan:dimuliakake=dimuliakan:dimulyakake=dimuliakan:wengiwengi=malam-malam:wengi-wengi=malammalam:dibandingake=dibandingkan:astimiwa=istimewa:astimiwane=istimewanya:sakiwa-tengene=kirikanannya:sakiwatengene=kiri-kanannya:ngandut=mengandung:dijelasake=dijelaskan:pangemutan=pengingat:pertandha=pertanda:sakitere=sekitarnya:gambalang=gamblang:istimiwane=istimewanya:istimiwa=istimewa:kaistimiwaan=keistimewaan:mudhunake=turunkan:mbengi=malam:dipengetake=diperingati:mengetake=memeringati:dipangetake=diperingati:mangetake=memeringati:dipangeti=diperingati:mangeti=memeringati:dipengeti=diperingati:mengeti=memeringati:omah-omah=berkeluarga:bebrayan=warga:crah=pertikaian:gumelar=terbentang:kapiyarsa=memdengar:kawruhana=mengertilah:kendurinan=pesta:kentun=ketinggalan:kantun=ketinggalan:kari=ketinggalan:kecrobohane=kecerobohannya:ketledhorane=keteledorannya:ketledhorane=kelalaiannya:kecrobohan=kecerobohan:ketledhoran=keteledoran:ketledhoran=kelalaian:meri=anak itik:lelabuhan=pengorbanan:enggala=buruburu:enggala=buru-buru:miwah=juga:miwa=juga:mupangate=manfaatnya:mupangate=manfaat:ndadrane=menjadijadi:ndadi=menjadijadi:ndadi=menjadi-jadi:ngancik=bertumpu:ngawistara=kentara:nggulawentah=menasehati:ngumbara=berkelana:ngupakara=berusaha:direken=diperhatikan:nggatekake=memerhatikan:digatekake=diperhatikan:diperhatikake=diperhatikan:paraga=pelakon:pralaya=meninggal:prayogane=pantasnya:prayoga=pantas:rahayune=selamatnya:rahayu=selamat:rina=siang:sabarang=sembarang :santosa=kokoh:sareh=sabar:kemrungsung=tergesagesa:kemrungsung=tergesa-gesa:uwuhe=sampahnya:uwuh=sampah:winarna=dikatakan:wurunge=urungnya:nyuda=mengurangi:suda=berkurang:kaanggotaan=keanggotaan:dhindhinge=dindingnya:dhindhing=dinding:temboke=dindingnya:tembok=dinding:ditepungi=ditemukan:ditampa=diterima:panglompokane=pengelompokannya:tinamtu=tertentu:pranyata=ternyata:panyengkuyung=pendukung:dharat=darat:pangowah=pengubah:wewiji=berbiji:kendhang=gendang:dikendhangi=digendangi:digawea=dibuatlah:ngolehake=dapatkan:diolehi=diperoleh:diolehi=didapat:diolehi=didapatkan:dhaerahe=daerahnya:diundhuh=diunduh:cendhek=pendek:ditandur=ditanam:serate=seratnya:ngundhakake=menaikkan:nandang=terkena :ancase=tujuannya:ancase=sasarannya:dianjurke=dianjurkan:panalitene=penelitiannya:panaliten=penelitian:ngrangsang=merangsang:ngisolasi=mengisolasi:panaliti=peneliti:ndeteksi=mendeteksi:ngundhakake=menaikkan:nurunake=menurunkan:nggodhog=menggodog:nggodhog=merebus:wurwurane=taburannya:kenthange=kentangnya:kenthang=kentang:ngimpor=mengimpor:ngoptimalke=mengoptimalkan:sedhepe=sedapnya:sedhep=sedap:liya-liyane=lainlainnya:liyaliyane=lain-lainnya:digodhog=direbus:godhog=rebus:diwuwurake=ditaburkan:diwuwuri=ditaburi:wuwuran=taburan:dikasilake=dihasilkan:kaserat=tertulis:ngabungake=menggabungkan:kalaksanan=dilaksanakan:yudhikatif=yudikatif:dhemokrasi=demokrasi:murub=menyala:brambang=bawang merah:pucuking=pucuk :tigan=telur:bundhering=bulat :manawi=kalau:nglambangake=melambangkan:nedahake=menunjukkan:partene=partainya:parte=partai:nunjukake=menunjukkan:seserahan=penyerahan:pamulaan=permulaan:kawitane=bermulanya:kawitan=bermula:wawitane=permulaannya:wiwitan=permulaan:ditindhakake=dilakukan:mlebete=masuknya:owah-owahan=perubahan:sanes=bukan:sanes=lain|bukan:andadosake=menjadikan:dipendhet=diambil:toya=air:asalusule=asal-usulnya:asal-usule=asalusulnya:ngangge=menggunakan:mligine=khususnya:gunggunge=jumlahnya:gunggung=jumlah:krajane=kerajaannya:caket=dekat:wewatesan=berbatasan:ngantos=sampai :dhasaring=dasar:andhap=rendah:seganten=samudera:kainggilan=ketinggian:inggil=atas:kilen=barat:ler=utara:jawi=jawa :wiyare=luasnya:krajan=kerajaan:kaelih=terpindah:jare=katanya :watese=batasnya:tafsire=tafsirnya:bates=batas:dienggoni=dihuni:jarake=jaraknya:kepuloan=kepulauan:ngupaya=berupaya:nyambut gawe=bekerja:ngabdikake=mengabdikan:muji=memuji:nggumun=mengagumi:ngapresiasi=mengapresiasi:dituku=dibeli:nyambut=menyambut:karire=karirnya:vidhio=video:gawene=buatnya:ngunggulake=mengunggulkan:tembangane=lagunya:tembangan=lagu:kemayu=sok cantik:judhul=judul:judhule=judulnya:ngrampungake=menyelesaikan:ngrampungake=merampungkan:nembangake=menyanyikan:disengkuyung=didukung:waninan=pemberani:ngreka=merekayasa:ngunggulke=mengunggulkan:njalin=menjalin:dikabarake=dikabarkan:pawartakake=memberitakan:dipawartakake=diberitakan:keora=ketidak:kepriyea=bagaimanapun:diluncurake=diluncurkan:dipopulerake=dipopulerkan:ngluncurake=meluncurkan:rampunge=berakhirnya:rampung=berakhir:cedhake=kedekatan:menangake=memenangkan:nggawakake=membawakan:paling larange=termahalnya:matok=mematok:jalaran=dikarenakan:ngaterake=menghantarkan:tanah air=tanahair:tanah aire=tanahairnya:diciptakake=diciptakan:digawe=diciptakan:sagedhe=sebesar:paling dhuwure=tertingginya:direwangi=dibantu:salubare=seusai:gawakake=bawakan:digawakake=dibawakan:ndongkrak=mendongkrak:ngapusi=bohong:jalarane=lantarannya:amarga=lantaran:awit=sedari:nyetujui=menyetujui:nyetujuine=menyetujuinya:sekolah =bersekolah:sabapa=seayah:kuwalon=tiri:ngrilis=merilis:nuduhake=memerlihatkan:nulak=menolak:nolak=menolak:mrambah=melebar:mbusake=menghapusnya:mbuseke=menghapusnya:nekani=menghadiri:mbentur=membentur:macakake:ndedikasikake=mendedikasikan:kerja sama=bekerjasama:anyare=terbarunya:kowe lah=kaulah:nyutradarai:kowe=kau:njembari=melebarkan:nembang=menyanyikan:nyumbangake=menyumbangkan:tumut=turut:kondhang=ternama:mbintangi=membintangi:nggayuh=meraih:ngrasani=menggosip:dirasani=digosipkan:emoh=enggan:nukangi=menukangi:pengalaman =berpengalaman:karo kae=kepadanya:kanggo kae=baginya:dipadhakake=dibandingbandingkan:dipadhakake=dibanding-bandingkan:ngganteni=menggantikan:tekane=kedatangannya:ketekanan=kedatangan:nggondol=menggondol:kangen=merindukan:manggul=memanggul:dipanggoni=dihuni:age-age=segera:mulihe=sepulangnya:mulihe=sepulang:mulihe=pulangnya:mulihe=kembalinya:esuk-esuk=pagipagi:esukesuk=pagi-pagi:srawung kae=menyapanya:ngepak=mengepak:heran=terheran:mitrane=sahabatnya:mitra=sahabat:buwang=buang:mangga=marilah:mangga=mari:disediakan=disediyakake:dibuwang=dibuang:bayangkan=bayangake:mbanjiri=membanjiri:piliane=alirannya:pilian=aliran:gelenggelengake=menggelengkan:geleng-gelengake=menggelengkan:gelenggeleng=menggeleng:geleng-geleng=menggeleng:meneng=terdiam:sabara=bersabarlah:sabar =bersabar:gawa=bawa:sanajana=kalaupun:sanadyana=kalaupun:buwanga=buanglah:siji-siji:satusatu:sijisiji:satu-satu:siji-sijine:satusatunya:sijisijine:satu-satunya:terusterusan=teru-smenerus:terus-terusan=terusmenerus:diregedi=dikotori:beninge=jernihnya:bening=jernih:pegaweanku=perbuatanku:pegaweanmu=perbuatanmu:pegaweane=perbuatannya:pegawean=perbuatan:sakebake=sepenuhnya:mbuwange=membuangnya:dudu=bukanlah:nembe=barusan:nimbulake=menimbulkan:gabung =bergabung:pangan=santap:nedha=santap:nyenengake=mengasyikkan:ndang karo=seraya:mbari=sembari:karo =sambil:kedadeyan lah=terjadilah:kandha=mengobrol:kandha=ngobrol:seanane=seadanya:saanane=seadanya:ditegesi=diartikan:tandang =bertandang:kasaji=tersaji:sajikake=sajikan:nemoni=menjumpai:ditemoni=dijumpai:ditemoni=ditemui:kutha=perkotaan:temoni=temui:kadhang=acapkali:diaturake=disampaikan:nangkep=menangkap:supados=supaya :margi=jalan:mindhahake=memindahkan:angartos=mengerti:mangartos=mengerti:mangertos=mengerti:diusahakake=diusahakan:kawontenan=keadaan:pundi=mana:wekdal=waktu:ngirangi=mengurangi:diwontenake=diadakan:gampil=mudah:kedhah=harus:temtokake=tentukan:sadaya=semua:mersani=melihat:kegem=untuk:keramean=keramaian:ngirangi=mengurangi:diginakake=digunakan:anggene=posisinya:ginakake=gunakan:sakiwa=sekiri:satunggale=satunya:pintenpinten=beberapa:ngudi=mengharap:mekaten=begitu:kagem=untuk:raos=rasa:sekeca=enak:ndadosake=menjadikan:dadosake=jadikan:dadekake=jadikan:ndukung=mendukung:wontene=adanya:panguripane=penghidupannya:kangge=untuk:dilampahi=dijalani:satunggaling=salah satu:menika=itu:pamulangan=pengajaran:pasinaon=pembelajaran:kedah=harus:bilih=bila:gesang=hidup:tiyang=orang:sampun=sudah|jangan:jejibahane=kewajibannya:jejibahane=tugasnya:jejibahan=kewajiban:jejibahan=tugas:mangkono lah=demikianlah:online=online:klairan=kelahiran:dhuwuring=tinggi:nyambungake=menghubungkan:panemu=penemu:ngancik=menanjak:dipracaya=dipercaya:patuwuhan=pertumbuhan:disumurupi=diketahui:penganggo=pemakai:panganggo=pemakai:pangguna=pemakai:wewacan=bacaan:malaekat=malaikat:nyawijekake=menyatukan:didunake=diturunkan:panutup=penutup:turunake=diturunkan:sekabehane=keseluruhannya:sekabehane=keseluruhnya:sakabehane=keseluruhannya:sakabehane=keseluruhnya:sakabehane=kesemuanya:sekabehane=kesemuanya:kaji=haji:jakat=zakat:ramelan=ramadhan:sewengi=semalam:sawengi=semalam:ngugemi=meneguhkan:dikandut=dikandung:dikandhut=dikandung:netepi=menetapkan:nyekseni=bersaksi:setunggal=satu:sekawan=empat:sedasa=sepuluh :sepuluh=sepuluh:asma=nama:dilairake=dilahirkan:ngluluhake=meluluhkan:manahe=hatinya:prigel=ahli:pinten=berapa:mbenten-bentenake=membedabedakan:mbentenbentenake=membeda-bedakan:mangka=sehingga:alite=kecilnya:alit=kecil:taksih=masih:tilar=tinggal :sesarengan=bersamaan:bebarengan=berbarengan:bebarengan=bersamaan:demenaning=kesukaan:widodarine=bidadarinya:widodari=bidadari:sanese=lainnya:prameswarine=permaisurinya:tandhingan=tandingan:tandhingane=tandingannya:kamangkan=makanya:panjalmaning=penjelmaan :panjalman=penjelmaan:kekasining=kekasih :sekti=sakti:samanten=dahulu:nyowek=menyobek:kabungkus=terbungkus:samodra=samudera:sagara=samudera:kuwasanya=kuasanya:kuwasa=kuasa:ngagem=menggunakan:pikantuk=punya:prameswuri=permaisuri:kalih=dua:ngancurake=menghancurkan:kakuwatane=kekuatannya:kakuwatan=kekuatan:landhepe=tajamnya:landhep=tajam:kukuh=kokoh:panggalihe=pikirannya:amargi=karena:panjenengane=dianya:gadah=mempunyai:sederek=saudara:sedereke=saudaranya:saha=dan juga:kagungan=mempunyai:pamenange=pemenangnya:pamenang=pemenang:kesaenan=kebaikan:saged=bisa :tinulung=menolong:jejuluk=julukan:dadose=jadinya:dados=jadi:panitisane=penitisannya:panitisan=penitisan:gangsal=lima :sedhereke=saudaranya:sedherek=saudara:nate=pernah:kapercayane=kepercayaannya:kapercayan=kepercayaan:kaprecayane=kepercayaannya:kaprecayan=kepercayaan:nerjang=menerjang:garwane=pasangannya:pandhawa=pandawa:ngakene=mengakunya:ngaken=mengaku:pinulung=penolong:pitedah=petunjuk:pituduh=petunjuk:pendhiri=pendiri:basan=berbahasa:pawicara=pembicara:saluwihe=selebihnya:wiwitan=awal :dianakake=diadakan:wicara=bicara:masarakate=masyarakatnya:sajabane=seluarnya:nuswantara=nusantara:enggal=cepat|baru:sakabeh=semua:peradhaban=peradaban:padunung=penempat:pambageyan=pembagian:sadonya=sedunia:wus=sudah:kapadhetane=kapadatannya:pendhudhuke=penduduknya:pandhudhuke=penduduknya:ing kae=padanya:nguterake=memutarkan:sadulursedulur=saudara-saudara:sadulur-sedulur=saudarasaudara:sadulursedulure=saudara-saudaranya:sadulur-sedulure=saudarasaudaranya:disepata=dikutuk:jemparing=anak panah:jemparinge=anak panahnya:ature=aturnya:dipretheli=dicopoti:digugure=gugurnya:tumekaning=datang :kelairan=kelahiran:nglabuhi=berlabuh:dijagakake=dijagakan:kakang=kakak:kakange=kakaknya:mbelani=membela:mbelani=membelai:mumur=lebur:ajur=hancur:sewot=marah:becike=bagusnya :ngalengka=alengka:klirune=kelirunya:kliru=keliru:tindake=kelakuannya:prajurite=prajuritnya:nyerbu=menyerbu:dipandhegani=diketuai:ngumpulake=mengumpulkan:didhusta=dibohongi:ndhusta=membohongi:nggarwa=menikahi:garwane=pasangannya:kepengin=ingin:jagad=bumi :jagad=alam :precayane=percayanya:precaya=percaya:kadiran=mentangmentang:kadiran=mentang-mentang:ngadirake=mentang-mentang:srakahe=serakahnya:srakah=serakah:njalari=menyebabkan:nulari=menulari:mangkene=begini :anduweni=mempunyai:dicaosake=diberikan:disilihake=dipinjami:disilihake=dipinjamkan:turahe=sisanya:turah=sisa:luwihe=sisanya:luwih=sisa:astine=astine:tiwas=tewas:nangis=menangis:sesebutan=sebutan:kawiwitan=termulai:sakabehing=semua:kasekten=kesaktian:wutane=butanya:wuta=buta:pengawale=pengawalnya:ngabekti=berbakti:tlatene=telatennya:tlaten=telaten:temen=serius:asipat=bersifat:ndeloke=menontonnya:ndelok=nonton:ndelok=menonton:ndeleng=menontonnya:ndeleng=nonton:ndeleng=menonton:tetembungan=perkataan:dibalekake=dikembalikan:disebutake=disebutkan:kasebut=disebutkan:gawea=buatlah:mlampahake=menjalankan:mlakokake=menjalankan:fungsine=berfungsinya:fungsi =berfungsi:dumunung=berlokasi:dumununge=berlokasinya:rewangi=bantulah:ndandani=memerbaiki:karo=beserta:ora=ngga:wis=udah:baleni=ulangi:mbalen=mengulang:dibalen=diulang:balen=ulang:mbaleni=mengulangi:dibaleni=diulangi:ngampile=meminjamnya:ampile=pinjamnya:diampile=dipinjamnya:ngampil=meminjam:ampil=pinjam:diampil=dipinjam:diampilake=dipinjamkan:pegawe=pegawai:wiwitane=mulanya:nglambangake=melambangkan:diolehi=diperkenankan:nganggone=memakainya:ditampilake=ditampilkan:ringkih=lemah:ditulisake=dituliskan:diseratake=dituliskan:mbubarake=membubarkan:awit=semenjak:mrene-mrene=mrenesini:menemene=kesini-sini:mene-mene=kesinisini:mrenemrene=kesini-sini:mrene-mrene=kesinisini:nyerminake=mencerminkan:ijen=sendirian:kawinane=perkawinannya:sakwalike=sebaliknya:caritacaritane=cerita-ceritanya:carita-caritane=ceritaceritanya:wedoke=perempuannya:wadone=perempuannya:wadone=wanitanya:caritacarita=cerita-cerita:carita-carita=ceritacerita:wedok=perempuan:senenge=sukanya:separone=separuhnya:separo=separuh:pawujudane=perwujudannya:pawujudan=perwujudan:nggabungake=menggabungkan:nggabung=menggabung:digambarake=digambarkan:dimungkinake=dimungkinkan:ngirimine=mengiriminya:ngirimi=mengirimi:nglebokake=memasukkan:duwe pola=berpola:tampilake=tampilkan:dakmasak=kumasak:kokmasak=kaumasak:dinesoni=dimarahi:nesoni=memarahi:kasunyatane=kenyataannya:kasunyatan=kenyataan:masake=memasaknya:masak=memasak:pagaweane=pekerjaannya:ananging=melainkan:yaiku=yakni:paling cilik=terkecil:dandani=perbaiki:kembangake=kembangkan:masang=memasang:buatlah=gawea:ngganti=mengganti:sida=jadi :njagakake=menjagakan:tumindake=tindakannya:seksine=saksinya:lengane=minyaknya:lenga=minyak:ngedum=membagi:dum=bagi :nggo=untuk:abang-abang=merahmerah:abangabang=merah-merah:lambene=bibirnya:lambe=bibir:bebudene=budinya:bebudine=budinya:ciblek=pelacur:asor=rendah:endhep=rendah:pendhek=pendek:nggoleki=mencari:nyolong=mencuri:emaneman=merasa sayang:eman=sayang :keduman=kebagian:tai=tahi:mbalang=melempar:dibeciki=dibaiki:mbeciki=menghargai:piwales=balasan:gunem=bicara:narima=menerima:nrima=menerima:panarima=penerima:rempela=ampela:ngrogoh=merogoh:kumpulaning=kumpulan :uyuhe=kencingnya:uyuh=kencing:sadane=lidinya:alingalingane=berpenghalangnya:aling-alingane=berpenghalangnya:nguyuhe=kencingnya:sada=lidi:alingalingan=berpenghalang:aling-alingan=berpenghalang:nguyuh=kencing:ndandanine=memerbaikinya:nglakonine=melakukannya:delikake=sembunyikan:umpetake=sembunyikan:ndelikake=menyembunyikan:ngumpetake=menyembunyikan:bagean=bagian :ngyakinke=meyakinkan:ngyakinake=meyakinkan:nglawan=melawan:mbela=membela:mbelanine=membelanya:ngendika=ngomong:pangadeg=pendiri:nemokake=menemukan:nyambutgawe=kerja:nyisipake=menyisipkan:nyaranake=menyarankan:nyampekake=menyampaikan:ditetepake=ditetapkan:manfaatake=memanfaatkan:digampangake=dimudahkan:luwihluwih=terlebih:luwih-luwih=terlebih:ngangelake=menyulitkan:dikulintenake:dibiasakan:ngeluhake=mengeluhkan:mulang=mengajarkan:angele=sulitnya:ngenteni=menanti:dinanti=dienteni:didandanine=diperbaikinya:didandani=diperbaiki:sathithik-sathithike=sedikitsedikitnya:sathithiksathithike=sedikit-sedikitnya:sathithik-sathithik=sedikitsedikit:sathithiksathithik=sedikit-sedikit:ditambahake=ditambahkan:pastekake=pastekan:tulisake=tuliskan:manggon=bersemayam:manggone=bersemayamnya:pepak=lengkap:ngrayakake=merayakan:lajeng=kemudian:ngrapekake=merapikan:ditancepake=ditancapkan:ayeme=damainya:wilangan=bilangan:wilangane=bilangannya:dinten=hari:kosokbalen=kosokbalen (lawan kata):panuntun=penuntun:sarana=dengan sarana:panganggoning=pemakaian :panganggone=pemakaian:pitembungan=kata-kata:mbesut=membesut:wedhi=pasir :kaca=laman:wedharaning=pembahasan :ngemu=memuat:kawedharake=terpaparkan:mbangun=membangun:sugeng=selamat:keulang=terulang:kebalen=terulang:disik=duluan:paling gedhene=terbesarnya:wedi=ketakutan:wektu=disaat:nggawene=membuatnya:ketemu=bertemu:mutusake=memutuskan:karepe=kemauannya:karepe=kemauan:nyuwarakake=menyuarakan:nywarakake=menyuarakan:disuwarakake=disuarakan:diswarakake=disuarakan:crita=kisah:sakepiye=sebagaimana:sakepriye=sebagaimana:ngeduke=menggalinya:ngeduk=menggali:dipadhakake=disesuaikan:kaamot=dimuat:uripe=kehidupannya:mraktekake=memraktikkan:tamtu=tentu:kaengah=tersisa:sabenere=sesungguhnya:wae=semata:apike=sebaiknya:nganggo=memergunakan:natani=membenahi:ngulinakake=pembiasaan:biyasa=biasa:kulinakake=biasakan:ngulinakake=membiasakan:dicawisake=disajikan:diareparep=diharapkan :diarep-arep=diharapkan:arep-arep=harapkan:crita=berceritera:dijembari=diperluas:kasusastran=kesastraan:diprelukake=diperlukan:diprelokake=diperlukan:basan=berbahasa:mengko=kelak:mata =mataa:nguji=menguji:mulane=karenanya:kasugihan=kekayaan:kumpulan=himpunan:dirapekake=dirapikan:prelu=perlu:nggetunake=miris:nyedihake=menyedihkan:mbingungake=membingungkan:pandhengpandhengan=berpandangan :pandheng-pandhengan=berpandangan:suwarane=suaranya:seru=keras :ndadak=mendadak:tandha-tandhane=tandatandanya:tandhatandhane=tanda-tandanya:tandha-tandha=tandatanda:tandhatandha=tanda-tanda:mbatin=membatin:mertamu=bertamu:kancaku=temanku:kancamu=temanmu:gudhang=gudang:gudhange=gudangnya:tulunglah=tolonglah:mulane=makanya:ajeng=akan:niki=ini:niku=itu:keleresan=kebetulan:ngrembuk=membahas:napa=apa :bapake=bapaknya:guneme=bicaranya:nggih=ya:ya=ya:mawon=saja:mlebet=masuk:mangke=nanti:kekarepane=keinginannya:eling=sadar:diparingi=dikasih:alon=pelan:alonalon=pelan-pelan:alon-alon=pelanpelan:ngundhuh=memanen :nandhur=menanam:getun=jengkel:apakake=apakan:karepe=keinginannya:pracaya=percaya:dikandani=dinasehati:larane=sakitnya:njaluki=mintai:njaluki=memintai:bakale=bakalan:kijange=kijangnya:mobile=mobilnya:dewekan=sendirian:dhewekan=sendirian:sebab apa=mengapa:pendhidhikane=pendidikannya:pendhidhikan=pendidikan:cerkake=cerpennya:cerkak=cerpen:isuk=pagi:katelu=ketiga:kaloro=kedua:kapapat=keempat:kalima=kelima:kaenem=keenam:kapitu=ketujuh:kawolu=kedelapan:kasanga=kesembilan:kasepuluh=kesepuluh:sudhut=sudut:suketan=rerumputan:pandhang=pandang:kadohan=kejauhan:merga=karena:mlayokake=melarikan:mangkat=berangkat:budhal=berangkat:njaluk=minta:sedhela=sebentar:sabrang=sebrang:dadosipun=jadinya:olehku=aku :simbahe=mbahnya:sregep=rajin:sabrebetan=sekilas:kapethik=terpetik:disinau=dipelajari:nyinau=belajar:kanangapa=mengapa :raup=cuci muka:digawa=dibawa:bodhone=bodohnya:bodho=bodoh:srakah=serakah:kudhu=harus:enthute=kentutnya:enthut=kentut:ngenthut=kentut:oceki=kupas:ngira=mengira:tuduhna=tunjukkan:tuduhake=tunjukkan:gaweyane=kerjanya:ngentirake=menghanyutkan:kandha=bercerita:ndina=hari :mbopong=membopong:dijorokake=didorong :diunikake=dibunyikan:ngomahe=rumahnya:ngomah=rumah:kagete=kagetnya:luru=cari:kentirake=hanyutkan:dikentirake=dihanyutkan:gentigenti=bergiliran:genti-genti=bergiliran:gentigenti=bergantian:genti-genti=bergantian:gentigenti=bergilir:genti-genti=bergilir:reseki=bersihkan:resiki=bersihkan:direseki=dibersihkan:diresiki=dibersihkan:bunderane=bulatannya:bunderan=bulatan:bundherane=bulatannya:bundheran=bulatan:drijiku=jariku:drijimu=jarimu:driji-drijine=jarijarinya:drijidrijine=jari-jarinya:driji-driji=jarijari:drijidriji=jari-jari:bunderane=lingkarannya:bunderan=lingkaran:bundherane=lingkarannya:bundheran=lingkaran:ditokake=dikeluarkan:kersa=berkenan:garebeg=grebeg:lanjutake=lanjutkan:terusake=lanjutkan:nglanjutake=melanjutkan:nerusake=melanjutkan:dilanjutake=dilanjutkan:diterusake=dilanjutkan:kersane=kehendaknya:ndhisiki=mendahului:ndisiki=mendahului:miwiti=mengawali:klapane=kelapanya:klapa=kelapa:ngobah=mengubah:ngowahi=mengubahi:ngowah=mengubah:ngobahake=mengubahkan:ngowahake=mengubahkan:magrongmagronge=megahnya:magrong-magronge=megahnya:magrongmagrong=megah:magrong-magrong=megah:ibukuthane=ibukotanya:ibukutha=ibukota:pamarentahe=pemerintahnya:pamarintah=pemerintah:pamarentah=pemerintah:lawasku =lamaaku:lawasmu =lamaamu:lawase =lamaanya:lawas =lamaa:iki lah=inilah:lindu =gempa:lindhu =gempa:lindhu=gempabumi:lindu=gempa bumi:wesine=besinya:wesi=besi:ngenesake=memprihatinkan:nimba=menimba:dhuwure=atasnya:nekanine=mencapainya:pinggire=sampingnya:mburine=belakangnya:suwesuwe=lama-kelamaan:suwe-suwe=lamakelamaan:sapretelon=sepertiga:dhuwure=ketinggiannya:ngrusak=merusak:ngrusakake=merusakkan:bunder=bulat:bundher=bulat:disakseni=disaksikan:kandel=ketebalan:njabat=menjabat:siyapake=siapkan:disiyapake=dipersiapkan:kulawargane=keluarganya:nindakake=melaksanakan:dikanggokake=diperuntukkan:tugas =bertugas:nyiyapake=memersiapkan:tengenkiwane=kanan-kirinya:tengen-kiwane=kanankirinya:tengenkiwa=kanan-kiri:tengen-kiwa=kanankiri:urange=udangnya:urang=udang:duwene=milik:mugar=merenovasi:dipugar=direnovasi:nganakake=memergelarkan:latihan=berlatih:pating sliwer=lalulalang:diunggahake=ditinggikan:langgare=suraunya:langgar=surau:kudune=harusnya:samesthine=seharusnya:tilik=berkunjung:dano:danau:prentah=perintah:liya-liya=liyalain:tumpang =bertumpang:dikubengi=dikelilingi:kabehe=segalanya:kabeh=segala:namung=hanyalah:nyiyuti=memersempit:nyiyuti=persempit:diciyuti=dipersempit:sawise=selepas:sakabehe=keseluruhan:gumantung=tergantung:sabensaben=tiap-tiap:saben-saben=tiaptiap:saben=tiap:gedhong=gedung:kursi =kursii:lagi =lagii:bata=batu bata:bata =batubata:nglalekake=melupakan:dilalekake=dilupakan:nggandengake=menghubungkan:ngadeke=berdirinya:ngadege=berdirinya:jarane=kudanya:jaran=kuda:saindenge=seluruhnya:ngguncang=mengguncang:ambruk=runtuh:mbatesi=menyekat:ndampingi=mendampingi:aling-aling=penyekat:ndokok=meletakkan:mimpin=memimpin:nglibatake=melibatkan:ilange=hilangnya:ilange=lenyapnya:ilang=lenyap:nginep=menginap:dipageri=dipagari:pager=pagar:cedhake=kedekatannya:kapisahake=terpisahkan:dipisahake=dipisahkan:misahake=memisahkan:pisahake=pisahkan:werna =berwarna:pedhot=putus:sawatarane=sekitarnya:nganakake=menyelenggarakan:dilantike=dilantiknya:nglantike=melantiknya:nglaporake=melaporkan:nglantik=melantik:laporan=melapor:manggonake=menempatkan:ditanamake=ditanamkan:tandurane=tanamannya:tanduran=tanaman:nanduri=menanami:tanduri=tanami:ditanduri=ditanami:darah tinggi=darahtinggi:darah rendah=darahrendah:dhuwur=tinggi:kagawene=terbuatnya:kagawe=terbuat:sakubengan=sekeliling:belakang =burii:ketoke=kelihatannya:ketoke=tampaknya:ketok=tampak:katone=kelihatannya:katone=tampaknya:katon=tampak:sabanjure=berikutnya:rampunge=selesainya:rampung=selesai:rampungake=selesaikan:dirampungake=diselesaikan:nganggepe=menganggapnya:dicalonake=dicalonkan:arupa=berbentuk:manggon=berdiam:nyebutake=menyebutkan:hadiyah=pemberian:duwene=punya:didelikake=disembunyikan:diumpetake=disembunyikan:ditakokake=dipertanyakan:pirsanana=ketahuilah :anging=tapi:sumurup=terbenam:srengengene=mataharinya:paribasa=peribahasa:pulitik=politik:pratama=utama :tatabasa=tata bahasa:kerabate=kerabatnya:kurangluwih=kurang lebih:diperkirakake=diperkirakan:wong-wong=orangorang:wongwong=orang-orang:pirang=berapa:mbales=membalas:kasebare=tersebarnya:disebarake=disebarkan:nyebar=menyebar:nggaringake=mengeringkan:digaringake=dikeringkan:garinge=keringnya:garing=kering:preine=liburnya:prei=libur:tengahe=tengahnya:diwatesi=dibatasi:siyarane=siarannya:siyaran=siaran:anggone=sewaktunya:nggebyah=bertebaran:samana=dahulu:diterjemahake=diterjemahkan:pareng=boleh:ngalore=ke utaranya:ngidul=ke selatannya:ngetan=ke timurnya:ngulon=ke baratnya:ngalor=ke utara:ngidul=ke selatan:ngetan=ke timur:ngulon=ke barat:mlaku-mlakune=berjalanjalannya:mlakumlakune=berjalan-jalannya:mlaku-mlaku=berjalanjalan:mlakumlaku=berjalan-jalan:mlakune=berjalannya:petengpeteng=gelap-gelap:peteng-peteng=gelapgelap:ngenerake=mengarahkan:ngener=mengarah:pepenginan=keinginan:bokmanawa=barangkali:mbokmanawa=barangkali:sesirah=judul:mratela=memuat:umpetane=sembunyinya:umpetane=bersembunyinya:munine=berbunyinya:umpetan=sembunyi:umpetan=bersembunyi:muni=berbunyi:ndase=kepalanya :ndas =kepala:cendek=pendek:kodhok=kodok:dirapekake=dirapikan:dipastikake=dipastikan:dipesthekake=dipastikan:kaunggulan=keunggulan:nyingkiri=menyingkirkan:nyingkirake=menyingkirkan:ngudhunake=menurunkan:paling apik=terbaik:ambuambu=bau-bau:ambu-ambu=baubau:ngelmu=ilmu :senthong=ruangan :dereng=belum:diwasa=dewasa:pandhidhikan=pendidikan:sakebak=sepenuh:tindakake=lakukan:njero=kedalam:mrono=kesitu:mrene=kesini:mrana=kesana:eneme=enamnya:pitune=tujuhnya:sangane=sembilannya:wolune=delapannya:limane=limanya:papate=empatnya:sijine=satunya:mene=ke sini:mana=ke sana:mono=ke situ:mrene=ke sini:mrana=ke sana:mrono=ke situ:laku =lakuu:ngertine=mengertinya:mantep=mantap:diwenehi=dikasih:angger=kalau:medhoke=medoknya:nyedhaki=mendekati:aksara-aksara=hurufhuruf:aksaraaksara=huruf-huruf:pangucape=pengucapannya:pocapane=pengucapannya:pangalusan=penghalusan:kraton-kraton=keratonkeraton:kratonkraton=keraton-keraton:kraton=keraton:karajan=kerajaan:karajankarajan=kerajaan-kerajaan:karajan-karajan=kerajaankerajaan:ameh=hampir:rasakake=rasakan:ngunjungi=mengunjungi:suda=berkurang:ngliwatine=melintasinya:ngliwati=melintasi:rangda=janda:randa=janda:diwuruki=diajarin:mangkono lah=begitulah:ora=enggak:emange=memangnya:wes=sudah:yowes=ya sudah:kahananku=keadaanku:kahananmu=keadaanmu:pancene=memangnya:pancen=memang:nunggoni=menunggui:keturu=tertidur:keturon=tertidur:balesan=balasan:walesan=balasan:koe=kamu:goleken=carilah:seko=dari:apike=bagusnya:jajale=cobanya:apik=bagus:jajal=coba:lima =limaa:diduweni=dimiliki:ngakses=mengakses:dibenerake=dibenarkan:dibenerake=dibetulkan:ndhemeni aku=menyukaiku:ndhemeni kowe=menyukaimu:sejatine=sebetulnya:papan=letak:endhep=landai:adem=dingin:karine=tertinggalnya:kerine=tertinggalnya:kari=tertinggal:keri=tertinggal:kelingane=teringatnya:kelingan=teringat:dhadhane=dadanya:dhadha=dada:kempole=betisnya:pupune=pahanya:kempol=betis:pupu=paha:janggute=dagunya:janggut=dagu:teka=tiba:krungu=mendengar:ngomong=bilang:kawengen=kemalaman:kawanen=kesiangan:pantese=pantasnya:pantes=pantas:kethek=kera:kera-ne=kurusnya:geringe=kurusnya:kera=kurus:gering=kurus:kurune=kurusnya:kuru=kurus:grapyake=ramahnya:grapyak=ramah:utawane=ataupun:omongake=katakan:menawa=apabila:saorane=setidaknya:nyinaoni=memelajari:njero=dalam:mratela=merinci:mulang=mengajar:muruki=mengajari:wuruki=ajari:wuruk=ajar:diwuruki=diajari:ngajari=mengajari:nglangi=berenang:langi=renang:nglumah=berbaring:menggok=berbelok:penggok=belok:cepeng=pegang:cekel=pegang:diperes=diperas:peres=peras:meres=memeras:nggosok=menggosok:mbusak=menghapus:mbusek=menghapus:surung=dorong:nyurung=mendorong:nguncal=melempar:uncal=lempar:cancang=ikat:nyancang=mengikat:njait=menjahit:nembang=bernyanyi:miline=mengalirnya:mili=mengalir:pili=alir:abuh=membengkak:abuh=bengkak:mbeku=membeku:kambang=mengapung:segarane=lautnya:segara=laut:uyahe=garamnya:uyah=garam:watune=batunya:watu=batu:ngobong=membakar:obong=bakar:kebule=asapnya:pedhute=kabutnya:pedhut=kabut:kemebul=berasap:kebul=asap:guyu=tawa:ngguyu=tertawa:ambekan=bernafas:nyebule=meniup:nyebul=tiup:nyebul=meniup:mutah=muntah:mutahake=memuntahkan:wutahe=muntahnya:wutah=muntah:idu=meludah:idu=ludah:disedhot=diisap:sedhot=isap:nyedhot=mengisap:disedhot=dihisap:sedhot=hisap:ngisep=menghisap:owel=berat :masrahake=memasrahkan:laire=lahirnya:endhas=kepala:endhase=kepalanya:kasenengane=kesukaannya:senengane=kesukaanya:panganane=makanannya:panganan=makanan:dhawuhi=suruh:ndhawuh=menyuruh:ndhawuhi=menyuruh:didhawuhi=disuruh:dhawuh=suruh:undhangan=undangan:saperlu=untuk:kon=suruh:dikon=disuruh:mben=lusa:esuke=paginya:wingine=kemarinnya:ngongkone=menyuruhnya:dikongkone=disuruhnya:kongkone=suruhnya:esuk=pagi:wingi=kemarin:ngongkon=menyuruh:dikongkon=disuruh:kongkon=suruh:wenehake=berikan:menehake=memberikan:anadene=adapun:ewadene=walau demikian:planite=planetnya:planit=planet:sedayane=semuanya:gadhahe=punyanya:pethake=putihnya:sedaya=semua:gadhah=punya:pethak=putih:kalebete=termasuknya:kalebet=termasuk:kawangun=terbangun:rasaksane=raksasanya:raseksane=raksasanya:rasaksa=raksasa:raseksa=raksasa:bal=bola:bale=bolanya:klambine=bajunya:klambi=baju:nembe=baru :nyebarake=menyebarkan:dilebokake=dimasukkan:kabecikan=kebaikan:swarga=surga:endahing=indahnya :ngrasaake=merasakan:sadulursadulure=saudara-saudaranya:sadulur-sedulure=saudarasaudaranya:puguh=teguh:totohan=taruhan:mranamrene=kesana-kemari:mrana-mrene=kesanakemari:ngadhepi=menghadapi:rumangsa=berasa :konangan=ketahuan:nyamar=menyamar:setaun=setahun:suwene=lamanya:totohane=taruhannya:diapusi=ditipu:babbabe=hal-halnya:bab-babe=halhalnya:wewatakane=kelakuannya:dipasrahake=dipasrahkan:dhirine=dirinya:lega=luas:pati =kematian:lila=rela:dijaluk=diminta:salawase=selamanya:kagawa=terbawa:aran=nama:pakulitane=kulitnya:sanalika=seketika:dhalang=dalang:dhalange=dalangnya:asringe=seringnya:asring=sering:dipocapake=diucapkan:pedhalangan=pedalangan:sinebut=disebut:angkate=angkatnya:salugune=aslinya:lugune=aslinya:seka=dari:bun-bunan=ubunubun:bunbunan=ubun-ubun:manjing=masuk :ngomong=berkata:bontote=bungsunya:bontot=bungsu:pembarepe=sulungnya:pembarep=sulung:dlamakan=telapak:nyokote=menggigitnya:nyokot=menggigit:mangane=memakannya:mangan=memakan:ngombe=meminum:ombene=minumnya:ombe=minum:gegere=punggungnya:geger=punggung:susune =payudaranya:susu =payudara:gulune=lehernya:gulu=leher:wetenge=perutnya:weteng=perut:cokote=gigitnya:cokot=gigit:dhengkule=lututnya:dhengkul=lutut:ilate=lidahnya:ilat=lidah:untu=gigi:untune=giginya:sungune=tanduknya:sungu=tanduk:endhoge=telurnya:endhog=telur:gajihe=lemaknya:gajih=lemak:balunge=tulangnya:balung=tulang:getihe=darahnya:getih=darah:sukete=rumputnya:suket=rumput:wijine=bijinya:wiji=biji:pange=rantingnya:pang=ranting:asune=anjingnya:asu=anjing:alase=hutannya:alas=hutan:bojone=istrinya:bojone=suaminya:bojone=istrinya/suaminya:bojo=istri:bojo=suami:bojo=istri/suami:lanang=pria:lanang=lakilaki:lanang=laki-laki:komunikasi=berkomunikasi:andelake=andalkan:diandelake=diandalkan:ula=ular:ulane=ularnya:dikembangake=dikembangkan:lempeng=lurus:lempenge=lurusnya:wedok=wanita:wadon=wanita:ciyute=sempitnya:cendheke=pendeknya:cilike=kecilnya:abotmu=beratmu:abotku=beratku:abote=beratnya:ambane=lebarnya:amba=lebar:dheweke kabeh=merekanya:kowe kabeh=kaliannya:dhewekekabeh=mereka :dheweke kabeh=mereka:kowekabeh=kalian :kowe kabeh=kalian:kita =kami:awake dhewe=kita:sedhihe=sedihnya:sedhih=sedih:nalangsane=sengsaranya:nalangsa=sengsara:awatak=berwatak:panganggone=pakainya:panganggone=pemakaiannya:panganggone=penggunaannya:yakni=ya iku:nyawijine=menyatunya:nyawiji=menyatu:dijupuki=diambili:njupuki=mengambili:menawa=bahwa:medharake=memaparkan:wedharan=pemaparan:ditandani=ditandai:ditandhani=ditandai:siji =suatu:piyambake=dia:piyambake=ia:tingkatake=tingkatkan:ningkatake=meningkatkan:nambahi=meningkatkan:nguwasani=menguasai:melu=mengikuti:numuti=mengikuti:mbungahake=membanggakan:ngelingake=mengingatkan:elingake=ingatkan:ngomong=mengatakan:sanjang=mengatakan:payune=lakunya:payu=laku:didol=dijual:nampike=menampiknya:nampik=menampik:ketaman=terbuai :kena=terkena:panggodha=godaan:panggodha=bujukan:srawung=gaul:srawunge=gaulnya:wulangane=pelajarannya:maceme=macamnya:entar=kiasan :kudanane=kehujanannya:kudanan=kehujanan:kringete=keringatnya:kringet=keringat:segarane=lautannya:segara=lautan:luase=luasnya:ambane=luasnya:jembare=luasnya:gedhene=besarnya:adol=jual:pangerten=pemberitahuan:sajinise=sejenisnya:sajinis=sejenis:tuladhane=misalnya:metune=keluarnya:bokong=pantat:bokonge=pantatnya:pocong=pantat:poconge=pantatnya:enteni=tunggu:diulemi=dipanggil:dolanan=bermainmain:dolanane=bermainnya:dolanan=bermain:uleme=panggilannya:uleme=undangannya:ulem=panggilan:ulem=undangan:saadoh=sejauh:nggelar=menggelar:sesuke=besoknya:sesuk=besok:sedina=seharian:sedinane=seharinya:sadinane=seharinya:sedina=sehari:sadina=sehari:guling=berguling:rantene=rantainya:rante=rantai:buntute=ekornya:buntut=ekor:sijine =seekornya:siji =seekor:kewan=binatang:kewane=binatangnya:sewiwi=sayap:sewiwine=sayapnya:swiwi=sayap:swiwine=sayapnya:suwiwi=sayap:suwiwine=sayapnya:diudharine=dikupasnya:ngudharine=mengupasnya:diudharake=dikupaskan:diudhari=dikupas:dioceki=dikupas:udhar=kupas:ngudhari=mengupas:ngonceki=mengupas:srana=sarana:wruh=lihat:srat=tulis:serat =tulis:disrat=ditulis:diserat=ditulis:nyrat=menulis:nyerat=menulis:pluta=ringkas :dipluta=diringkas :pasugatan=sajian:winates=terbatas:nglonggarake=melonggarkan:mlenceng=melenceng:pangestu=restu:donga=doa:manah=lubuk hati:wedharake=ungkapkan:wedharing=pengungkapan :tinata=tertata:keyong=keong:pangriptane=penciptanya:pangripta=pencipta:pangarang=pengarang:pangarange=pengarangnya:nawala=surat:gendhing=gamelan:gendhinge=gamelannya:kaancem=terancam:kuwalik=terbalik:numpak=menaiki:nitih=menaiki:dekek=taruh:didekek=ditaruh:kademen=kedinginan:gawean=buatan:ngganggu=mengganggu:uwonge=orangnya:wonge=orangnya:kuciwa=kekecewaan:kuciwa=kecewa:gumun=kekaguman:gumun=kagum:dhewe=tersendiri:nambah=menambah:numpang=menumpang:genti=ganti:umure=umurnya:sithik=sedikit:pirsani=ketahui:mangerteni=ketahui:cacahing=jumlah :dijenengake=dinamakan:taunan=tahunan:geseh=selisih:let=selisih:lete=selisihnya:watara=antara:dipadhakake=dipadankan:dipadhakake=disamakan:madhep=menghadap:kagambar=tergambar:kagambarake=tergambarkan:cethane=jelasnya :nggubah=menggubah:kedher=bingung:legi=manis :wacanen=bacalah:nglairake=melahirkan:pepak=komplit:nata=menata:tumuruning=turun :kewan=hewan:tumurun=turun:tumedhak=turun:mudhun=turun:munggah=naik:mulya=mulia:kamulyane=kemuliaannya:kamulyan=kemuliaan:manembah=menyembah:mengetine=memeringatinya:dinadina=hari-hari:dina-dina=harihari:padhanane=padanannya:arane=namanya:wateke=wataknya:setu=sabtu:kemis=kamis:rebo=rabu:panulise=penulisannya:nulise=menulisnya:sataun=setahun:memerang=membagi :senen=senin:pananggalan=penanggalan:didhasarake=didasarkan:genep=genap:karolas=kedua belas:ka=ke :pisanan=pertama:nunggu=menunggu:kasapuluh=kesepuluh:mangsa=musim :wiwitane=awalnya:peredharan=peredaran:peredharane=peredarannya:kesuwen=kelamaan:kesuwen=terlalu lama:ing ngisor iki=berikutini:sawal=syawal:pasa=ramelan:besar =dzulhijjah:sela =dzulkaidah:pasa=ramadhan:rejeb=rajab:sura=muharram:sapar=safar:cuci =cucii:kanggo=berlaku:andelake=handalkan:ngandelake=menghandalkan:apa wae=apapun:dikendhaleni=dikendalikan:dikendhalenine=dikendalikannya:luwe=lapar:luwene=laparnya:wesi-wesine=besibesinya:wesiwesine=besi-besinya:wesi-wesi=besibesi:wesiwesi=besi-besi:pengepule=pengepulnya:ngranto=merantau:dhodholan=berjualan:dhodholan=jualan:wetane=timurnya:lore=utaranya:kidule=selatannya:pulo-pulone=pulaupulaunya:pulopulone=pulau-pulaunya:pulo-pulo=pulaupulau:pulopulo=pulau-pulau:pramila=maka dari itu:kata =kataa:ana =tersedia:mantap=mantep:dirungokake=didengarkan:dirungokake=didengar:nyingkat=menyingkat:nyritakake=menceritakan:ratan=jalan raya:dipentaske=dipentaskan:dipentasake=dipentaskan:jenenge=namanya:jagowane=jagoannya:sijining=satu :nampilke=menampilkan:melebu=masuk:numbuhke=menumbuhkan:dicritaake=diceritakan:biyunge=ibunya :biyung=ibu :njawab=menjawab:bener=benar:dipersembahake=dipersembahkan:ndokoke=menaruhnya:ndokok=menaruh:didokok=ditaruh:utawi=atau:diperanake=diperankan:paraga=peraga:pangimpun=penghimpun:awujud=berwujud:owahe=ubahnya:owah=ubah:diowahine=diubahnya:diowahe=diubahnya:diowahi=diubah:diowah=diubah:ngrokok=merokok:udud=merokok :nuthuk=menjitak:nagih=menagih:nyiram=menyiram:menthung=memukul :nabrak=menabrak:linggih=duduk:pagaweyan=pekerjaan:pagawean=pekerjaan:makarya=kerja:panggandheng=penyambung:antawise=antaranya :orane=tidaknya:lingga=dasar :pangucap=pengucapan:pocapan=pengucapan:obah=berubah:padhet=padat:ngandelake=mengandalkan:nyariosake=menceritakan:nyantumake=mencantumkan:jeneng=nama:mirsani=menyaksikan:maragakake=memeragakan:nulisake=menuliskan:ngayalake=menghayalkan:kauripan=kehidupan:carkak=cerpen:saking=dari:luweh=tak peduli|lebih:musatake=memusatkan:cendhak=pendek:ngamot=memuat:langkung=lebih:modheren=modern:dumugi=sampai:werni-werni=warnawarni:werniwerni=warna-warni:nyusun=menyusun:nyiptakake=menciptakan:cariyos=cerita:punika=itu:inggih=ya :boten=tidak:mratelakake=merinci:diginakake=digunakan:endah=indah:ugi=juga:kaendahan=keindahan:sajinising=jenisnya :ngarani=menamai:cawang=cabang:tuwuhing=tumbuhnya :dhasare=dasarnya:edhisi=edhisi:tinulis=tertulis:kapindho=kedua:saputeran=seputaran:saindhenging=seputaran :diarani=dinamakan:panggandheng=penyambung:nggambarake=menggambarkan:ciyut=sempit:driji=jari:drijine=jarinya:kekuwatane=kekuatannya:nasionale=nasionalnya:ndhedhesake=mendesakkan:ngamardika=kebebasan:kapengin=ingin:njajal=mencoba:tau=pernah:mardika=merdeka:mardika=bebas:didum=dibagi :ensiklopedhi=ensiklopedia:marakake=mengakibatkan:temtune=tentunya:kerepe=kerapnya:jatidhiri=jatidiri:kadaden=terjadi:wigatine=pentingnya:panulis=penulis:palu =paluu:dolan=main:mungkin =mungkinn:saya=makin:main =maen:piye=gimana:priye=gimana:ngerti=tau:lungguhe=duduknya:lungguh=duduk:mbi=dengan:prawan=gadis:liyo=lain:nglarang=melarang:nglarang aku=melarangku:mikirake=memikirkan:sekaliber =bangetber:tenane=sungguh:kelangan=kehilangan:saiki=kini:lungane=kepergiannya:tumindak-tumindak=tindakantindakan:tumindaktumindak=tindakan-tindakan:kerangke=terangkai:ilang=hilang:nglengkapi=melengkapi:mepaki=melengkapi:njangkepi=melengkapi:liwat=berlalu:diolehake=diizinkan:saikia=sekaranglah:ngungkapake=mengungkapkan:diajokake=diajukan:oraa=tidaklah:saduluran=bersaudara:sadulure=saudaranya:ngarah=mengarah:wae=belaka:kebeneran=kebetulan:sesulih=ganti :tegesake=tegaskan:ditegesake=ditegaskan:negesake=menegaskan:biyasane=biasanya:dipangan=dimakan:duweni=punyai:dakpangan=kumakan:kokpangan=kaumakan:wuwuhan=imbuhan:sangareping=depan :ngenani=tentang:ati-ati=hatihati:atiati=hati-hati:koksimpen=kausimpan:daksimpen=kusimpan:kasimpen=tersimpan:disimpen=disimpan:nyimpen=menyimpan:kasimpene=tersimpannya:disimpene=disimpannya:nyimpene=menyimpannya:tanduran=tumbuhan:dlima=delima:dlimane=delimanya:katese=pepayanya:kates=pepaya:oyode=akarnya:oyod=akar:wohe=buahnya:woh=buah:swatantra=merdeka :kemandhirian=kemandirian:macu=memacu:kabutuhan=kebutuhan:lemah=tanah:disumrambahake=disebarluaskan:usada=kesehatan :mbudidayakake=membudidayakan:mbudidaya=membudidaya:omahan=rumahan:dicekak=disingkat:tuwuhan=tumbuhan:tuwuhane=tumbuhannya:gedhange=pisangnya:gedhang=pisang:tetuwuhane=tumbuhannya:tetuwuhan=tumbuhan:nanam=menanam:nandur=menanam:kepriye=bagaimana:kancane=temannya:omong-omongan=berbincangbincang:omongomongan=berbincang-bincang:sadina-dinane=sehariharinya:sadinadinane=sehari-harinya:endahe=indahnya:ngrasakake=merasakan:duwene=punyanya:isen=isi :remen=suka:samesthine=semestinya:panuture=penuturnya:kepengen=ingin:kuwajibane=kewajibannya:kuwajiban=kewajiban:kabudayaning=kebudayaannya :kabudayane=kebudayaannya:dilestarikake=dilestarikan:nglestarikake=melestarikan:migunani=berguna:nerjemahake=menerjemahkan:lagi=sedang:ana=terdapat:wis=telah:sawektu=sewaktu:ngrasuk=merasuk:ngrasuki=merasuki:lakune=kelakuannya:pangarepane=depannya:ngarepe=depannya:bocah=anak :njinggleng=terhenyak:mergoki=memergoki:rungokake=dengarkan:anggo=pake:weruhweruh=tiba-tiba:dumadakan =tibatiba:dumadakan=tiba-tiba:pungkasan=terakhir:ngandhut=kehamilan:ngandhute=kehamilannya:ngandhute=hamilnya:umur=berumur:dakkira=kirain:ngandhut=hamil:nggawa=membawa:apa maneh=apalagi:tekan=mencapai:gawan=bawaan:kanane=sononya:bocahbocahe=anak-anaknya:bocahbocah=anak-anak:diomongake=dikatakan:ditembungake=dikatakan:jujur =terusterang:nembak=menembak:pinter=pandai:bali=kembali:tembunge=katanya:kangelane=kesulitannya:kangelan=kesulitan:bener-bener=betulbetul:rumah tangga=berumahtangga:omah-omah=berumahtangga:omahomah=berumah-tangga:nggagas=berpikiran:kebanjur=terlanjur:kebacut=terlanjur:ngarep-arep=berharap:ngareparep=berharap :padha-padha=samasama:padhapadha=sama-sama:maratuwa=mertua:bapa=ayah:umur=berusia:umur=usia:adhi=adik:mbarep=sulung:mbontot=bungsu:utawa=maupun:ateges=berarti:entuk=mendapat:katulis=tertulis:ateges=bermakna:aterater=awalan :panambang=akhiran :lesan =lisan:diijolake=ditukarkan:jejer=subjek:wasesa=predikat:candhake=setelahnya :salubare=setelahnya:urutaning=urutan :mentingake=mementingkan:dumadine=terjadinya:dumadi=terjadi:pungkasaning=akhir :panggonan=tempat:panggonane=tempatnya:akibate=akibatnya:mbuntoni=menyumbat:kamangka=padahal :mbuwang=membuang:jinis=jenis:jinise=jenisnya:kembanging=bunganya :ngelingi=mengingat:bebojoan=rumah tangga:rekasaning=sengsara :tombaking=tombak :pangareparepe=pengharapannya:pengareparepe=pengharapannya:pangarep-arepe=pengharapannya:bubrahe=hancurnya:digantungake=digantungkan:nyegah=mencegah:kembang=bunga:kembange=bunganya:mbanyu=basah :teles=basah:aning=tapi:abang=merah:pucet=pucat:tur=dan juga:iler=air liur:ilere=air liurnya:trengginas=aktif :metu=keluar:cucuke=paruhnya :cucuk=paruh :lemes=lemas:lemese=lemasnya:nandhang=menderita :antaraning=di antara:nyengkuyung=mendukung:amerga=karena:rong=dua :mbandingake=membandingkan:anjalari=membuat :irenge=hitamnya:ireng=hitam:wurung=urung:dadine=jadinya:matenge=matangnya:mateng=matang:regede=kotore:reged=kotor:resike=bersihnya:resik=bersih:ngumbah=mencuci:umbah=cuci:diumbah=dicuci:kedhelene=kedelainya:kedhele=kedelai:pamaose=pembacanya:pamaos=pembaca:merlokake=memerlukan:tarkadhang=terkadang:sifate=sifatnya:tuladhatuladha=contoh-contoh:pangertene=pengertiannya:njembarake=meluaskan:njembarake=memerluas:titis=tepat :titise=tepatnya :tinuju=tertuju:ancas=sasaran:panyambung=penyambung:pangarep=pemimpin :kriya=kerja :nyambut gawe=kerja:wacana=bacaan:dibeberake=dibeberkan:beberake=beberkan:prastawa=peristiwa:katrangane=keterangannya:katrangan=keterangan:nerangake=menerangkan:mbeberake=membeberkan:nganggit=menyusun:anggitan=karangan:dianggit=disusun:dianggit=dikarang:samadya=siap sedia:sumadya=siap sedia:ditawakake=ditawarkan:pira=berapa:ngirim=mengirim:irunge=hidungnya:kupinge=telinganya:kakiku=sikilku:kakimu=sikilmu:mripatmu=matamu:mripatku=mataku:kupingku=telingaku:kupingmu=telingamu:kuping=telinga:irungmu=hidungmu:irungku=hidungku:irung=hidung:sirahmu=kepalamu:sirahku=kepalaku:karo aku=denganku:karo kowe=denganmu:bandhing=banding:mbandhingake=membandingkan:dibandhingake=dibandingkan:bandhingake=bandingkan:nematus=enam ratus:nemewu=enam ribu:nemyuta=enam juta:nemmiliar=enam miliar:nemtriliun=enam triliun:mangewu=lima ribu:mangyuta=lima juta:mangmiliar=lima miliar:mangtriliun=lima triliun:rongmiliar=dua miliar:rongtriliun=dua triliun:rongewu=dua ribu:rongyuta=dua juta:nyuwun=mohon:nyuwun=meminta:nyuwun=minta:sangang=sembilan :limang=lima :wolung=delapan :pitung=tujuh :rongatus=dua ratus:mangatus=lima ratus:telulas=tiga belas:patbelas=empat belas:limalas=lima belas:nembelas=enam belas:pitulas=tujuh belas:wolulas=delapan belas:sangalas=sembilan belas:rongpuluh=dua puluh:selikur=dua puluh satu:rolikur=dua puluh dua:patlikur=dua puluh empat:selawe=dua puluh lima:nemlikur=dua puluh enam:seket=lima puluh:swidak=enam puluh:sewidak=enam puluh:satus=seratus:sewu=seribu:seyuta=sejuta:angsal=dapat :kulo=saya :takokake=tanyakan:aturake=sampaikan:ngajukake=mengajukan:ngajukake=mengajukan:wangsulanku=jawabanku:wangsulanmu=jawabanmu:ngasilake=menghasilkan:ngasilke=menghasilkan:prakara=persoalan:contone=contohnya:kamardikan=kemerdekaan:nyatakake=menyatakan:pranyatan=pernyataan:tentokake=tentukan:menyatakan=nyatakake:diaturi=disampaikan:ngaturi=menyampaikan:sesasi=sebulan:sasasi=sebulan:kari=terlambat:wondene=adapun:wondene=ada pun:menange=menangnya:irahan=judul :irahirahan=judul :irah-irahan=judul:irah-irahane=judulnya:irahirahane=judulnya :pirangpirang=beberapa:pirang-pirang=beberapa:dipacak=dihias:nomer=nomor:uruturutan=berturut-turut:urut-urutan=berturutturut:yakuwe=yaitu:ngarang=mengarang:ngadani=mengadakan:sasi=bulan:saoraorane=setidak-tidaknya:saora-orane=setidaktidaknya:ndherek=ikut:syarate=syaratnya:yakuwi=yaitu:ajange=ajangnya:saumur=seumur:uripe=hidupnya:dikirim =dikirimkan:nganakake=mengadakan:dalandalan=jalan-jalan:dalan-dalan=ratanjalan:takon=tanya:takon=bertanya:pangapura=maaf:pangapurane=maaf:pangapurane=maafnya:methik=memetik:alangan=halangan:alangan=rintangan:ngresikake=membersihkan:ngreseki=membersihkan:ngresiki=membersihkan:nglelarani=menyakiti:nglelara=menyakiti:lelara=penyakit:aweh=beri:dianggepe=dianggapnya:dianggep=dianggap:dikaitake=dikaitkan:digayutake=dikaitkan:mbiyen=dahulu:anugrah=anugerah:njaga=menjaga:keslametan=keselamatan:kendhi=kendi:disiyapake=disiapkan:ndonga=berdoa:kebrasilan=keberhasilan:asile=hasilnya:brasil=berhasil:kasil=berhasil:asil=hasil:ngucapake=mengucapkan:ngucap=mengucap:maksude=maksudnya:seje-seje=bedabeda:sejeseje=beda-beda:waca=baca:conto-conto=contohcontoh:contoconto=contoh-contoh:sadina-dina=seharihari:sadinadina=sehari-hari:caturan=percakapan:kenal =mengenal:mangkono=demikian:asale=berasal:dilaksanakake=dilaksanakan:diselenggarakake=diselenggarakan:liwat=melalui:disebarake=disebarkan:ngumbara=merantau:ngumbara=mengembara:regane=harganya:alamate=alamatnya:dipesen=dipesan:kandele=tebalnya:kandel=tebal:sekalian=sekaligus:ngiras=sekaligus:umume=umumnya:sutresna=pencinta:pangajab=harapan:atusan=ratusan:sirahe=kepalanya:manfaate=manfaatnya:macan=harimau:lali=lupa:diterbitake=diterbitkan:lelembut=mahluk halus:lurahe=lurahnya:pasdhiyan=persediaan:diliwatake=dilewatkan:rega=harga:kaimpun=terhimpun:sanjabane=di luar:riyaya=hariraya:ngirimake=mengirimkan:ngresakake=menginginkan :ngersakake=menginginkan:mengini=menginginkan:cepet-cepet=cepatcepat:cepetcepet=cepat-cepat:kinyiskinyis=segar :seger=segar:cepet=cepat:liwat=lewat:mundhut=beli|ambil:rawuh=datang:teka=datang:rebutan=berebut:kelakon=kesampaian:asih=kasih:tandha=tanda:riyaya=hari raya:mbutuhake=membutuhkan:nyenengi=menyenangi:nyenengi=menyukai:mbuktekake=membuktikan:bola-bali=kesanakemari:bola-bali=bolakbalik:bolabali=bolak-balik:kababar=keluar :mbiji=menilai:maringi=memberikan:menehake=memberikan:ngendikakake=bicarakan:dingendikakake=dibicarakan:ndamel=membuat:ngenyek=menghina:ngremehake=meremehkan:ngendikan=berbicara:pawongan=seseorang:ngregani=menghargai:pingin=ingin:keganggu=terganggu:semakan=simakan:wutuh=utuh:disemak=disimak:digayuh=digapai:digayuh=dicapai:tertemtu=tertentu:tujuwan=tujuan:tujuwane=tujuannya:tumuju=menuju:musatake=memusatkan:kesel=cape:kahanane=keadaannya:nyiapake=menyiapkan:dijlentrehake=diperjelas :tambahake=tambahkan:matur nuwun=terimakasih:menawa=jika:wae=aja:ngono=gitu:ngene=gini:sawalike=sebaliknya:suwalike=sebaliknya:sawangsule=sebaliknya:sawangsule=sepulangnya:kanca=kawan:ketemune=jumpanya:ketemu=jumpa:nastiti=cermat:kenceng=kencang:nyepengi=memegangi:nyekeli=memegangi:watake=wataknya:nanjakake=membelanjakan:tentrem=tentram:welut=belut:welute=belutnya:jalarane=karenanya:jalaran=lantaran:enggone=tatkala :sacukupe=secukupnya:dhuwite=uangnya:dhuwit=uang:nyepeng=memegang:nyekel=memegang:diatiati=berhati-hati:akehakeh=banyak-banyak:akeh-akeh=banyakbanyak:akehakehe=kebanyakan :akeh-akeh=kebanyakan:mengkono=begitu:gemi=hemat:gemi=berhemat:sampeyan=anda:wangsulan=jawaban:uninga=tahu:sedulur=saudara:mina=ikan:culika=tak tahu:mirunggan=khusus:bekti=bakti:mituhu=menurut:mitayani=dapat dipercaya:tenanan=sunguh-sungguh:tumemen=sunguhsungguh:tumemen=sunguh-sungguh:ditindakake=dilakukan:kasil=hasil:mikolehi=memeroleh:bab-bab=halhal:babbab=hal-hal:kawit=sejak:awit=sejak:teges=arti:dilakoni=dijalani:crita=cerita:piranti=alat:pawarta=berita:pawarta=pemberitaan:piwulang=pengajaran:wacan=bacaan:guneman=obrolan:lesan=objek :kagiyatane=kegiatannya:kagiyatan=kegiatan:diwedharake=dijelaskan:nyemak=menyimak:mirengake=mendengarkan:ribet=sukar:reribet=kesukaran:kangelan=sulit:nemahi=mengalami:nemoni=menemui:konsultasikake=konsultasikan:diskusikake=diskusikan:disarujuki=disepakati:ngrungokake=mendengarkan:warawara=pengumuman :wara-wara=pengumuman:dikumpulake=dikumpulkan:jumbuh=sesuai:digarap=dikerjakan:diprayokake=disarankan:ngukuhake=mengukuhkan:ngukuhake=menguatkan:macane=membacanya:maca=membaca:nggarap=menggarap:nggarap=mengerjakan:nyenengake=menyenangkan:nemu=menemukan:karo=terhadap:menggak-menggok=berkelokkelok:menggakmenggok=berkelok-kelok:lembu=sapi:dalane=jalannya:sapa =siapakah:lunyu=licin:lunyune=licinnya:tukonen=belilah:tukon=belian:nuku=membeli:nulisa=menulislah:tulisa=tulislah:jupuken=ambilah:jupuken=ambillah:kawruhe=pengetahuannya:kawruh=pengetahuan:bathoke=tempurungnya:bathok=tempurung:banyake=angsanya:banyak=angsa:pitike=ayamnya:pitik=ayam:laose=lengkuasnya:peleme=mangganya:pelem=mangga:laos=lengkuas:kepinterane=kepiawaiannya:kepinteran=kepiawaian:sewelas=sebelas:rolas=dua belas:sanga=sembilan:wolu=delapan:pitu=tujuh:bathuke=dahinya:dithuthuke=dipukulnya:thuthuk=pukul :anyare=barunya:larange=mahalnya:larang=mahal:angope=menguapnya:angop=menguap:dhokter=dokter:dhoktere=dokternya:yutane =jutanya:ewune=ribunya:atuse=ratusnya:atus=ratus:wanine=beraninya:wani=berani:aduse=mandinya:adus=mandi:awane=siangnya:awan=siang:mareme=puasnya:marem=puas:sikile=kakinya:sikil=kaki:grobage=gerobaknya:grobag=gerobak:pojoke=sudutnya:pojok=sudut:amane=hamanya:ama=hama:tapa=semedi:tapa=bertapa:jogan=lantai:jogane=lantainya:darane=merpatinya:dara=merpati:cangkem=mulut:cangkeme=mulutnya:cangkemu=mulutmu:cangkemku=mulutku:esemu=senyummu:esemku=senyumku:esem=senyum:eseme=senyumnya:cete=catnya:cet=cat:mengkone=nantinya:pari=padi:parine=padinya:dhoyong=condong:dhoyonge=condongnya:rodha=roda:rodhane=rodanya:linthange=bintangnya:udane=hujannya:udan=hujan:kodhene=isyaratnya:kodhe=isyarat:wandane=sukukatanya:wandane=suku katanya:wanda=sukukata:wanda=suku kata:piala=keburukan:mari=sembuh:alon=perlahan:kono=situ:kana=sana:linthang=bintang:koen=kamu :inyong=aku :enyong=aku :nyong=aku :tahu =tahuu:ngerti=tahu:terbang =terbangg:mabur=terbang:mabure=terbangnya:mbatesine=membatasinya:mbatesi=membatasi:turune=tidurnya:turu=tidur:diwiwiti=diawali:ora ana=tiada:disampekake=disampaikan:awu=abu:nggawene=menjadikannya:geni=api:sempet=sempat:ora=tak:pan=mau :maring=ke :becik =baikk:ayu=cantik:ayune=cantiknya:sanget=sekali:karo aku=kepadaku:karo kowe=kepadamu:kepungkur=silam:kapungkur=silam:kepungkur=belakangan:kapungkur=belakangan:kaya=kayak:cecaturan=bercakapan:kabuktekake=terbuktikan:mugamuga=semoga :muga-muga=semoga:tulung=harap:sabenere=sebenarnya:wis lah=sudahlah:soale=soalnya:isine =isinya:isine =malunya:isin=malu:isine=isinya|malunya:kabegjan=keberuntungan:kabujuk=terbujuk:ngetoake=mengeluarkan:ngetokake=mengeluarkan:nyebabake=sebabkan:nyebabake=menyebabkan:kepaku=terpaku:miloro=menyakiti:milara=menyakiti:nyalahke=menyalahkan:sira=anda:eleke=jeleknya:ngatiati=berhati-hati:ngati-ati=berhatihati:kebak=penuh:agawe=membuat:pepinginan=keinginan:ngendhaleni=mengendalikan:mbabi=membabi:bales=balas:muring=marah:disenengi=disenangi:tumrap=untuk:tetulung =tolongmenolong:tetulung=tolong-menolong:mitulungi=menolong:sante=santai:nyampuri=mencampuri:urusaning=urusan :leren=rehat:ngaso=istirahat:kapribaden=kepribadian:iso=bisa :isa=bisa :ojo=jangan:pengin=ingin:nduganduga=menduga-duga:nduga-nduga=mendugaduga:muteri=memutari:ngubengi=mengelilingi:ngiteri=mengitari:dipengini=diinginkan:elek=jelek:pakulinan=kebiasaan:kepengaruh=terpengaruh:nggawe=membuat:mbantah=membantah:njupuk=mengambil:pitulungan=pertolongan:kepinginan=keinginan:gegayuhane=keinginannya:gegayuhan=keinginan:ngurusi=mengurusi:rasah=tak usah:wicaksana=bijaksana:omongane=bicaranya:tresno=cinta:sengit=benci:kuwat=kuat:uripmu=hidupmu:uripku=hidupku:ngurmati=menghormati:sampurna=sempurna:apike=baiknya:ngritik=mengkritik:tartemtu=tertentu:ndableg=keras kepala:diregani=dihargai:mateng-mateng=matangmatang:matengmateng=matang-matang:ngrencanaake=merencanakan:ngrencanakake=merencanakan:nimbang=menimbang:mikir=berpikir:duweni=punyai:becik=baik:ngisinisini=memalukan :ngisin-isini=memalukan:swasana=suasana:kajebak=terjebak:kapinteran=kepintaran:sugih=kaya:mlarat=miskin:liya=lain:kaluwihan=kelebihan:sik=yang:nek=kalau:nengarep=di depan:menengan=pendiam:ketutup=tertutup:nganggep=menganggap:okeh=banyak:dipilara=disakiti:siyap=siap:mesthi=pasti:njenengan=anda:ngapuro=memaafkan:ngapura=memaafkan:tumindak=berbuat:tumindak=tindakan:amarahe=amarahnya:nompo=menerima :nampa=menerima:tedheng=perisai:alingaling=penghalang :aling-aling=penghalang:seneng=senang:kui=itu:petung=hitung:itung=hitung:ala=buruk:eneng=ada:ngadohi=menjauhi:ngendhani=menghindari:nggolek=mencari:nggoleki=mencari:goleki=cari:golek=cari:ngitung=menghitung:mbiyantu=membantu:sambekala=celaka:slamet=selamat:ben=biar:amrih=agar:dietung=dihitung:sapanunggalane=sebagainya:lelungan=bepergian:wigati=penting:milih=memilih:semono=sebegitu:kelairane=kelahirannya:dhedhasar=berdasar:kalendher=kalender:petungan=perhitungan:lair=lahir:watek=watak:tradhisine=tradisinya:tradhisi=tradisi:ketok=kelihatan:katon=kelihatan:sarwa=serba:digunaake=digunakan:boso=bahasa:ketara=kelihatan :wates=batas:sawetara=berkisar:sawatara=sekitar:wektu=saat:wektune=saatnya:diganti=digantikan:banjur=kemudian:ngambung=mencium:lorkulon=barat laut:lor-kulon=baratlaut:kidulkulon=barat daya:kidul-kulon=baratdaya:ngusahakake=mengusahakan:iwak=ikan:nutup=menutup:mbuka=membuka:papan =terletak:uga=pula:kaaran=bernama:yen=kalo:bungah=bangga:karo kowe=terhadapmu:bareng=bersama:menyang ndi=kemana:gedhang=pisang:awakku=diriku:awakmu=dirimu:lorwetan=timur-laut:lor-wetan=timurlaut:saindenge=seluruh:kadhang-kadhang=kadangkadang:kadhangkadhang=kadang-kadang:kadhang=kadang:diajarke=diajarkan:pratamane=pertamanya:kapisanan=pertamanya:dibarengke=dibarengkan:dikukuhake=dikukuhkan:kaanan=keadaan:pengaruhe=pengaruhnya:dhadi=jadi:ngene=begini:ngono=begitu:mengkene=begini:gedhigi=tumbuki:ngendhi=mana:kawacan=terbaca:diwaca=dibaca:sethithik=sedikit:sanajan=walaupun:medhura=madura:kadadeane=kejadiannya:kadadeyane=kejadiannya:kadadean=kejadian:kadadeyan=kejadian:nyaturake=bertutur:disit=dahulu:disik=dahulu:ngliwati=melewati:winasis=ahli:nyaturake=membicarakan:ngomongake=membicarakan:salumrahe=umumnya:kena=kena:tansah=selalu:karan=dinamakan:kulina=biasa:dhemen=suka:tresna=cinta:nresnani aku=mencintaiku:nresnani kowe=mencintaimu:nresnani=mencintai:ndhemeni=menyukai:masarakat=masyarakat:kas=khas:embuh=entah:tembung-tembunge=katakatanya:tembungtembunge=kata-katanya:patemon=pertemuan:partemon=pertemuan:omonge=bicaranya:omong=bicara:iring=sisi:semene=sekian:samene=sekian:mengko=nanti:kapisan=pertama:sajroning=di dalam:nulis=menulis:ngomong=berbicara:kahanan=keadaan:andharan=penjelasan:digandengake=digabungkan:digandengake=dihubungkan:digayutake=dihubungkan:srawung=menyapa:jroning=di dalam:menawa=bila:ngandharake=mendeskripsikan:ngupadi=mencari:paedahe=manfaatnya:paedah=manfaat:ngandharake=menjelaskan:sesabungane=hubungannya:ngrembug=membahas:dirembag=dibahas:ngrembag=membahas:rembag=bahas:perangane=bagiannya:dhewedhewe=sendiri-sendiri:dhewe-dhewe=sendirisendiri:ngawujudake=mewujudkan:mujudake=mewujudkan:rumaket=rekat:sesambungan=hubungan:pangerten=pengertian:kodhe=kode:kaperang=terbagi:ditemokake=ditemukannya:cathet=catat:kasile=hasilnya:ukaraukarane=kalimat-kalimatnya:ukara-ukarane=kalimatkalimatnya:ukaraukara=kalimat-kalimat:ukara-ukara=kalimatkalimat:cetha=jelas :gegambaran=gambaran:ngolehake=memeroleh:ngolehake=mendapatkan:metodhe=metode:nggunakake=menggunakan:landhesan=landasan:adhedhasar=berdasar:didasarke=berdasarkan:babagan=perihal:dhatane=datanya:dhata=data:wujud=bentuk :kasebut=tersebut:nlitine=menelitinya:nliti=meneliti:paugerane=aturannya:paugerane=patokannya:paugerane=ketentuannya:paugeran=patokan:paugeran=ketentuan:paugeran=aturan:disawang=dilihat:panliten=penelitian:sajrone=dalam:dikandhakake=diperbincangkan:dikandhakake=dibincangkan:pacaturan=perbincangan:pigunakake=pergunakan:dijak=diajak :digunakake=digunakan:mangerteni=mengetahui:kudu=harus:disebabake=disebabkan:maneka=beraneka:werna=warna:wernane=bermacamnya:wernane=warnanya:sawiji=satu :mula=maka:ngalami=mengalami:iku lah=itulah:uni=bunyi:unine=bunyinya:tetep=tetap:yaiku:yakni:beda=perbedaan:atine=hatinya:atiku=hatiku:atimu=hatimu:tuwane=tuanya:maremake=memuaskan:wangsulane=jawabannya:palinga=paling-paling:esuke=paginya:bengi=malam:mandheg=berhenti:suwara=suara:anehe=anehnya:bathuk=dahi:wates=batas:panggoni=tempati:bojomu=istrimu|suamimu :bojoku=istriku|suamiku :pawon=dapur:ruwang=ruang:mung=hanya:mung=cuma:dakwedeni=kutakuti:kokwedeni=kautakuti:jodho=jodoh:jodhoku=jodohku:jodhomu=jodohmu:narik=menarik :wedi=takut:critane=ceritanya:kene=sini:ambune=baunya:ambu=bau:menyan=kemenyan:ngobong=membakar:jemuwah=jumat:malem=malam:wengi=malam:pitakonku=tanyaku:pitakonmu=tanyamu:pitakone=pertanyaannya:klompok=kelompok:sinau=belajar:ujare=ujarnya:mlebu=masuk:ngingu=memelihara:ngingune=memeliharanya:ngiringan=samping:ketel=lebat:ringin=beringin:wit=pohon:meneh=lagi :wingit=angker:didelok=dilihat:dideleng=dilihat:godhongane=daunnya:godhonge=daunnya:godhong=daun:luwih-luwih=lebihlebih:luwihluwih=lebih-lebih:lawange=pintunya:lawang=pintu:pondhasi=pondasi:mburi=belakang:kiwaku=kiriku:tengenku=kananku:kiwa=kiri:tengen=kanan:kiwane=kirinya:tengene=kanannya:platarane=halamannya:amba=luas:jembar=luas:cathetan=catatan:cithakan=cetakan:digawe=dibuat:nggegem=mengepal:ngepel=mengepal:manungsa=manusia:wujude=wujudnya:inggrise=inggrisnya:nandakake=menandakan:nandhakake=menandakan:silihan=pinjaman:asale=asalnya:nerusake=meneruskan:menyat=berdiri :ngadek=berdiri:ngadeg=berdiri:mungsuh=musuh:dinyatake=dinyatakan:itungan=hitungan:ndhuwur=atas:entuk=dapat:diitung=dihitung:sirah=kepala:ngenani=mengenai:awak=badan:nalika=ketika:boyok=pinggang:anteman=pukulan:diwenehake=diberikan:ulah=olah:rondhe=ronde:dijenengi=dinamai:dijenengi=dinamakan:tartamtu=tertentu:tinemtu=tertentu:loro=dua:nampilake=menampilkan:sakdawane=sepanjang:biji=nilai:ditentokake=ditentukan:ditemtokake=ditentukan:katemtokake=ditentukan:dinyatakake=dinyatakan:siji =sebuah:macem=macam:ya iku=merupakan:ing antarane=diantaranya:kapengaruh=terpengaruh:mbentuk=membentuk:jerone=dalamnya:bener-bener=benarbenar:benerbener=benar-benar:nanging=namun:ing=pada:dadi=sebagai:sawijine=salah satunya:telune=tiganya:ndindi=mana-mana:ndi-ndi=manamana:bibar=habis:bubar=habis :entek=habis:ewonan=ribuan:ewu=ribu:omah=rumah:omahe=rumahnya:omahku=rumahku:omahmu=rumahmu:arep=hendak:rupiyah=rupiah:yuta=juta:tulung=tolong:kebet=lembar :wiji=biji :wulan=bulan :taun=tahun :uwong=orang:akehe=banyaknya:malah=bahkan:utamane=terutama:sawetara=berbagai:sawetara=sementara:kalebu=meliputi:sumerep=melihat:ngemot=memuat:kaamot=termuat:pesen=pesan:busak=hapus:busek=hapus:mbagi=membagi:ben=agar:arupa=berupa:ditatakake=dirapikan:natakake=merapikan:mbedakake=membedakan:jabane=luarnya:kerep=kerap:nduwe=memiliki:katutup=tertutup:adohe=jauhnya:adoh=jauh:krungu=dengar :duwekke=punyanya:duwene=punyanya:diwiwiti=dimulai:sumebar=menyebar:ndadeake=menjadikan:nagari=negara:urip=hidup:lunga=pergi:sesrawungane=sapaannya:medhia=media:mudha=muda:dhisik=dulu:jupokna=ambilkan:kandhakke=beritahukan:wenehi ngerti=beritahukan:dheweke=dirinya:diapakke=diapakan:njur=lalu:banjur=lalu:ngapusi=menipu:ngiringi=mengiringi:panganten=pangantin:ananing=tetapi:sipat=sifat:tangi=bangun:bab=hal:lanang=lelaki:yo=ya :mangkono=begitu:konco=teman:kanca=teman:kanca-kanca=temanteman:kancakanca=teman-teman:ucapake=ucapkan:nambahi=menambahi:mulih=pulang:srengenge=matahari:memedi=hantu:memedhi=hantu:medeni=menakutkan:digoleki=dicari:tiba=jatuh:balbalan=sepak bola:pulisi=polisi:cilik=kecil:banyune=airnya:banyu=air:mripat=mata:mripate=matanya:gelut=berkelahi:lengen=lengan:ananging=tetapi:kedadeyan=kejadian:kedadeyan=terjadi:nglakoni=melakukan:teyeng=bisa :ngangkat=mengangkat:kuwawa=kuasa:awake=badannya:ambegan=nafas:unjal=menarik :napas=nafas:lara=sakit:angete=hangatnya:anget=hangat:kentel=kental:krasa=merasa:krasa=terasa:dawane=panjangnya:dawa=panjang:manuke=burungnya:manuk=burung:guyon=bercanda:guyon=bergurau:mlorot=melorot:kathok=celana:kathoke=celananya:upama=umpama:penggalih=pikiran:ngerti=mengerti:pigunaake=gunakan:saru=jorok:nesune=marahnya:piyayi=priyayi:rikala=kala:celeng=babi hutan:tenan=amat:edan=gila:emang=memang :dhasar=dasar:nesu=jengkel:nesu=marah:marakke=membikin:gawe=buat:sapa=siapa:ucapake=ucapkan:aja=jangan:ati=hati:mula =makanya:kekancan=pertemanan:kepiye=bagaimana:kepriye=bagaimana:kiro=kira :dikandhani=dinasehati:wedhok=perempuan:wadon=perempuan:jebule=ternyata:jebul=ternyata:diadepi=dihadapi:diadhepi=dihadapi:emoh=tidak mau:dak=ku:ku=ku:beda=beda:derajate=derajatnya:angel=susah:angel=sulit:gampang=mudah:disinaoni=dipelajari:prasaja=sederhana:ujud=wujud:dewek=sendiri:piyambak=sendiri:dewe=sendiri:dimangerteni=dimengerti:pakaryan=pekerjaan:dina=hari:dinane=harinya:arang=jarang:arangarang=jarang-jarang:arang-arang=jarangjarang:duwe=punya:conto=contoh:semana=dahulu:jaman=zaman:sesambunganing=hubungan :maneh=lagi:upamane=umpamanya:bedo=beda:dipituturake=dituturkan:gegayutane=keterkaitannya:hubungane=bubungannya:liyan=lain:kasebab=sebab:katone=terlihatnya:ketok=terlihat:katon=terlihat:rewangi=bantu:saengga=sehingga:ndi=mana:sae=baik:apik=baik:kathah=banyak:angon=menggembala:ingkang=yang:bae=saja:benten=lain:anteb=berat:abot=berat:upami=misal:rangkep=rangkap:kaucap=terucap:ateges=maksudnya:pangucaping=pengucapan :medhok=medok:pangucap=pengucapan :tembung=kata:ukara=kalimat:andadekake=menjadikan:watesing=batasnya:ngebaki=memenuhi:kang=yg:kuthakuthane=kota-kotanya:kutha-kuthane=kotakotanya:kuthakutha=kota-kota:kutha-kutha=kotakota:prakara=perkara:dhateng=ke:tanggung jawab=bertanggungjawab:tanggungjawab=bertanggung jawab:mau=tadi:wau=tadi:lumaku=berjalan:mlaku=jalan:dalan=jalan:lumakune=berjalannya:kondhang=terkenal:wonten=ada:biyen=dahulu:padhete=padatnya:dibedakake=dibedakan:saperangan=sebagian:wewengkone=wilayahnya:wewengkon=wilayah:cacahe=jumlahnya:jumlahe=jumlahnya:ngutamakake=mengutamakan:sabanjur=setelah:sabanjure=setelahnya:sangisore=di bawahnya:pamarentahan=pemerintahan:difokusake=difokuskan:kalurahan=kelurahan:anane=adanya:pernahe=posisinya:sundha=sunda:priangga=privasi:cumepak=siap tersedia:pangayoman=naungan:ngembangake=mengembangkan:ngewangi=membantu:ngrewangi=membantu:kuthane=kotanya:kutha=kota:sajeroning=dalam :kulone=baratnya:dunung=berada:dumunung=berada:ana=berada:dununge=posisinya:kuwi=itu:dheweke=dia:aku=saya:kula=saya:aku=saya:ning=di:nang=di:neng=di:arepan=depan:abasa=bahasa:basa=bahasa:basane=bahasanya:kagolong=tergolong:yaiku=yaitu:basabasa=bahasa-bahasa:basa-basa=bahasabahasa:sing=yang:dianggone=dipakainya:sawarnawarnane=bermacam-macam:sawarna-warnane=bermacammacam:ing=di:kapuloan=kepulauan:kidulwetan=tenggara:kidul-wetan=tenggara:sakidulwetaning=tenggaranya :sakidul-wetaning=tenggaranya :bawana=benua:kasebar=tersebar:wiwit=sejak:pucuk=puncak:pucuk=ujung:kulon=barat:pulo=pulau:nganti=hingga:nganti=sampai:tekan=sampai:wetan=timur:dening=oleh:panutur=penutur:kajaba=kecuali:saka=dari:dadi=menjadi:lorone=duanya:panyumbang=donatur:panyumbang=penyumbang:gedhe=besar:kanggone=untuknya:panuwuhane=pertumbuhannya:sanadyan=meskipun:sanadyan=meski:dudu=bukan:pamarentahan=pemerintahan:nduwe=punya:prabawa=pembawa:akeh=banyak:tinimbang=ketimbang:laladan=daerah:tlatah=wilayah:liyane=lainnya:kayata=seperti:lan=dan:kadhangkala=terkadang:kadhangkawis=terkadang:kadhangkala=kadangkala:nganggo=memakai:tembung=kata:iki=ini:endi=mana:anggo=pakai:pasrawungan=tegur sapa:ijo=hijau:tuwa=tua:artine=artinya:tegese=maksudnya:anome=mudanya:anom=muda:enome=mudanya:enom=muda:peranganing=bagiannya :kulawarga=keluarga:pang=cabang:pang:ranting:gilirane=gilirannya:isih=masih:sadulur=saudara:sedulur=saudara:cedhak=dekat:uga=juga:sarta=serta:dipigunaake=dipergunakan:pigunakake=gunakan:pasisir=pesisir:lor=utara:ditrapake=diterapkan:trapake=terapkan:dadi=jadi:kidul=selatan:karaton=keraton:dibedhah=dibedah:wong=orang:walanda=belanda:wusananing=penghujung :kaping=ke:ping =ke:kaanggep=dianggap:donya=dunia:sajarah=sejarah:kasusastran=kesasteraan:wis=sudah:lawas=lama:banget=sekali:sapisan=sekali:sepisan=sekali:pisan=sekali:lawase=selama:lawase=lamanya:punjul=lebih:meh=hampir:merang=memerang:patang=empat :papat=empat:kuna=kuno:kuna=kuna:anyaran=baru:anyar=baru:modhern=modern:modhern=moderen:pratelan=pembagian:ora=tidak:dianggo=dipakai:kanthi=secara:kanti=secara :mawa=menggunakan:migunakake=menggunakan:aksara=huruf:sanadyan=walau:sanadyan=walaupun:mendi=ke mana:ngendi=di mana:wae=saja:dhewe=sendiri: cacahe=jumlahnya:dituturake=dituturkan:dingerteni=diketahui:dingerteni=dimengerti:ndunungi=menduduki:nglenggahi=menduduki:nglungguhi=menduduki:nagara=negara:utawa=atau:manggon=menempati:kabeh=semua:presidhen=presiden:wiwit=mulai :taun=tahun:sajatine=sejatinya:ngakune=mengakunya:ngaku=mengaku:yen=kalau:bapane=ayahnya:nggumunake=mengherankan:menehi=memberi:pangaribawa=kekuatan:perkembangane=perkembangannya:diperang=dibagi:telung=tiga:telu=tiga:dhialek=dialek:ana=ada:diarani=dijuluki:diarani=dinamai:swara=suara:pangarepan=depan:ngarep=depan:wuri=belakang:pangucapan=pengucapan :swara-swara=suarasuara:swaraswara=suara-suara:rada=agak:njlimet=rumit:kabukak=terbuka:sadurunge=sebelum:sadurunge=sebelumnya:diucapake=diucapkan:kaya=seperti:dene=sedangkan:pituturane=pengucapannya :miturut=menurut:hierarkhi=hirarki:alus=halus:mligi=khusus:kaperlon=keperluan:adhedhasar=berdasarkan:didasarke=didasarkan:tlatahe=wilayahnya:sakabehe=semuanya:dimangarteni=dimengerti:dingarteni=dipahami:ngisor=bawah:kapacak=terhias:pamerangan=pengelompokan:pirapira=beberapa :pira-pira=beberapa:nggambar=menggambar:seje=beda:seje=berbeda:sarujuk=mufakat:sarujuk=sepakat:siji=satu:bukune=bukunya:dhialek-dhialek=dialekdialek:dhialekdhialek=dialek-dialek:dikelompokake=dikelompokkan:nduwur=atas:duwur=atas:lumrahe=umumnya:ingaran=dijuluki:kae=itu:iku=itu:wetanan=timuran:perangan=bagian:unggah-ungguhe=unggahungguhnya:unggahungguhe=unggah-ungguhnya:manut=menurut:tetembungan=katakata:tetembungan=kata-kata:saben=setiap:gunane=manfaatnya:gunane=gunanya:kanggo=untuk:marang=kepada:anake=anaknya:sapadhapadha=sesama :sapadha-padha=sesama:kulina=akrab:kulina=terbiasa:ndhuwuran=atasan:andhahan=bawahan:ngisoran=bawahan:tuladha=contoh:sampeyan=kamu:kowen=kamu:gelem=mau:mangan=makan:segane=nasinya:sega=nasi:nanging=tapi:ananging=tetapi:ngajeni=menghargai:drajade=derajatnya:dhuwur=atas:kowe=kamu:purun=mau:durung=belum:raket=rekat:raket=akrab:dhemografi=demografi:panyebaran=penyebaran:delengen=lihatlah:dicaturake=dituturkan:nagara-nagara=negaranegara:nagaranagara=negara-negara:tinemu=ditemukan:enem=enam:sumatra=sumatera:sawijining=salah satu:nuduhake=menunjukkan:wektu=waktu:nuturake=menuturkan:dikarepake=diinginkan:karepake=inginkan:dijupuk=diambil:kalebu=termasuk:saiki=sekarang:kapisah=terpisah:njaba=luar:jaba=luar:katerangan=keterangan:dhestop=desktop:diakoni=diakui:peteng=gelap:papan=tempat:minangka=yang menjadi:padhang=terang:terang=terang:ngandhut=mengandung:simbul-simbul=simbolsimbol:simbulsimbul=simbol-simbol:simbul=simbol:tehnis=teknis:kang=yang:trep=pas:panjenengan=anda:namung=cuma:bakal=akan:arep=akan:arep=mau:weruh=lihat:delok=lihat:deleng=lihat:takon=tanya:kothak=kotak:pesagi=persegi:pasagi=persegi:nanging=tetapi:layang=surat:layange=suratnya:layangku=suratku:layangmu=suratmu:tuladhane=contohnya:menyang=ke:melu=ikut:olih=boleh:oleh=boleh:oleh=dapat:yaiku=adalah:tuku=beli:jero=dalam:sisih=sisi:katata=tertata:sawise=setelah:walikutha=walikota:saliyane=selain:wisesa=kuasa:padha=sama:ngisorane=bawahnya:diwenehi=diberi:ngatur=mengatur:ngurus=mengurus:pamarentahane=pemerintahannya:dhisit=dahulu:dhisik=dahulu:amarga=karena:nduweni=mempunyai:nambahake=menambahkan:dibusak=dihapus:dibusek=dihapus:sawayahwayah=sewaktu-waktu:sawayah-wayah=sewaktuwaktu:dipituturake=dituturkan:rubedha=terlihat beda:rubeda=terlihat beda:wayah=waktu:dipigunakake=dipergunakan:sakteruse=seterusnya:bedane=bedanya:aku=aku:seje=lain:kelawan=dengan:kalawan=dengan:kaliyan=dengan:karo=dengan:endhahendhah=indah-indah:endhah-endhah=indahindah:endhah=indah:endah-endah=indahindah:endah=indah:bagus=ganteng:tembang=nyanyian:nembang=nyanyi:nembang=menyanyi:tembang=lagu:kapustakan=kepustakaan:kethoprak=ketoprak:nyalurake=menyalurkan:kabudayan=kebudayaan:gegayutan=keterkaitan:gayutan=kaitan:gayutane=kaitannya:nyiptaake=menciptakan:nyiptakake=menciptakan:ndadekake=menjadikan:ngrasa=merasa:anggepan=anggapan:tumuwuh=bertumbuh:tumuwuh=tumbuh:tuwuh=tumbuh:elmu=ilmu:ngalusake=menghaluskan:lewih=lebih:dibekeli=dibekali:dicritakake=diceritakan:dicaritakake=diceritakan:numbuhake=menumbuhkan:bocah-bocah=anakanak:dolanan=mainan:nuwuhake=menumbuhkan:kagunan=seni:racake=umumnya:kagunane=seninya:kelir=corak warna:jinising=jenis :ngolah=mengolah:dipirsani=ditengok:suwening=lama :suwe=lama :kadhesek=terdesak:lengket=lekat:enggon=posisi :cocog=cocok:carita=cerita:nyaritakake=menceritakan:kawujud=berwujud:ngidung=berkidung:gandheng=gandeng:dhialog=dialog:misuwur=termasyhur:luwih=lebih:luwihe=lebihnya:yaiku=ialah:dirangkep=dirangkap:ngrangkep=merangkap:dirangkepe=dirangkapnya:ngrangkepe=merangkapnya:rangkepe=rangkapnya:ngurangi=mengurangi:cacah=jumlah:sandhi=sandi:sathithik=sedikit:upamakake=umpamakan:suwe=lama:dhiri=diri:ngedegake=mendirikan:didhirikake=didirikan:adhine=adiknya:diturunake=diturunkan:diudhunake=diturunkan:rampung=usai:didadekake=dijadikan:sekar =bunga:sekare =bunganya:kali =sungai:kaline =sungainya:abangabang=merah-merah:abang-abang=merahmerah:gendera=bendera:genderane=benderanya:nyanding=bersanding:nyawang=melihat:weruh=melihat:nyawang=memandang:kaya =kayaa:remeni=sukai:remen=suka:dicedhaki=didekati:sumendhe=bersandar:pindha=mirip:pindhane=miripnya:miripe=miripnya:memper=mirip:diturokake=ditidurkan:diwacakake=dibacakan:didhampingi=didampingi:nggayuhe=menggapainya:nggayuhe=mencapainya:nggayuh=menggapai:anggayuh=mencapai:nggayuh=mencapai:diwangun=dibangun:didhesek=didesak:ndhesek=mendesak:ditibakake=dijatuhkan:sadhuwuring=atas :sarekat=serikat:wadyane=tentaranya:wadya=tentara:wadya=prajurit:negasake=menegaskan:nyerah=menyerah:sakuthune=sekutunya:sakuthu=sekutu:sekuthune=sekutunya:sekuthu=sekutu:dimanfaatake=dimanfaatkan:mroklamasekake=memroklamasikan:kamardikane=kemerdekaannya:dimaburake=diterbangkan:pinuju=menuju:sauntara=sementara :warta=berita:radhione=radionya:radhio=radio:siyapsiyap=siap-siap:siyap-siyap=siapsiap:wutahing=muntah :hake=haknya:mbalekake=mengembalikan:kakuwasan=kekuasaan:didhesak=didesak:ndhesak=mendesak:kesusune=tergesagesanya:kesusune=tergesanya:kesusune=tergesa-gesanya:kesusu=tergesagesa:kesusu=tergesa:kesusu=tergesa-gesa:nyetujuni=menyetujui:nyetujoni=menyetujui:paweweh=pemberian:panguwasa=penguasa:kantore=kantornya:kobong=terbakar:dhiskusine=diskusinya:dhiskusi=diskusi:cekak=singkat:pengetan=peringatan:dipanggedheni=dipimpin:diusulake=diusulkan:ngusulake=mengusulkan:usulake=usulkan:ndarbeni=memiliki:nduweni=memiliki:salarike=sebarisnya:salarik=sebaris:adate=adatnya:papat-papat=empatempat:papatpapat=empat-empat:papat-papate=empatempatnya:papatpapate=empat-empatnya:siji-sijine=satusatunya:sijisijine=satu-satunya:siji-siji=satusatu:sijisiji=satu-satu:lorolorone=dua-duanya:loro-lorone=duaduanya:loroloro=dua-dua:loro-loro=duadua:telutelu=tiga-tiga:telu-telu=tigatiga:telutelune=tiga-tiganya:telu-telune=tigatiganya:digolongake=digolongkan:sangskerta=sangsekerta:tibane=jatuhnya:cekakan=kependekan:nglagokake=melagukan:panembangan=tembang:kadhiri=kediri:disampurnakake=disempurnakan:sampurnakake=sempurnakan:nyampurnakake=menyempurnakan:ditresnani=dicintai:tresnani=cintai:sajarahe=sejarahnya:diupayakake=diupayakan:upayakake=upayakan:ngupayakake=mengupayakan:kacocogan=kecocokan:taune=tahunnya:ngiraira=memerkirakan:ngira-ira=memerkirakan:pangiraira=perkiraan:pangira-ira=perkiraan:nyakup=mencakup:nyakupe=mencakupnya:pancipta=pencipta:panciptane=penciptanya:diandarake=diungkapkan:diandharake=diungkapkan:kabangsane=kebangsaannya:kabangsan=kebangsaan:runtuhe=runtuhnya:kidunge=kidungnya:sumrambah=bertebaran:ngendingendi=mana-mana:ngendi-ngendi=manamana:lelakoning=lakon :kandhutane=kandungannya:kawruhan=ketahuan:ngambange=mengambangnya:ngambang=mengambang:ngangsu=menimba:nuntunake=menuntunkan:tuntunake=tuntunkan:nuntune=menuntunnya:nuntun=menuntun:bisa =bisaa:seneng-senenge=senangsenangnya:senengsenenge=senang-senangnya:senengseneng=senang-senang:seneng-seneng=senangsenang:sapadhapadha=sesama :sapadha-padha=sesama:piwulange=pengajarannya:piwulang=pengajaran:sosiale=sosialnya:rohe=rohnya:katimbalan=terpanggil:wancine=waktunya :digantekake=digantikan:ngripta=mengarang:jarwan=menyadur:nyalin=menyalin:kapustakan=perpustakaan:kapustakan=perbukuan:pustaka=buku :pangriptane=pengarangnya:pangripta=pengarang:panganggit=pengarang:sinambi=sambil:pitutur=nasehat:pitutur=nasihat:dituturi=dinasehati:dituturi=dinasihati:barat =badai:cilaka=celaka:winatesan=berbatasan:antawis=antara :sansaya=semakin:tansaya=semakin:ngajokake=mengajukan:omongan=ucapan:medhar=memapar:padinane=hariannya:padinan=harian:tuwuhe=tumbuhnya:pacelathone=percakapannya:pacelathon=percakapan:paribasane=peribahasanya:paribasan=peribahasa:kapenak=enak :nuturi=menasehati:nuturi=menasihati:nyemoni=menyindir:kekuwatan=kekuatan";
      Tlanslator.dictionaryParse = function (dictionaryAsText) {
        var returnValue = {};
        var entriesAsStrings = dictionaryAsText.split(":");
        for (var i = 0; i < entriesAsStrings.length; i++) {
          var entryAsString = entriesAsStrings[i];
          var entryAsKeyAndValue = entryAsString.split("=");
          var key = entryAsKeyAndValue[key1];
          var value = entryAsKeyAndValue[key2];
          returnValue[key] = value;
        }
        return returnValue;
      };
      Tlanslator.prototype.translateAndInterleave = function (
        passageToTranslate,
        charsPerLine
      ) {
        var passageInterleaved = "";
        var TiT = passageToTranslate
          .toLowerCase()
          .split("\r")
          .join(" ")
          .split("\n")
          .join(" ")
          .split(/[ ]+/)
          .join(" ")
          .split("Ã¨")
          .join("e")
          .split("Ã©")
          .join("e")
          .split("Ãª")
          .join("e")
          .split("Ä")
          .join("a")
          .split("Ã¥")
          .join("a")
          .split("0.")
          .join("0T")
          .split("1.")
          .join("1T")
          .split("2.")
          .join("2T")
          .split("3.")
          .join("3T")
          .split("4.")
          .join("4T")
          .split("5.")
          .join("5T")
          .split("6.")
          .join("6T")
          .split("7.")
          .join("7T")
          .split("8.")
          .join("8T")
          .split("9.")
          .join("9T")
          .split("0,")
          .join("0K")
          .split("1,")
          .join("1K")
          .split("2,")
          .join("2K")
          .split("3,")
          .join("3K")
          .split("4,")
          .join("4K")
          .split("5,")
          .join("5K")
          .split("6,")
          .join("6K")
          .split("7,")
          .join("7K")
          .split("8,")
          .join("8K")
          .split("9,")
          .join("9K")
          .split(".")
          .join(" . ")
          .split(",")
          .join(" , ")
          .split("Ta")
          .join("T a")
          .split("Tb")
          .join("T b")
          .split("Tc")
          .join("T c")
          .split("Td")
          .join("T d")
          .split("Te")
          .join("T e")
          .split("Tf")
          .join("T f")
          .split("Tg")
          .join("T g")
          .split("Th")
          .join("T h")
          .split("Ti")
          .join("T i")
          .split("Tj")
          .join("T j")
          .split("Tk")
          .join("T k")
          .split("Tl")
          .join("T l")
          .split("Tm")
          .join("T m")
          .split("Tn")
          .join("T n")
          .split("To")
          .join("T o")
          .split("Tp")
          .join("T p")
          .split("Tq")
          .join("T q")
          .split("Tr")
          .join("T r")
          .split("Ts")
          .join("T s")
          .split("Tt")
          .join("T t")
          .split("Tu")
          .join("T u")
          .split("Tv")
          .join("T v")
          .split("Tw")
          .join("T w")
          .split("Tx")
          .join("T x")
          .split("Ty")
          .join("T y")
          .split("Tz")
          .join("T z")
          .split("Ka")
          .join("K a")
          .split("Kb")
          .join("K b")
          .split("Kc")
          .join("K c")
          .split("Kd")
          .join("K d")
          .split("Ke")
          .join("K e")
          .split("Kf")
          .join("K f")
          .split("Kg")
          .join("K g")
          .split("Kh")
          .join("K h")
          .split("Ki")
          .join("K i")
          .split("Kj")
          .join("K j")
          .split("Kk")
          .join("K k")
          .split("Kl")
          .join("K l")
          .split("Km")
          .join("K m")
          .split("Kn")
          .join("K n")
          .split("Ko")
          .join("K o")
          .split("Kp")
          .join("K p")
          .split("Kq")
          .join("K q")
          .split("Kr")
          .join("K r")
          .split("Ks")
          .join("K s")
          .split("Kt")
          .join("K t")
          .split("Ku")
          .join("K u")
          .split("Kv")
          .join("K v")
          .split("Kw")
          .join("K w")
          .split("Kx")
          .join("K x")
          .split("Ky")
          .join("K y")
          .split("Kz")
          .join("K z")
          .split("T")
          .join(".")
          .split("K")
          .join(",")
          .split("â€”")
          .join(" â€” ")
          .split("â€“")
          .join(" â€” ")
          .split("â€³")
          .join('"')
          .split("â€²")
          .join("'")
          .split("â€œ")
          .join('"')
          .split("â€")
          .join('"')
          .split("â€ž")
          .join('"')
          .split("â€˜")
          .join("'")
          .split("â€™")
          .join("'")
          .split("=")
          .join(" = ")
          .split("!")
          .join(" ! ")
          .split("'")
          .join(" ' ")
          .split('"')
          .join(' " ')
          .split("?")
          .join(" ? ")
          .split(":")
          .join(" : ")
          .split(")")
          .join(" ) ")
          .split("(")
          .join(" ( ")
          .split("/")
          .join(" / ")
          .split(";")
          .join(" ; ")
          .split("&")
          .join(" & ")
          .split("â€¦")
          .join(" â€¦ ")
          .split("- ")
          .join("-")
          .split("]")
          .join(" ] ")
          .split("[")
          .join(" [ ")
          .split(" unggah ungguh")
          .join(" unggah-ungguh");
        if (key1 == 1) {
          var T0IT = TiT.split(" habis subuh")
            .join(" bar subuh")
            .split(" habis zuhur")
            .join(" bar zuhur")
            .split(" habis duhur")
            .join(" bar duhur")
            .split(" habis dzuhur")
            .join(" bar dzuhur")
            .split(" habis asar")
            .join(" bar asar")
            .split(" habis ashar")
            .join(" bar ashar")
            .split(" habis mag")
            .join(" bar mag")
            .split(" habis mah")
            .join(" bar mah")
            .split(" habis isya")
            .join(" bar isya")
            .split(" masukannya")
            .join(" lebonane")
            .split(" masakannya")
            .join(" masakane");
          var T0T = T0IT.split(" yg ")
            .join(" yang ")
            .split("perawakannya ")
            .join(" perawakane ")
            .split(" ikannya")
            .join(" iwake")
            .split(" mempr")
            .join(" memr")
            .split(" memper")
            .join(" memer")
            .split(" mempel")
            .join(" memel")
            .split(" mempeng")
            .join(" memeng")
            .split("kanmu,")
            .join("kan kamu,")
            .split("kanmu.")
            .join("kan kamu.")
            .split("kanmu ")
            .join("kan kamu ")
            .split("kanku,")
            .join("kan aku,")
            .split("kanku.")
            .join("kan aku.")
            .split("kanku ")
            .join("kan aku ")
            .split("kannya,")
            .join("kan,")
            .split("kannya.")
            .join("kan.")
            .split("kannya ")
            .join("kan ")
            .split(" kedua")
            .join(" kaping dua")
            .split(" ketiga")
            .join(" kaping tiga")
            .split(" keempat")
            .join(" kaping empat")
            .split(" kelima")
            .join(" kaping lima")
            .split(" keenam")
            .join(" kaping enam")
            .split(" ketujuh")
            .join(" kaping tujuh")
            .split(" kedelapan")
            .join(" kaping delapan")
            .split(" kesembilan")
            .join(" kaping sembilan")
            .split(" kesepuluh")
            .join(" kaping sepuluh")
            .split(" kesebelas")
            .join(" kaping sebelas")
            .split(" barat laut")
            .join(" barat-laut")
            .split(" barat daya")
            .join(" barat-daya")
            .split(" timur laut")
            .join(" timur-laut")
            .split(" naiknya")
            .join(" naik")
            .split(" trima")
            .join(" terima")
            .split(" masa iya ")
            .join(" apa iya ")
            .split(" masa sih")
            .join(" masa-sih")
            .split(" cantik jelita")
            .join(" ayu moblong-moblong")
            .split(" tinggal di ")
            .join(" manggon di ")
            .split(" apa pun ")
            .join(" apa wae ")
            .split(" kelapa muda ")
            .join(" degan ")
            .split(" pecahan kaca")
            .join(" beling")
            .split(" pecahan genteng")
            .join(" wingka")
            .split("tahu plet")
            .join("tahuu plet")
            .split(" baru pulang")
            .join(" nembe pulang")
            .split("tiang penyangga")
            .join("saka panyangga")
            .split("gunung meletus")
            .join("gunung mbledhug")
            .split("saat saat")
            .join("saat-saat")
            .split(" wayang kulit")
            .join(" ringgit purwa")
            .split(" main hakim ")
            .join(" maen hakim ")
            .split("pendengaran sedang")
            .join("pendengaran sedeng")
            .split(" sedang yaitu ")
            .join(" sedeng yaitu ")
            .split(" bagi aku")
            .join(" untuk aku")
            .split("sedikit demi sedikit")
            .join("sedikit makin sedikit")
            .split("sedapat mungkin")
            .join("sebisa mungkinn")
            .split("sebaik mungkin")
            .join("sebaik mungkinn")
            .split("rumah sakit")
            .join("rumah-sakit")
            .split("puji pujian")
            .join("puji-pujian")
            .split("pernah sekali")
            .join("pernah sepisan")
            .split(" jgn ")
            .join(" jangan ")
            .split(" sampe ")
            .join(" sampai ")
            .split("celana pendek")
            .join("sruwal cekak")
            .split(" kaus")
            .join(" kaos")
            .split(" alas kaki")
            .join(" kasut")
            .split(" sok cantik")
            .join(" kemajeng")
            .split(" sempet")
            .join(" sempat")
            .split(" sempat bertemu")
            .join(" menangi bertemu")
            .split(" tanpa alas kaki")
            .join(" nyeker")
            .split("asal palu")
            .join("asal paluu")
            .split("dari palu")
            .join("dari paluu")
            .split(" teramat ")
            .join(" sangat ")
            .split(" baru beli")
            .join(" nembe beli")
            .split("6 lalu")
            .join("6 silam")
            .split("7 lalu")
            .join("7 silam")
            .split("8 lalu")
            .join("8 silam")
            .split("9 lalu")
            .join("9 silam")
            .split("tiba tiba")
            .join("tiba-tiba")
            .split(" lebih baik")
            .join(" lebih apik")
            .split(" ikat pinggang")
            .join(" sabuk")
            .split(" batu asah")
            .join(" wungkal")
            .split(" tebak tebakan")
            .join(" badek-badekan")
            .split(" benang kusut")
            .join(" benangrawud")
            .split("satu sama lain")
            .join("satu dengan liya")
            .split("zaman")
            .join("jaman")
            .split("jaman dahulu")
            .join("jaman semana")
            .split("jaman dulu")
            .join("jaman semana")
            .split("dulu dulu")
            .join("duludulu")
            .split("dahulu kala")
            .join("dahulukala")
            .split("dulu kala")
            .join("dahulukala")
            .split("sodara")
            .join("saudara")
            .split(" baik bu,")
            .join(" baikk bu,")
            .split(" baik pak,")
            .join(" baikk pak,")
            .split(" pukul 1")
            .join(" jam 1")
            .split(" tanda lahir")
            .join(" toh")
            .split(" batang pisang")
            .join(" debog pisang")
            .split(" berpangku tangan")
            .join(" ngandelake")
            .split(" berulang tahun")
            .join(" ulang tahun")
            .split(" halaman rumah")
            .join(" latar rumah")
            .split("sudah jinak")
            .join("sudah tutut")
            .split("uang saku")
            .join("sangu")
            .split(" jalan raya")
            .join(" ratan")
            .split(" tahi ")
            .join(" tai ")
            .split(" tai lalat")
            .join(" andeng-andeng")
            .split(" naik motor")
            .join(" menaiki motor")
            .split(" naik pesawat")
            .join(" menaiki pesawat")
            .split(" naik becak")
            .join(" menaiki becak")
            .split(" naik bus")
            .join(" menaiki bus")
            .split(" naik kereta")
            .join(" menaiki kereta")
            .split(" naik andong")
            .join(" menaiki andong")
            .split(" naik delman")
            .join(" menaiki delman")
            .split(" naik kuda")
            .join(" menaiki kuda")
            .split("ratus satu tril")
            .join("ratus siji tril")
            .split("ratus dua tril")
            .join("ratus loro tril")
            .split("ratus tiga tril")
            .join("ratus telu tril")
            .split("ratus empat tril")
            .join("ratus papat tril")
            .split("ratus lima tril")
            .join("ratus limaa tril")
            .split("ratus enam tril")
            .join("ratus enem tril")
            .split("ratus tujuh tril")
            .join("ratus pitu tril")
            .split("ratus delapan tril")
            .join("ratus wolu tril")
            .split("ratus sembilan tril")
            .join("ratus sanga tril")
            .split("ratus satu mil")
            .join("ratus siji mil")
            .split("ratus dua mil")
            .join("ratus loro mil")
            .split("ratus tiga mil")
            .join("ratus telu mil")
            .split("ratus empat mil")
            .join("ratus papat mil")
            .split("ratus lima mil")
            .join("ratus limaa mil")
            .split("ratus enam mil")
            .join("ratus enem mil")
            .split("ratus tujuh mil")
            .join("ratus pitu mil")
            .split("ratus delapan mil")
            .join("ratus wolu mil")
            .split("ratus sembilan mil")
            .join("ratus sanga mil")
            .split(" dua puluh satu")
            .join(" selikur")
            .split(" dua puluh dua")
            .join(" rolikur")
            .split(" dua puluh tiga")
            .join(" telulikur")
            .split(" dua puluh empat")
            .join(" patlikur")
            .split(" dua puluh lima")
            .join(" selawe")
            .split(" dua puluh enam")
            .join(" nemlikur")
            .split(" dua puluh tujuh")
            .join(" pitulikur")
            .split(" dua puluh delapan")
            .join(" wolulikur")
            .split(" dua puluh sembilan")
            .join(" sangalikur")
            .split(" puluh satu tril")
            .join(" puluh siji tril")
            .split(" puluh dua tril")
            .join(" puluh loro tril")
            .split(" puluh tiga tril")
            .join(" puluh telu tril")
            .split(" puluh empat tril")
            .join(" puluh papat tril")
            .split(" puluh lima tril")
            .join(" puluh limaa tril")
            .split(" puluh enam tril")
            .join(" puluh enem tril")
            .split(" puluh tujuh tril")
            .join(" puluh pitu tril")
            .split(" puluh delapan tril")
            .join(" puluh wolu tril")
            .split(" puluh sembilan tril")
            .join(" puluh sanga tril")
            .split(" puluh satu mil")
            .join(" puluh siji mil")
            .split(" puluh dua mil")
            .join(" puluh loro mil")
            .split(" puluh tiga mil")
            .join(" puluh telu mil")
            .split(" puluh empat mil")
            .join(" puluh papat mil")
            .split(" puluh lima mil")
            .join(" puluh limaa mil")
            .split(" puluh enam mil")
            .join(" puluh enem mil")
            .split(" puluh tujuh mil")
            .join(" puluh pitu mil")
            .split(" puluh delapan mil")
            .join(" puluh wolu mil")
            .split(" puluh sembilan mil")
            .join(" puluh sanga mil")
            .split(" puluh satu juta")
            .join(" puluh siji juta")
            .split(" puluh dua juta")
            .join(" puluh loro juta")
            .split(" puluh tiga juta")
            .join(" puluh telu juta")
            .split(" puluh empat juta")
            .join(" puluh papat juta")
            .split(" puluh lima juta")
            .join(" puluh limaa juta")
            .split(" puluh enam juta")
            .join(" puluh enem juta")
            .split(" puluh tujuh juta")
            .join(" puluh pitu juta")
            .split(" puluh delapan juta")
            .join(" puluh wolu juta")
            .split(" puluh sembilan juta")
            .join(" puluh sanga juta")
            .split(" puluh satu ribu")
            .join(" puluh siji ribu")
            .split(" puluh dua ribu")
            .join(" puluh loro ribu")
            .split(" puluh tiga ribu")
            .join(" puluh telu ribu")
            .split(" puluh empat ribu")
            .join(" puluh papat ribu")
            .split(" puluh lima ribu")
            .join(" puluh limaa ribu")
            .split(" puluh enam ribu")
            .join(" puluh enem ribu")
            .split(" puluh tujuh ribu")
            .join(" puluh pitu ribu")
            .split(" puluh delapan ribu")
            .join(" puluh wolu ribu")
            .split(" puluh sembilan ribu")
            .join(" puluh sanga ribu")
            .split("ratus satu ribu")
            .join("ratus siji ribu")
            .split("ratus dua ribu")
            .join("ratus loro ribu")
            .split("ratus tiga ribu")
            .join("ratus telu ribu")
            .split("ratus empat ribu")
            .join("ratus papat ribu")
            .split("ratus lima ribu")
            .join("ratus limaa ribu")
            .split("ratus enam ribu")
            .join("ratus enem ribu")
            .split("ratus tujuh ribu")
            .join("ratus pitu ribu")
            .split("ratus delapan ribu")
            .join("ratus wolu ribu")
            .split("ratus sembilan ribu")
            .join("ratus sanga ribu")
            .split("ratus satu juta")
            .join("ratus siji juta")
            .split("ratus dua juta")
            .join("ratus loro juta")
            .split("ratus tiga juta")
            .join("ratus telu juta")
            .split("ratus empat juta")
            .join("ratus papat juta")
            .split("ratus lima juta")
            .join("ratus limaa juta")
            .split("ratus enam juta")
            .join("ratus enem juta")
            .split("ratus tujuh juta")
            .join("ratus pitu juta")
            .split("ratus delapan juta")
            .join("ratus wolu juta")
            .split("ratus sembilan juta")
            .join("ratus sanga juta")
            .split(" tiga puluh")
            .join(" telung puluh")
            .split(" empat puluh")
            .join(" patang puluh")
            .split(" lima puluh")
            .join(" seket")
            .split(" enam puluh")
            .join(" sewidak")
            .split(" tujuh puluh")
            .join(" pitung puluh")
            .split(" delapan puluh")
            .join(" wolung puluh")
            .split(" sembilan puluh")
            .join(" sangang puluh")
            .split(" dua belas")
            .join(" rolas")
            .split(" tiga belas")
            .join(" telulas")
            .split(" empat belas")
            .join(" patbelas")
            .split(" lima belas")
            .join(" limalas")
            .split(" enam belas")
            .join(" nembelas")
            .split(" tujuh belas")
            .join(" pitulas")
            .split(" delapan belas")
            .join(" wolulas")
            .split(" sembilan belas")
            .join(" sangalas")
            .split(" dua puluh")
            .join(" rong puluh")
            .split(" dua ratus")
            .join(" rong ratus")
            .split(" tiga ratus")
            .join(" telung ratus")
            .split(" empat ratus")
            .join(" patang ratus")
            .split(" lima ratus")
            .join(" mang ratus")
            .split(" enam ratus")
            .join(" nem ratus")
            .split(" tujuh ratus")
            .join(" pitung ratus")
            .split(" delapan ratus")
            .join(" wolung ratus")
            .split(" sembilan ratus")
            .join(" sangang ratus")
            .split(" dua ribu")
            .join(" rong ribu")
            .split(" tiga ribu")
            .join(" telung ribu")
            .split(" empat ribu")
            .join(" patang ribu")
            .split(" lima ribu")
            .join(" mang ribu")
            .split(" enam ribu")
            .join(" nem ribu")
            .split(" tujuh ribu")
            .join(" pitung ribu")
            .split(" delapan ribu")
            .join(" wolung ribu")
            .split(" sembilan ribu")
            .join(" sangang ribu")
            .split(" satu juta")
            .join(" sejuta")
            .split(" dua juta")
            .join(" rong juta")
            .split(" tiga juta")
            .join(" telung juta")
            .split(" empat juta")
            .join(" patang juta")
            .split(" lima juta")
            .join(" mang juta")
            .split(" enam juta")
            .join(" nem juta")
            .split(" tujuh juta")
            .join(" pitung juta")
            .split(" delapan juta")
            .join(" wolung juta")
            .split(" sembilan juta")
            .join(" sangang juta")
            .split(" satu mil")
            .join(" semil")
            .split(" dua mil")
            .join(" rong mil")
            .split(" tiga mil")
            .join(" telung mil")
            .split(" empat mil")
            .join(" patang mil")
            .split(" lima mil")
            .join(" mang mil")
            .split(" enam mil")
            .join(" nem mil")
            .split(" tujuh mil")
            .join(" pitung mil")
            .split(" delapan mil")
            .join(" wolung mil")
            .split(" sembilan mil")
            .join(" sangang mil")
            .split(" satu tril")
            .join(" setril")
            .split(" dua tril")
            .join(" rong tril")
            .split(" tiga tril")
            .join(" telung tril")
            .split(" empat tril")
            .join(" patang tril")
            .split(" lima tril")
            .join(" mang tril")
            .split(" enam tril")
            .join(" nem tril")
            .split(" tujuh tril")
            .join(" pitung tril")
            .split(" delapan tril")
            .join(" wolung tril")
            .split(" sembilan tril")
            .join(" sangang tril")
            .split("minggu lalu")
            .join("minggu kapungkur")
            .split(", lalu")
            .join(", banjur")
            .split(" tempat pensil")
            .join(" tepak")
            .split(" tempat sekolah")
            .join(" sekolahan")
            .split(" terbang jawa")
            .join(" terbangg jawa")
            .split(" pembawa acara")
            .join(" pranatacara")
            .split(" tahu goreng")
            .join(" tahuu goreng");
          var TloT = T0T.split(" rabiul akhir")
            .join(" bakdamulud")
            .split(" jumadil awal")
            .join(" jumadilawal")
            .split(" jumadil akhir")
            .join(" jumadilakir")
            .split(" sya ' ban")
            .join(" ruwah")
            .split(" rabiul awal")
            .join(" mulud");
          var TleT = TloT.split("layar")
            .join("QVlayarVQ")
            .split("panggung")
            .join("QVpanggungVQ")
            .split("televisi")
            .join("QVtelevisiVQ")
            .split("ruko")
            .join("QVrukoVQ")
            .split("kios")
            .join("QVkiosVQ")
            .split("toko")
            .join("QVtokoVQ")
            .split("huruf")
            .join("QVhurufVQ")
            .split("kalimat")
            .join("QVkalimatVQ")
            .split("katak")
            .join("QVkatakVQ")
            .split(" ia ")
            .join(" QVIa ")
            .split("kalian")
            .join("QVkalian")
            .split("mereka")
            .join("QVmereka")
            .split("kamu")
            .join("QVkamu")
            .split("saya")
            .join("QVsaya")
            .split("kamar")
            .join("QVkamarVQ")
            .split("bumi")
            .join("QVbumiVQ")
            .split("komunitas")
            .join("QVkomunitasVQ")
            .split("pikiran")
            .join("QVpikiranVQ")
            .split("televisi")
            .join("QVtelevisiVQ")
            .split("pohon")
            .join("QVpohonVQ")
            .split("buah")
            .join("QVbuahVQ")
            .split("warna")
            .join("QVwarnaVQ")
            .split("macam")
            .join("QVmacam")
            .split("jenis")
            .join("QVjenisVQ")
            .split("ekor")
            .join("QVekor")
            .split("kilo")
            .join("QVkilo")
            .split("waktu")
            .join("QVwaktuVQ")
            .split("meter")
            .join("QVmeter")
            .split("menit")
            .join("QVmenitVQ")
            .split("detik")
            .join("QVdetikVQ")
            .split("unit")
            .join("QVunitVQ")
            .split("gram")
            .join("QVgram")
            .split("porsi")
            .join("QVporsiVQ")
            .split("pilihan")
            .join("QVpilihanVQ")
            .split("cerita")
            .join("QVceritaVQ")
            .split("gelas")
            .join("QVgelasVQ")
            .split("rupiah")
            .join("QVrupiah")
            .split("tiang")
            .join("QVtiangVQ")
            .split("hati")
            .join("QVhati")
            .split("cinta")
            .join("QVcintaVQ")
            .split("matahari")
            .join("QVmatahariVQ")
            .split("rumah")
            .join("QVrumahVQ")
            .split("langit")
            .join("QVlangit")
            .split(" berbahasa")
            .join(" QX berbahasa")
            .split("kota")
            .join("QVkotaVQ")
            .split("abad")
            .join("QVabadVQ")
            .split("bukti")
            .join("QVbuktiVQ")
            .split("wilayah")
            .join("QVwilayahVQ")
            .split("barang")
            .join("QVbarangVQ")
            .split("ruangan")
            .join("QVruanganVQ")
            .split("film")
            .join("QVfilmVQ")
            .split("sahabat")
            .join("QVsahabatVQ")
            .split("teman")
            .join("QVtemanVQ")
            .split("desa")
            .join("QVdesaVQ")
            .split("model")
            .join("QVmodelVQ")
            .split("naskah")
            .join("QVnaskahVQ")
            .split("baju")
            .join("QVbajuVQ")
            .split("sepatu")
            .join("QVsepatuVQ")
            .split("sandal")
            .join("QVsandalVQ")
            .split("kompor")
            .join("QVkomporVQ")
            .split("meja")
            .join("QVmejaVQ")
            .split("kursi")
            .join("QVkursiVQ")
            .split("lampu")
            .join("QVlampuVQ")
            .split("radio")
            .join("QVradioVQ")
            .split("celana")
            .join("QVcelanaVQ")
            .split("sekolah")
            .join("QVsekolahVQ")
            .split("kasur")
            .join("QVkasurVQ")
            .split("mahasiswa")
            .join("QVmahasiswaVQ")
            .split("siswa")
            .join("QVsiswaVQ")
            .split("kelas")
            .join("QVkelasVQ")
            .split("kota")
            .join("QVkotaVQ")
            .split("kabupaten")
            .join("QVkabupatenVQ")
            .split("negara")
            .join("QVnegaraVQ")
            .split("kasus")
            .join("QVkasusVQ")
            .split("strategi")
            .join("QVstrategiVQ")
            .split("planet")
            .join("QVplanetVQ")
            .split("sisi")
            .join("QVsisiVQ")
            .split("pihak")
            .join("QVpihakVQ")
            .split("daerah")
            .join("QVdaerahVQ")
            .split("media")
            .join("QVmediaVQ")
            .split("individu")
            .join("QVindividuVQ")
            .split("pemain")
            .join("QVpemainVQ")
            .split("tempat")
            .join("QVtempatVQ")
            .split("pulau")
            .join("QVpulauVQ")
            .split("musik")
            .join("QVmusikVQ")
            .split("harimau")
            .join("QVharimauVQ")
            .split(" ruang")
            .join(" QVruangVQ")
            .split("petisi")
            .join("QVpetisiVQ")
            .split("pria")
            .join("QVpriaVQ")
            .split("wanita")
            .join("QVwanitaVQ")
            .split("gadis")
            .join("QVgadisVQ")
            .split(" yang")
            .join(" yangVQ")
            .split(" yg")
            .join(" ygVQ")
            .split("baris")
            .join("QVbarisVQ")
            .split("fungsi")
            .join("QVfungsiVQ")
            .split(" antara")
            .join(" antaraVQ")
            .split("kerbau")
            .join("QVkerbauVQ")
            .split("kucing")
            .join("QVkucingVQ")
            .split("kambing")
            .join("QVkambingVQ")
            .split("pintu")
            .join("QVpintuVQ")
            .split("jendela")
            .join("QVjendelaVQ")
            .split("motor")
            .join("QVmotorVQ")
            .split("sepeda")
            .join("QVsepedaVQ")
            .split("anjing")
            .join("QVanjingVQ")
            .split("binatang")
            .join("QVbinatangVQ")
            .split("dimensi")
            .join("QVdimensiVQ")
            .split("perut")
            .join("QVperutVQ")
            .split("kepala")
            .join("QVkepalaVQ")
            .split("mulut")
            .join("QVmulutVQ")
            .split("kesempatan")
            .join("QVkesempatanVQ")
            .split("stasiun")
            .join("QVstasiunVQ")
            .split("terminal")
            .join("QVterminalVQ")
            .split("dialek")
            .join("QVdialekVQ")
            .split("bentuk")
            .join("QVbentukVQ")
            .split("tahun")
            .join("QVtahunVQ")
            .split(" hidup")
            .join(" QVhidup")
            .split("artikel")
            .join("QVartikelVQ")
            .split("bahasa")
            .join("QVbahasaVQ")
            .split("orang")
            .join("QVorangVQ")
            .split("pelatih")
            .join("QVpelatihVQ")
            .split("lemari")
            .join("QVlemariVQ")
            .split("laci")
            .join("QVlaciVQ")
            .split("dukungan")
            .join("QVdukunganVQ")
            .split("kekuatan")
            .join("QVkekuatanVQ")
            .split("tindakan")
            .join("QVtindakanVQ")
            .split("nasihat")
            .join("QVnasihatVQ")
            .split("sore")
            .join("QVsoreVQ")
            .split(" perusahaan")
            .join(" QVperusahaan")
            .split(" udara")
            .join(" QVudara")
            .split("pesawat")
            .join("QVpesawatVQ")
            .split("sastra")
            .join("QVsastraVQ")
            .split("wan ")
            .join("wanVQ ")
            .split(" harta")
            .join(" QVhartaVQ")
            .split(" api")
            .join(" QVapi")
            .split(" air")
            .join(" QVair")
            .split(" ayah")
            .join(" QVayahVQ")
            .split("ibu")
            .join("QVibuVQ")
            .split("bandara")
            .join("QVbandaraVQ")
            .split("sudut")
            .join("QVsudutVQ")
            .split("hewan")
            .join("QVhewanVQ")
            .split("jawaban")
            .join("QVjawabanVQ")
            .split("bibi")
            .join("QVbibiVQ")
            .split("bola")
            .join("QVbolaVQ")
            .split("pisang")
            .join("QVpisangVQ")
            .split("burung")
            .join("QVburungVQ")
            .split("buku")
            .join("QVbukuVQ")
            .split("otak")
            .join("QVotakVQ")
            .split("roti")
            .join("QVrotiVQ")
            .split("saudara")
            .join("QVsaudaraVQ")
            .split("mobil")
            .join("QVmobilVQ")
            .split("ayam")
            .join("QVayamVQ")
            .split("anak")
            .join("QVanakVQ")
            .split("masjid")
            .join("QVmasjidVQ")
            .split("gereja")
            .join("QVgerejaVQ")
            .split("gempuran")
            .join("QVgempuranVQ")
            .split("wihara")
            .join("QVwiharaVQ")
            .split("rokok")
            .join("QVrokokVQ")
            .split("lingkaran")
            .join("QVlingkaranVQ")
            .split("sapi")
            .join("QVsapiVQ")
            .split("alat")
            .join("QValatVQ")
            .split("makan")
            .join("QVmakan")
            .split("arah")
            .join("QVarahVQ")
            .split("bencana")
            .join("QVbencanaVQ")
            .split("penyakit")
            .join("QVpenyakitVQ")
            .split("boneka")
            .join("QVbonekaVQ")
            .split("supir")
            .join("QVsupirVQ")
            .split("gempa")
            .join("QVgempaVQ")
            .split("pendidik")
            .join("QVpendidikVQ")
            .split("mesin")
            .join("QVmesinVQ")
            .split("hiburan")
            .join("QVhiburanVQ")
            .split("keluarga")
            .join("QVkeluargaVQ")
            .split("petani")
            .join("QVpetaniVQ")
            .split("lapangan")
            .join("QVlapanganVQ")
            .split("bendera")
            .join("QVbenderaVQ")
            .split("bunga")
            .join("QVbungaVQ")
            .split(" sepak bola")
            .join(" QVsepak bolaVQ")
            .split("kata")
            .join("QVkataVQ")
            .split(" pem")
            .join(" QVpem")
            .split("sampah")
            .join("QVsampahVQ")
            .split("hantu")
            .join("QVhantuVQ")
            .split("kakek")
            .join("QVkakekVQ")
            .split("nenek")
            .join("QVnenekVQ")
            .split("rumput")
            .join("QVrumputVQ")
            .split("senjata")
            .join("QVsenjataVQ")
            .split(" aula")
            .join(" QVaulaVQ")
            .split(" kese")
            .join(" QVkese")
            .split(" jantung")
            .join(" QVjantungVQ")
            .split("bukit")
            .join("QVbukitVQ")
            .split("sejarah")
            .join("QVsejarahVQ")
            .split(" liburan")
            .join(" QVliburanVQ")
            .split("pekerja")
            .join("QVpekerjaVQ")
            .split(" madu")
            .join(" QVmaduVQ")
            .split("kuda")
            .join("QVkudaVQ")
            .split("panas")
            .join("QVpanasVQ")
            .split(" pen")
            .join(" QVpen")
            .split(" keme")
            .join(" QVkeme")
            .split(" memer")
            .join(" QVmemer")
            .split("serangga")
            .join("QVseranggaVQ")
            .split("lelucon")
            .join("QVleluconVQ")
            .split("kerajaan")
            .join("QVkerajaanVQ")
            .split("layang")
            .join("QVlayang")
            .split("bayang")
            .join("QVbayang")
            .split("danau")
            .join("QVdanauVQ")
            .split("hukum")
            .join("QVhukumVQ")
            .split("majalah")
            .join("QVmajalahVQ")
            .split("manusia")
            .join("QVmanusiaVQ")
            .split("topeng")
            .join("QVtopengVQ")
            .split(" matematika")
            .join(" QVmatematikaVQ")
            .split(" tengah malam")
            .join(" QVtengah malamVQ")
            .split(" susu")
            .join(" QVsusuVQ")
            .split("pagi")
            .join("QVpagiVQ")
            .split("siang")
            .join("QVsiangVQ")
            .split("malam")
            .join("QVmalamVQ")
            .split(" alam")
            .join(" QValamVQ")
            .split("berita")
            .join("QVberitaVQ")
            .split(" qur")
            .join(" QVqur")
            .split(" al-")
            .join(" QVal-")
            .split(" al ")
            .join(" QVal ")
            .split("kitab")
            .join("QVkitabVQ")
            .split("koran")
            .join("QVkoranVQ")
            .split(" laut")
            .join(" QVlautVQ")
            .split("kantor")
            .join("QVkantorVQ")
            .split("kertas")
            .join("QVkertasVQ")
            .split(" kepribadian")
            .join(" QVkepribadianVQ")
            .split("gambar")
            .join("QVgambarVQ")
            .split("kelinci")
            .join("QVkelinciVQ")
            .split("sungai")
            .join("QVsungaiVQ")
            .split("berjalan")
            .join("QVberjalanVQ")
            .split("ilmu")
            .join("QVilmuVQ")
            .split("ular")
            .join("QVularVQ")
            .split(" masyarakat")
            .join(" QVmasyarakatVQ")
            .split("lagu")
            .join("QVlaguVQ")
            .split("gula")
            .join("QVgulaVQ")
            .split("musim")
            .join("QVmusimVQ")
            .split("guru")
            .join("QVguruVQ")
            .split("pakaian")
            .join("QVpakaianVQ")
            .split(" sayur")
            .join(" QVsayurVQ")
            .split("kendaraan")
            .join("QVkendaraanVQ")
            .split("kekayaan")
            .join("QVkekayaan")
            .split(" cuaca")
            .join(" QVcuacaVQ")
            .split("istri")
            .join("QVistriVQ")
            .split(" suami")
            .join(" QVsuamiVQ")
            .split("isteri")
            .join("QVisteriVQ")
            .split("kayu")
            .join("QVkayuVQ")
            .split(" dunia")
            .join(" QVduniaVQ")
            .split(" semesta")
            .join(" QVsemestaVQ")
            .split("hitungan")
            .join("QVhitunganVQ")
            .split("rindu")
            .join("QVrinduVQ")
            .split("kurikulum")
            .join("QVkurikulumVQ")
            .split("gedung")
            .join("QVgedungVQ");
          var TuIT = TleT.split(" pertandingan")
            .join(" QVpertandinganVQ")
            .split(" naungan")
            .join(" QVnaunganVQ")
            .split("kebiasaan")
            .join("QVkebiasaanVQ")
            .split("logo")
            .join("QVlogoVQ")
            .split("kapal")
            .join("QVkapalVQ")
            .split("provinsi")
            .join("QVprovinsiVQ")
            .split("sidang")
            .join("QVsidangVQ")
            .split("konstitusi")
            .join("QVkonstitusiVQ")
            .split("minggu")
            .join("QVmingguVQ")
            .split("orde")
            .join("QVordeVQ")
            .split("pasal")
            .join("QVpasalVQ")
            .split("shalawat")
            .join("QVshalawatVQ")
            .split(" kereta ")
            .join(" QVkeretaVQ ")
            .split("warung")
            .join("QVwarungVQ")
            .split(" bengawan")
            .join(" QVbengawanVQ")
            .split(" proses")
            .join(" QVprosesVQ")
            .split("bangsa")
            .join("QVbangsaVQ")
            .split("kecamatan")
            .join("QVkecamatanVQ")
            .split("puisi")
            .join("QVpuisiVQ")
            .split(" sejarah")
            .join(" QVsejarah")
            .split(" kami ")
            .join(" QVkamiVQ ")
            .split("administrasi ")
            .join("QVadministrasi ")
            .split("kawasan")
            .join("QVkawasanVQ")
            .split("puasa")
            .join("QVpuasaVQ")
            .split("perjalanan")
            .join("QVperjalananVQ")
            .split("bulan")
            .join("QVbulanVQ")
            .split(" jam")
            .join(" QVjamVQ")
            .split("cincin")
            .join("QVcincinVQ")
            .split("pisau")
            .join("QVPisauVQ")
            .split("rumusan")
            .join("QVrumusanVQ")
            .split("teknologi")
            .join("QVteknologi")
            .split("gunung")
            .join("QVgunungVQ")
            .split("benua")
            .join("QVbenuaVQ")
            .split("jaman")
            .join("QVjaman")
            .split("lembar")
            .join("QVlembar")
            .split("tumpuk")
            .join("QVtumpuk")
            .split("kesabaran")
            .join("QVkesabaran")
            .split("kebudayaan")
            .join("QVkebudayaanVQ")
            .split("budaya")
            .join("QVbudayaVQ")
            .split("jaringan")
            .join("QVjaringanVQ")
            .split("suntingan")
            .join("QVsuntinganVQ")
            .split("industri")
            .join("QVindustriVQ")
            .split("sumur")
            .join("QVsumurVQ")
            .split("mata")
            .join("QVmataVQ")
            .split("hari")
            .join("QVhariVQ")
            .split("tanah")
            .join("QVtanahVQ")
            .split("tangan")
            .join("QVtanganVQ")
            .split("versi")
            .join("QVversiVQ")
            .split("partai")
            .join("QVpartaiVQ")
            .split("rambut")
            .join("QVrambutVQ")
            .split("kulit")
            .join("QVkulitVQ")
            .split(" unsur")
            .join(" QVunsurVQ")
            .split(" momen")
            .join(" QVmomen")
            .split(" muka")
            .join(" QVmukaVQ")
            .split(" blog")
            .join(" QVblog")
            .split(" ratus")
            .join(" QVratus")
            .split(" bidang")
            .join(" QVbidangVQ")
            .split(" budaya")
            .join(" QVbudayaVQ")
            .split(" menanggapi")
            .join(" QVmenanggapi")
            .split(" koper")
            .join(" QVkoperVQ")
            .split(" tataran")
            .join(" QVtataranVQ")
            .split(" bisnis")
            .join(" QVbisnisVQ")
            .split(" uang")
            .join(" QVuangVQ")
            .split(" novel")
            .join(" QVnovelVQ")
            .split(" kesalahan")
            .join(" QVkesalahan")
            .split(" salah")
            .join(" QVsalah")
            .split(" kalangan")
            .join(" QVkalanganVQ")
            .split("pura")
            .join("QVpuraVQ")
            .split(" kesukaran")
            .join(" QVkesukaran")
            .split("tradisi")
            .join("QVtradisiVQ")
            .split("tulisan")
            .join("QVtulisanVQ")
            .split(" parkiran")
            .join(" QVparkiranVQ")
            .split(" jembatan")
            .join(" QVjembatanVQ")
            .split(" keanekaragaman")
            .join(" QVkeanekaragamanVQ")
            .split(" keragaman")
            .join(" QVkeragamanVQ")
            .split(" hutan")
            .join(" QVhutanVQ")
            .split(" kesalahan")
            .join(" QVkesalahan")
            .split(" keraton")
            .join(" QVkeratonVQ")
            .split(" kraton")
            .join(" QVkratonVQ")
            .split(" kita ")
            .join(" QVkitaVQ ")
            .split(" gol ")
            .join(" QVgolVQ ")
            .split(" aku")
            .join(" QVaku")
            .split(" tas")
            .join(" QVtas")
            .split("wikipedia")
            .join("QVwikipediaVQ")
            .split("dia ")
            .join("QVdia ")
            .split("jalanan")
            .join("QVjalananVQ")
            .split("jalan")
            .join("QVjalanVQ")
            .split("pengguna")
            .join("QVpenggunaVQ")
            .split(" prod")
            .join(" QVprod")
            .split(" karung")
            .join(" QVkarung")
            .split(" paragraf")
            .join(" QVparagrafVQ")
            .split("sawah")
            .join("QVsawahVQ")
            .split("raja")
            .join("QVrajaVQ")
            .split("merek")
            .join("QVmerekVQ")
            .split("merk")
            .join("QVmerkVQ")
            .split("konteks")
            .join("QVkonteksVQ")
            .split(" para ")
            .join(" QVpara ")
            .split(" bursa ")
            .join(" QVbursa ")
            .split(" teks")
            .join(" QVteks")
            .split(" goni")
            .join(" QVgoni")
            .split(" nasi ")
            .join(" QVnasi ")
            .split(" garam ")
            .join(" QVgaram ")
            .split(" botol ")
            .join(" QVbotolVQ ")
            .split(" bantal ")
            .join(" QVbantalVQ ")
            .split(" seprei ")
            .join(" QVsepreiVQ ")
            .split("bagian")
            .join("QVbagianVQ")
            .split("sistem")
            .join("QVsistemVQ")
            .split(" selimut ")
            .join(" QVselimutVQ ")
            .split(" kaca ")
            .join(" QVkacaVQ ")
            .split(" bedak ")
            .join(" QVbedakVQ ")
            .split("acara")
            .join("QVacaraVQ")
            .split(" ber")
            .join(" QXber")
            .split(" mem")
            .join(" QXmem")
            .split("VQ lain")
            .join(" liya")
            .split("VQ lama")
            .join(" lawas")
            .split("VQ baru")
            .join(" anyar")
            .split("VQ")
            .join("")
            .split(" lawasran")
            .join(" lamaran");
          var TrT = TuIT.split(" nomor ")
            .join(" nomor")
            .split("triliun sembilan QV")
            .join("triliun sanga ")
            .split("triliun delapan QV")
            .join("triliun wolu ")
            .split("triliun tujuh QV")
            .join("triliun pitu ")
            .split("triliun enam QV")
            .join("triliun enem ")
            .split("triliun lima QV")
            .join("triliun limaa ")
            .split("triliun empat QV")
            .join("triliun papat ")
            .split("triliun tiga QV")
            .join("triliun telu ")
            .split("triliun dua QV")
            .join("triliun loro ")
            .split("triliun satu QV")
            .join("triliun siji ")
            .split("miliar sembilan QV")
            .join("miliar sanga ")
            .split("miliar delapan QV")
            .join("miliar wolu ")
            .split("miliar tujuh QV")
            .join("miliar pitu ")
            .split("miliar enam QV")
            .join("miliar enem ")
            .split("miliar lima QV")
            .join("miliar limaa ")
            .split("miliar empat QV")
            .join("miliar papat ")
            .split("miliar tiga QV")
            .join("miliar telu ")
            .split("miliar dua QV")
            .join("miliar loro ")
            .split("miliar satu QV")
            .join("miliar siji ")
            .split("juta sembilan QV")
            .join("juta sanga ")
            .split("juta delapan QV")
            .join("juta wolu ")
            .split("juta tujuh QV")
            .join("juta pitu ")
            .split("juta enam QV")
            .join("juta enem ")
            .split("juta lima QV")
            .join("juta limaa ")
            .split("juta empat QV")
            .join("juta papat ")
            .split("juta tiga QV")
            .join("juta telu ")
            .split("juta dua QV")
            .join("juta loro ")
            .split("juta satu QV")
            .join("juta siji ")
            .split("ribu sembilan QV")
            .join("ribu sanga ")
            .split("ribu delapan QV")
            .join("ribu wolu ")
            .split("ribu tujuh QV")
            .join("ribu pitu ")
            .split("ribu enam QV")
            .join("ribu enem ")
            .split("ribu lima QV")
            .join("ribu limaa ")
            .split("ribu empat QV")
            .join("ribu papat ")
            .split("ribu tiga QV")
            .join("ribu telu ")
            .split("ribu dua QV")
            .join("ribu loro ")
            .split("ribu satu QV")
            .join("ribu siji ")
            .split("ratus sembilan QV")
            .join("ratus sanga ")
            .split("ratus delapan QV")
            .join("ratus wolu ")
            .split("ratus tujuh QV")
            .join("ratus pitu ")
            .split("ratus enam QV")
            .join("ratus enem ")
            .split("ratus lima QV")
            .join("ratus limaa ")
            .split("ratus empat QV")
            .join("ratus papat ")
            .split("ratus tiga QV")
            .join("ratus telu ")
            .split("ratus dua QV")
            .join("ratus loro ")
            .split("ratus satu QV")
            .join("ratus siji ")
            .split("puluh sembilan QV")
            .join("puluh sanga ")
            .split("puluh delapan QV")
            .join("puluh wolu ")
            .split("puluh tujuh QV")
            .join("puluh pitu ")
            .split("puluh enam QV")
            .join("puluh enem ")
            .split("puluh lima QV")
            .join("puluh limaa ")
            .split("puluh empat QV")
            .join("puluh papat ")
            .split("puluh tiga QV")
            .join("puluh telu ")
            .split("puluh dua QV")
            .join("puluh loro ")
            .split("puluh satu QV")
            .join("puluh siji ")
            .split("seket sembilan QV")
            .join("seket sanga ")
            .split("seket delapan QV")
            .join("seket wolu ")
            .split("seket tujuh QV")
            .join("seket pitu ")
            .split("seket enam QV")
            .join("seket enem ")
            .split("seket lima QV")
            .join("seket limaa ")
            .split("seket empat QV")
            .join("seket papat ")
            .split("seket tiga QV")
            .join("seket telu ")
            .split("seket dua QV")
            .join("seket loro ")
            .split("seket satu QV")
            .join("seket siji ")
            .split("sawidak sembilan QV")
            .join("sawidak sanga ")
            .split("sawidak delapan QV")
            .join("sawidak wolu ")
            .split("sawidak tujuh QV")
            .join("sawidak pitu ")
            .split("sawidak enam QV")
            .join("sawidak enem ")
            .split("sawidak lima QV")
            .join("sawidak limaa ")
            .split("sawidak empat QV")
            .join("sawidak papat ")
            .split("sawidak tiga QV")
            .join("sawidak telu ")
            .split("sawidak dua QV")
            .join("sawidak loro ")
            .split("sawidak satu QV")
            .join("sawidak siji ")
            .split(" satu QV")
            .join(" sa ")
            .split(" dua QV")
            .join(" rong ")
            .split(" tiga QV")
            .join(" telung ")
            .split(" empat QV")
            .join(" patang ")
            .split(" lima QV")
            .join(" limang ")
            .split(" enam QV")
            .join(" nem ")
            .split(" tujuh QV")
            .join(" pitung ")
            .split(" delapan QV")
            .join(" wolung ")
            .split(" sembilan QV")
            .join(" sangang ")
            .split(" beberapa QV")
            .join(" pirang-pirang ")
            .split(" QXberapa QV")
            .join(" pirang ")
            .split(" hasratnya QV")
            .join(" krenteging ")
            .split(" hasrat QV")
            .join(" krenteging ")
            .split(" timurnya QV")
            .join(" wetaning ")
            .split(" timur QV")
            .join(" wetaning ")
            .split(" tenggaranya QV")
            .join(" kidul-wetaning ")
            .split(" tenggara QV")
            .join(" kidul-wetaning ")
            .split(" selatannya QV")
            .join(" kiduling ")
            .split(" selatan QV")
            .join(" kiduling ")
            .split(" barat-dayanya QV")
            .join(" kidul-kuloning ")
            .split(" barat-daya QV")
            .join(" kidul-kuloning ")
            .split(" baratnya QV")
            .join(" kuloning ")
            .split(" barat QV")
            .join(" kuloning ")
            .split(" barat-lautnya QV")
            .join(" lor-kuloning ")
            .split(" barat-laut QV")
            .join(" lor-kuloning ")
            .split(" utaranya QV")
            .join(" loring ")
            .split(" utara QV")
            .join(" loring ")
            .split(" timur-lautnya QV")
            .join(" lor-wetaning ")
            .split(" timur-laut QV")
            .join(" lor-wetaning ")
            .split(" rangkaian QV")
            .join(" rerangkening ")
            .split(" seQVjenis QV")
            .join(" sajinising ")
            .split(" QVjenisnya QV")
            .join(" jinising ")
            .split(" QVjenis QV")
            .join(" jinising ")
            .split(" QVjenis-QVjenisnya QV")
            .join(" jinis-jinising ")
            .split(" QVjenis-QVjenis QV")
            .join(" jinis-jinising ")
            .split(" sebalik QV")
            .join(" sawaliking ")
            .split(" balik QV")
            .join(" waliking ")
            .split(" sekitarnya QV")
            .join(" sawataraning ")
            .split(" sekitar QV")
            .join(" wataraning ")
            .split(" QVkeseluruhan QV")
            .join(" sakabehaning ")
            .split(" semuanya QV")
            .join(" kabehing ")
            .split(" semua QV")
            .join(" kabehing ")
            .split(" seluruhnya QV")
            .join(" kabehing ")
            .split(" seluruh QV")
            .join(" kabehing ")
            .split(" sebelahnya QV")
            .join(" iringaning ")
            .split(" sebelah QV")
            .join(" iringaning ")
            .split(" sisinya QV")
            .join(" iringaning ")
            .split(" sisi QV")
            .join(" iringaning ")
            .split(" setengahnya QV")
            .join(" setengahing ")
            .split(" setengah QV")
            .join(" setengahing ")
            .split(" tengahnya QV")
            .join(" tengahing ")
            .split(" tengah QV")
            .join(" tengahing ")
            .split(" bawahnya QV")
            .join(" ngisoring ")
            .split(" bawah QV")
            .join(" ngisoring ")
            .split(" sampingnya QV")
            .join(" iringaning ")
            .split(" samping QV")
            .join(" iringaning ")
            .split(" belakangnya QV")
            .join(" wurining ")
            .split(" belakang QV")
            .join(" wurining ")
            .split(" depannya QV")
            .join(" ngareping ")
            .split(" depan QV")
            .join(" ngareping ")
            .split(" golongan QV")
            .join(" golonganing ")
            .split(" seisinya QV")
            .join(" saisining ")
            .split(" seisi QV")
            .join(" saisining ")
            .split(" di dalam QV")
            .join(" sajroning ")
            .split(" dalam QV")
            .join(" jroning ")
            .split(" berjalannya QV")
            .join(" lumakuning ")
            .split(" berjalan QV")
            .join(" lumakuning ")
            .split(" luarnya QV")
            .join(" jabaning ")
            .split(" luar QV")
            .join(" jabaning ")
            .split(" awalnya QV")
            .join(" wiwiting ")
            .split(" mulainya QV")
            .join(" wiwiting ")
            .split(" awal QV")
            .join(" wiwiting ")
            .split(" sejak QV")
            .join(" wiwiting ")
            .split(" sekejapnya QV")
            .join(" sakedheping ")
            .split(" sekejap QV")
            .join(" sakedheping ")
            .split(" jumlahnya QV")
            .join(" cacahing ")
            .split(" jumlah QV")
            .join(" cacahing ")
            .split(" atasnya QV")
            .join(" dhuwuring ")
            .split(" atas QV")
            .join(" dhuwuring ")
            .split(" kumpulannya QV")
            .join(" kumpulaning ")
            .split(" kumpulan QV")
            .join(" kumpulaning ")
            .split(" pinggir QV")
            .join(" pinggiring ")
            .split(" tepinya QV")
            .join(" tepining ")
            .split(" tepian QV")
            .join(" tepining ")
            .split(" tepi QV")
            .join(" tepining ")
            .split(" tugasnya QV")
            .join(" jejibahaning ")
            .split(" tugas QV")
            .join(" jejibahaning ")
            .split(" nama-nama QV")
            .join(" aran-araning ")
            .split(" nama QV")
            .join(" araning ")
            .split(" adabnya QX")
            .join(" unggah-ungguhing ")
            .split(" adab QX")
            .join(" unggah-ungguhing ")
            .split(" di dalam QX")
            .join(" sajroning ")
            .split(" dalam QX")
            .join(" jroning ")
            .split(" sama QV")
            .join(" dengan ")
            .split(" semua QV")
            .join(" sakabehing ")
            .split(" kemajuannya QV")
            .join(" kamajuaning ")
            .split(" kemajuan QV")
            .join(" kamajuaning ")
            .split(" majunya QV")
            .join(" majuning ")
            .split(" pangkuannya QV")
            .join(" pangkoning ")
            .split(" pangkuan QV")
            .join(" pangkoning ")
            .split(" lamanya QV")
            .join(" suwening ")
            .split(" lama QV")
            .join(" suwening ")
            .split(" salah satu QV")
            .join(" sawijining ")
            .split(" puncaknya QV")
            .join(" pucuking ")
            .split(" puncak QV")
            .join(" pucuking ")
            .split(" pucuknya QV")
            .join(" pucuking ")
            .split(" pucuk QV")
            .join(" pucuking ")
            .split(" QVbuahnya QV")
            .join(" wohing ")
            .split(" QVbuah QV")
            .join(" wohing ")
            .split(" urutannya QV")
            .join(" urutaning ")
            .split(" urutan QV")
            .join(" urutaning ")
            .split(" batasnya QV")
            .join(" watesing ")
            .split(" batas QV")
            .join(" watesing ")
            .split(" dinginnya QV")
            .join(" adheming ")
            .split(" dingin QV")
            .join(" adheming ")
            .split(" halusnya QV")
            .join(" alusing ")
            .split(" halus QV")
            .join(" alusing ")
            .split(" QVtempat QV")
            .join(" panggonaning ")
            .split(" suburnya QV")
            .join(" suburing ")
            .split(" subur QV")
            .join(" suburing ")
            .split(" banyaknya QV")
            .join(" akehing ")
            .split(" QVpanasnya QV")
            .join(" panasing ")
            .split(" QVpanas QV")
            .join(" panasing ")
            .split(" sinarnya QV")
            .join(" sinaring ")
            .split(" sinar QV")
            .join(" sinaring ")
            .split(" subur QV")
            .join(" suburing ")
            .split(" QVmerekahnya QV")
            .join(" mletheking ")
            .split(" mekarnya QV")
            .join(" mekaring ")
            .split(" mekar QV")
            .join(" mekaring ")
            .split(" isi QV")
            .join(" isining ")
            .split(" unggah-ungguhnya QV")
            .join(" unggah-ungguhing ")
            .split(" unggah-ungguh QV")
            .join(" unggah-ungguhing ")
            .split(" belahannya QV")
            .join(" sigaraning ")
            .split(" belahan QV")
            .join(" sigaraning ")
            .split(" xxx QV")
            .join(" xxx ")
            .split(" xxx QV")
            .join(" xxx ")
            .split(" xxx QV")
            .join(" xxx ")
            .split(" xxx QV")
            .join(" xxx ")
            .split(" xxx QV")
            .join(" xxx ")
            .split(" xxx QV")
            .join(" xxx ")
            .split(" xxx QV")
            .join(" xxx ")
            .split(" xxx QV")
            .join(" xxx ")
            .split(" bagi QV")
            .join(" untuk ")
            .split("QV")
            .join("")
            .split("QX")
            .join("")
            .split(" nomor")
            .join(" nomor ");
          var TlT = TrT.split(" mahu ")
            .join(" mau ")
            .split(" kita sendiri ")
            .join(" kita ")
            .split(" terus jalan")
            .join(" terus berjalan")
            .split(" potong rambut")
            .join(" cukur")
            .split("3 lalu")
            .join("3 silam")
            .split(" lagi bingung")
            .join(" sedang bingung")
            .split("lakukan kaene")
            .join("lakukannya")
            .split(" anak muda")
            .join(" bocah muda")
            .split(" baik hati")
            .join(" baik-hati")
            .split(" batu asah")
            .join(" wungkal")
            .split(" jangan percaya")
            .join(" jangan nggugu")
            .split(" zig zag ")
            .join(" zigzag ")
            .split(" bermacam macam")
            .join(" bermacam-macam")
            .split(" acap kali")
            .join(" kadhangkala")
            .split(" habis ke ")
            .join(" bibar ke ")
            .split("tindak tanduk")
            .join("tindaktanduk")
            .split(" air terjun")
            .join(" grojogan")
            .split(" ke atas")
            .join(" mendhuwur")
            .split(" lama di")
            .join(" lawas di")
            .split(" ke bawah")
            .join(" mengingsor")
            .split(" selama lamanya")
            .join(" selama-lamanya")
            .split(" buat kita")
            .join(" untuk kita")
            .split(" tahu susur")
            .join(" tahuu susur")
            .split("menaikan harga")
            .join("mundakake harga")
            .split("menaikkan harga")
            .join("mundakake harga")
            .split(" gak papa")
            .join(" tak apa apa")
            .split(" ga papa")
            .join(" tak apa apa")
            .split(" mau kasih ")
            .join(" mau memberi ")
            .split(" ketawa ketiwi")
            .join(" kikak kikik")
            .split(" bagi bagi")
            .join(" bagi-bagi")
            .split(" buat saya")
            .join(" untuk saya")
            .split(" bagi saya")
            .join(" untuk saya")
            .split(" tukar menukar")
            .join(" tukar-menukar")
            .split(" lalat buah")
            .join(" lalat-buah")
            .split(" baru kali ini")
            .join(" nembe pisan ini")
            .split(" jangan percaya")
            .join(" jangan percaya")
            .split(" akhir akhir")
            .join(" akhir-akhir")
            .split(" lalu waktu")
            .join(" banjur waktu")
            .split(" lalu saat")
            .join(" banjur saat")
            .split("uang logam")
            .join("uang kricik")
            .split(" sangkut pautnya")
            .join(" gandeng cenenge")
            .split(" mendarah daging")
            .join(" mbalung sungsum")
            .split(" lalu pergi")
            .join(" banjur pergi")
            .split("senin lalu")
            .join("senin wingi")
            .split(" kemarin dulu")
            .join(" winginane")
            .split("guru bantu")
            .join("guru-bantu")
            .split(" sama orang")
            .join(" dengan orang")
            .split(" lalu jadi")
            .join(" banjur jadi")
            .split(" punya siapa")
            .join(" gadhahipun siapa")
            .split(" tinggal serumah")
            .join(" manggon serumah")
            .split(" tinggal bareng")
            .join(" manggon bareng")
            .split("masing masing")
            .join("masing-masing")
            .split("kita masing-masing")
            .join("kita piyambak-piyambak")
            .split("kalau lagi")
            .join("kalau sedang")
            .split("kalo lagi")
            .join("kalo sedang")
            .split(" orang baru")
            .join(" orang enggal")
            .split(" enggak mau")
            .join(" tidak gelem")
            .split(" mau gak mau")
            .join(" gelem tidak gelem")
            .split(" kaki lima")
            .join(" kaki-lima")
            .split(" tempat tinggal")
            .join(" tempat manggon")
            .split(" nelen obat")
            .join(" ngeleg obat")
            .split(" yang lagi")
            .join(" yang lagii")
            .split(" buat yang")
            .join(" nggo yang")
            .split(" buat yang")
            .join(" nggo yang")
            .split(" lagi musim")
            .join(" lagii musim")
            .split(" mau sama ")
            .join(" mau dengan ")
            .split(" sayang sama ")
            .join(" sayang dengan ")
            .split(" ngeliat ")
            .join(" melihat ")
            .split(" melihat ke")
            .join(" lihat ke")
            .split("nurut sama ")
            .join("nurut dengan ")
            .split(" aku pikir ")
            .join(" dak pikir ")
            .split(" naik mobil")
            .join(" menaiki mobil")
            .split(" baru tahu")
            .join(" nembe tahu")
            .split(" buat apa")
            .join(" untuk apa")
            .split(" antar jemput")
            .join(" antar-jemput")
            .split("batu bata")
            .join("batu-bata")
            .split("janji sama ")
            .join("janji dengan ")
            .split(" sama si ")
            .join(" dengan si ")
            .split(" lalu tiba")
            .join(" banjur tiba")
            .split(" sekali kali ")
            .join(" sekali-kali ")
            .split(" keluar air")
            .join(" ngetuk air")
            .split(" kerap kali ")
            .join(" kerap ")
            .split(" buat kamu")
            .join(" untuk kamu")
            .split(" buat kami")
            .join(" untuk kami")
            .split(" tegur sapa")
            .join(" pasrawungan")
            .split(". lalu, ")
            .join(". banjur, ")
            .split(") lalu,")
            .join(") rumiyin,")
            .split(" lagi maha ")
            .join(" lagii maha ")
            .split(" akan hal ")
            .join(" mengenai hal ")
            .split("tahun sekali")
            .join("tahun sepisan")
            .split("temu sama ")
            .join("temu dengan ")
            .split("mudah mudahan")
            .join("mudah-mudahan")
            .split(" lalu lalang")
            .join(" lalu-lalang")
            .split(" potongan tahu")
            .join(" potongan tahuu")
            .split(" buat hadapi")
            .join(" untuk hadapi")
            .split(" jadi mungkin")
            .join(" jadi mungkinn")
            .split("telanjang bulat")
            .join("telanjang bral")
            .split("masa lalu")
            .join("masa silam")
            .split(" lain sebagainya")
            .join(" sebagainya")
            .split(" lalu me")
            .join(" banjur me")
            .split("hancur lebur")
            .join("hancur lantak")
            .split(" ketupat ")
            .join(" kupat ")
            .split(" kupat tahu")
            .join(" kupat tahuu")
            .split(" turun temurun")
            .join(" turun-temurun")
            .split(" sama mereka")
            .join(" dengan mereka")
            .split("wilayah masing-masing")
            .join("wilayah piyambak-piyambak")
            .split("seneng")
            .join("senang")
            .split("kemaren")
            .join("kemarin")
            .split("uari lalu")
            .join("uari wingi")
            .split("maret lalu")
            .join("maret wingi")
            .split(" kali per")
            .join(" kaping per")
            .split(" tahu cokol")
            .join(" tahuu cokol")
            .split(" kaya mau ")
            .join(" kayaa mau ")
            .split("sana sana")
            .join("sana-sana")
            .split("sana sini")
            .join("sana-sini")
            .split("sini sini")
            .join("sini-sini")
            .split('"ke ')
            .join('" ke ')
            .split("'ke ")
            .join("' ke ")
            .split(" lalu apa")
            .join(" banjur apa")
            .split("untuk sekali")
            .join("untuk sepisan")
            .split("lama kelamaan")
            .join("lama-kelamaan")
            .split(" isteri")
            .join(" istri")
            .split(" sang suami")
            .join(" sing-lanang")
            .split(" sang istri")
            .join(" sing-wadon")
            .split(" seorang suami")
            .join(" sing-lanang")
            .split(" seorang istri")
            .join(" sing-wadon")
            .split(" kosa kata")
            .join(" kosakata")
            .split(" lawan kata")
            .join(" kosok balen")
            .split(" hiruk pikuk")
            .join(" ramai")
            .split(" pakaian dalam")
            .join(" pakaian daleman")
            .split(" meminta izin")
            .join(" pamit")
            .split(" minta izin")
            .join(" pamit")
            .split(" make up")
            .join(" paesan")
            .split(" segala gala")
            .join(" segala-gala")
            .split(" ayah ibu")
            .join(" ayah-ibu")
            .split(" tahu,")
            .join(" tahu,")
            .split(" tahu mentah")
            .join(" tahuu mentah")
            .split(" tahu di ")
            .join(" tahuu di ")
            .split(" ikan bakar")
            .join(" ikan-bakar")
            .split("goreng tahu")
            .join("goreng tahuu")
            .split(" kali lipat")
            .join(" kali lipet")
            .split(" terang bulan")
            .join(" padang bulan")
            .split(" kosa kata")
            .join(" kosa kataa")
            .split("telepon")
            .join("telpon")
            .split(" ke engganan")
            .join(" ke-engganan")
            .split("nya masing-masing")
            .join("nya piyambak-piyambak")
            .split("ampas tahu")
            .join("ampas tahuu")
            .split(" berapa kali")
            .join(" kaping berapa")
            .split(" ban dalam")
            .join(" ban dalem")
            .split(" lalu siapa")
            .join(" banjur siapa")
            .split(" tinggal hitung")
            .join(" nggari hitung")
            .split("an masing-masing")
            .join("an piyambak-piyambak")
            .split(" naik kelas")
            .join(" minggah kelas")
            .split(" kenaikan kelas")
            .join(" inggah-inggahan kelas")
            .split(" tahu kuning")
            .join(" tahuu kuning")
            .split(" hanya sekali")
            .join(" hanya sepisan")
            .split(" cuma sekali")
            .join(" cuma sepisan")
            .split(" sudut pandang")
            .join(" sudutt pandang")
            .split(" gempa bumi")
            .join(" gempa-bumi")
            .split("rumah tua")
            .join("rumah suwung")
            .split(" tak berpenghuni")
            .join(" suwung")
            .split(" paku beling")
            .join(" sunggan")
            .split(" seumur hidup")
            .join(" saumur hidup")
            .split("terkena beling")
            .join(" kesungga beling")
            .split(" rabun senja")
            .join(" kotok ayam")
            .split(" kotoran ayam")
            .join(" tembelek ayam")
            .split("jalan jalan")
            .join("jalan-jalan")
            .split(" jalan-jalan kecil")
            .join(" dalan-dalan kecil")
            .split("jalan-jalan besar")
            .join("dalan-dalan besar")
            .split(" mengadu nasib")
            .join("ngadu nasib")
            .split("kali lipat")
            .join("kali lipatt")
            .split("waktu lalu")
            .join("waktu wingi")
            .split(" tinggal berapa")
            .join(" kari berapa")
            .split(" ubi jalar")
            .join(" boled")
            .split(" ubi kayu")
            .join(" bodin")
            .split(" pena-nya")
            .join(" pulpene")
            .split(" bagian timur")
            .join(" sisi timur")
            .split(" bagian selatan")
            .join(" sisi selatan")
            .split(" bagian barat")
            .join(" sisi barat")
            .split(" bagian utara")
            .join(" sisi utara")
            .split("hujan deras")
            .join("hujan gemerot")
            .split(" serabut kelapa")
            .join(" tepes kelapa")
            .split("kan kembali")
            .join("kan laggi")
            .split(" ruang tamu")
            .join(" mbale")
            .split(" berlalu lalang")
            .join(" lalu-lalang")
            .split(" terkena paku ")
            .join(" kesungga ")
            .split(" lantai 1")
            .join(" lante 1")
            .split(" lantai 2")
            .join(" lante 2")
            .split(" lantai 3")
            .join(" lante 3")
            .split(" lantai 4")
            .join(" lante 4")
            .split(" lantai 5")
            .join(" lante 5")
            .split(" lantai 6")
            .join(" lante 6")
            .split(" lantai 7")
            .join(" lante 7")
            .split(" lantai 8")
            .join(" lante 8")
            .split(" lantai 9")
            .join(" lante 9")
            .split(" suka cita")
            .join(" sukacita")
            .split(" oleh oleh")
            .join(" oleh-oleh")
            .split(" lalu ber")
            .join(" banjur ber")
            .split(" serta merta")
            .join(" serta-merta")
            .split(" hujan angin")
            .join(" hujan-angin")
            .split(" sekali teguk")
            .join(" sa-guk-an")
            .split(" sekali telan")
            .join(" sa-leg-an")
            .split(" keadaan mengandung")
            .join(" keadaan hamil")
            .split(" tali pusar")
            .join(" pusar")
            .split(" khalayak ramai ")
            .join(" khalayak ageng ")
            .split(" lalu kamu")
            .join(" banjur kamu")
            .split(" lalu kau")
            .join(" banjur kau")
            .split(" lalu kalian")
            .join(" banjur kalian")
            .split(" lalu kita")
            .join(" banjur kita")
            .split(" daun ubi")
            .join(" lengguk")
            .split("0 lalu")
            .join("0 silam")
            .split(" habis itu")
            .join(" bibar itu")
            .split("sejak lama")
            .join("sejak dulu")
            .split(" malang melintang")
            .join(" malang-melintang")
            .split(" lebaran haji")
            .join(" badha ji")
            .split(" angkutan umum")
            .join(" embret")
            .split(" kendaraan umum")
            .join(" embret")
            .split(". lalu")
            .join(". banjur")
            .split("di duri")
            .join("di durii")
            .split(" mulai ber")
            .join(" molai ber")
            .split(" sampai sampai")
            .join(" sampai-sampai")
            .split(" kolam renang")
            .join(" kolam-renang")
            .split(" melimpah ruah")
            .join(" melimpah-ruah")
            .split("tidak jadi masalah")
            .join("tidak dadi masalah")
            .split("tak jadi masalah")
            .join("tak dadi masalah")
            .split(" masing-masing.")
            .join(" piyambak-piyambak.")
            .split(" bala tentara")
            .join(" tentara bala")
            .split(" habis dari ")
            .join(" bibar dari ")
            .split(" kalau seperti")
            .join(" bila seperti")
            .split("warna terang")
            .join("warna mencreng")
            .split(" bola lampu")
            .join(" bohlam")
            .split(" naik sepeda")
            .join(" menaiki sepeda")
            .split(" mata kuliah")
            .join(" mataa kuliah")
            .split(" meletusnya gunung")
            .join(" mbledhugipun gunung")
            .split("terdiri atas")
            .join("terdiri dari")
            .split(" lubang sampah")
            .join(" blumbang")
            .split(" habis kemana")
            .join(" bibar kemana")
            .split(" kan ? ")
            .join(" ya ? ")
            .split("wedang")
            .join("wedhang")
            .split(" wedhang teh manis")
            .join(" wedhang manis")
            .split(" teh manis")
            .join(" wedhang manis")
            .split(" anak istri")
            .join(" anak-istri")
            .split(" ke mari")
            .join(" kemari")
            .split("mobil tank")
            .join("mobil krapyak")
            .split("menadahkan tangan")
            .join("nodongake tangan")
            .split("tahu isi")
            .join("tahuu isi")
            .split(" terkena ranjau")
            .join(" kesungga")
            .split(" selamat pagi")
            .join(" sugeng enjing")
            .split(" sama calo")
            .join(" dengan calo")
            .split(" buat beli")
            .join(" untuk beli");
          var TuT = TlT.split(" tentang hal")
            .join(" ngenani hal")
            .split("sana sekali ")
            .join("sana sepisan ")
            .split("! lalu ")
            .join("! banjur ")
            .split("? lalu ")
            .join("? banjur ")
            .split("sekujur tubuh")
            .join("sabadan sakojor")
            .split("sekujur badan")
            .join("sebadan sakojur")
            .split(" lalu aku ")
            .join(" banjur aku ")
            .split("gula jawa")
            .join("gula merah")
            .split("air kencing")
            .join("air uyuh")
            .split("tidak mahu")
            .join("tidak gelem")
            .split(" terlalu masak")
            .join(" kematengen")
            .split("adu domba")
            .join("adudomba")
            .split("catatan")
            .join("cathetan")
            .split(" selamat siang")
            .join(" sugeng siyang")
            .split("kotoran kambing")
            .join("tai mendil")
            .split("kotoran domba")
            .join("tai mendil")
            .split(" berapa lembar")
            .join(" pirang lembar")
            .split(" selamat sore")
            .join(" sugeng sonten")
            .split("tepuk tangan")
            .join("tepuk-tangan")
            .split("menyisihkan sedikit")
            .join("ngengah sedikit")
            .split("bunga hias")
            .join("bunga petetan")
            .split("tumbuhan hias")
            .join("tumbuhan petetan")
            .split(" kata ganti ")
            .join(" kata sesulih ")
            .split("tahun lalu")
            .join("tahun silam")
            .split("arik benang merah")
            .join("arik benang-merah")
            .split("senyum simpul")
            .join("senyum mesem")
            .split("sebaik baik")
            .join("sebaik-baik")
            .split(" selamat malam")
            .join(" sugeng ndalu")
            .split(" selamat datang")
            .join(" sugeng rawuh")
            .split("tif sekali")
            .join("tif banget")
            .split("kursi roda")
            .join("kursii roda")
            .split("kursi goyang")
            .join("kursii goyang")
            .split(" salam sejahtera")
            .join(" katur kawilujengan")
            .split("tidak berkesudahan")
            .join("tidak habis-habis")
            .split("tak berkesudahan")
            .join("tak habis-habis")
            .split(" mata kaki")
            .join(" kiyongan")
            .split(" kurus kering")
            .join(" kurus aking")
            .split(" sesak nafas")
            .join(" ambekanipun sesek")
            .split(" kemarin lusa")
            .join(" winginane")
            .split(" tempat siapa")
            .join(" nggone siapa")
            .split(" tempat mana")
            .join(" nggone mana")
            .split(" secepat kilat")
            .join(" sebanter kilat")
            .split("merah muda")
            .join("merah jambon")
            .split(" selamat me")
            .join(" sugeng me")
            .split("hitam pekat")
            .join("hitam banget")
            .split("jalan berbatu")
            .join("jalan rokel")
            .split("jalan yang berbatu")
            .join("jalan yang rokel")
            .split("jalan yg berbatu")
            .join("jalan yang rokel")
            .split(" darah tinggi")
            .join(" darah-tinggi")
            .split(" darah rendah")
            .join(" darah-rendah")
            .split(" kaya raya")
            .join(" kaya-raya")
            .split(" segitu gitu")
            .join(" samono-mono")
            .split(" baru ber")
            .join(" nembe ber")
            .split(" terang benderang")
            .join(" padang njinggrang")
            .split(" terang benerang")
            .join(" padang njinggrang")
            .split(" tahu siwil")
            .join(" tahuu siwil")
            .split(" tahu upil")
            .join(" tahuu upil")
            .split("bertolak belakang sama")
            .join("bertolak belakang dengan")
            .split("nikah sama")
            .join("nikah dengan")
            .split(" memukul kentongan")
            .join(" menthung kentongan")
            .split("sendal")
            .join("sandal")
            .split(" panik ")
            .join(" kedangdapan ")
            .split(" selamat be")
            .join(" sugeng be")
            .split(" ketuk pintu")
            .join(" dogdog pintu")
            .split(" selamat hari ")
            .join(" sugeng hari ")
            .split(" tinggal sisa")
            .join(" nggari sisa")
            .split(" mengusir ayam")
            .join(" nggusah ayam")
            .split(" ngusir ayam")
            .join(" nggusah ayam")
            .split(" masing masing")
            .join(" masing-masing")
            .split(" masing-masing orang")
            .join(" saben-saben orang")
            .split(" tulang punggung")
            .join(" tulang-punggung")
            .split(" teka teki")
            .join(" teka-teki")
            .split(" mondar mandir")
            .join(" mondar-mandir")
            .split(" terus bagaimana")
            .join(" toli bagaimana")
            .split(" terus gimana")
            .join(" toli gimana")
            .split(" terus mau")
            .join(" toli mau")
            .split(" terus akan")
            .join(" toli akan")
            .split(" bulir nasi")
            .join(" upa")
            .split(" anak ayam")
            .join(" kuthuk")
            .split(" terakhir kali")
            .join(" terakhir pisan")
            .split(" terahir kali")
            .join(" terahir pisan")
            .split(" belum sempat")
            .join(" belum kober")
            .split(" sapu tangan")
            .join(" sapu-tangan")
            .split("pada akhirnya")
            .join("pada-akhirnya")
            .split("timur tengah")
            .join("timur-tengah")
            .split(" kain basah")
            .join(" gombal basah")
            .split("4 lalu")
            .join("4 silam")
            .split("5 lalu")
            .join("5 silam")
            .split("sungguh sungguh")
            .join("sungguh-sungguh")
            .split("buru buru")
            .join("buru-buru")
            .split(" jam lalu")
            .join(" jam wau")
            .split(" menit lalu")
            .join(" menit wau")
            .split(" detik lalu")
            .join(" detik wau")
            .split(" selamat berpuasa")
            .join(" sugeng berpuasa")
            .split("telur busuk")
            .join("telur kuwuk")
            .split("mau jalan-jalan")
            .join("mau mlaku-mlaku")
            .split("mau jalan2")
            .join("mau mlaku2")
            .split("selasa lalu")
            .join("selasa wingi")
            .split("sering kali")
            .join("sering-kali")
            .split("i ekor")
            .join("i buntut")
            .split("tidak lain dan tidak bukan")
            .join("tidak beda dan tidak liya")
            .split("tak lain dan tak bukan")
            .join("tidak beda dan tidak liya")
            .split(" baik dari")
            .join(" baikk dari")
            .split("mulutnya terbuka")
            .join("mulutnya mangap")
            .split("mulutnya yang terbuka")
            .join("mulutnya yang mangap")
            .split("mulut terbuka")
            .join("mulut mangap")
            .split(" tanah lapang")
            .join(" lemah-lapang")
            .split(" membangunkan asrama")
            .join(" mbangunake asrama")
            .split(" membangunkan rumah")
            .join(" mbangunake rumah")
            .split(" membangunkan gedung")
            .join(" mbangunake gedung")
            .split(" membangunkan kios")
            .join(" mbangunake kios")
            .split("rabu lalu")
            .join("rabu wingi")
            .split(" lalu lintas")
            .join(" lalu-lintas")
            .split(" selamat puasa")
            .join(" sugeng puasa")
            .split("efek samping")
            .join("efek-samping")
            .split(" lambaikan tangan")
            .join(" dadah-dadah tangan")
            .split(" lambaian tangan")
            .join(" dadah-dadah tangan")
            .split(" kasih tau")
            .join(" memberi tahu")
            .split("kamis lalu")
            .join("kamis wingi")
            .split("sakit keras")
            .join("sakit parah")
            .split(" milyar ")
            .join(" miliar ")
            .split(" trilyun ")
            .join(" triliun ")
            .split(" terkesan me")
            .join(" memberi kesan me")
            .split(" kali ini")
            .join(" hari ini")
            .split(" uang koin")
            .join(" uang pecah")
            .split(" sugeng mendengarkan ")
            .join(" sugeng midhangetaken ")
            .split(" selamat jalan ")
            .join(" sugeng tindak ")
            .split(" selamat makan ")
            .join(" sugeng dhahar ")
            .split(" selamat bekerja ")
            .join(" sugeng makarya ")
            .split(" selamat tidur ")
            .join(" sugeng sare ")
            .split(" mau apa tidak")
            .join(" gelem apa tidak")
            .split(" arus balik")
            .join(" arus-balik")
            .split(" hari raya idul fitri")
            .join(" riyadi")
            .split(" hari idul fitri")
            .join(" riyadi")
            .split(" idul fitri")
            .join(" riyadi")
            .split(" anak yang")
            .join(" bocah yang")
            .split(" kata benda ")
            .join(" kata aran ")
            .split(" kata keterangan ")
            .join(" kata katrangan ")
            .split(" kata seru ")
            .join(" kata panguwuh ")
            .split(" kata depan ")
            .join(" kata pangarep ")
            .split(" kata sambung ")
            .join(" kata panyambung ")
            .split(" kata sandang ")
            .join(" kata sandhangan ")
            .split(" seperti halnya ")
            .join(" seperti dene ")
            .split(" seperti hal ")
            .join(" seperti dene ")
            .split(" tenaga kerja")
            .join(" tenaga nyambut gawe")
            .split(" curahan hati ")
            .join(" ngudhar rasa ")
            .split(" tempat tidur")
            .join(" paturon")
            .split(" anak gajah")
            .join(" bledug")
            .split(" puting beliung")
            .join(" lisus")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" bak mandi")
            .join(" kolam")
            .split(" tulang kering")
            .join(" gares")
            .split(" buang air besar")
            .join(" ngising")
            .split(" buang air kecil")
            .join(" nguyuh")
            .split(" menggosok gigi")
            .join(" sikatan gigi")
            .split(" menyikat gigi")
            .join(" sikatan gigi")
            .split(" berbincang bincang")
            .join(" berbincang-bincang")
            .split(" keong sawah")
            .join(" kraca")
            .split(" kali lipat")
            .join(" kali lipatt")
            .split("tidak mau")
            .join("tidak gelem")
            .split(" berjalan sangat cepat")
            .join(" ngenceg")
            .split(" bahu membahu")
            .join(" bahu-membahu")
            .split(" sangat terang")
            .join(" padang njinggrang")
            .split(" kasih kesempatan")
            .join(" memberi kesempatan")
            .split("es campur")
            .join("es campurr")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" selamat ulang ")
            .join(" sugeng ulang ")
            .split(" jalanan yang tidak rata")
            .join(" jalanan yang rokel")
            .split(" jalan yang tidak rata")
            .join(" jalan yang rokel")
            .split("an yang tidak rata")
            .join("an yang rokel")
            .split(" berkeluh kesah")
            .join(" ngresula")
            .split(" keluh kesah")
            .join(" ngresula")
            .split("untuk persediaan")
            .join("untuk pranti")
            .split(" buat persediaan")
            .join(" untuk pranti")
            .split(" sendok sayur")
            .join(" irus")
            .split(" sendok nasi")
            .join(" centong")
            .split(" musim kemarau")
            .join(" musim ketigga")
            .split(" tidak jadi")
            .join(" tidak sida")
            .split(" tak jadi")
            .join(" tak sida")
            .split(" kembang api")
            .join(" kembang-api")
            .split(" sewaktu di ")
            .join(" sedang di ")
            .split(" waktu di ")
            .join(" sedang di ")
            .split(" sampai sekarang")
            .join(" nganti sekarang")
            .split(" mata keranjang")
            .join(" tukmis");
          var TsT = TuT.split(" mengobrol")
            .join(" VVmengobrol")
            .split(" ngobrol")
            .join(" VVngobrol")
            .split(" makan")
            .join(" VVmakan")
            .split(" minum")
            .join(" VVminum")
            .split(" pergi")
            .join(" VVpergi")
            .split(" pulang")
            .join(" VVpulang")
            .split(" malas")
            .join(" VVmalas")
            .split(" dapat")
            .join(" VVdapat")
            .split(" mandi")
            .join(" VVmandi")
            .split(" genting")
            .join(" VVgenting")
            .split(" senang")
            .join(" VVsenang")
            .split(" seneng")
            .join(" VVseneng")
            .split(" lupa")
            .join(" VVlupa")
            .split(" sedih")
            .join(" VVsedih")
            .split(" nyinyir")
            .join(" VVnyinyir")
            .split(" ke ")
            .join(" VVke ")
            .split(" lagi VV")
            .join(" sedang ")
            .split(" pada VV")
            .join(" sama ")
            .split(" baru VV")
            .join(" nembe ")
            .split("VV")
            .join("");
          var TluT = TsT.split(" diberi pengertian").join(" dingertekake");
          var TliT = TluT.split(" terbatas")
            .join(" terbatasVZ")
            .split(" lama")
            .join(" lamaVZ")
            .split(" percaya")
            .join(" percayaVZ")
            .split(" jauh")
            .join(" jauhVZ")
            .split(" bermacam-macam")
            .join(" bermacam-macamVZ")
            .split(" menarik")
            .join(" menarikVZ")
            .split(" sederhana")
            .join(" sederhanaVZ")
            .split(" cerdas")
            .join(" cerdasVZ")
            .split(" ingin")
            .join(" inginVZ")
            .split(" baik")
            .join(" baikVZ")
            .split(" bagus")
            .join(" bagusVZ")
            .split(" kotor")
            .join(" kotorVZ")
            .split(" panjang")
            .join(" panjangVZ")
            .split(" ramai")
            .join(" ramaiVZ")
            .split(" jarang")
            .join(" jarangVZ")
            .split(" dingin")
            .join(" dinginVZ")
            .split(" sering")
            .join(" seringVZ")
            .split(" tega")
            .join(" tegaVZ")
            .split(" malu")
            .join(" maluVZ")
            .split(" hitam")
            .join(" hitamVZ")
            .split(" lapar")
            .join(" laparVZ")
            .split(" malam")
            .join(" malamVZ")
            .split(" pintar")
            .join(" pintarVZ")
            .split(" nikmat")
            .join(" nikmatVZ")
            .split(" santun")
            .join(" santunVZ")
            .split(" hebat")
            .join(" hebatVZ")
            .split(" susah")
            .join(" susahVZ")
            .split(" gawat")
            .join(" gawatVZ")
            .split(" kagum")
            .join(" kagumVZ")
            .split(" pengap")
            .join(" pengapVZ")
            .split(" ironis")
            .join(" ironisVZ")
            .split(" sombong")
            .join(" sombongVZ")
            .split(" berat")
            .join(" beratVZ")
            .split(" buruk")
            .join(" burukVZ")
            .split(" cantik")
            .join(" cantikVZ")
            .split(" dekat")
            .join(" dekatVZ")
            .split(" lelah")
            .join(" lelahVZ")
            .split(" senang")
            .join(" senangVZ")
            .split(" mirip")
            .join(" miripVZ")
            .split(" berbeda")
            .join(" berbedaVZ")
            .split(" beda")
            .join(" bedaVZ")
            .split(" jorok")
            .join(" jorokVZ")
            .split(" cepat")
            .join(" cepatVZ")
            .split(" terutama")
            .join(" terutamaVZ")
            .split(" sayang")
            .join(" sayangVZ")
            .split("dikit")
            .join("dikitVZ")
            .split(" jarang")
            .join(" jarangVZ")
            .split(" ajar")
            .join(" ajarVZ")
            .split(" banyak")
            .join(" banyakVZ")
            .split(" besar")
            .join(" besarVZ")
            .split(" suka")
            .join(" sukaVZ")
            .split(" marah")
            .join(" marahVZ")
            .split(" benci")
            .join(" benciVZ")
            .split(" kangen")
            .join(" kangenVZ")
            .split(" rindu")
            .join(" rinduVZ")
            .split(" cinta")
            .join(" cintaVZ")
            .split(" hancur")
            .join(" hancurVZ")
            .split(" asyik")
            .join(" asyikVZ")
            .split(" pandai")
            .join(" pandaiVZ")
            .split(" panas")
            .join(" panasVZ")
            .split(" bingung")
            .join(" bingungVZ")
            .split("ramah")
            .join("ramahVZ")
            .split(" tahu")
            .join(" tahuVZ")
            .split(" setuju")
            .join(" setujuVZ")
            .split("akut")
            .join("akutVZ")
            .split("malas")
            .join("malasVZ")
            .split(" heran")
            .join(" heranVZ")
            .split(" mantap")
            .join(" mantapVZ")
            .split(" suka")
            .join(" sukaVZ")
            .split(" berani")
            .join(" beraniVZ")
            .split(" mau")
            .join(" mauVZ")
            .split(" hampir")
            .join(" hampirVZ")
            .split(" tinggi")
            .join(" tinggiVZ")
            .split(" rendah")
            .join(" rendahVZ")
            .split(" empuk")
            .join(" empukVZ")
            .split(" keras")
            .join(" kerasVZ")
            .split(" dalam")
            .join(" dalamVZ")
            .split(" luar")
            .join(" luarVZ")
            .split(" gemar")
            .join(" gemarVZ")
            .split(" miskin")
            .join(" miskinVZ")
            .split(" hina")
            .join(" hinaVZ")
            .split(" bermanfaat")
            .join(" bermanfaatVZ")
            .split(" berkhasiat")
            .join(" berkhasiatVZ")
            .split(" manjur")
            .join(" manjurVZ")
            .split(" kaya")
            .join(" kayaVZ")
            .split(" rajin")
            .join(" rajinVZ")
            .split(" ganteng")
            .join(" gantengVZ")
            .split(" gagah")
            .join(" gagahVZ")
            .split(" manis")
            .join(" manisVZ")
            .split(" pahit")
            .join(" pahitVZ")
            .split(" miring")
            .join(" miringVZ")
            .split(" haus")
            .join(" hausVZ")
            .split(" mengantuk")
            .join(" mengantukVZ")
            .split(" jelek")
            .join(" jelekVZ")
            .split(" kontras")
            .join(" kontrasVZ")
            .split(" kencang")
            .join(" kencangVZ")
            .split(" konyol")
            .join(" konyolVZ")
            .split(" merdu")
            .join(" merduVZ")
            .split(" lezat")
            .join(" lezatVZ")
            .split(" muda")
            .join(" mudaVZ")
            .split(" tua")
            .join(" tuaVZ")
            .split(" cemas")
            .join(" cemasVZ")
            .split(" lebar")
            .join(" lebarVZ")
            .split(" putih")
            .join(" putihVZ")
            .split(" basah")
            .join(" basahVZ")
            .split(" lemah")
            .join(" lemahVZ")
            .split(" terlantar")
            .join(" terlantarVZ")
            .split(" kasihan")
            .join(" kasihanVZ")
            .split(" tepat")
            .join(" tepatVZ")
            .split(" masam")
            .join(" masamVZ")
            .split(" serasi")
            .join(" serasiVZ")
            .split(" menakjubkan")
            .join(" menakjubkanVZ")
            .split(" lucu")
            .join(" lucuVZ")
            .split(" geli")
            .join(" geliVZ")
            .split(" kuno")
            .join(" kunoVZ")
            .split(" gelisah")
            .join(" gelisahVZ")
            .split(" mengagumkan")
            .join(" mengagumkanVZ")
            .split(" mengerikan")
            .join(" mengerikanVZ")
            .split(" indah")
            .join(" indahVZ")
            .split(" bermanfaat")
            .join(" bermanfaatVZ")
            .split(" aneh")
            .join(" anehVZ")
            .split(" biru")
            .join(" biruVZ")
            .split(" berani")
            .join(" beraniVZ")
            .split(" singkat")
            .join(" singkatVZ")
            .split(" luas")
            .join(" luasVZ")
            .split(" rusak")
            .join(" rusakVZ")
            .split(" tenang")
            .join(" tenangVZ")
            .split(" cermat")
            .join(" cermatVZ")
            .split(" murah")
            .join(" murahVZ")
            .split(" mahal")
            .join(" mahalVZ")
            .split(" tembem")
            .join(" tembemVZ")
            .split(" berkelas")
            .join(" berkelasVZ")
            .split(" bersih")
            .join(" bersihVZ")
            .split(" jernih")
            .join(" jernihVZ")
            .split(" ceroboh")
            .join(" cerobohVZ")
            .split(" nyaman")
            .join(" nyamanVZ")
            .split(" umum")
            .join(" umumVZ")
            .split(" lengkap")
            .join(" lengkapVZ")
            .split(" keren")
            .join(" kerenVZ")
            .split(" menyeramkan")
            .join(" menyeramkanVZ")
            .split(" menyedihkan")
            .join(" menyedihkanVZ")
            .split(" kejam")
            .join(" kejamVZ")
            .split(" keriting")
            .join(" keritingVZ")
            .split(" imut")
            .join(" imutVZ")
            .split(" berbahaya")
            .join(" berbahayaVZ")
            .split(" gelap")
            .join(" gelapVZ")
            .split(" halus")
            .join(" halusVZ")
            .split("enangkan")
            .join("enangkanVZ")
            .split(" jahat")
            .join(" jahatVZ")
            .split("tis ")
            .join("tisVZ ")
            .split(" kering")
            .join(" keringVZ")
            .split(" berdebu")
            .join(" berdebuVZ")
            .split(" dinamis")
            .join(" dinamisVZ")
            .split(" awal")
            .join(" awalVZ")
            .split(" mudah")
            .join(" mudahVZ")
            .split(" elegan")
            .join(" eleganVZ")
            .split(" menghibur")
            .join(" menghiburVZ")
            .split(" unggul")
            .join(" unggulVZ")
            .split(" eksklusif")
            .join(" eksklusifVZ")
            .split(" eksotis")
            .join(" eksotisVZ")
            .split(" adil")
            .join(" adilVZ")
            .split(" setia")
            .join(" setiaVZ")
            .split(" akrab")
            .join(" akrabVZ")
            .split(" terkenal")
            .join(" terkenalVZ")
            .split("stis ")
            .join("stisVZ ")
            .split(" irit")
            .join(" iritVZ")
            .split(" datar")
            .join(" datarVZ")
            .split(" pelupa")
            .join(" pelupaVZ")
            .split("untung")
            .join("untungVZ")
            .split(" rapuh")
            .join(" rapuhVZ")
            .split(" bebas")
            .join(" bebasVZ")
            .split("beku")
            .join("bekuVZ")
            .split(" segar")
            .join(" segarVZ")
            .split(" lembut")
            .join(" lembutVZ")
            .split(" berbakat")
            .join(" berbakatVZ")
            .split(" glamor")
            .join(" glamorVZ")
            .split(" boros")
            .join(" borosVZ")
            .split(" anggun")
            .join(" anggunVZ")
            .split(" berminyak")
            .join(" berminyakVZ")
            .split(" serakah")
            .join(" serakahVZ")
            .split(" hijau")
            .join(" hijauVZ")
            .split(" pemarah")
            .join(" pemarahVZ")
            .split(" tampan")
            .join(" tampanVZ")
            .split(" berdaya")
            .join(" berdayaVZ")
            .split(" riang")
            .join(" riangVZ")
            .split(" menyeluruh")
            .join(" menyeluruhVZ")
            .split(" bebal")
            .join(" bebalVZ")
            .split(" sakit")
            .join(" sakitVZ")
            .split(" sopan")
            .join(" sopanVZ")
            .split(" penting")
            .join(" pentingVZ")
            .split(" mungkin")
            .join(" mungkinVZ")
            .split(" meyakinkan")
            .join(" meyakinkanVZ")
            .split("biasa")
            .join("biasaVZ")
            .split("bahayakan")
            .join("bahayakanVZ")
            .split(" gatal")
            .join(" gatalVZ")
            .split("buru")
            .join("buruVZ")
            .split(" berair")
            .join(" berairVZ")
            .split("kenal")
            .join("kenalVZ")
            .split(" timpang")
            .join(" timpangVZ")
            .split("akhir")
            .join("akhirVZ")
            .split("lambat")
            .join("lambatVZ")
            .split(" lincah")
            .join(" lincahVZ")
            .split(" longgar")
            .join(" longgarVZ")
            .split(" mewah")
            .join(" mewahVZ")
            .split(" sakti")
            .join(" saktiVZ")
            .split(" ajaib")
            .join(" ajaibVZ")
            .split("besaran")
            .join("besaranVZ")
            .split(" cair")
            .join(" cairVZ")
            .split(" kacau")
            .join(" kacauVZ")
            .split(" berantakan")
            .join(" berantakanVZ")
            .split(" modern")
            .join(" modernVZ")
            .split(" lembek")
            .join(" lembekVZ")
            .split(" misterius")
            .join(" misteriusVZ")
            .split(" naif")
            .join(" naifVZ")
            .split(" sempit")
            .join(" sempitVZ")
            .split(" mini")
            .join(" miniVZ")
            .split("iah")
            .join("iahVZ")
            .split(" nakal")
            .join(" nakalVZ")
            .split(" perlu")
            .join(" perluVZ")
            .split(" gugup")
            .join(" gugupVZ")
            .split(" berisik")
            .join(" berisikVZ")
            .split(" normal")
            .join(" normalVZ")
            .split(" bergizi")
            .join(" bergiziVZ")
            .split(" taat")
            .join(" taatVZ")
            .split(" gemuk")
            .join(" gemukVZ")
            .split(" gendut")
            .join(" gendutVZ")
            .split(" kuna")
            .join(" kunaVZ")
            .split("lebihan")
            .join("lebihanVZ")
            .split(" menyakitkan")
            .join(" menyakitkanVZ")
            .split(" panik")
            .join(" panikVZ")
            .split(" sempurna")
            .join(" sempurnaVZ")
            .split("kecil")
            .join("kecilVZ")
            .split("mungil")
            .join("mungilVZ")
            .split(" polos")
            .join(" polosVZ")
            .split(" berarti")
            .join(" berartiVZ")
            .split("kuasa")
            .join("kuasaVZ")
            .split(" bangga")
            .join(" banggaVZ")
            .split("banggakan")
            .join("banggakanVZ")
            .split("diam")
            .join("diamVZ")
            .split(" unik")
            .join(" unikVZ")
            .split(" lega")
            .join(" legaVZ")
            .split(" menjijikan")
            .join(" menjijikanVZ")
            .split(" busuk")
            .join(" busukVZ")
            .split(" bulat")
            .join(" bulatVZ")
            .split(" pedesaan")
            .join(" pedesaanVZ")
            .split(" perkotaan")
            .join(" perkotaanVZ")
            .split(" aman")
            .join(" amanVZ")
            .split(" asin")
            .join(" asinVZ")
            .split(" memuaskan")
            .join(" memuaskanVZ")
            .split(" egois")
            .join(" egoisVZ")
            .split(" dangkal")
            .join(" dangkalVZ");
          var TrIT = TliT.split(" buncit")
            .join(" buncitVZ")
            .split("kilau")
            .join("kilauVZ")
            .split(" pendek")
            .join(" pendekVZ")
            .split(" bodoh")
            .join(" bodohVZ")
            .split(" mahir")
            .join(" mahirVZ")
            .split(" kurus")
            .join(" kurusVZ")
            .split(" padat")
            .join(" padatVZ")
            .split(" kotak")
            .join(" kotakVZ")
            .split(" curam")
            .join(" curamVZ")
            .split(" lengket")
            .join(" lengketVZ")
            .split(" lurus")
            .join(" lurusVZ")
            .split(" kuat")
            .join(" kuatVZ")
            .split(" hambar")
            .join(" hambarVZ")
            .split(" tegang")
            .join(" tegangVZ")
            .split(" tipis")
            .join(" tipisVZ")
            .split(" muak")
            .join(" muakVZ")
            .split("uakkan ")
            .join("uakkanVZ ")
            .split("pikirkan ")
            .join("pikirkanVZ ")
            .split(" mengamcam")
            .join(" mengancamVZ")
            .split(" sulit")
            .join(" sulitVZ")
            .split("sulitkan ")
            .join("sulitkanVZ ")
            .split(" khas")
            .join(" khasVZ")
            .split(" mampu")
            .join(" mampuVZ")
            .split(" rata")
            .join(" rataVZ")
            .split(" tertarik")
            .join(" tertarikVZ")
            .split(" berguna")
            .join(" bergunaVZ")
            .split("jaya")
            .join("jayaVZ")
            .split(" hangat")
            .join(" hangatVZ")
            .split(" kuning")
            .join(" kuningVZ")
            .split("luruh")
            .join("luruhVZ")
            .split("genting")
            .join("gentingVZ")
            .split(" jenaka")
            .join(" jenakaVZ")
            .split(" berguna")
            .join(" bergunaVZ")
            .split(" bersalah")
            .join(" bersalahVZ")
            .split(" bandel")
            .join(" bandelVZ")
            .split(" menggemaskan")
            .join(" menggemaskanVZ")
            .split(" jelas")
            .join(" jelasVZ")
            .split(" terbantu ")
            .join(" terbantuVZ ")
            .split("ragu")
            .join("raguVZ")
            .split("VZ sekali")
            .join(" banget")
            .split("VZ ")
            .join(" ")
            .split("VZ")
            .join("");
          var TeT = TrIT.split(" daun melinjo")
            .join(" so")
            .split(" es batu")
            .join(" es-batu")
            .split(" batu es ")
            .join(" batu-es ")
            .split(" baru paham")
            .join(" nembe paham")
            .split(" baru faham")
            .join(" nembe paham")
            .split(" baru me")
            .join(" nembe me")
            .split(" baru sadar")
            .join(" nembe sadar")
            .split(" lalu langsung")
            .join(" banjur langsung")
            .split(" pencukur rambut")
            .join(" tukang cukur rambut")
            .split(" tas plastik")
            .join(" tas kresek")
            .split("air mata")
            .join("air-mata")
            .split("lebih lebih")
            .join("lebih-lebih")
            .split(" terlebih lagi")
            .join(" apa lagi")
            .split(" cuci tangan")
            .join(" wisuh")
            .split(" akan beredar")
            .join(" akan dijual")
            .split(" belum beredar")
            .join(" belum dijual")
            .split(" kamar kecil")
            .join(" wingking")
            .split(" ganti baju")
            .join(" salin")
            .split(" ganti pakaian")
            .join(" salin")
            .split("qur ' an")
            .join("qur'an")
            .split("quran")
            .join("qur'an")
            .split("alqur'an")
            .join("al-qur'an")
            .split(" baca qur'an")
            .join(" nderes qur'an")
            .split(" membaca al-qur'an")
            .join(" nderes al-qur'an")
            .split(" membaca qur'an")
            .join(" nderes qur'an")
            .split(" baca al-qur'an")
            .join(" nderes al-qur'an")
            .split("tanggung jawab")
            .join("tanggung-jawab")
            .split(" tingkatan bertutur")
            .join(" unggah-ungguh bertutur")
            .split(" tingkatan bahasa")
            .join(" unggah-ungguhing bahasa")
            .split(" memberitahu")
            .join(" memberi tahu")
            .split(" diberitahu")
            .join(" diberi tahu")
            .split(" jangan sampai")
            .join(" jangan nganti")
            .split(" ulang tahun")
            .join(" ambal warsa")
            .split(" selamat jalan")
            .join(" selamat berjalan")
            .split(" bersenda gurau")
            .join(" bercanda")
            .split(" bersendau gurau")
            .join(" bercanda")
            .split(" meninggal dunia")
            .join(" meninggal-dunia")
            .split(" pukul 0")
            .join(" jam 0")
            .split(" pukul 2")
            .join(" jam 2")
            .split(" pukul 3 ")
            .join(" jam 3 ")
            .split(" pukul 4 ")
            .join(" jam 4 ")
            .split(" pukul 5 ")
            .join(" jam 5 ")
            .split(" pukul 6 ")
            .join(" jam 6 ")
            .split(" pukul 7 ")
            .join(" jam 7 ")
            .split(" pukul 8 ")
            .join(" jam 8 ")
            .split(" pukul 9 ")
            .join(" jam 9 ")
            .split(" sedang pada")
            .join(" sedang padaa")
            .split(" memohon izin")
            .join(" pamit")
            .split(" mohon izin")
            .join(" pamit")
            .split(" ke kanan")
            .join(" nengen")
            .split(" ke kiri")
            .join(" ngiwa")
            .split(" ketidak")
            .join(" ketidak ")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" bilang sama ")
            .join(" bilang dengan ")
            .split(" baru kelihatan")
            .join(" nembe kelihatan")
            .split(" xxx ")
            .join(" xxx ")
            .split(" bersama sama")
            .join(" bersama-sama")
            .split(" suku kata")
            .join(" suku-kata")
            .split(" xxx")
            .join(" xxx")
            .split(" belum biasa")
            .join(" belum terbiasa")
            .split(" mahu ?")
            .join(" gelem ?")
            .split(" mau ?")
            .join(" gelem ?")
            .split(" mau tidak ?")
            .join(" gelem tidak ?")
            .split(" mau apa tidak ?")
            .join(" purun apa tidak ?")
            .split(" habis ini")
            .join(" setelah ini")
            .split(" bulu mata")
            .join(" bulu-mata")
            .split(" apa kabar")
            .join(" piye kabar")
            .split(" bersama sama")
            .join(" bersama-sama")
            .split(" berjalan jalan")
            .join(" berjalan-jalan")
            .split(" ke sana")
            .join(" mrana")
            .split(" di sana")
            .join(" di kana")
            .split(" ke sini")
            .join(" mrene")
            .split(" di sini")
            .join(" di kene")
            .split(" ke situ")
            .join(" mrono")
            .split(" di situ")
            .join(" di kono")
            .split(" dari sana")
            .join(" dari kana")
            .split(" dari sini")
            .join(" dari kene")
            .split(" dari situ")
            .join(" dari kono")
            .split(" nenek moyang")
            .join(" mbah moyang")
            .split(" kalian semua")
            .join(" kalian")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split(" mereka semua")
            .join(" mereka")
            .split("ak tahuu")
            .join("ak tahu")
            .split("lain lain")
            .join("lain-lain")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split(" luar jawa")
            .join(" luarnya jawa")
            .split("kan lain")
            .join("kan liya")
            .split(" teng sini")
            .join(" teng ngriki")
            .split(" teng sana")
            .join(" teng kana")
            .split(" teng situ")
            .join(" teng kono")
            .split(" lahir batin")
            .join(" lair batin")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split(" xxx")
            .join(" xxx")
            .split(") lalu.")
            .join(") kepengker.")
            .split(" ya rob")
            .join(" ya-rob")
            .split("xxx")
            .join("xxx")
            .split(" pekan lalu")
            .join(" pekan kepengker")
            .split(" xxx ")
            .join(" xxx ")
            .split(" tadi malam")
            .join(" wau malam")
            .split("hal tentang ")
            .join("hal ngenani ")
            .split(" sama siapa")
            .join(" dengan siapa")
            .split("1 kali ")
            .join("1 kalix ")
            .split("2 kali ")
            .join("2 kalix ")
            .split("3 kali ")
            .join("3 kalix ")
            .split("4 kali ")
            .join("4 kalix ")
            .split("5 kali ")
            .join("5 kalix ")
            .split("6 kali ")
            .join("6 kalix ")
            .split("7 kali ")
            .join("7 kalix ")
            .split("8 kali ")
            .join("8 kalix ")
            .split("9 kali ")
            .join("9 kalix ")
            .split("0 kali ")
            .join("0 kalix ")
            .split(" xxx ")
            .join(" xxx ")
            .split(" ulang tahun")
            .join(" tanggap tahun")
            .split(" sangat lah ")
            .join(" sangat-lah ")
            .split(" sekitar sini")
            .join(" sekitar ngriki")
            .split(" sekitar situ")
            .join(" sekitar kono")
            .split("sebelah sana")
            .join("sebelah kana")
            .split("sebelah sini")
            .join("sebelah ngriki")
            .split("sebelah situ")
            .join("sebelah kono")
            .split("bagian sana")
            .join("bagian kana")
            .split("bagian sini")
            .join("bagian ngriki")
            .split("bagian situ")
            .join("bagian kono")
            .split(" keburu nafsu")
            .join(" keburu-nafsu")
            .split(" orang utan")
            .join(" orang-utan")
            .split(" peran serta")
            .join(" peran-serta")
            .split(" ada pun ")
            .join(" ada-pun ")
            .split(" tergesa gesa")
            .join(" tergesa-gesa")
            .split(" air bah ")
            .join(" bena ")
            .split("bolak balik")
            .join("bolak-balik")
            .split(" tahu menahu")
            .join(" menahu")
            .split(" anak cicak")
            .join(" sawiyah")
            .split(" ayam jantan")
            .join(" sawung")
            .split(" anak kerbau")
            .join(" gudel")
            .split(" tidak mengapa")
            .join(" tidak apa-apa")
            .split(" biar saja")
            .join(" biarlah saja")
            .split(" sudahlah biar")
            .join(" sudahlah biarlah")
            .split(" terus menerus")
            .join(" terus-menerus")
            .split(" xxx")
            .join(" xxx")
            .split(" baik bu ")
            .join(" baikk bu ")
            .split(" baik pak ")
            .join(" baikk pak ")
            .split(" terlalu jauh")
            .join(" kadohen")
            .split(" tidak terlalu")
            .join(" tidak pati")
            .split(" tak terlalu")
            .join(" tak pati")
            .split(" gak terlalu")
            .join(" tidak pati")
            .split(" sekali lagi,")
            .join(" sepisan lagi,")
            .split(" sekarang ini ")
            .join(" sekarang ")
            .split(" cerita pendek")
            .join(" cerita cekak")
            .split("belanda")
            .join("walanda")
            .split(" belum begitu ")
            .join(" belum pati ")
            .split(" maka dari itu")
            .join(" pramila")
            .split(" oleh karena itu")
            .join(" pramila")
            .split(" oleh sebab itu")
            .join(" pramila ")
            .split(" oleh karenanya")
            .join(" pramila")
            .split(" oleh sebabnya")
            .join(" pramila")
            .split(" oleh sebab")
            .join(" pramila")
            .split(" oleh karena")
            .join(" pramila")
            .split(" pramila maka")
            .join(" pramila")
            .split(" lagi ngapa")
            .join(" sedang ngapa")
            .split(" hal hal ")
            .join(" hal-hal ")
            .split(" habis diajak")
            .join(" bibar diajak")
            .split(" yang empunya")
            .join(" ingkang punya")
            .split(" yg empunya")
            .join(" ingkang punya")
            .split(" tidak lain ")
            .join(" tidak liya ")
            .split(" lagi dirawat")
            .join(" sedang dirawat")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" jadi pergi")
            .join(" sida pergi")
            .split(" ke timur")
            .join(" ngetan")
            .split(" ke selatan")
            .join(" ngidul")
            .split(" ke barat")
            .join(" ngulon")
            .split(" ke utara")
            .join(" ngalor")
            .split("xxx")
            .join("xxx")
            .split(" mau tak")
            .join(" gelem tak")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("ulang ulang")
            .join("ulang-ulang")
            .split(" berulang-ulang kali ")
            .join(" ping pindho-pindho ")
            .split("xxx")
            .join("xxx")
            .split("an lain")
            .join("an liya")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("laki lain")
            .join("laki liya")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split(" kembali meng")
            .join(" malih meng")
            .split("kumpul kembali ")
            .join("kumpul malih ")
            .split(" salat hari raya")
            .join(" salat riyaya")
            .split(" rendah hati")
            .join(" rendah-hati")
            .split(" sama pemain")
            .join(" dengan pemain")
            .split(" kata2nya")
            .join(" kata-katanya")
            .split(" hilang ingatan")
            .join(" gila")
            .split(" xxx")
            .join(" xxx")
            .split(" tuan rumah")
            .join(" tuanrumah")
            .split(" sembarang tempat")
            .join(" saenggon-enggon");
          var Te0T = TeT.split("april lalu")
            .join("april kapungkur")
            .split("mei lalu")
            .join("mei kapungkur")
            .split("juni lalu")
            .join("juni kapungkur")
            .split("juli lalu")
            .join("juli kapungkur")
            .split("stus lalu")
            .join("stus kapungkur")
            .split("mber lalu")
            .join("mber kapungkur")
            .split("ober lalu")
            .join("ober kapungkur")
            .split(" xxx")
            .join(" xxx")
            .split(" berlaku untuk ")
            .join(" berlaku nggo ")
            .split(" anak anak ")
            .join(" anak-anak ")
            .split("yang lain dari")
            .join("yang beda dari")
            .split("xxx")
            .join("xxx")
            .split(" atau tidak")
            .join(" apa tidak")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("pada pukul ")
            .join("pada jam ")
            .split(" amat ")
            .join(" banget ")
            .split(", lalu di")
            .join(", banjur di")
            .split("tiada duanya ")
            .join("tiada samanya ")
            .split(" robiul ")
            .join(" rabiul ")
            .split("xxx")
            .join("xxx")
            .split(" berumah tangga")
            .join(" berumah-tangga")
            .split(" tdk ")
            .join(" tak ")
            .split(" kaca mata")
            .join(" kaca-mata")
            .split(" sedang.")
            .join("sedeng.")
            .split(" sedang,")
            .join("sedeng,")
            .split("perorang")
            .join("per orang")
            .split(" atas segala ")
            .join(" atas semua ")
            .split(" rumah tangga")
            .join(" rumahtangga")
            .split(" lha wong ")
            .join(" dadah ")
            .split(" piring kecil ")
            .join(" pisin ")
            .split(" berikut ini")
            .join(" berikut-ini")
            .split(" mengeroyok")
            .join(" ngroyok")
            .split(" keroyok")
            .join(" kroyok")
            .split(" berjalan kaki")
            .join(" mlampah")
            .split(" jalan kaki")
            .join(" mlampah")
            .split(" ini baru ")
            .join(" ini nembe ")
            .split("lompat lompat")
            .join("lompat-lompat")
            .split("pasta gigi")
            .join("odol")
            .split(" kamar mandi")
            .join(" kulah")
            .split("sandaran")
            .join("sendehan")
            .split(" minyak goreng")
            .join(" minyak klentik")
            .split(" baru saja")
            .join(" nembe saja")
            .split(" kasih bocoran")
            .join(" memberi bocoran")
            .split(" daun bawang")
            .join(" kuncar")
            .split(" bunga bawang")
            .join(" lengeng")
            .split(" kapak")
            .join(" prekul")
            .split(" suami istri")
            .join(" suami-istri")
            .split(" suami isteri")
            .join(" suami-istri")
            .split(" tidak berubah")
            .join(" ajeg")
            .split("xxx")
            .join("xxx")
            .split(" yang lalu")
            .join(" yang rumiyin")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split("luar biasa")
            .join("luarbiasa")
            .split(" cuci gudang")
            .join(" cucii gudang")
            .split(" mengada ada")
            .join(" mengada-ada")
            .split(" punya saya")
            .join(" kepunyaan saya")
            .split(" anak sekolah")
            .join(" bocah sekola")
            .split("sekali lagi")
            .join("sapisan lagi")
            .split(" saya marahi")
            .join(" tak omongi")
            .split(" lemah lembut")
            .join(" tanah lembut")
            .split(" baru sampai")
            .join(" baru tiba")
            .split(" sampai di ")
            .join(" tiba di ")
            .split(" lalu gimana")
            .join(" banjur gimana")
            .split("lalu bagaimana")
            .join("banjur pripun")
            .split(" kerja bakti")
            .join(" kerja-bakti")
            .split(" tahu kuping")
            .join(" tahuu kuping")
            .split(" tinggal minta")
            .join(" nggari minta")
            .split(" tinggal meminta")
            .join(" nggari minta")
            .split(" kasih tahu")
            .join(" memberi tahu")
            .split("baru kemudian")
            .join("baru banjur")
            .split("kalau begitu")
            .join("kalo begitu")
            .split(" lauk pauk")
            .join(" laukpauk")
            .split(" jadi ikut")
            .join(" sida ikut")
            .split(" jadi ke ")
            .join(" sida ke ")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split(" saya kira")
            .join(" takk kira")
            .split(" tahu sumedang")
            .join(" tahuu sumedang")
            .split(" tahu aci")
            .join(" tahuu aci")
            .split(" tolak ukur")
            .join(" tolok ukur")
            .split(" anak kecil")
            .join(" bocah kecil")
            .split(" sama aku")
            .join(" karo aku")
            .split(" sama kamu")
            .join(" karo kamu")
            .split(" sama dia")
            .join(" karo dia")
            .split(" sama saya")
            .join(" karo saya")
            .split(" mana mungkin")
            .join(" tidak mungkin")
            .split(" baru berjalan")
            .join(" nembe mlaku")
            .split(" baru jalan")
            .join(" nembe mlaku")
            .split("baik itu")
            .join("baikk itu")
            .split(" sebelah utara")
            .join(" sisi utara")
            .split(" sebelah barat")
            .join(" sisi barat")
            .split(" sebelah selatan")
            .join(" sisi selatan")
            .split(" sebelah timur")
            .join(" sisi timur")
            .split(" lalu jam")
            .join(" banjur jam")
            .split(" lalu diarahkan")
            .join(" banjur diarahkan")
            .split("jumat lalu")
            .join("jumat wingi")
            .split("sabtu lalu")
            .join("sabtu wingi")
            .split(" membukakan pintu")
            .join(" ngeblegna pintu")
            .split("jum'at lalu")
            .join("jumat wingi")
            .split("belum sampai")
            .join("belum tiba")
            .split("1 lalu")
            .join("1 silam")
            .split("xxx")
            .join("xxx")
            .split("urusan belakangan")
            .join("urusan mburi-mburian")
            .split(" ya tuhan ")
            .join(" ya allah ")
            .split(" xxx")
            .join(" xxx")
            .split("bertelanjang dada")
            .join("lukar baju")
            .split("telanjang dada")
            .join("lukar baju")
            .split(" xxx")
            .join(" xxx")
            .split(" hujan lebat")
            .join(" hujan besar")
            .split("kereta kuda")
            .join("dokar")
            .split("gula batu")
            .join("gulabatu")
            .split(" belajar naik")
            .join(" sinau menaiki")
            .split(" belajar menaiki")
            .join(" genau menaiki")
            .split(" tak mau")
            .join(" tidak gelem")
            .split(" baru datang")
            .join(" nembe datang")
            .split(" baru tiba")
            .join(" nembe datang")
            .split(" melainkan karena")
            .join(" ananging karena")
            .split(" xxx")
            .join(" xxx")
            .split(" minyak sayur")
            .join(" minyak klentik")
            .split(" minyak tanah")
            .join(" minyak gas")
            .split("xxx")
            .join("xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" bermandikan keringat")
            .join(" keringatnya byuk-byukan")
            .split(" bersimbah keringat")
            .join(" keringatnya byuk-byukan")
            .split(" pertama kali")
            .join(" kaping pertama")
            .split(" tahun lalu")
            .join(" tahun kapungkur")
            .split("bulan lalu")
            .join("bulan kapungkur")
            .split("hari minggu")
            .join("hari ahad")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split(" tidak menyangka")
            .join(" tidak nyana")
            .split(" dan juga")
            .join(" tur")
            .split(" baikk daripada")
            .join(" baik daripada")
            .split(" xxx")
            .join(" xxx")
            .split(" cuci baju")
            .join(" mencuci baju")
            .split(" xxx")
            .join(" xxx")
            .split(" cuci pakaian")
            .join(" mencuci pakaian")
            .split(" mencuci piring")
            .join(" isah-isah piring")
            .split(" cuci piring")
            .join(" isah-isah piring")
            .split(" cuci muka")
            .join(" raup")
            .split("2 lalu")
            .join("2 silam")
            .split("sebulan sekali")
            .join("sebulan sepisan")
            .split(" kakak beradik")
            .join(" kakang adi")
            .split(" bukan main ")
            .join(" por banget ")
            .split(" abu bakar")
            .join(" abubakar")
            .split(" bulu tangkis")
            .join(" minton")
            .split("tanah liat")
            .join("lempung")
            .split(" sepeda motor")
            .join(" montor")
            .split(" naik bis")
            .join(" menaiki bis")
            .split("pesawat terbang")
            .join("montor terbang")
            .split("pesawat udara")
            .join("montor terbang")
            .split(" naik angkot")
            .join(" nitih angkot")
            .split("mencuci muka")
            .join("raup")
            .split("sayang sekali")
            .join("eman-eman banget")
            .split(" sepak bolanya")
            .join(" bal-balane")
            .split(" gak mau")
            .join(" tidak gelem")
            .split("berulang kali ")
            .join("ping pinten-pinten ")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" beberapa kali ")
            .join(" ping pira-pira ")
            .split(" membabi buta")
            .join(" mbabi buta")
            .split("membuat tahu")
            .join("membuat tahuu")
            .split(" musim lalu")
            .join(" musim wingi")
            .split(" hari lalu")
            .join(" hari wingi")
            .split("xxx")
            .join("xxx")
            .split("xxx")
            .join("xxx")
            .split(" abad lalu")
            .join(" abad mbiyen")
            .split(" bulan sekali")
            .join(" wulan sepisan")
            .split(" bertingkah laku")
            .join(" bertingkah lakuu")
            .split(" tingkah laku")
            .join(" tingkah-laku")
            .split("tempe tahu")
            .join("tempe tahuu")
            .split(" xxx")
            .join(" xxx")
            .split(" xxx")
            .join(" xxx")
            .split(" di karenakan")
            .join(" amargi")
            .split(" sepak bola")
            .join(" bal-balan")
            .split("tanah air")
            .join("tanah-air")
            .split("kereta api")
            .join("sepur")
            .split(" naik sepur")
            .join(" menaiki sepur")
            .split(" sama sekali")
            .join(" babar pisan")
            .split(" keras kepala")
            .join(" tambeng")
            .split("xxx")
            .join("xxx")
            .split(" tak ada ")
            .join(" tidak ada ")
            .split("xxx")
            .join("xxx")
            .split(" kaya gini")
            .join(" kayak gini")
            .split(" kaya gitu")
            .join(" kayak gitu")
            .split(" dari pada")
            .join(" daripada")
            .split("terima kasih")
            .join("terima-kasih")
            .split("jangan mau")
            .join("jangan gelem")
            .split(" nggak mau")
            .join(" tidak gelem")
            .split(" ngga mau")
            .join(" tidak gelem")
            .split(" tak kan ")
            .join(" tak akan ")
            .split("kuala lumpur")
            .join("kuala-lumpur")
            .split(" jam segini")
            .join(" wayah segini")
            .split("naik daun")
            .join("naikdaun")
            .split("kerja keras")
            .join("kerjakeras")
            .split("ikan asin")
            .join("gesekk")
            .split("pandai berbicara")
            .join("ladak")
            .split("papan tulis")
            .join("blabag")
            .split(" xxx")
            .join(" xxx")
            .split(" tak mengapa")
            .join(" tak apa-apa")
            .split("xxx")
            .join("xxx")
            .split("dulu kala")
            .join("dulu banget")
            .split("dahulu kala")
            .join("dahulu banget")
            .split("di jalan")
            .join("di ratan")
            .split("xxx")
            .join("xxx")
            .split(" akan tetapi")
            .join(" ananging")
            .split("kebanyakan gaya")
            .join("ngaksi")
            .split(" tuh kan ")
            .join(" kweh ya ")
            .split(" tawar menawar")
            .join(" anyang-anyangan")
            .split("ukuran sedang")
            .join("ukuran sedeng")
            .split("babi hutan")
            .join("celeng")
            .split(" unjuk gigi")
            .join(" unjukgigi")
            .split(" mau tidak")
            .join(" gelem tidak")
            .split(" mau ga")
            .join(" gelem ga")
            .split("kerja sama")
            .join("kerjasama")
            .split("xxx")
            .join("xxx")
            .split(" punya dia ")
            .join(" milik kae ")
            .split(" fakir miskin")
            .join(" fakirmiskin")
            .split("lain sebagainya")
            .join("lain-sebagainya")
            .split("terus terang")
            .join("terus-terang")
            .split(" bagi para")
            .join(" nggo para")
            .split(" bagi keluarga")
            .join(" nggo keluarga")
            .split("an lama")
            .join("an lamaa")
            .split(" kata kerja")
            .join(" kata kriya")
            .split(" suatu ketika")
            .join(" suatu waktu")
            .split(" bukannya sudah")
            .join(" kan sudah")
            .split(" jadi dibeli")
            .join(" sida dibeli")
            .split(" jadi pergi")
            .join(" sida pergi")
            .split(" naik apa ")
            .join(" menaiki apa ")
            .split(" bertopang dagu")
            .join(" sangga uwang")
            .split(" sok pintar")
            .join(" keminter")
            .split(" anak tangga")
            .join(" undhak-undhakan");
        }
        if (key1 == 0) {
          var T0T = TiT.split(" pripun ")
            .join(" gimana ")
            .split(" diaken")
            .join(" diakenn")
            .split(" ngaken")
            .join(" ngakenn")
            .split(" kaken")
            .join(" kakenn")
            .split(" taken")
            .join(" takon")
            .split(" baken")
            .join(" bakenn")
            .split(" dipungkasi")
            .join(" diakhiri")
            .split(" dipundhut")
            .join(" dipendhet")
            .split(" dipundut")
            .join(" dipendet")
            .split(" semangke ")
            .join(" samengko ")
            .split(" samangke ")
            .join(" samengko ")
            .split(" mangke ")
            .join(" mengko ")
            .split("ngke ")
            .join("ngake ")
            .split("kke ")
            .join("kake ")
            .split("lke ")
            .join("lake ")
            .split("kno ")
            .join("kake ")
            .split("kna ")
            .join("kake ")
            .split("pna ")
            .join("pake ")
            .split("tna ")
            .join("take ")
            .split("hke ")
            .join("hake ")
            .split("uake ")
            .join("ukake ")
            .split("oake ")
            .join("okake ")
            .split("iake ")
            .join("ikake ")
            .split("eake ")
            .join("ekake ")
            .split("aake ")
            .join("akake ")
            .split("hke ")
            .join("hake ")
            .split("kne ")
            .join("kake ")
            .split("kakene ")
            .join("kake ")
            .split("aaken ")
            .join("akaken ")
            .split("aake ")
            .join("akake ")
            .split(" dipun")
            .join(" di")
            .split("isin isin")
            .join("isin-isin")
            .split(" salah sawiji")
            .join(" sawiji")
            .split(" pirang pirang")
            .join(" pirang-pirang")
            .split("nipun ")
            .join("ne ")
            .split("nipun.")
            .join("ne.")
            .split("nipun,")
            .join("ne,")
            .split("ipun ")
            .join("e ")
            .split("ipun.")
            .join("e.")
            .split("ipun,")
            .join("e,")
            .split("aken ")
            .join("ake ")
            .split("aken.")
            .join("ake.")
            .split("aken,")
            .join("ake,")
            .split(" yuto")
            .join(" yuta")
            .split("milyar")
            .join("miliar")
            .split("trilyun")
            .join("triliun")
            .split(" rong atus")
            .join(" rongatus")
            .split(" rong ewu")
            .join(" rongewu")
            .split(" rong yuta")
            .join(" rongyuta")
            .split(" rong mil")
            .join(" rongmil")
            .split(" rong tril")
            .join(" rongtril")
            .split("akses padha ")
            .join("akses pada ")
            .split("tembung lingga")
            .join("tembung dhasar")
            .split("tembung andhahan")
            .join("tembung jadian")
            .split("tembung tanggap")
            .join("tembung pasif")
            .split("tembung tanduk")
            .join("tembung aktif")
            .split("tembung ayahan")
            .join("tembung tugas")
            .split("tembung ancer-ancer")
            .join("tembung preposisi")
            .split("tembung panggandheng")
            .join("tembung konjungsi")
            .split("tembung panguwuh")
            .join("tembung seru")
            .split("tembung panyilah")
            .join("tembung sandang")
            .split(" kaya ta ")
            .join(" kayata ")
            .split(" ya iku ")
            .join(" yaiku ")
            .split(" apa wae ")
            .join(" apa pun ")
            .split(" kasusastran para ")
            .join(" kasusastran lisan ")
            .split(" dheweke kabeh")
            .join(" dheweke-kabeh")
            .split(" kowe kabeh")
            .join(" kowe-kabeh")
            .split(" telu likur")
            .join(" dua puluh tiga")
            .split(" pitu likur")
            .join(" dua puluh tujuh")
            .split(" wolu likur")
            .join(" dua puluh delapan")
            .split(" sanga likur")
            .join(" dua puluh sembilan")
            .split(" babar pisan")
            .join(" sama sekali")
            .split(" babar blas")
            .join(" sama sekali")
            .split(" irah irah")
            .join(" irah-irah")
            .split(" nyambut gawe")
            .join(" nyambut-gawe")
            .split(" lung tinulung")
            .join(" tolong menolong")
            .split(" andhap asor")
            .join(" rendah hati")
            .split(" kosok balen")
            .join(" lawan kata")
            .split(" sangga uwang")
            .join(" bertopang dagu")
            .split(" kaya dene")
            .join(" kayadene")
            .split(" kanggo nggo")
            .join(" pakai nggo")
            .split(" matur nuwun")
            .join(" matur-nuwun")
            .split(" ora pati ")
            .join(" ora terlalu ")
            .split(" ping pindho")
            .join(" dua kali")
            .split(" gandeng cenenge")
            .join(" sangkut pautnya")
            .split(" mbalung sungsum")
            .join(" mendarah daging")
            .split(" blas ")
            .join(" sama sekali ")
            .split(" bola bali")
            .join(" bola-bali")
            .split(" ambal warsa")
            .join(" ulang warsa")
            .split(" ngudhar rasa")
            .join(" curhat")
            .split(" kados pundi ")
            .join(" bagaimana ")
            .split(" adhem ayem ")
            .join(" adem-ayem ")
            .split(" basa bali ")
            .join(" basa balii ")
            .split(" pulau bali ")
            .join(" pulau balii ")
            .split(" tukar padu ")
            .join(" bertengkar ")
            .split(" sande kala ")
            .join(" senja ")
            .split(" taun saka ")
            .join(" taunsaka ")
            .split(" ing sor ")
            .join(" ing bawah ")
            .split("brayat ageng ")
            .join("brayat ramai ");
          var Te0T = T0T;
        }
        if (key1 == 1) {
          ToT = Te0T.split('nya"')
            .join('nyaâ™¦"')
            .split("nya'")
            .join("nyaâ™¦'")
            .split("nya.")
            .join("nyaâ™¦.")
            .split("nya,")
            .join("nyaâ™¦,")
            .split("nya ")
            .join("nyaâ™¦ ")
            .split(" nyaâ™¦")
            .join("nyaâ™¦")
            .split(" ");
        }
        if (key1 == 0) {
          ToT = Te0T.split('ne"')
            .join('neâ™¦"')
            .split("ne'")
            .join("neâ™¦'")
            .split("ne.")
            .join("neâ™¦.")
            .split("ne,")
            .join("neâ™¦,")
            .split("ne ")
            .join("neâ™¦ ")
            .split("-e ")
            .join("-neâ™¦ ")
            .split(" neâ™¦")
            .join("neâ™¦")
            .split(" ");
        }
        var charsInCurrentLine = 0;
        var lineToTranslateCurrent = "";
        var lineTranslatedCurrent = "";
        for (var i = 0; i < ToT.length; i++) {
          var wordToTranslate = ToT[i].toLowerCase();
          if (key1 == 1) {
            if (ToT[i].split(/[a-z]+/).join("") == "-")
              if (ToT[i + 1] == "lain.") {
                ToT[i + 1] = "liya.";
              }
            if (ToT[i].split(/[a-z]+/).join("") == "-")
              if (ToT[i + 1] == "lain,") {
                ToT[i + 1] = "liya,";
              }
            if (ToT[i].split(/[a-z]+/).join("") == "-")
              if (ToT[i + 1] == "lain") {
                ToT[i + 1] = "liya";
              }
            if (ToT[i] == "lahir")
              if (ToT[i + 2] == "batin") {
                ToT[i] = "lair";
              }
            if (ToT[i] == "lahir")
              if (ToT[i + 3] == "batin") {
                ToT[i] = "lair";
              }
            if (ToT[i] == "di")
              if (ToT[i + 2] == "sini") {
                ToT[i + 2] = "ngriki";
              }
            if (ToT[i] == "di")
              if (ToT[i + 2] == "situ") {
                ToT[i + 2] = "kono";
              }
            if (ToT[i] == "di")
              if (ToT[i + 2] == "sana") {
                ToT[i + 2] = "kana";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 2] == "dan") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 3] == "dan") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 4] == "dan") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 5] == "dan") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 6] == "dan") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 2] == "atau") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 2] == "maupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 2] == "ataupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 3] == "atau") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 3] == "maupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 3] == "ataupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 4] == "atau") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 4] == "maupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 4] == "ataupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 5] == "atau") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 5] == "maupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 5] == "ataupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 6] == "atau") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 6] == "maupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 6] == "ataupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 7] == "atau") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 7] == "maupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 7] == "ataupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 8] == "atau") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 8] == "maupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 8] == "ataupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 9] == "atau") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 9] == "maupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "baik")
              if (ToT[i + 9] == "ataupun") {
                ToT[i] = "baikk";
              }
            if (ToT[i] == "ke") {
              ToT[i] = "menyang";
            } else if (ToT[i].split(/[!-?]+/).join("") == "ke") {
              ToT[i] = "kaping" + ToT[i].split(/[a-z]+/).join("");
            }
            if (ToT[i] == ToT[i])
              if (ToT[i + 1] == "kalix") {
                ToT[i + 1] = ToT[i];
                ToT[i] = " kalix ";
              }
            if (ToT[i] == "sangat")
              if (ToT[i + 1] == null) {
                ToT[i] = wordToTranslate;
              } else {
                ToT[i] = ToT[i + 1].split(/[!-?]+/).join("");
                ToT[i + 1] = "banget" + ToT[i + 1].split(/[a-zâ™¦-]+/).join("");
              }
            if (ToT[i] == "banget")
              if (ToT[i + 1] == null) {
                ToT[i] = wordToTranslate;
              } else if (ToT[i + 1].split(/[!-?]+/).join("") == "sekali") {
                ToT[i] = "";
                ToT[i + 1] = "banget" + ToT[i + 1].split(/[a-z]+/).join("");
              }
            if (ToT[i] == "banget")
              if (ToT[i + 1] == null) {
                ToT[i] = wordToTranslate;
              } else if (ToT[i + 1].split(/[!-?]+/).join("") == "banget") {
                ToT[i] = "";
                ToT[i + 1] = "banget" + ToT[i + 1].split(/[a-z]+/).join("");
              }
            if (ToT[i] == "tidak")
              if (ToT[i + 1] == "banget")
                if (ToT[i + 2] == null) {
                  ToT[i] = "tidak";
                  ToT[i + 1] =
                    "banget" + ToT[i + 1].split(/[a-zâ™¦]+/).join("");
                } else {
                  ToT[i] = "tidak";
                  ToT[i + 1] = ToT[i + 2].split(/[!-?]+/).join("");
                  ToT[i + 2] =
                    "banget" + ToT[i + 2].split(/[a-zâ™¦]+/).join("");
                }
          }
          var wordToTranslate = ToT[i];
          var wordToTranslateAsKey = wordToTranslate
            .toLowerCase()
            .split(/[â€â€,â€¦,â€™â€™,â€œâ€œ!-?`â™¦â€¢ )~ "â€˜â€™]+/)
            .join("");
          var charlast = wordToTranslate
            .toLowerCase()
            .split(/[-a-zâ™¦]+/)
            .join("");
          var wordtanslated = this.dictionary[wordToTranslateAsKey];
          var wordTranslated = wordtanslated + charlast;
          if (wordtanslated == null) {
            if (key1 == 1) {
              wordTranslated = wordToTranslate
                .split("anyaâ™¦")
                .join("ane")
                .split("inyaâ™¦")
                .join("ine")
                .split("unyaâ™¦")
                .join("une")
                .split("enyaâ™¦")
                .join("ene")
                .split("onyaâ™¦")
                .join("one")
                .split("nyaâ™¦")
                .join("e");
            }
            if (key1 == 0) {
              wordTranslated = wordToTranslate
                .split("aneâ™¦")
                .join("anya")
                .split("ineâ™¦")
                .join("inya")
                .split("uneâ™¦")
                .join("unya")
                .split("eneâ™¦")
                .join("enya")
                .split("oneâ™¦")
                .join("onya")
                .split("neâ™¦")
                .join("nya")
                .split("kake.")
                .join("kan.")
                .split("kake,")
                .join("kan,");
            }
          }
          var wordToTranslateLength = wordToTranslate.length;
          var wordTranslatedLength = wordTranslated.length;
          {
            String.prototype.padRight = function (
              charToPadWith,
              lengthToPadTo
            ) {
              var returnValue = this;
              while (returnValue.length > lengthToPadTo) {
                returnValue += charToPadWith;
              }
              return returnValue;
            };
          }
          var wordLengthGreater = Math.max(
            wordToTranslateLength,
            wordTranslatedLength
          );
          var wordTranslatedPadded = wordTranslated.padRight(
            " ",
            wordLengthGreater
          );
          charsInCurrentLine += 1 + wordLengthGreater;
          if (charsInCurrentLine >= charsPerLine) {
            passageInterleaved += lineTranslatedCurrent;
            lineTranslatedCurrent = wordTranslatedPadded + " ";
            charsInCurrentLine = wordLengthGreater;
          } else {
            lineTranslatedCurrent += wordTranslatedPadded + " ";
          }
        }
        passageInterleaved += lineTranslatedCurrent;
        return passageInterleaved;
      };
    }
    var dictionaryAsLookup = Tlanslator.dictionaryParse(dictionaryAsText);
    var teranslator = new Tlanslator(dictionaryAsLookup);
    var textTranslatedAndInterleaved1 = teranslator.translateAndInterleave(
      passageToTranslate,
      charsPerLine
    );
    var textTranslatedAndInterleaved = textTranslatedAndInterleaved1;
    if (key1 == 1) {
      hasilFungsiGan = textTranslatedAndInterleaved
        .split(" . ")
        .join(".")
        .split(" , ")
        .join(",")
        .split(" ( ")
        .join("(")
        .split(" ) ")
        .join(")")
        .split(" / ")
        .join("/")
        .split(" ! ")
        .join("!")
        .split(" ? ")
        .join("?")
        .split(" : ")
        .join(":")
        .split(" ; ")
        .join(";")
        .split(' " ')
        .join('"')
        .split(" ' ")
        .join("'")
        .split(" kalix kaping")
        .join(" ingkang kaping")
        .split(" kalix ")
        .join(" ping ")
        .split(" salah sa ")
        .join(" sawijining ")
        .split("salah sa ")
        .join("salah siji ")
        .split(" kali kaping ")
        .join(" kaping ");
    }
    if (key1 == 0) {
      hasilFungsiGan = textTranslatedAndInterleaved
        .split(" . ")
        .join(".")
        .split(" , ")
        .join(",")
        .split(" ( ")
        .join("(")
        .split(" ) ")
        .join(")")
        .split(" / ")
        .join("/")
        .split(" ! ")
        .join("!")
        .split(" ? ")
        .join("?")
        .split(" : ")
        .join(":")
        .split(" ; ")
        .join(";")
        .split(' " ')
        .join('"')
        .split(" ' ")
        .join("'")
        .split(" di di dalam")
        .join(" di dalam")
        .split(" di di luar")
        .join(" di luar")
        .split(" di di bawah")
        .join(" di bawah")
        .split(" dengan dengan sarana")
        .join(" dengan sarana")
        .split(" salah salah satu")
        .join(" salah satu")
        .split(" di dimana")
        .join(" dimana")
        .split("komentare")
        .join("komentarnya");
    }
  } else {
    var passageToTranslate = " " + kotakkalimat + " ";
    var charsPerLine = kotakkalimat.cols;
    var habuC = translate_options;
    {
      if (habuC == 4) {
        var krama = 4;
      }
      if (habuC == 1) {
        var krama = 2;
      }
      if (habuC == 2) {
        var krama = 1;
      }
      if (habuC == 3) {
        var krama = 0;
      }

      var dictionaryAsText =
        "terpejamnye=meremipun:terpejam=merem:berilah=sukani[PARINGI]:kutinggalkan=kula tilar:memburu=mbujeng:kehidupanmu=gesang[SUGENG] sampeyan[PANJENENGAN]:kehidupanku=gesang[SUGENG] kula:itunye=punikunipun[MENIKANIPUN]:tertuju=konjuk:ditunjukan=dipuntedahaken:sajakah=mawon:penyuka=pangremen:penggemar=pangremen:didefinisikan=dipunwedharaken:berpotensi=gadhah[KAGUNGAN] potensi:meletus=mlethus:sewaktuwaktu=kapan-kapan:bahunye=pundhakipun[PAMIDHANGANIPUN]:menewaskan=mejahi[NYEDANI]:dialokasikan=dipunalokasikaken:membatalkan=mbatalaken:melompati=mlumpati:mensponsori=sponsori:mempromosikan=mromosikaken:patah=tugel:patahnye=tugelipun:dirimu=sampeyanipun[PANJENENGANIPUN]:diriku=kulanipun:dipatahkan=dipuntugelaken:terhimpun=kahimpun:memensiunkan=mensiunaken:dipensiunkan=dipunpensiunaken:mengirimnya=ngintunipun:mengiriminye=ngintuninipun:berapaan=pintenan:mengukus=mbethak:mauku=kajengipun[KERSANIPUN] kula:maumu=kajengipun[KERSANIPUN] sampeyan[PANJENENGAN]:memainkannye=dolananipun[AMENG-AMENGANIPUN]:gampanggampang=gampil-gampil:menyisihkan=nyisihaken:merekayasa=ndamel-ndamel:ketemuannye=pepanggihanipun:ketemuan=pepanggihan:kepastian=pepesthen:urung=sande:merilis=ngumumaken:berposisi=gadhah[KAGUNGAN] panggenan:dirilis=dipunumumaken:kebebasan=kamardikan:berlambangkan=duwe lambang:meluap=wutah:melingkupi=nglingkupi:percintaan=tresna asih:jodoh=jodho:menikmati=nikmati:disukainye=dipunremeni:dipersiapkan=dipunsiyapaken:memborong=mborong:fasih=paseh:disindir=disemoni:menyindirmu=nyemoni sampeyan[PANJENENGAN]:menyindirku=nyemoni kula:menyindir=nyemoni:menyindirnye=nyemoni:kecintaanmu=katresnan sampeyan[PANJENENGAN]:kecintaanku=katresnan kula:kecintaan=katresnan:perlombaan=lomba:menggali=ndhudhuk:didayagunakan=dipundayagunakaken:dilanggar=dipunlanggar:kendati=sanadyan:kendatipun=sanadyan:malingnye=pandungipun:kemalingan=kepandungan:kelumrahan=kalimrahan:gemuknye=lemanipun:lemariku=lemantun kula:lemarimu=lemantun sampeyan[PANJENENGAN]:kuatkuatan=kiyat-kiyatan:mempertimbangkan=mertimbangaken:akankah=punapa[MENAPA] mangke:ditandingi=dipuntandingi:mukamu=rai[PASURYAN] sampeyan[PANJENENGAN]:mukaku=rai[PASURYAN] kula:diputar=diuter:diputarputar=diuter-uter:memutari=ngubengi:berputar=muter:berputarputar=mubeng-mubeng:melemparkan=mbalang:melemparnye=mbalangipun:melempar=mbalang:tugastugasnye=ayahan-ayahanipun:tugastugas=ayahan-ayahan:membekali=nyangoni:bekal=sangu:bekalnye=sangunipun:berpendidikan=gadhah[KAGUNGAN] pendhidhikan:disejajarkan=dipunjejer-jejeraken:sejajarkan=jejer-jejeraken:realita=kasunyatan:realitanye=kasunyatanipun:bertabrakan=tabrakan:penugasan=ayahan:tertempa=kelatih:beralamat=gadhah[KAGUNGAN] alamat:ragu=ragu-ragu:terkait=kekait:menempatkannye=manggenakenipun:bertuliskan=gadhah[KAGUNGAN] seratan:selempang=slempang:menyandang=nyandang:berpartisipasi=tumut[NDEREK]:prioritas=utami:diwariskan=dados tilaran:tegas=teges:bergelar=gadhah[KAGUNGAN] gelar:pemakaman=kuburan[PASAREAN]:diampuni=dipunampuni:sedalam=salebet:sedalamdalamnye=salebet-lebetipun:meladeninye=ngladeni[ngladosi] piyambakipun[PANJENENGANIPUN]:meladeni=ngladeni[ngladosi]:terbenamnye=sumerepipun:mataharinye=srengengenipun[SURYANIPUN]:terbenam=sumerep:petirnye=bledhegipun:petir=bledheg:digincui=dipunbengesi:gincunye=bengesipun:gincu=benges:bibirnye=lambenipun[LATHINIPUN]:bumikan=mbumikaken:keenakan=kecanen:mengidap=kenging[KEPARENG]:diwawancarai=dipunwawancara:diwawancara=dipunwawancara:pemanggilan=uleman[TIMBALAN]:menghilangnye=ngicalipun:kautinggal=sampeyan[PANJENENGAN] tilar:kutinggal=kula tilar:dapurnye=pawonipun:memasaknye=masakipun:dapur=pawon:memasak=masak:sampul=samak:pantai=pasisir:bukit=gumuk:kandasnye=kandhasipun:ombaknye=alunipun:kandas=kandhas:ombak=alun:jernihnye=weningipun:jernih=wening:tugas=ayahan:tugasnye=ayahanipun:pulaunye=pulonipun:pulau=pulo:terdiri=madeg:persawahannye=pasabinanipun:buahbuahannye=woh-wohanipun:buahbuahan=woh-wohan:benih=winih:benihnye=winihipun:perpustakaannye=pabukonipun:perpustakaan=pabukon:belanja=blanja:sandal=sandhal:pegunungan=pareden:bertiup=sumilir:gedung=gedhong:gedunggedung=gedhong-gedhong:merobohkan=ngrebahaken:badainye=praharanipun:badai=prahara:tangisan=pamuwun:tangisannye=pamuwunipun:meleleh=ndlewer:airmatanye=eluhipun[WASPANIPUN]:sambalnye=sambelipun:sambal=sambel:emasnye=jenenipun:menyemburkan=nyembur:cairan=cuweran:bergarisgaris=lorek-lorek:bulu=wulu:berbulu=wulu:berkaki=suku[SAMPARAN]:mengkilap=gilar-gilar:mengilap=gilar-gilar:pertunjukannye=tetingalanipun:pertunjukan=tetingalan:gunungnye=redinipun:kebakaran=kabesmen:dinyalakannye=dipunsumedipun:dinyalakan=dipunsumed:diterangi=dipadhangi:meletus=njeblug:muat=amot:bajunye=rasukanipun:indah=endah:bersinar=sumunar:presiden=presidhen:hanyut=keli:hanyutnye=kelinipun:pegangannye=cepenganipun:berpegangannye=cepenganipun:berpegangan=cepengan:angsa=banyak:berkicau=ngoceh:hinggapnye=mencokipun:hinggap=mencok:mekar=megar:mekarnye=megaripun:berdaun=godhongan:pohonpohon=wit-wit:udara=hawa:udaranye=hawanipun:dikunyah=dipunmamah[DIPUN GILUT]:menutupinye=nutupinipun:menutupi=nutupi:melintasinye=nyabranginipun:melintasi=nyabrang:perahunye=baitanipun:berbuahnye=wohipun:berbuah=woh:pohonnye=witipun:pohon=wit:mangga=pelem:mangganye=pelemipun:mengunyah=mamah[NGGILUT]:badannye=badanipun[SALIRANIPUN]:berkeringat=kringeten[RIWENEN]:sesak=sesek:dadanye=dhadhanipun[JAJANIPUN]:kekarkekar=keker-keker:kekar=keker:mirip=memper:dimiripkan=dipunmemperaken:dikitdikit=sakedhik-sakedhik:ginigini=kados puniki[MENIKA]:tinggalan=tilaran:makasi=matur nuwun:terbayar=kebayar:pembayar=pambayar:tanyatanye=taken-taken:beraniberani=wantun-wantun:beraniberaninye=wantun-wantunipun:kepekaan=peka:setahuku=sangertos kula:setahumu=sangertos sampeyan[PANJENENGAN]:setauku=sangertos kula:setaumu=sangertos sampeyan[PANJENENGAN]:mengakselerasi=ngenggali:mematangkan=matengaken:berkomentar=komentar:tanggapan=tanggepan:tanggapannye=tanggepanipun:menggombal=ngrayu:menyayat=nyeset:sayat=seset:tersayat=kebeset:disayat=diseset:gadismu=prawan sampeyan[PANJENENGAN]:gadisku=prawan kula:gadis=prawan:ilmiah=elmiyah:mencakupi=nyakupi:sanesya=sanesipun:tambahin=tambahi:nyarinye=madosinipun:mengobati=njampeni:mengemban=ngemban:dipungkiri=dipunpungkuri:termakan=katedha[KADHAHAR]:ormu=ormu:semauku=sekajengipun kula:semaumu=sekajengipun sampeyan[PANJENENGAN]:semau=sekajeng[SEKERSA]:semaunye=sekajengipun[SEKERSANIPUN]:dijabat=dipun-jabat:pendek=pendhek:suapi=ndulang:menyuapi=ndulang:berkontribusi=kontribusi:mengalokasikan=ngalokasikaken:hidupmu=gesang[SUGENG] sampeyan[PANJENENGAN]:hidupku=gesang[SUGENG] kula:berbaring=tileman[SAREAN]:terbaring=tileman[SAREAN]:tiduran=tileman[SAREAN]:mendongeng=ndongeng:dituju=dipuntuju:merekomendasikan=nyaranaken:terpelihara=keingah:dipeliharanye=dipuningahipun:rawat=rimat:batasanye=watesanipun:batasannye=watesanipun:kebalikanye=kuwangsulanipun:kebalikannye=kuwangsulanipun:telor=tigan:telurnye=tiganipun:telornye=tiganipun:menyunting=nyunting:paksakan=paksakaken:mengenyam=ngenyam:terpancing=kepancing:rezekinye=rejekinipun:menyangka=nyana:kawannye=kancanipun:harapnye=kekajenganipun:mengoptimalkan=ngoptimalaken:sertakan=sartakaken:digantungnye=dipun-gantungipun:digantung=dipun-gantung:menggantungnye=nggantungipun:menggantung=nggantung:bergantian=gantosan:menggantungkan=nggantungaken:pembagi=pamerang:pemudinye=nem-nemanipun:pemudanye=nem-nemanipun:pemudapemudinye=para nem-nemanipun:pemudapemudanye=para nem-nemanipun:pemudapemudi=para nem-neman:pemudapemuda=para nem-neman:diinjakkan=dipuntapakaken:diinjak=dipunpidak:menapakkan=napakaken:menginjakkan=napakaken:dijamu=dijamu:tulinye=budhegipun:tuli=budheg:saksi=seksi:saksinye=seksinipun:dirobohkan=dipunrebahaken:berlanjut=lajeng:tajam=landhep:tajamnye=landhepipun:tajamkan=landhepaken:menajamkan=nglandhepaken:ditajamkan=dipunlandhepaken:tumpul=papak:tumpulnye=papakipun:tumpulkan=papakaken:menumpulkan=mapakaken:terengahengah=krenggosan:meniupkan=nyebulaken:ditiupkan=dipunsebulaken:tiupkan=sebulaken:meniupnye=nyebulipun:ditiupnye=dipunsebulipun:tiupnye=sebulipun:meniup=nyebul:ditiup=dipunsebul:tiup=sebul:nginput=mlebetaken:terupdate=paling enggal:pampangkan=tingalaken[PRIKSAKAKEN]:memampangkan=ningalaken[MRIKSAKAKEN]:menggarap=nggarap:yng=ingkang:paham=mangertos:pahami=mangertosi:nyampai=dumugi:diimbuhi=dipunimbeti:berbasis=adhedhasar:elmu=elmu:ngelmu=ngelmu:dustanye=doranipun:dusta=dora:dilewatinye=dipunlangkunginipun:kelewatan=kelangkungan:terlewatkan=kelangkungaken:terlewatnye=kelangkungipun:terlewat=kelangkung:mengaktifkan=ngaktipaken:kualitas=kwalitet:digelontorkan=dipun glontoraken:menggelontorkan=ngglontoraken:menyiksa=nyiksa:mengibaratkan=ngibarataken:ibaratkan=ibarataken:diibaratkan=dipunibarataken:dalamdalam=lebet-lebet:penantian=entosan:penantianku=entosan kula:penantianmu=entosan sampeyan[PANJENENGAN]:menyesakkan=nyesekaken:menebus=nebus:ditebus=dipuntebus:hambar=anyep:mengaminkan=ngaminaken:diamini=dipun amini:terlempar=kabalang:sapisanpun=sapisana:dihimpun=dipunkempalaken:bertarung=tangled:merumput=ngrumput:diketuai=dipunpangagengi:dikomandoi=dipunpangagengi:keberuntunganku=kabegjanipun kula:keberuntunganmu=kabegjanipun sampeyan[PANJENENGAN]:keberuntungannye=kabegjanipun:keberuntungan=kabegjan:beroleh=angsal[KEPARINGAN]:merengkuh=angsal[KEPARINGAN]:musimmusim=mangsa-mangsa:kemudinye=kemudhinipun:kemudi=kemudhi:diri=dhiri:mandiri=mandhiri:menyudahi=ngrampungi:sepasang=sapasang:usainye=bibaripun:depanmu=ngajeng sampeyan[PANJENENGAN]:depanku=ngajeng kula:pikirkan=pamanahaken[PANGGALIHAKEN]:memandangi=mandengi:kedalaman=lebet:kedalamannye=lebetipun:pindahkan=pindhahaken[JENGKARAKEN]:catatlah=cathet:perbanyaklah=kathah-kathahaken:tergambar=kegambar:tilik=tuwi:menengok=ningali[nuweni]:menjenguk=ningali[nuweni]:diabaikan=dipun jor aken:memberdayakan=mberdayakaken:dibudidaya=dipunbudidaya:diberdayakan=dipunberdayakaken:menyusulnye=nusule:disusulnye=dipunsusulipun:disusul=dipunsusul:membarui=ngenggali:membaharui=ngenggali:terpicu=keenggalaken:memicu=ngenggalaken:dipicu=dipunenggalaken:kenaikannye=minggahipun:kenaikan=minggah:penurunannye=mandhapipun:penurunan=mandhap:lokasinye=papanipun:lokasi=papan:menciumi=ngambungi[NGARASI]:termulia=paling mulya:tersempurna=paling sempurna:terkaya=paling sugih:dialah=piyambakipun:sakitnye=sakitipun[GERAHIPUN]:terminum=keombe[KEUNJUK]:terinjak=kepidak:kakiku=suku[SAMPARAN] kula:kakimu=suku[SAMPARAN] sampeyan[PANJENENGAN]:kakinye=sukunipun[SAMPARANIPUN]:akar=oyod:akarnye=oyodipun:berdampingan=jejeran:menggulingkan=nggulingaken:melengserkan=nglengseraken:memeluk=nyikep:saudarasaudaranye=sadherek-sadherekipun:mulai=wiwit:menidurkan=nilem-nilem[NYARE-NYARE]:merekalah=piyambakipun sedaya lah:provinsi=propinsi:lainye=sanesipun:dipolitisasi=dipunpolitisasi:menyematkan=nyemataken:lampau=rumiyin:ketimbang=katimbang:tertimbang=katimbang:mencemaskannye=mutawatosinipun:mencemaskan=mutawatosi:mainanku=dolanan[AMENG-AMENGAN] kula:mainanmu=dolanan[AMENG-AMENGAN] sampeyan[PANJENENGAN]:mainannye=dolananipun[AMENG-AMENGANIPUN]:mainan=dolanan[AMENG-AMENGAN]:seumur=pantaran:mengumpat=ngraosi:menyambungi=nyambeti:dihitungnye=dipunetange:hitungnye=etange:dihitung=dipunetang:ngasih=nyukani[MARINGI]:dilangkahi=dipunlangkahi:diapaapain=dipunpunapa-punapakaken[DIPUNMENAPA-MENAPAKAKEN]:diapaapakan=dipunpunapa-punapakaken[DIPUNMENAPA-MENAPAKAKEN]:diruntuhkan=dipun rentah aken:menelanjangi=wudani:memadai=mumpuni:tertendang=ketendhang:segar=seger:disetorkan=dipunsetoraken:menyetorkan=nyetoraken:disetornye=dipunsetoripun:menyetornye=nyetoripun:disetor=dipunsetor:menyetor=nyetor:keberlanjutan=kelajengan:menopang=nopang:berkelilingnye=mubeng-mubengipun:berkeliling=mubeng-mubeng:berdandannye=dandosipun:berdandan=dandos:wilayahwilayah=tlatah-tlatah:merekamnye=ngrekamipun:merekam=ngrekam:truk=trik:terserap=mresep:terkecil=paling alit:perkelahian=pabenan:berkelahi=tangled:pertengkaran=pabenan:bersalinnye=babaranipun[WEDHARANIPUN]:bersalin=babaran[WEDHARAN]:menandakan=nandhakaken:terurai=kerembyak:mengurai=ngrembyak:menguraikan=ngrembyak:bus=bis:masanye=wekdalipun:pengingat-ingat=pangemut-emut:pengingat=pangemut:peduli=perduli:rendahan=alitan:mengalahnye=ngawonipun:mengalah=ngawon:persenkah=persen:didengarkan=dipunpirengaken[DIPUNPIDHANGETAKEN]:penyampaiannye=aturipun[UNJUKIPUN]:penyampaiannye=aturipun[UNJUKIPUN]:penyampaian=atur[UNJUK]:nyampe=dumugi:nggk=mboten:lemah=ringkih:yaiku=yaiku:kapan=kala punapa[KALA MENAPA]:tiriku=kuwalon kula:tirimu=kuwalon sampeyan[PANJENENGAN]:tirinye=kuwalonipun:tiri=kuwalon:batubatunye=sela selanipun:batubatu=sela sela:ikatannye=tangsulanipun:ikatan=tangsulan:ikat=tangsul:pengantinnye=pangantenipun:pengantin=panganten:mendampinginye=ngiringinipun:mendampingi=ngiringi:kerabatkerabatnye=sadherek-sadherekipun:kerabatkerabat=sadherek-sadherek:kerabatnye=sadherekipun:kerabat=sadherek:berhias=dandos:rias=dandos:terikatnye=ketangsulipun:terikat=ketangsul:diikat=dipuntangsuli:ditaburi=diuwuri:berjongkok=ndodok:jongkok=ndodok:diperintahnye=dipunkengkenipun[DIPUNDAWUHIPUN]:cikalbakal=cikal bakal:dibalutnye=dipun-gubedipun:dibalutkan=dipun-gubedaken:dibalut=dipun-gubed:membalutkannye=nggubedakenipun:membalutkan=nggubedaken:membalutnye=nggubedipun:membalut=nggubed:menyingkirnye=sumingkiripun:menyingkir=sumingkir:berpindahnye=pindhahipun:terbawah=paling andhap:memudar=luntur:digolongkannye=dipun-golongakenipun:menggolongkannye=nggolongakenipun:digolongkan=dipun-golongaken:menggolongkan=nggolongaken:mencampurnye=nyampuripun:mencampur=nyampur:dewasaini=dewasa puniki[MENIKA]:terlat=kantun:telat=kantun:malem=dalu:kunjungi=dugini[RAWUHI]:menyahutnye=mangsulinipun:menyahut=mangsuli:setau=sangertos:nerjemahin=nerjemahaken:diterjemahin=dipunterjemahaken:tidurku=tilemipun[SARENIPUN] kula:tidurmu=tilemipun[SARENIPUN] sampeyan[PANJENENGAN]:tidurnye=tilemipun[SARENIPUN]:mengoroknye=ngorokipun:mengorok=ngorok:kegelapan=petengan:tersesatnye=kesasaripun:tersesat=kesasar:malasnye=kesedipun:malas=kesed:memperkokoh=ngiyati:mempersulitku=nyisah-nyisahi kula:mempersulitmu=nyisah-nyisahi sampeyan[PANJENENGAN]:mempersulitnye=nyisah-nyisahi piyambakipun[PANJENENGANIPUN]:mempersulit=nyisah-nyisahi:kehadirannye=duginipun[RAWUHIPUN]:baliknye=wangsulipun[KONDURIPUN]:kemalaman=kedalon:melamarnye=nglamar piyambakipun[PANJENENGANIPUN]:melamarmu=nglamar sampeyan[PANJENENGAN]:melamarku=nglamar kula:keningnye=bathukipun[PALARAPANIPUN]:keningmu=bathuk[PALARAPAN] sampeyan[PANJENENGAN]:keningku=bathuk[PALARAPAN] kula:keadaanmu=kawontenan sampeyan[PANJENENGAN]:keadaanku=kawontenan kula:membantainye=numpesipun:bantainye=tumpesipun:dibantainye=dipuntumpesipun:membantai=numpes:bantai=tumpes:dibantai=dipuntumpes:permainan=dolanan[AMENG-AMENG]:kesalahankesalahan=kelepatan-kelepatan:dijangkaunye=dipuncawelipun:menjangkaunye=nyakupipun:jangkauannye=cakupanipun:menjangkau=nyakup:jangkauan=cakupan:remaja=nemneman:memberatkan=ngawrataken:memperberat=ngawrati:dijanjikan=dipun janjikaken:menjanjikan=njanjikaken:disinkronkan=dipunsinkronaken:dilacak=dipunlacak:melacaknye=nglacakipun:melacak=nglacak:sepandai=sapinter:sepandaipandainye=sapinter-pinteripun:perekayasa=tukang rekayasa:menemuinye=manggihi piyambakipun[PANJENENGANIPUN]:menemuiku=manggihi kula:menemuimu=manggihi sampeyan[PANJENENGAN]:perkebunan=tegalan:mengenakkan=ngecakaken:dihaturkan=katur[KONJUK]:jelang=tumuju:oleholehmu=angsal-angsalipun sampeyan[PANJENENGAN]:oleholehku=angsal-angsalipun kula:oleholeh=angsal-angsal:oleholehnye=angsal-angsalipun:diharap=dipunajeng-ajeng:sambungnye=sambetipun:mengasahkan=ngasahaken:mengasah=ngasah:mengasahnye=ngasahipun:ditinjau=dipuntilik:pisau=lading:pisaunye=ladingipun:tahap=perangan:tahapan=perangan:mingguan=minggon:tahunan=taunan:kelebihankelebihanmu=kalangkungan-kalangkungan sampeyan[PANJENENGAN]:kelebihankelebihanku=kalangkungan-kalangkungan kula:kelebihankelebihannye=kalangkungan-kalangkunganipun:kelebihankelebihan=kalangkungan-kalangkungan:kelebihanku=kalangkungan kula:kelebihanmu=kalangkungan sampeyan[PANJENENGAN]:kelebihannye=kalangkunganipun:kelebihan=kalangkungan:desaku=dhusun kula:desamu=dhusun sampeyan[PANJENENGAN]:menimbulkannye=nimbulakenipun:timbulkannye=timbulakenipun:ditimbulkannye=dipuntimbulakenipun:menimbulkan=nimbulaken:timbulkan=timbulaken:ditimbulkan=dipuntimbulaken:ejekannye=pepoyokipun:ejekan=pepoyok:diolokolok=dipunpoyoki:olokolok=pepoyok:mengolokolok=moyoki:diperdalam=dipunlebeti:kebun=kebon:meluruskannye=nglurusakenipun:luruskannye=lurusakenipun:diluruskannye=dipunlurusakenipun:meluruskan=nglurusaken:luruskan=lurusaken:diluruskan=dipunlurusaken:menyepakati=mupakati:disepakati=dipun mupakati:direnungkan=dipunmanahaken[DIPUN GALIHAKEN]:ternyaman=paling nyaman:keseruan=karamean:keseruannye=karameanipun:diabadikan=dipunabadikaken:kenyangnye=tuwukipun:menyedihkan=nyedhihaken:sedihkan=sedhihaken:sedihnye=sedhihipun:sedih=sedhih:mengemuka=nyongat:dicetaknye=dipuncithakipun:mencetaknye=nyithakipun:cetaknye=cithakipun:cetak=cithak:jenisjenis=jinis-jinis:sejenis=sajinis:sejenisnye=sajinisipun:disertakan=dipunsartani:mencuatkan=nyongataken:mencuatnye=nyongatipun:mencuat=nyongat:menyehatkan=nyarasaken[NYENGGANGAKEN]:sehatkan=sarasaken[SENGGANGAKEN]:sehatnye=sarasipun[SENGGANGIPUN]:cintanye=tresnanipun:diulang=dipunwangsuli:ulang=wangsul:karanganmu=anggitan sampeyan[PANJENENGAN]:karanganku=anggitan kula:karangannye=anggitanipun:karangan=anggitan:gapai=gayuh:raih=gayuh:resah=ewed:gelisah=pakewed:tamunye=dhayohipun:tamumu=dhayohipun sampeyan[PANJENENGAN]:tamuku=dhayohipun kula:diajarnye=dipunwucalipun[DIPUNASTANIPUN]:dipadu=dipunpadu:beralas=ngangge samak:belasan=welasan:terbangun=tangi[WUNGU]:didirikannye=dipundhirikakenipun:didanai=dipun artani:belikan=tumbasaken[PUNDHUTAKEN]:kocek=arta:seputar=sawentawis:menyisipkan=nyisipaken:menggembleng=nggembleng:dititipinye=dipuntitipi:dititipkannye=dipuntitipaken:dititipi=dipuntitipi:dititipkan=dipuntitipaken:perilaku=lampahan[TINDAKAN]:bertingkah=lampah[TINDAK]:diajarinye=dipunwucalipun[DIPUNASTANIPUN]:berperilaku=lampah[TINDAK]:berukuran=ukuran:menungguinye=nenggani:membimbing=mbimbing:menyanyikannye=nyekarakenipun:bawabawa=bekta-bekta[ASTA-ASTA]:seartinye=seartosipun:searti=seartos:mendukungku=nyengkuyung kula:mendukungmu=nyengkuyung sampeyan[NJENENGAN]:semangat=sengkuyung:tulisantulisanmu=seratan-seratan sampeyan[PANJENENGAN]:tulisantulisanku=seratan-seratan kula:tulisantulisannye=seratan-seratanipun:tulisantulisan=seratan-seratan:tergesernye=keingseripun:tergeser=keingser:ungu=wungu:ungunye=wungunipun:kuningnye=jenenipun:hijaunye=ijemipun:menyapunye=nyapunipun:menyapu=nyapu:membelinye=tumbasipun[MUNDHUTIPUN]:dibelinye=dipuntumbasipun[DIPUNPUNDHUTIPUN]:belinye=tumbasipun[MUNDHUTIPUN]:pelajaran=wucalan:pelajarannye=wucalanipun:hewanhewan=kewan-kewan:wawasan=kawruh:menyusul=nusul:parutan=parudan:parut=parud:tujuan=tujuwan:pemeriksaan=pamriksan:mendeskripsikan=ngandharaken:penyebarnye=panyebaripun:penebarnye=panyebaripun:penyebar=panyebar:penebar=panyebar:usahlah=betah lah:usah=betah:dipikirnye=dipunmanahipun[DIPUN GALIHIPUN]:dipikir=dipunmanah[DIPUN GALIH]:melantur=ngawur:kanakkanak=lare-lare[PEPUTRA]:kanakkanaknye=lare-larenipun[PEPUTRANIPUN]:mengherankan=heran:menyodorkan=nyodoraken:mengeceknye=mriksanipun:memeriksanye=mriksanipun:mengecek=mriksa:memeriksa=mriksa:efeknye=murugaken:berefek=murugaken:berprofesi=gadhah[KAGUNGAN] pandamelan:terbebaninye=kawratenipun:keberatannye=kawratenipun:terbebani=kawraten:mengambilalihnye=ngrebatipun:mengambilalih=ngrebat:pernyataan=pranyatan:ingatingat=emut-emut:bertebaran=pating-slebar:bertebarannye=pating-slebaripun:bisabisanye=saged-sagedipun:menghujat=nyepaosi:tepian=tepi:mbenerin=ngleresi:benerin=ngleresi:diikutsertakan=dipundherekaken:diluar=nten jawi:pemuda=nem-neman:pemimpinnye=pangagengipun:pimpinannye=pangagengipun:pemimpin=pangageng:pimpinan=pangageng:keanekaragaman=maneka-warni:keragaman=maneka-warni:sederhana=prasaja:kesederhanaan=prasaja:enggalbaru=enggal-enggal:menyadarkan=ngemutaken:mukanye=praenipun[PASURYANIPUN]:dijamin=dipunjamin:berjulukan=gadhah[KAGUNGAN] wastan:serangkaian=sarangken:menantangnye=nantangipun:merendah=andhap asor:dihapuskan=dipunbusek:pemahaman=pangertosan:menantang=nantang:ulasnye=jlentrehipun:ulas=jlentreh:dzulhijjah=besar:dzulkaidah=sela:syawal=sawal:rajab=rejeb:ramadhan=pasa:safar=sapar:muharram=sura:cerdasnye=pinteripun:cerdas=pinter:menjelek=ngawon:berfikirnye=manahipun[NGGALIHIPUN]:berpikirnye=manahipun[NGGALIHIPUN]:mikir=manah[NGGALIH]:terpikir=kapanah[KAGALIH]:pembaca=pamaos:terbengong=mlongo:terbengongbengong=mlongo:mengompori=manas-manasi:dibikinin=didamelaken:partai=parte:kakek=embah[EYANG] kakung:berkakek=gadhah[KAGUNGAN] embah[EYANG] kakung:kakeknye=embah[EYANG] kakungipun:kakekku=embah[EYANG] kakungipun kula:kakekmu=embah[EYANG] kakungipun sampeyan:nenek=embah[EYANG] putri:bernenek=gadhah[KAGUNGAN] embah[EYANG] putri:neneknye=embah[EYANG] putrinipun:nenekku=embah[EYANG] putrinipun kula:nenekmu=embah[EYANG] putrinipun sampeyan:kakekkakek=embah[EYANG] kakung:kakekkakeknye=embah[EYANG] kakungipun:neneknenek=embah[EYANG] putri:nenekneneknye=embah[EYANG] putrinipun:bekerja=nyambut damel:kerja=nyambut damel:kenapa=kenging punapa[MENAPA]:knapa=kenging punapa[MENAPA]:mengapa=kenging punapa[MENAPA]:kedepan=dhateng ngajeng:kemana=dhateng pundi:begitu=kados puniku[MENIKA]:dibawah=nten ngandhap:melebihi=nglangkungi:ingin=kajeng[badhe]:diinginkan=dipunkajengi[DIPUNKERSANI]:inginkan=kajengi[KERSANI]:diingini=dipunkajengi[DIPUNKERSANI]:teringin=kajeng[KERSA]:maunye=kajengipun[KERSANIPUN]:mahunye=kajengipun[KERSANIPUN]:bila=bilih:beberapa=pinten-pinten:beri=sukani[PARINGI]:diberi=dipunsukani[DIPUNPARINGI]:diberikan=dipunsukakaken[DIPUNPARINGAKEN]:setelah=sasampunipun:berakar=gadhah[KAGUNGAN] oyod:menjadi=dados:kesastraan=kasusastran:bersaing=saingan:menghadiahkan=nyukani[MARINGI] bebingah:menghadiahi=nyukani[MARINGI] bebingah:hadiah=bebingah:menjadikannye=ndadosakenipun:kepada=kalih[dhateng]:kepadanye=kalih piyambakipun[PANJENENGANIPUN]:merah=abrit:berat=awrat:beratku=awratipun kula:beratmu=awratipun sampeyan[PANJENENGAN]:di=nten:ungkapkan=wedharaken:sahutnye=sumauripun:sahut=sumaur:dukungannye=dhukunganipun:dingin=asrep:dinginnye=asrepipun:menghadap=majeng:menghadapnye=marani[SOWAN] piyambakipun[PANJENENGANIPUN]:dihadapkan=dipunajengaken:dihadapkannye=dipunajengakenipun:hadapan=ajengan:hadapannye=ajenganipun:dihadapan=nten ajengan:berhadapan=ajeng-ajengan:ngadep=marani[SOWAN]:senin=senen:selasa=slasa:rabu=rebo:kamis=kemis:jumat=jemuwah:adik=adhi[RAYI]:jauh=tebih:jauhkan=nebihaken:sejauh=satebih:dijauhkan=dipuntebihaken:dijauhkannye=dipuntebihakenipun:dijauhi=dipuntebihi:menjauh=nebihi:menjauhi=nebihi:jauhjauh=tebih-tebih:mandi=adus[SIRAM]:agama=agami:cepat=enggal:cepatnye=enggalipun:mempercepat=ngenggali:lekas=enggal:jangan=sampun:bernilai=aos:menghargai=ngaosi:dihargai=dipunaosi:dihargainye=dipunaosi nipun:dihargaimu=dipunaosi sampeyan[PANJENENGAN]:dihargaiku=dipunaosi kula:maju=majeng:majunye=majengipun:memajukan=majengaken:dimajukan=dipunajengaken:diajukan=dipunajengaken:banyak=kathah:memperbanyak=ngatah-ngatahi:terbanyak=paling kathah:kebetulan=keleresan:aku=kula:saya=kula:mengaku=ngaken:ngaku=ngaken:mengakui=ngakeni:mengakuimu=ngakeni sampeyan[PANJENENGAN]:mengakuiku=ngakeni kula:diaku=dipunaken:diakui=dipunakeni:jelek=awon:buruk=awon:sejelek=saawon:seburuk=saawon:jeleknye=awonipun:buruknye=awonipun:burukmu=awonipun sampeyan[PANJENENGAN]:burukku=awonipun kula:alangalang=kambengan:ilalang=kambengan:halangan=pambengan:menghalangi=ngambengi:menghalanginye=ngambenginipun:menghalangimu=ngambengi sampeyan[PANJENENGAN]:menghalangiku=ngambengi kula:hutan=wana:hutannye=wana nipun:hutanmu=wana sampeyan[PANJENENGAN]:hutanku=wana kula:cincin=sesupe:cincinnye=sesupe nipun:cincinku=sesupe nipun kula:cincinmu=susupe nipun sampeyan[PANJENENGAN]:alis=alis[IMBA]:alisnye=alisipun[IMBANIPUN]:alismu=alis[IMBA] sampeyan[PANJENENGAN]:alisku=alis[IMBA] kula:karena=amargi:karenanye=amarginipun:dikarenakan=dipunamargikaken:lebar=wiyar:luas=wiyar:memperluas=miyar-aken:bau=mambet:membaui=ngambet:cium=aras:ada=wonten:anaknye=larenipun[PUTRANIPUN]:untuk=kangge[KAGEM]:berlaku=kangge:mengiringi=ngiringi[NDHEREKAKEN]:buatan=damelan:antara=antawis:diantaranye=nten antawisipun:antaranye=antawisipun:menawar=ngawis:menawarnye=ngawisipun:apa=punapa[MENAPA]:apaapa=napa-napa[MENAPA-MENAPA]:bagus=sae:bagusnye=saenipun:maaf=pangapunten[nuwun sewu]:maafnye=pangapuntenipun:maafkan=ngapuntenaken:dimaafkan=dipun-apuntenaken:dimaafkannye=dipun ngapuntenipun:memaafkan=ngapuntenaken:arane=wasthanipun:jarang=awis:gelem=purun[KERSA]:kehendak=kajeng[KERSA]:berkehendak=kajeng[KERSA]:keinginan=kekajengan:mau=ajeng[badhe]:hendak=badhe:ariari=tuntunan[ARUMAN]:anjing=segawon:anjingmu=segawonipun sampeyan[PANJENENGAN]:anjingku=segawonipun kula:hati=manah[PANGGALIH]:hatinye=manahipun[PANGGALIHIPUN]:atiati=atos-atos:hatihati=atos-atos:awak=badan[SALIRA]:tubuh=badan[SALIRA]:tubuhmu=badan[SALIRA] sampeyan[PANJENENGAN]:tubuhku=badan[SALIRA] kula:siang=siyang:kemudian=lajeng:saja=mawon:aja=mawon:hanye=namung[naming]:bakal=badhe:tembakau=sata:baku=baken:pulang=wangsul[KONDUR]:mundur=mundur[LENGSER]:tulang=tosan:tulangnye=balungipun[TOSANIPUN]:tulangmu=balung[TOSAN] sampeyan[PANJENENGAN]:tulangku=balung[TOSAN] kula:banget=sanget:sangat=sanget:banjir=bena:banjirnye=benanipun:air=toya:airnye=toyanipun:berair=toyanan:bareng=sareng:barengbareng=sareng-sareng:bersama=sareng:bersamasama=sareng-sareng:sulung=pembajeng:sulungnye=pembajengipun:bata=banon:dahi=bathuk[PALARAPAN]:pembantu=rencang[ABDI]:teman=kanca:temanteman=kanca-kanca:tementemen=kanca-kanca:temen=kanca:temantemannye=kanca-kancanipun:tementemennye=kanca-kancanipun:bebek=kambangan:beda=benten:bedabeda=benten-benten:berbedabeda=benten-benten:membedakan=mbentenaken:membedakannye=mbentenakenipun:berbeda=benten:bedanye=bentenipun:perbedaan=benten:bener=leres:benar=leres:sebenarnye=saleresipun:sebenernye=saleresipun:sesungguhnye=saestunipun:betul=leres:sebetulnye=saleresipun:malam=dalu:semalam=ndalu:beras=wos:bisa=saged:lebihlebih=langkung-langkung:terlebih=langkung-langkung:sebisa=sasaged:sebisanye=sasagedipun:mungkinn=mungkin:dahulu=rumiyin:dahulunye=rumiyinipun:bocah=lare:dahulukan=rumiyinaken:didahulukan=dipunrumiyinaken:mendahulukan=ngrumiyinaken:anak=lare[PUTRA]:cilik=alit:suami=semah[GARWA]:istri=semah[GARWA]:bokong=pocong:pantat=pocong:balik=wangsul[KONDUR]:bedak=parem[KONYOH]:payung=payung[songsong]:pijit=pijet[PETEK]:bawang=brambet:kumis=kumis[RAWIS]:bubar=bibar:rusak=risak:berangkat=bidhal[TINDAK]:buka=bikak:pembukaan=bebikak:dibuka=dipunbikak:dibukakan=dipunbikakaken:bukanye=bikakipun:dibukanye=dipunbikakipun:membuka=mbikak:membukakan=mbikakaken:membukanye=mbikakipun:digambarkan=dipun gambaraken:gembira=bingah[RENA]:bongkar=bingkar:belakang=wingking:belakangan=wingkingan:buruh=berah:butuh=betah:kebutuhan=kebetahan:dibutuhkan=dipunbetahaken:membutuhkan=mbetahaken:membutuhkannye=mbetahakenipun:diperlukan=dipunbetahaken:perlu=betah:memerlukan=mbetahaken:buang=bucal:membuang=mbucal:dibuang=dipunbucal:mulut=cangkem[TUTUK]:mulutnye=cangkemipun[TUTUKIPUN]:bicara=sanjang[MATUR]:ngobrol=gineman[NGENDIKAN]:ngobrolngobrol=gineman[NGENDIKAN]:bercakap=gineman[NGENDIKAN]:percakapan=gineman[NGENDIKAN]:bercakapcakap=gineman[NGENDIKAN]:membicarakan=ngginemaken[NGENDIKAKAKEN]:dibicarakan=dipun-ginemaken[DIPUN-NGENDIKAKAKEN]:dekat=celak/caket:dekatnye=celakipun/caketipun:pegang=cepeng[ASTA]:berpegang=cepengan[ASTANAN]:memegang=nyepeng[NGASTA]:celeng=andhapan:copot=copot[LUKAR]:cebok=cawik:kecil=alit:kecilnye=alitipun:kecilkecil=alit-alit:remeh=alitan:coba=cobi:cerita=criyos:ceritanye=criyosipun:curi=colong:mengukir=ngukir:juara=juwara:juaranye=juwaranipun:mengukirnye=ngukiripun:kekalahannye=kekawonanipun:kekesalan=muring-muring:diungkapkannye=dipun-wedhar piyambakipun:setia=setya:menceritakan=nyriyosaken:diceritakan=dipuncriyosaken:menegakkan=njumenengaken:mengisahkan=nyriyosaken:lepas=copot[LUKAR]:cukup=cekap:cukur=cukur[PARAS]:kalung=sangsangan:jadi=dados:terjadi=kedados:kejadian=kedadosan:jadinye=dadosipun:terjadinye=kedadosipun:menjadikan=ndadosaken:jadikan=dadosaken:menimbulkan=ndadosaken:dandan=dandos[BUSANA]:dandanan=dandosan[BUSANA]:dandanannye=dandosanipun[BUSANANIPUN]:berpakaian=angge-angge[BUSANA]:desa=dhusun:dada=dhadha[JAJA]:ketika=kala[NALIKA]:lutut=dhengkul[JENGKU]:dengkul=dhengkul[JENGKU]:sendiri=piyambak:dukuh=dhekah:duit=arta:uang=arta:atas=inggil:diatas=nten inggil:hari=dinten:adaada=wonten-wonten:mengatasi=nginggili:menghaturkan=ngaturaken[NGONJUKAKEN]:haturkan=ngaturaken[NGONJUKAKEN]:harinye=dintenipun:kertas=dlancang:berdagang=nyade:dagang=sade:dagangannye=sadeanipun:dagangan=sadean:jual=sade:menjual=nyade:terjual=kasade:jualan=sadean:jualannye=sadeanipun:berjualan=sadean:dijual=dipunsade:dijualnye=dipunsadenipun:main=dolan[AMENG-AMENG]:dolan=dolan[AMENG-AMENG]:memainkan=ndolanaken[AMENG-AMENGAKEN]:setuju=purun[KERSA]:setujui=puruni[KERSANI]:setujunye=purunipun[KERSANIPUN]:menyetujui=muruni[NGERSANI]:disetujui=dipunpuruni[DIPUNKERSANI]:doyan=purun[KERSA]:jari=driji[RACIKAN]:adu=aben:bukan=sanes:bukanlah=sanes:durian=asiran:duren=asiran:belum=dereng:punye=gadhah[KAGUNGAN]:punyai=gadhahi[KAGUNGANI]:miliki=gadhahi[KAGUNGANI]:sembari=kalih:kepunyaan=gadhahipun[KAGUNGANIPUN]:punyanye=gadhahipun[KAGUNGANIPUN]:dipunyai=dipungadhahi[DIPUNKAGUNGANI]:gila=ewah:ingat=emut:mengingat=ngemut-emut:eluh=waspa:emas=jene:entah=duka:enak=eca:kepala=sirah[MUSTAKA]:telur=tigan:mana=pundi:tempat=papan:muda=enem[TIMUR]:habis=telas:menghabiskan=nelasaken:habiskan=telasaken:dihabiskan=dipuntelasaken:habishabis=telas-telas:habishabisnye=telas-telasipun:kentut=entut[SARIP]:pagi=enjing:paginye=enjingipun:pagipagi=enjing-enjing:hitung=etang:sedang=saweg:lagi=malih:gajah=liman:senjata=dedamel:gamelan=gangsa:gampang=gampil:mudah=gampil:kemudahan=kegampilan:memudahkan=nggampilaken:mempermudah=nggampilaken:dimudahkan=dipun-gampilaken:meremehkan=nggampilaken:diremehkan=dipunanggep alitan:lengkap=jangkep:kelengkapan=kajangkepan:lengkapkan=jangkepaken:lengkapnye=jangkepipun:selengkapnye=sajangkepipun:genap=jangkep:genapkan=jangkepaken:digenapkan=dipunjangkepaken:melengkapi=njangkepi:lengkapi=jangkepi:dilengkapi=dipunjangkepi:digenapi=dipunjangkepi:menggenapi=njangkepi:ganti=gantos:gantiganti=gantos-gantos:bergantiganti=gantos-gantos:mengganti=nggantos:menggantinye=nggantosipun:menggantikan=nggantosaken:diganti=dipun-gantos:digantinye=dipun-gantosipun:digantikan=dipun-gantosaken:pengganti=panggantos:giliran=gantosan:bergilir=gantosan:bergiliran=gantosan:terganti=kegantos:itulah=puniku[MENIKA] lah:inilah=puniki[MENIKA] lah:bawa=bekta[ASTA]:dibawa=dipunbekta[DIPUNASTA]:dibawabawa=dipunbekta-bekta[DIPUNASTA-ASTA]:buat=damel:dibuat=dipundamel:membuat=ndamel:membikin=ndamel:membuatkan=ndamelaken:menyebabkan=ndamel:membuatnye=ndamelipun:besar=ageng:punggung=gigir[PENGKERAN]:punggungnye=gigiripun[PENGKERANIPUN]:gelang=gelang[BINGGEL]:sanggul=gelung[UKEL]:bersanggul=gelungan[UKELAN]:gemak=puyuh:api=latu:darahnye=rahipun:darah=rah:tengkuk=githok[GRIWA]:tepung=glepung:cambang=godheg[ATHI-ATHI]:daundaun=ron-ron:daundaunnye=ron-ronipun:daun=ron:cari=pados:bohong=dora:berdusta=dora:gugat=gigat:menggugat=nggigat:digugat=dipun-gigat:gugatan=gigatan:patuh=gega:gula=gendhis:gulanye=gendhisipun:bergula=gendhisan:leher=jangga:lehernye=jangganipun:guna=gina:gunung=redi:tertawa=nggujeng:tawa=gujeng:bergurau=gegujengan:bercanda=gegujengan:menertawakan=nggegujeng:cicip=cicip[KEDHAP]:ludah=idu[KECOH]:meludah=idu[KECOH]:diludahkan=dipun idukaken[DIPUN KECOH AKEN]:pergi=kesah[TINDAK]:kepergian=kesahipun[TINDAKIPUN]:dulu=rumiyin:dulunye=rumiyinipun:hijau=ijem:tukar=lintu:menukar=nglintu:iket=udheng[DHESTAR]:ini=puniki[MENIKA]:ilang=ical:hilang=ical:menghilang=ngical:kehilangan=kaicalan:dihilangkan=dipunicalaken:menghilangkan=ngicalaken:lidah=ilatipun[LIDHAHIPUN]:lidah=ilat[LIDHAH]:lidahmu=ilat[LIDHAH] sampeyan[PANJENENGAN]:lidahku=ilat[LIDHAH] kula:imbuh=imbet[TANDUK]:nambah=imbet[TANDUK]:menambah=nambah:ditambahkan=dipuntambahaken:inap=sipeng[SARE]:menginap=nyipeng[NYARE]:bermalam=nyipeng[NYARE]:pelihara=ingah:intan=sela:mimpi=supena:mimpinye=supenanipun:mimpimu=supena sampeyan[PANJENENGAN]:mimpiku=supena kula:impian=supena:impiannye=supenanipun:impianmu=supena sampeyan[PANJENENGAN]:impianku=supena kula:hitam=cemeng:hidung=irung[GRANA]:masih=taksih:malu=lingsem:ikan=ulam:ikannye=ulamipun:jaga=jagi:minta=nedha[NYUWUN]:meminta=nedha[NYUWUN]:mohon=nedha[NYUWUN]:memohon=nedha[NYUWUN]:jam=tabuh:pinang=wohan:jambu=jambet:jamu=jampi[LOLOH]:dagu=janggut[KETHEKAN]:kuda=kapal[KUDA]:jarit=sinjang:kain=sinjang[NYAMPING]:jati=jatos:jawa=jawi:jeneng=nami:nama=nami[ASMA]:namanama=nami-nami[ASMA-ASMA]:namanye=naminipun[ASMANIPUN]:lantai=jogan:lantainye=joganipun:ubin=jubin:ubinnye=jubinipun:mengubin=njubin:berubin=ngangge[NGAGEM] jubin:kekurangannye=kakiranganipun:jero=lebet:jeruk=jeram:joged=beksa:ambil=pendhet[PUNDHUT]:terambil=kependhet[KEPUNDHUT]:mengambil=mendhet[MUNDHUT]:mengambilkan=mendhetaken[MUNDHUTAKEN]:diambil=dipunpendhet[DIPUNPUNDHUT]:ambilkan=pendhetaken[PUNDHUTAKEN]:diambilkan=dipunpendhetaken[DIPUNPUNDHUTAKEN]:semua=sedaya:semuanye=sedayanipun:segalanye=sedayanipun:kacek=kaut:terpaut=kaut:kecuali=kejawi:kakang=raka:kakak=kakang[RAKA]:kakakkakak=kakang-kakang[RAKA-RAKA]:kaku=kaken:kalah=kawon:kekalahan=kekawonan:dikalahkan=dipunkawonaken:mengalahkan=ngawonaken:mengalahkanmu=ngawonaken sampeyan[PANJENENGAN]:mengalahkanku=ngawonaken kula:kalahkan=kawonaken:dikalahkannye=dipunkawonakenipun:mengalahkannye=ngawonakenipun:kalahkannye=kawonakenipun:ditaklukkan=dipunkawonaken:ditaklukkannye=dipunkawonakenipun:menaklukkan=ngawonaken:menaklukkanmu=ngawonaken sampeyan[PANJENENGAN]:menaklukkanku=ngawonaken kula:takluk=kawon:taklukkan=kawonaken:sungai=lepen:kalung=kalung[SANGSANGAN]:kelapa=klapa:sana=mrika:disana=nten ngrika:kesana=mrika:bercerita=criyos[MATUR]:ngomong=sanjang[MATUR]:bilang=sanjang[MATUR]:mengatakan=sanjang[MATUR]:katakan=sanjangaken[ATURAKEN]:dikata=dipunsanjang[DIPUNATUR]:dikatakan=dipunsanjangaken[DIPUNATURAKEN]:terhapus=kebusek:dikatakannye=dipunsanjangakenipun[DIPUNATURAKENIPUN]:mengadu=matur:kanti=kantos:sabar=kantos:tertinggal=kantun:cuman=namung[naming]:dengan=kalih[kaliyan]:dgn=kalih[kaliyan]:jelas=kantenan:jelasnye=kantenanipun:celana=sruwal[LANCINGAN]:terlihat=ketingal[KEPRIKSAN]:nampak=ketingal[KEPRIKSAN]:nampaknye=ketingalipun[KEPRIKSANIPUN]:kelihatan=ketingal[KEPRIKSAN]:kelihatannye=ketingalipun[KEPRIKSANIPUN]:memperlihatkan=ningalaken[PRIKSAKAKEN]:menampakkan=ningalaken[PRIKSAKAKEN]:tampakkan=ningalaken[PRIKSAKAKEN]:tampak=ketingal[KEPRIKSAN]:kelahiran=wedalan[WIYOSAN]:seperti=kados:sprti=kados:sepertinye=kadosipun:kayaknye=kadosipun:kayu=kajeng:kebo=maesa:kerbau=maesa:keduga=kedugi:kembang=sekar:bunga=sekar:kemenyan=sela:kempol=wengkelan:betis=kempol[WENGKELAN]:paluu=palu:kemu=kembeng:berkumur=kemu[KEMBENG]:kumurkumur=kemu[KEMBENG]:selimut=kemul[SINGEB]:berselimut=kemulan[SINGEBAN]:kuburan=kuburan[PASAREAN]:makam=kuburan[PASAREAN]:sabuk=sabuk[PANINGSET]:kena=kenging[KEPARENG]:boleh=angsal[KEPARENG]:kendur=kendhor[LUKAR]:kendhi=lantingan:kendi=lantingan:sini=mriki:disini=nten ngriki:kesini=mriki:pulas=kepatos:kepatihan=kepatosan:kepenak=sekeca:seenaknye=sakecanipun:enaknye=ecanipun:bagaimana=kados pundi:sebagaimana=sakepripunn:sebagainye=sanesipun:kepung=kepang:kebelakang=kepengker:kerep=asring:keris=dhuwung[WANGKINGAN]:kesusu=kesesa:tergesa-gesa=kesesa:buru-buru=kesesa:ketan=ketos:ketara=ketawis:kentara=ketawis:kemarau=ketiga:terlanjur=kelajeng:kijing=sekaran:nisan=kijing[SEKARAN]:pusara=kijing[SEKARAN]:kinang=ganten:sirih=ganten:kira=kinten:dikira=dipunkinten:sekiranye=sakintenipun:kirakira=kinten-kinten:kirim=kintun:klambi=rasukan[AGEMAN]:baju=rasukan[AGEMAN]:klasa=gelaran:tikar=gelaran:kleru=klentu:keliru=klentu:berkumpul=kempal:berkumpulnye=kempalipun:mengumpulkan=ngempalaken:mengumpulkannye=ngempalakenipun:dikumpulkan=dipunkempalaken:dikumpulkannye=dipunkempalakenipun:disederhanakannye=dipunringkesakenipun:terbakar=kebesmi:suruh=kengken[DHAWUHI]:disuruh=dipunkengken[DIPUNDHAWUHI]:menyuruh=ngengken[NDHAWUHI]:memerintah=ngengken[NDHAWUHI]:melaksanakan=nglampahaken[NINDAKAKEN]:melakukan=nglampahaken[NINDAKAKEN]:situ=mriku:disitu=nten ngriku:kesitu=mriku:kutang=kutang[semekan]:engkau=sampeyan[PANJENENGAN]:anda=sampeyan[PANJENENGAN]:terasa=kraos:kerasa=kraos:betah=kraos:keringat=kringet[riwe]:keringatnye=kringetipun[riwenipun]:mendengar=mireng[MIDHANGET]:kubur=kubur[PETAK]:harus=kedah:harusnye=kedahipun:mesti=kedah:mestinye=kedahipun:dari=saking:sebelum=saderengipun:barat=kilen:kambuh=kimat:mencuci=nggirahi:cuci=girah:kumpul=kempal:kuning=jene:telinga=kuping[TALINGAN]:kurang=kirang:kurangnye=kirangipun:kekurangan=kekirangan:sekurang=sakirang:sekurangkurangnye=sakirang-kirangipun:mengurangi=ngirangi:dikurangi=dipunkirangi:kurus=kera:kurung=sengker:kota=kitha:kuasa=kuwaos:kekuasaan=kekuwaosan:kekuasaannye=kekuwaosanipun:mampu=kuwawi:kemampuan=kesagahan:kuat=kiyat:diperkuat=dipunkiyati:memperkuat=merkiyat:kekuatan=kekiyatan:kuatir=kuwatos:khawatir=kuwatos:itu=puniku[MENIKA]:berjalan=mlampah[TINDAK]:berjalannye=mlampahipun[TINDAKIPUN]:jalan={margi, mlampah}:lahir=wedal[WIYOS]:dilahirkan=dipunwedalaken[DIPUNWIYOSAKEN]:lahirlah=wedal[WIYOS]:lupa=kesupen:dilupakan=dipunsupekaken:bibir=lambe[LATHI]:lampu=dilah:lelaki=jaler[KAKUNG]:mahal=awis:pintu=konten:lama=lami[DANGU]:selama=salami[SADANGU]:selamalamanye=salami-laminipun[SADANGU-DANGUNIPUN]:selamanye=salaminipun[SADANGUNIPUN]:kacamata=kacamripat[KACA-TINGAL]:setiba=wekdal dugi[RAWUH]:khas=kas:berjuluk=gadhah[KAGUNGAN] wastan:kebudayaan=kabudayan:kebudayaanku=kabudayan kula:kebudayaanmu=kabudayan sampeyan[PANJENENGAN]:kebudayaannye=kabudayanipun:berjenjang=indhak-indhakan:membandingkannye=nandhingakenipun:menikah=emah-emah[KRAMA]:surat=serat:begadang=lek-lekan[WUNGON]:tanah=siti:lemari=lemantun:halus=lembat:gendut=lema:lengan=lengen[PAMENTHANGAN]:berhenti=mendel:langgeng=lestantun:lewat=langkung:melewati=nglangkungi:melalui=nglangkungi:lalui=nglangkungi:lewati=nglangkungi:utara=ler:membajak=melujeng:lumrah=limrah:duduk=lenggah[PINARAK]:menduduki=nglenggahi[MINARAKI]:duduknye=lenggahipun[PINARAKIPUN]:mampir=mampir[PINARAK]:singgah=mampir[PINARAK]:salah=lepat:salahnye=lepatipun:kesalahan=kelepatan:khilaf=lepat:kekhilafan=kelepatan:benarbenar=saestu:betulbetul=saestu:lebih=langkung[MIYOS]:lbih=langkung[MIYOS]:madu=maben:pencuri=pandung:maling=pandung:apabila=menawi:demikian=mekaten:burung=paksi:berakibat=murugaken:akibatnye=murugaken:sembuh=mantun:mata=mripat[SOCA]:sebagian=saperangan:mati=pejah[SEDA]:tewas=pejah[SEDA]:mayat=mayit[LAYON]:terjaga=melek[WUNGU]:tadi=kala-wau:ikut=tumut[NDEREK]:diikuti=dipuntumuti[DIPUN-DEREKI]:mengikuti=numuti[NDEREKI]:tidak=mboten:tidaknye=mbotenipun:ngga=mboten:gak=mboten:engga=mboten:enggak=mboten:jika=bilih:depan=ngajeng:kalau=menawi:klw=menawi:sudah=sampun:sudahlah=sampun lah:menunggu=ngentosi:menunggui=nenggani:tunggu=tengga:tunggui=tenggani:karuan=kantenan:sematamata=namung[naming]:menunggununggu=ngantos-antos:ditunggu=dipunentosi:apalagi=punapa[MENAPA] malih:kamu=sampeyan[PANJENENGAN]:silahkan=mangga[sumangga]:silakan=mangga[sumangga]:masuk=mlebet:masukan=lebetan:memasukkan=mlebetaken:dimasukkan=dipunlebetaken:dimasukan=dipunlebetaken:menyarankan=nyaranaken:terbang=mabur:sore=sonten:melulu=mawon:hingga=ngantos:beli=tumbas[MUNDHUT]:terbeli=ketumbas[KEPUNDHUT]:dibeli=dipuntumbas[DIPUNPUNDHUT]:dibelikan=dipuntumbasaken[DIPUNPUNDHUTAKEN]:tuma=tuma[ITIK]:membeli=tumbas[MUNDHUT]:membelikan=numbasaken[MUNDHUTAKEN]:lupakan=nyupekaken:melupakan=nyupekaken:untukmu=kangge[KAGEM] sampeyan[PANJENENGAN]:manusia=manungsa:manusiamanusia=manungsa-manungsa:seorang=setunggaling tiyang:seseorang=salah setunggaling tiyang:mendapat=angsal[KEPARING]:mendapatkan=angsal[KEPARINGAN]:peroleh=angsal[KEPARING]:diperoleh=dipunangsal[DIPUNKEPARING]:memperoleh=angsal[KEPARING]:dan=lan:tapi=nanging:tetapi=nanging:namun=nanging:dia=piyambakipun[PANJENENGANIPUN]:ia=piyambakipun[PANJENENGANIPUN]:bulan=wulan:sebulan=sawulan:bidadari=widadari:berlangsungnye=mlampahipun[TINDAKIPUN]:berbulanbulan=sasen-sasen:berbulan=sasen-sasen:tau=ngertos:dengar=pireng[PIDHANGET]:didengar=dipunpireng[DIPUNPIDHANGET]:tak=mboten:mendengarkan=mirengaken[MIDHANGETAKEN]:terdengar=kapireng[KAPIDHANGET]:kuku=kuku[KENAKA]:adlh=inggih punika[MENIKA]:adalah=inggih punika[MENIKA]:menemui=manggihi:orang=tiyang:orangnye=tiyangipun:ditemui=dipunpanggihi:berjumpa=kepanggih:dijumpai=dipunpanggihi:menjumpai=manggihi:menjumpaiku=manggihi kula:menjumpaimu=manggihi sampeyan[PANJENENGAN]:menjumpainye=manggihi piyambakipun[PANJENENGANIPUN]:semuanye=sedayanipun:seharusnye=kedahipun:bahasa=basa:bahasabahasa=basa-basa:gemuk=lema:sama=sami:mencoba=nyobi:juga=ugi:jg=ugi:keadaan=kawontenan:keadaannye=kawontenanipun:meningkat=ningkat:kemarin=kala-wingi:tamu=dhayoh:agak=radi:agar=supados:supaya=supados:mencuri=nyolong:ngeluarin=ngedalaken[MIYOSAKEN]:dimarahi=dipunsrengeni[DIPUNDUKANI]:memarahi=nyrengeni[NDUKANI]:ampas=sepahan:andai=upami:misal=upami:umpama=upami:jatuh=dhawah:ialah=inggih punika[MENIKA]:cantik=elok:ganteng=bagus:saudara=sadherek:bagai=kados:pada=ing:satu=setunggal:satunye=setunggalipun:dua=kalih:empat=sekawan:lima=gangsal:enam=enem:tujuh=pitu:delapan=wolu:sembilan=sanga:sepuluh=sedasa:puluh=dasa:ratus=atus:seratus=satus:seribu=sewu:belas=welas:kasih=asih:sebelas=sawelas:ya=nggih:iya=nggih:yang=ingkang:kalo=menawi:klo=menawi:bahawa=menawi:bahwa=menawi:menuliskannye=nyeratipun:memang=estu:emang=estu:sendirian=piyambakan:tersendiri=piyambakan:tahu=ngertos:atau=utawi:tanggung=tanggel:berbuat=lampah[TINDAK]:bertindak=lampah[TINDAK]:pekerjaan=pandamelan:pekerjaannye=pandamelanipun:dg=kalih[kaliyan]:suara=suwanten:pakai=angge[AGEM]:dipakai=dipunangge[DIPUNAGEM]:pemakaiannye=panganggenanipun[PANGAGEMANIPUN]:pemakainye=panganggenipun[PANGAGEMIPUN]:memakai=ngangge[NGAGEM]:memakainye=nganggenipun[NGAGEMIPUN]:menggunakan=ngangge[NGAGEM]:mempergunakan=ngangge[NGAGEM]:mempergunakannye=nganggenipun[NGAGEMIPUN]:memergunakan=ngangge[NGAGEM]:memergunakannye=nganggenipun[NGAGEMIPUN]:yg=ingkang:telah=sampun:ku=kula:rumah=griya[DALEM]:nye=ipun:rumahnye=griyanipun[DALEMIPUN]:rumahku=griyanipun[DALEMIPUN] kula:rumahmu=griyanipun[DALEMIPUN] sampeyan[PANJENENGAN]:keluarga=keluwargi:sekeluarga=sakluwargi:keluarganye=kluwarginipun:menemukan=manggihaken:menemukannye=manggihakenipun:ditemukan=dipunpanggihaken:ditemukannye=dipunpanggihakenipun:sungguh=estu:menargetkan=nargetaken:sungguhsungguh=saestu:sungguhan=saestu:beneran=saestu:sampaikan=sanjangaken[ATURAKEN]:menyampaikan=sanjangaken[NGATURAKEN]:serta=saha:samasama=sami-sami:sesama=sesami:lain=benten:lainnye=sanesipun:lainlain=sanes-sanes:lainlainnye=sanes-sanesipun:seandainye=upaminipun:andainye=upaminipun:misalnye=upaminipun:jikalau=menawi:yaitu=inggih punika[MENIKA]:bernama=naminipun[ASMANIPUN]:nanti=mangke:nantinye=mangkenipun:siapa=sinten:mabuk=mendhem[WURU]:diam=mendel:rusa=sangsam:baru=enggal:hamil=ngandhut[MBOBOT]:keguguran=keluron[TERAG]:kabur=lolos:memuat=ngewrat:perhiasan=angge-angge:kumpulkumpul=kempal-kempal:mori=monten:turun=mandhap[TEDHAK]:moga=mugi:semoga=mugi-mugi:mudahmudahan=mugi-mugi:maka=mila:bolak-balik=wongsal-wangsul:cuma=namung[naming]:membelakangi=mengkeri:musuh=mengsah:musuhin=mengsahaken:muntah=luntak:mengkhawatirkan=mutawatosi:menghawatirkan=mutawatosi:negara=nagari:negeri=nagari:menangis=nangis[MUWUN]:menangisi=nangisi[MUWUNI]:menempuh=nempah:nempuh=nempah:jengkel=nesu:sewot=nesu:berdiri=ngadeg[JUMENENG]:pindah=pindhah[JENGKAR]:pindahnye=pindhahipun[JENGKARIPUN]:memindah=mindhah[NJENGKAR]:memindahkan=mindhahaken[NJENGKARAKEN]:dipindah=dipunpindhah[DIPUNJENGKAR]:dipindahkan=dipunpindhahaken[DIPUNJENGKARAKEN]:percaya=pitados:kepercayaan=kepitadosan:sampai=dumugi:haus=ngelak[SALIT]:pusing=ngelu[PUYENG]:mengabdi=ngenger[NGABDI]:menanti=ngentosi:menantikan=ngentosi:mengerti=ngertos[sumerep]:ngerti=ngertos[sumerep]:memelihara=ngingah:dipelihara=dipuningah:peliharaan=ingah-ingah:ngiring=ndherek:berak=bebucal[BOBOTAN]:ngising=bebucal[BOBOTAN]:bawah=ngandhap:mencari=madosi:mencarikan=madosaken:mengupayakan=madosaken:mencarikannye=madosakenipun:nonton=ningali[MRIKSANI]:menunjuk=nedah:menunjukkan=nedahi[MARINGI PRIKSA]:ubah=ebah:berubah=ebah:mengubah=ngebahi:merubah=ngebahi:membolehkan=ngangsalaken[MARENGAKEN]:diminum=dipun-ombe[DIPUN-UNJUK]:meminum=ngombe[NGUNJUK]:minum=ombe[UNJUK]:omongan=gineman[NGENDIKAN]:perkataan=gineman[NGENDIKAN]:terucap=keginem[KENGENDIKA]:ucapan=gineman[NGENDIKAN]:ucapkan=sanjangaken[ATURAKEN]:mengucapkan=sanjangaken[NGATURAKEN]:diucapkan=dipunsanjangaken[DIPUNATURAKEN]:pengucapannye=ginemanipun[NGENDIKANIPUN]:upah=epah:kejar=bujeng:dikejar=dipunbujeng:dikejarkejar=dipunbujeng-bujeng:mengejar=mbujeng:berburu=bebujeng:sami=sami:padha=sami:terang=padhang:bertengkar=paben:paido=paiben:pajak=paos:sungkan=pakewed:pakewuh=pakewed:panah=jemparing:panas=benter:pandapa=pandhapi:makanan=tedha[DHAHARAN]:makan=nedha[DHAHAR]:memakan=nedha[DHAHAR]:pangling=pandung:rotan=panjatos:panjalin=panjatos:rantau=purug:padi=pantun:paro=palih:separuh=sepalih:separo=sepalih:puasa=siyam:puas=marem:pasar=peken:pasarpasar=peken-peken:patia=patos:laku=pajeng:pekarangan=pekawisan:pijat=pijet[PETEK]:pikir=manah[PANGGALIH]:memikirkan=manahaken[NGGALIHAKEN]:pilis=pilis[SIGITAN]:pipi=pipi[PANGARASAN]:pikul=rembat:berapa=pinten:piranti=pirantos:alat=pirantos:piara=piyanten:pelihara=piyanten:lari=plajeng:berlari=mlajeng:ponakan=penakan:keponakan=kapenakan:dipercaya=dipunpitados:memercayai=mitadosi:memercayakan=mitadosaken:mempercayai=mitadosi:mempercayakan=mitadosaken:perkara=prakawis:perahu=baita:patut=prayogi:layak=prayogi:prihatin=prihatos:bambu=deling:bahu=pundhak[PAMIDHANGAN]:paha=pupu[WENTIS]:pusar=puser[TUNTUNAN]:putih=pethak:cucu=putu[WAYAH]:wajah=rai[PASURYAN]:muka=rai[PASURYAN]:raupp=raup[SURYAN]:dahak=riak[JLAGRA]:sendok=sendhok[LANTARAN]:rambut=rambut[RIKMA]:rasa=raos:rasanye=raosipun:rasakan=raosaken:merasakan=ngraosaken:merasakannye=ngraosakenipun:dirasa=dipunraos:dirasakan=dipunraosaken:dirasakannye=dipunraosakenipun:rata=radin:rebut=rebat:harga=regi:harganye=reginipun:sulit=sisah[SEKEL]:menyulitkan=nyisahaken[NYEKELAKEN]:menyusahkan=nyisahaken[NYEKELAKEN]:kesulitan=kesisahan[KESEKELAN]:rembuk=rembag:runding=rembag:perundingan=rembagan:bantu=rencangi:pembantu=rencang:membantu=ngrencangi:repot=ribet:lebaran=riyadi:berlebaran=riyadinan:rokok=ses:roboh=rebah:merasa=rumaos:pelihara=rimat:runtuh=rentah:tumbang=dhawah:rupa=rupi:sempit=ripak:ciut=ripak:rusuh=resah:kerusuhan=keresahan:ribut=resah:keributan=keresahan:diributkan=dipunresahaken:meributkan=ngresahaken:samudera=seganten:segara=seganten:samudra=seganten:laut=seganten:lautan=seganten:bersedia=sagah:sanggup=sagah:kesanggupan=kesagahan:sekarang=sapunika[SAMENIKA]:sesajian=sajen[CAOSAN]:sajian=segahan[PASUGATAN]:skarang=sapunika[SAMENIKA]:kini=sapunika[SAMENIKA]:salin=salin[SANTUN]:sambung=sambet:berhubungan=sesambetan:samubarang=samukawis:sangga=sanggi:sapi=lembu:sarung=sande:bersarung=sandean:serba=sarwi:sawah=sabin:sawahnye=sabinipun:sebut=sebat:disebut=dipunsebat:disebutkan=dipunsebataken:sebutkan=sebataken:tersebut=kasebat:menyebut=nyebat:menyebutnye=nyebatipun:sebentar=sekedhap:nanye=taken:sekejap=sekedhap:sedulur=sadherek:nasi=sekul:sejati=sejatos:semaya=semados:ribu=ewu:sembelih=pragat:sekian=semanten:menyembelih=pragat:segini=semanten:walau=sanadyan:walaupun=sanadyan:kalaupun=sanadyan:meskipun=sanadyan:senang=remen:gemar=remen:disenangi=dipunremeni:digemari=dipunremeni:sepata=sepaos:sepi=sepen:lengang=sepen:seprana=semrika:kemari=mriki:seprene=semriki:keras=atos|sora:besok=benjing:sida=estu[sios]:kaki=suku[SAMPARAN]:kakikaki=suku-suku[SAMPARAN-SAMPARAN]:kakikakinye=suku-sukunipun[SAMPARAN-SAMPARANIPUN]:sikut=sikut[SIKU]:pinjam=nyambut[NGAMPIL]:minjam=nyambut[NGAMPIL]:meminjam=nyambut[NGAMPIL]:dikit=sakedhik:sedikit=sakedhik:sedikitpun=sakedhika:sedikitsedikit=sakedhik-sakedhik:selamat=wilujeng[SUGENG]:menyelamatkan=milujengaken[NYUGENGAKEN]:sering=asring:seringnye=asringipun:seringkali=asring:asalkan=angger:marah=srengen[DUKA]:memerangi=mengsahi:ditugaskan=didhawuhi:matahari=srengenge[SURYA]:suguh=segah[SUGATA]:suket=rumput:saji=segah[SUGATA]:suguhan=segahan[PASUGATAN]:tanduk=singat:arti=artos:artinye=artosipun:sirih=sedhah:surup=serap:susah=sisah[SEKEL]:susahnye=sisahipun[SEKELIPUN]:susahkan=sisahaken[SEKELAKEN]:surga=suwarga[SUWARGI]:susur=susur[PANASAR]:tai=tinja:tanye=taken[MUNDHUT PRIKSA]:tanyakan=nakekaken[MUNDHUTAKEN PRIKSA]:menanyakan=nakekaken[MUNDHUTAKEN PRIKSA]:mempertanyakan=nakekaken[MUNDHUTAKEN PRIKSA]:ditanyakan=dipuntakekaken[DIPUNPUNDHUTAKEN PRIKSA]:ditanyai=dipuntakeni[DIPUNPUNDHUT PRIKSA]:ditanye=dipuntakeni[DIPUNPUNDHUT PRIKSA]:bertanye=taken[MUNDHUT PRIKSA]:pertanyaan=pitakenan:pertanyaanpertanyaan=pitakenan-pitakenan:pertanyaannye=pitakenanipun:tali=tangsul:tampa=tampi:terima=tampi:terimakasih=matur nuwun:berterimakasih=matur nuwun:tanam=tanem:tangan=tangan[ASTA]:menangani=nangani[NGASTANI]:tangguh=tanggen:bangun=tangi[WUNGU]:pernah=nate:pernahkah=nate mboten:tawar=tawi:tebu=rosan:datang=dugi[RAWUH]:kedatangan=dugi[RAWUH]:kedatangannye=duginipun[RAWUHIPUN]:tiba=dugi[RAWUH]:mendatangkan=ndugikaken[NGRAWUHAKEN]:menghadirkan=ndugikaken[NGRAWUHAKEN]:tembaga=tembagi:tembang=sekar:lagu=sekar:temu=panggih:ketemu=kepanggih:diketemukan=dipunkepanggihaken:dipertemukan=dipunkepanggihaken:mempertemukan=ngepanggihaken:bertemu=kepanggih:ketemunye=kepanggihipun:bertemunye=kepanggihipun:sungguh=estu:kenal=tepang:perkenalkan=tepangaken:kenalkan=tepangaken:dikenal=dipuntepang:mengenal=tepang:dikenalkan=dipuntepangaken:memperkenalkan=nepangaken:kenalan=tepangan:perkenalan=tepangan:mengenalkan=nepangaken:pengenalan=nepangaken:membudayakan=mbudayakaken:seterusnye=salajengipun:sunat=supit[TETES]:tinggal=tilar:ditinggal=dipuntilar:ditinggalkan=dipuntilaraken:jenguk=tuwi[SOWAN]:ketinggalan=kantun:tinggalkan=tilaraken:tlaten=tlatos:tekun=tlatos:menerima=nampi:tunjuk=tedah:tulis=serat:tertulis=keserat:ditulis=dipunserat:tulisan=seratan:tulisannye=seratanipun:penulisannye=panyeratanipun:menulis=nyerat:menuliskan=nyerataken:tuliskan=serataken:tombak=waos[WATANGAN]:tunggangan=tumpakan[TITIHAN]:tunggang=tumpak[TITIH]:menaiki=numpak[NITIH]:tidur=tilem[SARE]:tua=sepuh[YUSWA]:dewasa=sampun umur[YUSWA]:hujan=jawah:hujanhujan=jawah-jawah:kehujanan=kejawahan:ujan=jawah:ujanujan=jawah-jawah:keujanan=kejawahan:juga=ugi:ular=sawer:ingus=umbel[GADHING]:undang=ulem[TIMBAL]:undangannye=ulem-ulemanipun[ATUR-ATURANIPUN]:undangan=ulem-uleman[ATUR-ATURAN]:diundang=dipunulemi[DIPUNATUR-ATURI]:dipanggil=dipunulemi[DIPUNTIMBALI]:mengundang=ngulemi[NGATURI]:memanggil=ngulemi[NIMBALI]:mundak=mindhak:haji=kaji:naik=minggah:menaikkan=nginggahaken:meningkatkan=nginggahaken:menaikkannye=nginggahakenipun:meningkatkannye=nginggahakenipun:dinaikkan=dipuninggahaken:tanjakan=inggah-inggah:bunyi=ungel:berbunyi=mungel:bersuara=nyuwanten:gigi=untu[WAJA]:umpama=upami:hidup=gesang[SUGENG]:hidupnye=gesangipun[SUGENGIPUN]:usus=usus[JARINGAN]:utama=utami:terutama=utaminipun:diutamakan=dipunutamikaken:utamanye=utaminipun:hutang=sambutan[AMPILAN]:pinjaman=sambutan[AMPILAN]:atau=utawi:garam=sarem:garamnye=saremipun:bergaram=sarem-an:uyuh=turas:waca=waos:baca=waos:dibaca=dipunwaos:membaca=maos:membacanye=maosipun:rahasia=wados:rahasiakan=wadosaken:rahasianye=wadosipun:wanita=estri[PUTRI]:bersin=wahin[SIGRA]:baja=waos:sehat=saras[SENGGANG]:kenyang=tuwuk:warna=warni:warta=wartos:berita=wartos:diberitakan=dipunwartosaken:dikabarkan=dipunkabaraken:warung=wande:waspada=waspaos:batu=sela:batunye=selanipun:batuk=watuk[CEKOH]:batuknye=watukipun[CEKOHIPUN]:minuman=wedang[UNJUKAN]:kambing=menda:takut=ajrih:takutkan=ajrihaken:menakutkan=ngajrihaken:takutnye=ajrihipun:ketakutan=kaajrihan:waktu=wekdal:melihat=sumerep[PRIKSA]:didengarnye=dipunpirengipun[DIPUNPIDHANGETIPUN]:pandangan=pandengan:pandangannye=pandenganipun:penunjukkan=panedahan:penunjukan=panedahan:penunjuk=panedah:menatap=mandeng:menonton=ningali[MRIKSANI]:menyaksikan=ningali[MRIKSANI]:memandang=mandeng:besi=tosan:perut=wetheng[PADHARAN]:keluar=medal[MIYOS]:keluarkan=medalaken[MIYOSAKEN]:mengeluarkan=ngedalaken[MIYOSAKEN]:waktuwaktu=wekdal-wekdal:dikeluarkan=dipunwedalaken[DIPUNWIYOSAKEN]:minggat=minggat[LOLOS]:berbicara=wicanten[NGENDIKA]:berbicaranye=wicantenipun[NGENDIKANIPUN]:berkata=wicanten[NGENDIKA]:dipertuturkan=dipunwicantenaken[DIPUN-NGENDIKAKAKEN]:wisuh=wisuh[WIJIK]:penting=wigatos:pentingnye=wigatosipun:pentingkan=wigatosaken:kepentingan=kewigatosan:mementingkan=wigatosaken:bisul=wudun[UNTAR]:ajar=wucal:diajarkan=dipunwucal:mengajarkan=mucalaken[NGASTAKAKEN]:mengajar=mucal[NGASTA]:tiap=saben:tiaptiap=saben-saben:setiap=saben:utuh=wetah:iya=nggih:ya=nggih:yekti=yektos:bersih=resik:dibersihkan=dipunresekaken:membersihkan=ngresekaken:dalam=lebet:mengkaji=ngaos:mengaji=ngaos:pengajian=pengaosan:ataupun=utawi:mengadaada=ndamel-ndamel:akan=ajeng[badhe]:nyatanye=nyatanipun:belajar=sinau:belajarnye=sinaunipun:terdapat=wonten:terdapatnye=wontenipun:memberi=nyukani[MARINGI]:memberikan=nyukani[MARINGAKEN]:pemberian=sukanan[PARINGAN]:suka=remen:disukai=dipunremeni:disuka=dipunremen:menyukai=ngremeni:lapar=luwe:kelaparan=luwe:berani=wantun:ke=dhateng:menurut=midherek:se=sa:sebanyakbanyaknye=sakathah-kathahipun:banyaknye=kathahipun:dimana=nten pundi:dimanakah=nten pundi:manakah=pundi:belaka=mawon:doang=mawon:menggunakannye=nganggenipun[NGAGEMIPUN]:membawa=mbekta[NGASTA]:oleh=dening:menjalankan=nglampahaken[NINDAKAKEN]:menjalani=nglampahaken[NINDAKAKEN]:seharihari=sadinten-dinten:sehariharinye=sadinten-dintenipun:dapat=angsal[KEPARING]:didapat=dipunangsal[DIPUNKEPARING]:didapati=dipunangsali[DIPUNKEPARINGI]:perkumpulan=pakempalan:kumpulan=kempalan:sabaran=kantosan:teruskan=lajengaken:meneruskan=nglajengaken:menjawab=mangsuli:menjawabkan=mangsulaken:dijawab=dipunwangsuli:dijawabkan=dipunwangsulaken:jawaban=wangsulan:jawabannye=wangsulanipun:hampir=meh:salahh=salah:lamalama=lami-lami[DANGU-DANGU]:lamakelamaan=lami-lami[DANGU-DANGU]:kelamaan=kedangon:dipegang=dipuncepeng[DIPUNASTA]:terpegang=kecepeng[KEASTA]:gimana=kados pundi:dah=empun:adanye=wontenipun:ujicoba=ujicobi:sebesar=saageng:besarnye=agengipun:sebesarbesarnye=saageng-agengipun:sesudah=sasampunipun:diperintah=dipunkengken[DIPUNDHAWUH]:perintah=kengkenan[DHAWUH]:memerintah=ngengken[NDHAWUH]:memiliki=nggadhahi[NGAGUNGANI]:milik=gadhahipun[KAGUNGANIPUN]:dimiliki=dipun-gadhahi[DIPUNKAGUNGANI]:miliknye=gadhahipun[KAGUNGANIPUN] piyambakipun[PANJENENGANIPUN]:memilikinye=nggadhahinipun[NGAGUNGANINIPUN]:dimilikinye=dipun-gadhahipun[DIPUNKAGUNGANIPUN] piyambakipun[PANJENENGANIPUN]:serahkan=nyukani[MARINGAKEN]:menyerahkan=nyukani[MARINGAKEN]:melanggar=nglanggar:kencing=toyan[TURAS]:istirahatnye=ngaso nipun:rehatnye=lerenipun:istirahat=ngaso:rehat=leren:perawakan=pawakan:perawakannye=dedegpangadegipun:postur=dedegpangadeg:posturnye=dedegpangadegipun:membayar=mbayar:ngucapin=sanjangaken[ATURAKEN]:cium=ambung[ARAS]:mencium=ngambung[NGARAS]:dikasih=dipunsukani[DIPUNPARINGI]:dikasihkan=dipunsukakaken[DIPUNPARINGAKEN]:misalkan=upamikaken:sebelumnye=saderengipun:lanjut=lajeng:lanjutannye=lajengipun:melanjutkan=nglajengaken:dilanjutkan=dipunlajengaken:sebagai=dados:bagi=kangge[KAGEM]:udah=empun:selanjutnye=salajengipun:anakanak=lare-lare[PEPUTRA]:anakanaknye=lare-larenipun[PEPUTRANIPUN]:mengembala=angen:menggembala=angen:mengembalakan=angen aken:menggembalakan=angen aken:kuranglebih=kurang luwih:terlama=paling lami[DANGU]:terlestarikan=lestantun:sengsara=rekaos:melahirkan=ngedalaken[MIYOSAKEN]:batin=batos:batinnye=batosipun:batinku=batosipun kula[DALEM]:batinmu=batosipun sampeyan[PANJENENGAN]:diagendakan=dipunagendakaken:tulang=balung[TOSAN]:bantal=bantal[KAJANG SIRAH]:ubunubun=mbun-mbunan[SUNDHULAN]:baikbaik=sae-sae:rupiahorg=tiyang:baik=sae:rupiahmgg=minggu:rupiahbul=wulan:rupiahthn=warsa:rupiahbij=wiji:kebaikan=kesaenan:rupiahjam=jam:rupiahlem=lembar:kebajikan=kesaenan:baiknye=saenipun:terbaik=paling sae:sebaiknye=sasaenipun:yakni=inggih punika[MENIKA]:tinggi=inggil:merupakan=inggih punika[MENIKA]:digunakan=dipunangge[DIPUNAGEM]:pengguna=pangangge[PANGAGEM]:pemakai=pangangge[PANGAGEM]:penggunanye=panganggenipun[PANGAGEMIPUN]:penggunaan=panganggenan[PANGAGEMAN]:pemakaian=panganggenan[PANGAGEMAN]:penggunaannye=panganggenanipun[PANGAGEMANIPUN]:menghormati=ngurmati:orangorang=tiyang-tiyang:berilmu=gadhah[KAGUNGAN] elmi:sedangkan=dene:dimaksud=dipunmaksud:pun=nggih:mempunyai=gadhah[KAGUNGAN]:tetap=tetep:kehalusan=kealusan:ditukarkan=dipunlintokaken:ditukar=dipunlintu:dicari=dipunpadosi:menurunkan=ngandhapaken[NEDHAKAKEN]:rendah=andhap:hanyalah=namunga[naminga]:tigaa=tiga:kee=kaping :taruh=suka[PARING]:menaruh=sukakaken[PARINGAKEN]:lihat=tingal[PRIKSA]:dilihat=dipuntingal[DIPUNPRIKSA]:jemput=pethuk:menjemput=methuk:dijemput=dipunpethuk:sekedar=sadermi:airmata=eluh[WASPA]:janji=janji[PUNAGI]:almarhum=jenat[SWARGI]:tari=joged[BEKSA]:sakit=sakit[GERAH]:berada=wonten:keberadaan=kawontenan:keberadaannye=kawontenanipun:merendahkan=ngandhapaken:mengadakan=ngawontenaken:luar=jawi:selain=kejawi:setidaktidaknye=samboten-botenipun:harinye=dintenipun:memutus=medhot:memutuskan=medhotaken:menyambung=nyambet:menyambungkan=nyambetaken:peralatan=pirantos:terbuat=kadamel:tersambung=nyambet:disambung=dipunsambet:diputus=dipunpedhot:dipisah=dipunpisah:terpisah=kepisah:rangkaian=rangkean:sebuah=setunggaling:suatu=setunggaling:lumrahnye=limrahipun:dipilih=dipunpilih:terpilih=kapilih:menahan=nahan:difungsikan=difungsikaken:menyalakan=murubaken:nyalakan=murubaken:dijuluki=dipunwastani:disapa=dipunwastani:menjuluki=mastani:menjulukinye=mastaninipun:julukan=wastanan:sebutan=wastanan:dinamai=dipunwastani:perempuan=estri[PUTRI]:lakilaki=jaler[KAKUNG]:lakukan=lampahaken[TINDAKAKEN]:melakukannye=nglampahakenipun[NINDAKAKENIPUN]:ngelakuin=nglampahaken[NINDAKAKEN]:dilakukan=dipunlampahaken[DIPUNTINDAKAKEN]:dilakukannye=dipunlampahakenipun[DIPUNTINDAKAKENIPUN]:tatkala=kala[NALIKA]:sewaktu=sawekdal:saat=wanci[wekdal]:dinamakan=dipunwastani:meniru=nulad:tiada=mboten wonten:kami=kita:barangkali=mbokmenawi:ayah=bapa[RAMA]:cinta=tresna:kecintaannye=katresnanipun:mari=mangga[sumangga]:marilah=mangga[sumangga]:panjatkan=panjataken:dianugerahkan=dipunsukakaken[DIPUNPARINGAKEN]:cintai=tresnani:kanan=tengen:kiri=kiwa:murah=mirah:dinanti=dipunentosi:dinantikan=dipunentosi:dibandingkan=dipunbandingaken:gunakan=angge[AGEM]:menelaah=ningali[MRIKSANI]:membesarkan=ngagengaken:seramai=sa rame:memeriahkan=ngramekaken:mempererat=ngencengi:besarkan=agengaken:dibesarkan=dipunagengaken:pembesar=pangageng:penurut=purunan:diadakan=dipunwontenaken:biayanye=dananipun:tergantung=gumantung:menghasilkan=ngasilaken:sehari=sadinten:kata=tembung:katakata=tembung-tembung:katakatanye=tembung-tembungipun:katanye=tembungipun:seluruh=sedaya:seluruhnye=sedayanipun:keseluruh=sedaya:keseluruhan=sedayanipun:keseluruhannye=sedayanipun:ribuan=ewonan:bangku=bangku:suku=suku:bersuku=gadhah[KAGUNGAN] suku:menyelidiki=nyelidiki:bermain=dolanan[AMENG-AMENG]:maen=main:dimengerti=dipun ngertosi:timur=wetan:selatan=kidul:tuturkan=ginemaken[NGENDIKAKAKEN]:dituturkan=dipunwicantenaken[DIPUN-NGENDIKAKAKEN]:dipergunakan=dipunangge[DIPUNAGEM]:termasuk=kelebet:dihuni=dipunpanggeni:lalu=lajeng:mewujudkan=mujudaken:tersebarnye=kasebaripun:melainkan=ananging:pula=ugi:kenye=kenya:yaallah=ya allah:sepertimu=kados sampeyan[PANJENENGAN]:sepertiku=kados kula:apakah=punapa[MENAPA]:melawan=nglawan:memastikan=mesthekaken:ternoda=kedlemok:diminimalisir=dikirangi:upayakan=upayakaken:dikeroyok=dikrubut:wongtua=tiyang sepuh:wongtuanye=tiyang sepuhipun:semacam=kados:merasuki=ngrasuki:ubahlah=ebaha:pastekan=pastekaken:berbahasa=basan:membahasakan=mbasakaken:mempertahankan=mertahanaken:memertahankan=mertahanaken:dipraktikkan=dipunpraktekaken:dipraktekkan=dipunpraktekaken:membosankan=mbosenaken:pemerintah=pamarintah:tepatnye=leresipun:mewajibkan=majibaken:diwajibkan=dipunwajibaken:kedalam=dhateng lebet:perbaiki=dandosaken:diperbaiki=dipundandosi:memperbaiki=dandosaken:sarjana=sarjana[SUJANA]:begitupun=mekaten-a:lagii=saweg:rupiah=rupiyah:dirubah=dipunebah:diubah=dipunebah:sebatas=sabates:sejak=wiwit:meringankan=ngentengaken:selaku=dados:kembali=wangsul:pasti=mesthi:begini=kados puniki[MENIKA]:gini=ngeten:gitu=ngoten:yakin=saestu:baikk=nggih:selalu=tansah:manapun=pundia:menganggap=nganggep:dianggap=dipunanggep:memenangkan=menangaken:dimenangkan=dipunmenangaken:memulai=miwiti:mengawali=miwiti:dimulai=dipunwiwiti:juta=yuta:dudukduduk=lenggah[PINARAK]:diawali=dipunwiwiti:menandatangani=napakasmakaken:ditandatangani=dipuntapakasmakaken:tandatangan=tapak asma:mencetak=nyithak:dicetak=dipuncithak:cetakan=cithakan:pesan=pesen:membalas=mangsuli:balasan=wangsulan:membalaskan=mangsulaken:dibalas=dipunwangsuli:balas=wangsuli:menyakitkan=nyakitaken:menyakiti=nyakiti:disakiti=dipunsakiti:kagak=mboten:menampung=nampung:menilai=mbriji:menerapkan=nerapaken:terapkan=terapaken:pelajari=sinauni:dipelajari=dipunsinaoni:memelajari=nyinaoni:memahami=mangertosi:memahaminye=mangertosi nipun:diapain=dipunpunapakaken:diapakan=dipunpunapakaken:biarpun=sanadyan:memangmemanglah=saestu lah:memangmemang=saestu:pelbagai=pinten-pinten:berbagai=pinten-pinten:setidaknye=samboten-mbotenipun:bersisa=tirah:sisa=tirah:tersisa=ketirah:sisanye=tirahipun:maupun=utawi:wilayah=tlatah:wilayahnye=tlatahipun:mengetahui=sumerep:buku=buku:paku=paku:hamengku=hamengku:berbakti=bektos:bakti=bektos:tandanye=tandhanipun:meliputi=ngliputi:bergabung=gabung:ilmu=elmi:sudi=kajeng[KERSA]:berkenan=kajeng[KERSA]:serupa=sarupi:menawarkan=nawikaken:mengedepankan=ngajengaken:menghadapi=ngajengi:hadapi=ajengi:dihadapi=dipunajengi:mendatang=mangke:setelahnye=salajengipun:diumumkan=dipunumumaken:sepakbola=bal-balan:laporkan=laporaken:dilaporkan=dipunlaporaken:melaporkan=nglaporaken:bagikan=edumaken:membagibagikan=ngedum-edumaken:dibagi=dipunperang:terbagi=kaperang:pembagian=pamerangan:bagian=perangan:lampirkan=lampiraken:dilampirkan=dipunlampiraken:melampirkan=nglampiraken:banyakan=kathah:tepat=leres:dri=saking:gemar=remen:saudarasaudara=sadherek-sadherek:bersaudara=sadherekan:semakin=saya:makin=saya:kataa=kata:kakilima=kaki lima:terbangg=terbang:tahuu=tahu:saatsaat=wanci[wekdal]:bermula=wiwitan:menyatakan=nyatakaken:mengajak=ngajak:memperkaya=nyugihi:contoh=tuladha:mencontohkan=nuladhakaken:sambil=sinambi:bilangan=wicalan:terkejut=kaget:takk=kula:mendorong=nyurung:berusaha=usaha:diupayakan=dipunupadosaken:mataa=mata:mendaftar=ndaftar:menyebutkan=nyebat:berlibur=preinan:difokuskan=dipunfokusaken:pria=jaler[KAKUNG]:menuturkan=sanjangaken[NGATURAKEN]:minyak=lisah:terlaksana=kelaksana:ternyata=kasunyatanipun:menyamar=nyamar:diarahkan=dipunarahaken:mengarahkan=ngarahaken:pulih=mantun:blum=dereng:menambahkan=nambahaken:disampaikan=dipunsanjangaken[DIPUNATURAKEN]:maluku=maluku:mu=sampeyan[PANJENENGAN]:padamu=dhateng sampeyan[PANJENENGAN]:padaku=dhateng kula:padanye=dhateng piyambakipun[PANJENENGANIPUN]:maukah=punapa[MENAPA] purun[KERSA]:khususnye=mliginipun:khusus=mligi:memanjatkan=konjuk:dipentaskan=dipunpentasaken:mementaskan=mentasaken:selesai=bibar:seselesainye=sabibaripun:menyelesaikan=ngrampungaken:termasyhur=misuwur:dituduh=dipuntedah:tertawaan=gegujengan:beruntung=begja:termashur=misuwur:berawal=wiwitan:bola=bal:umur=umur[YUSWA]:usia=umur[YUSWA]:berumur=umur[YUSWA]:berusia=umur[YUSWA]:berlatih=latihan:musti=kedah:mengisi=ngiseni:mempersiapkan=mersiapaken:menendang=ngeding:terkadang=kadhang-kadhang:kadang=kadhang:kadangkala=kadhangkawis:banggakan=bingahaken:membanggakan=mbingahaken:doa=donga:berdoa=ndonga:mendoakan=ndongakaken:siasiakan=sia-siakaken:berpisah=pisahan:mengajukan=ngajengaken:mengecat=ngecet:riang=bingah[RENA]:menemani=ngancani:menjaringkan=njaringaken:dihukum=dipun-ukum:diterapkan=dipunterapaken:penuh=kebak:sepenuh=sakebak:penuhnye=kebakipun:penuhi=kebaki:disengaja=dipunsengaja:kalian=sampeyan-sampeyan[PANJENENGAN-PANJENENGAN]:menguntungkan=nguntungaken:kedua=kaping kalih:diyakini=dipunestuni:menguji=nguji:beradaptasi=adaptasi:sementara=sawentawis:maksudnye=tegesipun:dimaksudkan=dipunmaksudaken:mengalami=ngalami:mengganggu=ngganggu:tampilkan=tampilaken:sesekali=sapisan-pisan:cobacoba=cobi-cobi:keduanye=kekalihipun:kayak=kados:gapapa=mboten napa-napa[MENAPA-MENAPA]:ditentukan=dipuntemtukaken:erat=kenceng:dihindari=dipun endhani:dihormati=dipunhormati:bahkan=malah:mempengaruhi=mengaruhi:dipengaruhi=dipunpengaruhi:pertama=pertami:menjaga=njagi:menjagakan=njagikaken:dijaga=dipunjagi:penjagaan=panjagian:agaknye=kadosipun:diketahui=dipun ngertosi:ketahui=ngertosi:perkantoran=kantor-kantor:terdesaknye=kadhesekipun:terdesak=kadhesek:desak=dhesek:didesak=dipundhesek:desakan=dhesekan:disadari=dipunsadari:merambah=ngrambah:merembes=ngembes:merembesnye=ngembesipun:mengakibatkan=murugaken:situasi=kawontenan:situasinye=kawontenanipun:menyadari=rumaosi:menyadarinye=rumaosinipun:mengoreksi=ngoreksi:disusun=dipunsusun:sebaliknye=sa-wangsulipun:justru=malah:justeru=malah:menegaskan=negasaken:terulang=kewangsul:mengulangi=mangsuli:maluin=lingsemaken:meski=sanadyan:tercatat=keserat:beruntun=runtung-runtung:tercipta=kedamel:membentuk=mbentuk:diisi=dipunisi:tercampur=kekempal:terkumpul=kekempal:mencakup=nyakup:kering=aking:basah=teles:menyebar=nyebar:berdasarkan=adhedhasar:tertutup=ketutup:menyajikan=nyajikaken:disajikan=dipunsajikaken:kuno=kina:usulkan=usulaken:enggan=mboten purun[KERSA]:keengganan=ke mboten purunan[KERSANAN]:membocorkan=mbocoraken:beberkan=beberaken:membeberkan=mbeberaken:alasan=alesan:memperpanjang=merpanjang:diperpanjang=dipunperpanjang:berakhir=bibar:melatih=nglatih:dilatih=dipunlatih:siapapun=sintena:apaapa=punapa-punapa[MENAPA-MENAPA]:penggantinye=panggantosipun:lestari=lestantun:abadi=lestantun:mengabadikan=nglestantunaken:melestarikan=nglestantunaken:dilestarikan=dipunlestantunaken:menyanyi=nyekar:menyanyikan=nyekaraken:tikar=gelaran klasa:karpet=gelaran karpet:bangunkan=bangunaken:membangunkan=mbangunaken:gergaji=grantos:semenjak=wiwit:kelestariannye=kelestantunanipun:dipastikan=dipunpesthekaken:diselenggarakan=dipunwontenaken:empunye=ingkang gadhah[KAGUNGAN]:membuktikan=mbuktikaken:dipahami=dipunpahami:memperjuangkan=merjuangaken:sudutt=sudut:menentukan=nemtukaken:mengeluhkan=ngeluhaken:pantas=patut:kepantasan=kepatutan:lubang=bolongan:ketahuan=konangan:capek=sayah:cape=sayah:hansamu=hansamu:mengungkapkan=medharaken:berkesudahan=bibar:korbankan=korbanaken:makanye=mila:dibebankan=dipunbebanaken:kerajaan=krajan:kerajaannye=krajanipun:kerajaankerajaan=krajan-krajan:kerajaankerajaannye=krajan-krajanipun:ditargetkan=dipuntargetaken:bayangbayang=wewayangan:setempat=sak enggen:tertinggi=paling inggil:meraih=nggayuh:meraihnye=nggayuhipun:digapai=dipun-gayuh:digapainye=dipun-gayuhipun:menggapai=nggayuh:menggapainye=nggayuhipun:mengantarkan=ngateraken:menggaransi=nggaransi:dipenuhi=dipunkebaki:memenuhi=ngebaki:diraih=dipun-gayuh:diraihnye=dipun-gayuhipun:mengonfirmasi=konfirmasi:berharap=ngajeng-ajeng:mengharapkan=ngajeng-ajeng:menginginkan=ngajeng-ajeng:permintaan=panedha[PANYUWUN]:secara=kalih[kaliyan]:skrg=sapunika[SAMENIKA]:mengizinkan=ngangsalaken[MARENGAKEN]:mengijinkan=ngangsalaken[MARENGAKEN]:ayo=mangga[sumangga]:mengembangkan=ngembangaken:dilontarkan=dipunlontaraken:menjamu=njamu:bertamu=merdhayoh:apapun=napa[MENAPA] mawon:mengecewakan=nguciwakaken:segera=enggal:sesegera=saenggalipun:dilaksanakan=dipunlampahaken[DIPUNTINDAKAKEN]:digelar=dipun-gelar:dihujani=dipunjawahi:seusai=sasampun:sejatinye=sejatosipun:jatuhkan=dhawahaken:jatuhin=dhawahaken:kok=koh:bintang=lintang:kau=sampeyan[PANJENENGAN]:berasal=asalipun:ditayangkan=dipuntayangaken:harimau=sima:macan=sima:menetap=manggen:masukin=mlebetaken:tari=tari[BEKSA]:menari=nari[MBEKSA]:joget=joged[MBEKSA]:berjoget=njoged[MBEKSA]:dinyatakan=dipunnyatakaken:terancam=keancem:menggelar=nggelar:merancang=ngrancang:masingmasing=piyambak-piyambak:sebanyak=sakathah:mantap=mantep:memantapkan=mantepaken:sedari=awit:menjabat=njabat:sempat=sempet:menciutkan=ngripakaken:mengumumkan=ngumumaken:termuda=paling enem:sbg=dados:memilih=milih:membagikan=mbagikaken:diacak=dipunacak:bolanye=bal ipun:unggul=inggil:mengungguli=nginggili:menduga=ndugi:menempatkan=manggenaken:mengusung=ngusung:amankan=amanaken:menjelang=jelang:mencapai=dugi:dipertanggungjawabkan=dipunpertanggeljawabaken:menjauhkan=nebihaken:dlm=lebet:dibetulkan=dipunleresaken:tikungan=penggokan:melestarikannye=nglestantunipun:mencobanye=nyobinipun:dibantu=dipunrencangi:mengunduh=ngunduh:mengunggah=ngunggah:ditambah=dipuntambah:mengirim=ngintun:dikirim=dipunkintun:dikembangkan=dipunkembangaken:meyakini=saestu:diminati=dipunminati:mengirimkan=ngintunaken:sekaligus=ngiras:didatangkan=dipundugikaken[DIPUNRAWUHAKEN]:mengekalkan=nglestantunaken:menjajah=njajah:terhadap=kalih[kaliyan]:didirikan=dipundhirikaken:dirikan=dirikaken:mendirikan=ndirikaken:menimba=nimba:tertua=paling sepuh[YUSWA]:terawat=kereksa:dikuasai=dipunkuwaosi:kuasai=kuwaosi:dikenakan=dipunangge[DIPUNAGEM]:kotanye=kithanipun:terhenti=mendel:mudanye=enemipun:terbentang=kebentang:ajegannye=ajeganipun:bersabarlah=kantos lah:penulisan=penyeratan:tunjukkan=tedahaken:dibagikan=dipunbagikaken:menyarankannye=nyaranakenipun:dijadikan=dipundadosaken:contohlah=contoha:wuku=wuku:melisankan=ngginemaken[NGENDIKAKAKEN]:dibunyikan=dipun-ungelaken:bukannye=sanesipun:disuku=di-suku:dituliskan=dipunserataken:bicarakan=ginemaken[NGENDIKAKAKEN]:mengutarakannye=ngutarakakenipun:manakala=kala[NALIKA]:mendadak=ndadak:diperkenankan=dipunkengingaken[DIPUNPARENGAKEN]:diperbolehkan=dipunkengingaken[DIPUNPARENGAKEN]:dibolehkan=dipunkengingaken[DIPUNPARENGAKEN]:berikan=sukakaken[PARINGAKEN]:tetangga=tangga:tetangganye=tangganipun:kehidupan=gesang[SUGENG]:kehidupannye=gesangipun[SUGENGIPUN]:terbilang=keetang:terhitung=keetang:menyumbangkan=nyumbangaken:segala=sedaya:wajahnye=rainipun[PASURYANIPUN]:seketika=ndadak:tibatiba=ndadak:kataanye=katanipun:memaparkan=medharaken:terpaparkan=kewedharaken:dicabut=dipuncabut:adapun=wondene:gampangnye=gampilipun:artian=artos:disesali=digetuni:sesal=getun:menyesal=getun:menyesali=nggetuni:dilagukan=dipunlagokaken:melagukan=nglagokaken:digubah=dipun gubah:merujuk=ngrujuk:janggut=janggut[KETHEKAN]:janggutku=janggut[KETHEKAN] kula:janggutmu=janggut[KETHEKAN] sampeyan[PANJENENGAN]:janggutnye=janggutipun[KETHEKANIPUN]:dikramakan=dipunkramakaken:lakuu=laku:dihormati=dipunhormati:usianye=umuripun[YUSWANIPUN]:diajak=dipun-ajak:menantu=mantu:diperiksa=dipunperiksa:nunggu=ngentosi:cucunye=putunipun[WAYAHIPUN]:cucuku=putunipun[WAYAHIPUN] kula:cucumu=putunipun[WAYAHIPUN] sampeyan[PANJENENGAN]:berziarah=ziarah:berbincangbincang=gineman[NGENDIKAN]:berbincang=gineman[NGENDIKAN]:selagi=mumpung:suaminye=semahipun[GARWANIPUN]:istrinye=semahipun[GARWANIPUN]:dikenalnye=dipuntepangipun:lainsebagainye=sanes-sanesipun:pelaku=pelaku:tepatan=leresan:sehingga=mila:mendesaknye=ndhesekipun:mendesak=ndhesek:didesaknye=dipundhesekipun:kepentingannye=kewigatosanipun:disebabkan=dipunamargikaken:ditujukan=dipunkonjuk:mengaplikasikan=ngaplikasikaken:hendaknye=kedahipun:mengajari=mucalaken[NGASTAKAKEN]:ketetanggaan=tetangganan:ditempati=dipunpanggeni:keberadaanye=kawontenanipun:diperkenalkan=dipuntepangaken:memperkenalkannye=nepangakenipun:memperkenalkanye=nepangakenipun:menyerupai=sarupi:pencarian=pados-an:diterjemahkan=dipunterjemahaken:menterjemahkan=nerjemahaken:menerjemahkan=nerjemahaken:benarkah=napa[MENAPA] leres:bnget=sanget:mendongkrak=ndongkrak:mendukung=nyengkuyung:mendukungnye=nyengkuyungipun:mudahan=mugi:dpat=angsal[KEPARING]:mencatat=nyerat:sedikitnye=sakedhikipun:dipinjam=dipunsambut[DIPUNAMPIL]:mengikutinye=numuti[NDEREKI]:jambunye=jambetipun:tidaklah=mboten:menghendaki=ngajeng-ajeng:padaakhirnye=nten pungkasanipun:bermainmain=dolanan[AMENG-AMENG]:kepalanye=sirahipun[MUSTAKANIPUN]:menjunjung=njunjung:mempersembahkan=mersembahaken:kumpulkan=kempalaken:bermanfaat=manfaat:berikutnye=salajengipun:berikut=puniki[MENIKA]:tepatkah=leres-mboten:menanggapinye=nanggepinipun:segampang=sagampil:mengurus=ngurus:urutkan=urutaken:meninggalkan=nilaraken:mencegah=nyegah:menyegah=nyegah:mengidentifikasi=ngidentifikasi:berkomunikasi=komunikasi:diharapkan=dipunajeng-ajeng:inginnye=kajengipun:terserah=napa kajengipun[MENAPA KERSANIPUN]:berlebihan=kelangkung-langkung:perhiasanmu=angge-anggenipun sampeyan[PANJENENGAN]:perhiasanku=angge-anggenipun kula:perhiasannye=angge-anggenipun:merokok=eses:minjem=nyambut[NGAMPIL]:kerapkali=asring:kerap=asring:hilangnye=icalipun:hilangkan=icalaken:mengakibatkan=ndamel:pintarnye=pinteripun:pintar=pinter:menginjak=ngidak:anggapan=anggepan:anggapananggapan=anggepan-anggepan:bertanyatanye=tetakenan:meninggal=pejah[SEDA]:menggunjing=ngraosi:memaki=misuhi:bergunjing=ngraosi:kecilkecilan=alit-alitan:diakuinye=dipunaken piyambakipun[PANJENENGANIPUN]:dirinye=piyambakipun[PANJENENGANIPUN]:memalukan=nglingsemaken:siapakah=sinten:baubauan=ambet-ambet:berbau=mambet:memulangkan=mangsulaken[NGONDURAKEN]:dipulangkan=dipunwangsulaken[DIPUNKONDURAKEN]:dikembalikan=dipunwangsulaken[DIPUNKONDURAKEN]:mengembalikan=mangsulaken[NGONDURAKEN]:jarangjarang=awis-awis:mahalmahal=awis-awis:tawarkan=tawikaken:tawaran=tawinan:ditawarkan=dipuntawikaken:membubuhkan=mbebahaken:bubuhkan=bebahaken:bengawan=benawi:esok=benjing:membakar=mbesmi:menanak=mbethak:membubarkan=mbibaraken:dibubarkan=dipunbibaraken:bubarkan=bibaraken:bubarnye=bibaripun:membubarkannye=mbibarakenipun:hancur=bibrah:bangga=bingah:sukacita=bingah:cengkrama=cengkrami:bercengkrama=cengkrami:secukupnye=sacekapipun:cukupnye=cekapipun:cukupkan=cekapaken:berlandaskan=ngangge[NGAGEM] landesan:mencukupkan=nyekapaken:berkisar=sawentawis:sekitar=sawentawis:sekitarnye=sawentawisipun:menyukupkan=nyekapaken:mencukupi=nyekapaken:menyukupi=nyekapaken:cukupi=cekapaken:memegangnye=nyepengipun[NGASTANIPUN]:memegangi=nyepengi[NGASTANI]:dipegangi=dipuncepengi[DIPUNASTANI]:memeganginye=nyepenginipun[NGASTANINIPUN]:dipeganginye=dipuncepenginipun[DIPUNASTANINIPUN]:menjajal=nyobi:dijajal=dipuncobi:dicoba=dipuncobi:menjajalnye=nyobinipun:persenjataan=dedamelan:epek=sabuk[PANINGSET]:keris=dhuwung:berkeris=dhuwungan:kerisnye=dhuwungipun:berkertas=dlancangan:kertasnye=dlancangipun:berumahtangga=emah-emah[KRAMA]:teringat=emut:mematuhi=ngestuni:segan=pakewed:tergugat=kegigat:berdomisili=manggen:sabarnye=kantosipun:sabarkah=kantos kah:sabarkan=kantosaken:kudanye=kapalipun[KUDANIPUN]:embuh=kilap:kempis=kimpes:mengempis=ngimpes:mengempiskan=ngimpesaken:kempisnye=kimpesipun:kumat=kimat:terbiasa=kulinten:jauhnye=tebihipun:bawakan=bektakaken[ASTAKAKEN]:membawakan=mbektakaken[NGASTAKAKEN]:digunakannye=dipunanggenipun[DIPUNAGEMIPUN]:raup=angsal[KEPARING]:hujannye=jawahipun:baiklah=nggih pun:baikklah=nggih pun:takkan=mboten badhe:uangnye=artanipun:duitnye=artanipun:sajalah=mawon pun:kesukaan=keremenan:mewujudkannye=mujudakenipun:seberapa=sapinten:terasi=traos:waktunye=wekdalipun:dimanapun=nten pundia:dikirimkan=dipunkintunaken:dikirimkannye=dipunkintunakenipun:mengirimkannye=ngintunakenipun:terkirim=kekintun:kiriman=kintunan:teras=emper:menyembur=nyembur:semburkan=semburaken:kecoklatan=semu coklat:sekali=pisan:terpantau=ketingal[KEPRIKSAN]:bersamaan=sesarengan:disaksikan=dipuntingali[DIPUNPRIKSANI]:ditonton=dipuntingali[DIPUNPRIKSANI]:berarti=gadhah artos:mereda=mantun:reda=mantun:meninjau=ningali[MRIKSANI]:memantau=ningali[MRIKSANI]:seumuran=sa pantaran:serasa=kraos:serasanye=kraosipun:menurutnye=midherek piyambakipun[PANJENENGANIPUN]:terburuk=paling awon:letaknye=panggenanipun:terdekat=paling caket:disiapkan=dipunsiyapaken:disiagakan=dipunsiagakaken:melayani=nglayani:terbesar=paling ageng:menguasai=nguwaosi:temannye=kancanipun:telaten=tlatos:kesekian=kesemanten:barubaru=enggal-enggal:kemauan=kekajengan:kalinye=pisanipun:menorehkan=norehaken:perbaikan=dandosan:berikutini=salajeng puniki[MENIKA]:berikutinilah=salajeng puniki[MENIKA]:bagaimanapun=kados pundia:mengingatkan=ngemutaken:lihatlah=tingali[PRIKSANI]:bandingkan=bandingaken:menggerakkan=nggerakaken:dialog=pagineman:dialognye=paginemanipun:berdialog=pawicantenan:menggerakan=nggerakaken:menghina=moyoki:menjelekkan=ngawon-awonaken:menjelekjelekkan=ngawon-awonaken:menjelekjelekan=ngawon-awonaken:menjelekan=ngawon-awonaken:mlaku=mlampah[TINDAK]:mlakumlaku=mlampah-mlampah:sangatsangat=sanget-sanget:harian=dintenan:besoknye=mbenjingipun:selesaikan=rampungaken:biar=supados:puasanye=siyamipun:makasih=matur nuwun:keliatan=ketingal[KEPRIKSAN]:belakangnye=wingkingipun:cuman=namung[naming]:matikan=pejahaken[SEDAKAKEN]:mudahhan=mugi:diantara=nten antawis:perbedaannye=bentenipun:mendengarnye=mirengipun[MIDHANGETIPUN]:membingungkan=mbingungaken:tahukah=ngertos mboten:taukah=ngertos mboten:prilaku=prilaku:mengagungkan=ngagungaken:mewakili=makili:berkobar=mulad-mulad:berkobarkobar=mulad-mulad:mengobarkan=mulad-muladaken:memperbaikinye=ndandosinipun:diharuskan=dipunkedahaken:mengharuskan=ngedahaken:haruskan=kedahaken:keharusan=kekedahan:menggenggam=nggegem:kacamatanye=kacamripatipun[KACA-TINGALIPUN]:kacamatamu=kacamripat[KACA-TINGAL] sampeyan[PANJENENGAN]:kacamataku=kacamripat[KACA-TINGAL] kula:tunggutunggu=tengga:menghampiri=murugi[NGRAWUHI]:menghampirinye=murugi[NGRAWUHI]:bermukim=manggen:bermukimnye=manggenipun:keperluan=perlu:menggembirakan=mbingahaken:nemu=manggih:karnanye=amarginipun:keempat=kaping sekawan:perbedaanye=bentenipun:dibohongi=dipundorani:dikibuli=dipundorani:dikibulin=dipundorani:ngrti=ngertos:usai=bibar:berakhirnye=bibaripun:banyakbanyak=kathah-kathah:menyingkirkan=nyingkiraken:membudidayakan=mbudidayakaken:dibudidayakan=dipunbudidayakaken:memanfaatkan=manfaataken:alatalat=pirantos-pirantos:menjahit=njait:pembuatan=pandamelan:keluargakeluarga=kluwargi-kluwargi:memerintahkan=ngengken[NDHAWUHAKEN]:ratusan=atusan:memberitakan=wartosaken:udh=sampun:msh=taksih:bulannye=wulanipun:bertahuntahun=tetaunan:tanggapi=tanggepi:rugi=tuni:menunggang=numpak[NITIH]:gue=kula:kebenarannye=keleresanipun:menyiarkan=nyiaraken:mainnye=dolanipun[AMENG-AMENGIPUN]:disuguhkan=dipunsegahaken[DIPUNSUGATAKAKEN]:warisan=tilaran:peninggalan=tilaran:jalannye={marginipun, mlampahipun}:menamakan=namikaken[ASMAKAKEN]:ucapannye=wicantenipun[NGENDIKANIPUN]:dijatuhkan=dipundhawahaken:menyamakan=nyamikaken:mendominasi=ndominasi:ketertinggalan=kekantunan:ketertinggalannye=kekantunanipun:ketertinggalanye=kekantunanipun:memasuki=mlebeti:melepaskan=nguculi:melepas=nguculi:dijalankan=dipunlampahaken[DIPUNTINDAKAKEN]:jalankan=lampahaken:menyukaimu=remeni sampeyan[PANJENENGAN]:mengetahuinye=nyumerepi:seputih=sepethak:manamana=pundi-pundi:singkong=bodin:rasarasanye=raos-raosipun:kawan=kanca:nyoba=nyobi:dululah=rumiyina:lantas=lajeng:pengin=kajeng:dibuktikan=dipunbuktikaken:terjebak=kejebak:jadilah=dadosa:memetik=metik:perbuat=lampahaken[TINDAKAKEN]:memintalah=nedhaha[NYUWUNA]:menyelaraskan=nyelarasaken:perbuatan=lampahan[TINDAKAN]:mulanye=wiwitipun:kesemua=sedaya:bukubuku=buku-buku:orangtuanye=tiyang sepuhipun:dijodohkan=dipunjodhokaken:jodohkan=jodhokaken:mengutarakan=ngutarakaken:menerangkan=nerangaken:dikaji=dipunaosi:dicarikan=dipunpadosaken:dicari=dipunpadosi:carikan=padosaken:bicaranye=wicantenipun[NGENDIKANIPUN]:laggi=malih:bacaan=waosan:bacaanbacaan=waosan-waosan:membacakan=maosaken:laggian=susuk:laggiannye=susukipun:kembalian=susuk:kembaliannye=susukipun:meninggalkannye=nilarakenipun:menaikan=nginggahaken:naikan=nginggahaken:dinaikan=dipuninggahaken:naikkan=nginggahaken:mengangkat=nginggahaken:diangkat=dipuninggahaken:mentranslate=nranslat:ditranslate=dipunterjemahaken:buatlah=damela:tempattempat=panggenan-panggenan:dibikin=dipundamel:bikin=damel:dibikinnye=dipundamelipun:dibawain=dipunbektakaken[DIPUNASTAKAKEN]:pake=angge[AGEM]:ga=mboten:inget=emut:kayaa=kados:nggak=mboten:ajah=mawon:bacakan=waosaken:tulisanye=seratanipun:tulisnye=seratipun:berisi=gadhah isi:kisah=criyos:kisahkisah=criyos-criyos:kisahnye=criyosipun:kisahkisahnye=criyos-criyosipun:ceritaceritanye=criyos-criyosipun:sebaik=sasae:sebaikbaik=sasae-sae:sebaikbaiknye=sasae-saenipun:ikutan=tumut[NDEREK]:dapet=angsal[KEPARING]:dapetnye=angsalipun[KEPARINGIPUN]:dapatkan=angsal[KEPARINGAN]:mendapati=nyumerepi:ikutkan=tumutaken[DEREKAKEN]:diikutkan=dipuntumutaken[DIPUNDEREKAKEN]:entahlah=duka:kedengarannye=kepirengipun[KAPIDHANGETIPUN]:menjalaninye=nglampahakenipun[NINDAKAKENIPUN]:menjalankannye=nglampahakenipun[NINDAKAKENIPUN]:dijalani=dipunlampahaken[DIPUNTINDAKAKEN]:tempatnye=panggenanipun:diadakannye=dipunwontenakenipun:diadakanye=dipunwontenakenipun:barunye=enggalipun:cepatcepat=enggal-enggal:memeliharanye=ngingahipun:sebutannye=wastananipun:sahabat=mitra:bertemen=kancan:bersahabat=mitran:persahabatan=memitran:temenan=kancan:sahabatan=mitran:mengunakan=ngangge[NGAGEM]:berupa=rupinipun:rupanye=rupinipun:dekil=reged:kotor=reged:rajin=giyat:beribadah=ngibadah:setali=satangsul:talinye=tangsulipun:buatku=kangge[KAGEM] kula:buatmu=kangge[KAGEM] sampeyan[PANJENENGAN]:selayaknye=pantesipun:dipotongpotong=dipunkethok-kethok:dipisahpisah=dipunpisah-pisah:dipilahpilah=dipunpilah-pilah:dipotongpotongkan=dipunkethok-kethokaken:dipisahpisahkan=dipunpisah-pisahaken:dipilahpilahkan=dipunpilah-pilahaken:dicontohkan=dipuntuladhani:dijabarkan=dipunjlentrehaken:telanjur=kelajeng:wongtuaku=tiyang sepuhipun kula:wongtuamu=tiyang sepuhipun sampeyan[PANJENENGAN]:darinye=saking piyambakipun[PANJENENGANIPUN]:dihentikan=dipunkendelaken:didiamkan=dipunkendelaken:timurnye=wetanipun:selatannye=kidulipun:baratnye=kilenipun:utaranye=leripun:berbentuk=awujud:dirangkai=dipunrangkai:pemenuhan=ngebakaken:berdirinye=ngadegipun[JUMENENGIPUN]:diartikan=dipunartosaken:artikan=artosaken:mengajarkannye=mucalakenipun[NGASTAKAKENIPUN]:disimpulkan=dipunsimpulaken:pengertiannye=pangartosipun:menaklukannye=ngawonakenipun:menaklukkannye=ngawonakenipun:menaklukan=ngawonaken:taklukan=kawonaken:menyerang=nyerang:menyerangnye=nyerangipun:dimasuki=dipunlebeti:kalimat=ukanten:kalimatnye=ukantenipun:merebut=ngrebat:dikelilingi=dipunubengi:kelilingi=ubengi:menempati=manggeni:penguasanye=panguwaosanipun:penguasa=panguwaos:mengenakan=ngangge:mempelajari=nyinaoni:berdarah=rahan:mendalami=nglebeti:semasa=kala[NALIKA]:segitu=semriku:membiasakan=ngulintenaken:meluncurkan=ngluncuraken:meluncur=ngluncur:meluncurlah=ngluncura:merangkul=ngrangkul:keseharian=sadinten-dinten:tebal=kandhel:disumbangkan=dipunsumbangaken:diprotes=dipunprotes:terbitkan=terbitaken:diluncurkan=dipunluncuraken:hadirkan=dugikaken[RAWUHAKEN]:dihadirkan=dipundugikaken[DIPUNRAWUHAKEN]:silam=kepengker:bersifat=gadhah[KAGUNGAN] sipat:dibanding=dipunbanding:terbatas=kewates:diduga=dipundugi:mengutamakan=ngutamikaken:saudaranye=sadherekipun:ditandai=dipuntandani:kelak=mangke:kelima=kaping gangsal:keenam=kaping enem:bersikap=gadhah[KAGUNGAN] sikap:kedelapan=kaping wolu:diperkirakan=dipunkintenaken:kesembilan=kaping sanga:ketiga=kaping tiga:pemangku=pemangku:bersyukurlah=syukura:mengucapkannye=sanjangakenipun[NGATURAKENIPUN]:ataukah=utawi:diminta=dipuntedha[DIPUNSUWUN]:dimintanye=dipuntedhanipun[DIPUNSUWUNIPUN]:dituntut=dipuntuntut:menuntut=nuntut:seolah=kadosipun:seolaholah=kados-kadosipun:seolah=kadosipun:kebanyakan=kathah-kathah:setahu=sangertos:diamalkan=dipunamalaken:terselip=keselip:berpidato=pidato:dibahas=dipunbahas:tergantikan=kegantosaken:gantikan=gantosaken:sendirisendiri=piyambak-piyambak:sukanye=remenipun:beritanye=wartosipun:berkirim=kintun:olehnye=dening piyambakipun[PANJENENGANIPUN]:perbincangan=gineman[NGENDIKAN]:masamasa=kala[NALIKA]:berisikan=gadhah isi:ceritacerita=criyos-criyos:dibacakan=dipunwaosaken:titipkan=titipaken:dilekasi=dipunwiwiti:digerakkan=dipun-gerakaken:nemunemu=manggihi:ditemu=dipunpanggih:berlangsung=kedados:seingatku=emutipun kula:membuatku=ndamel kula:disepakati=dipun mupakati:memuaskan=maremaken:jelaskan=jlentrehaken:menjelaskan=njlentrehaken:ditinggalkannye=dipuntilarakenipun:ditinggalkanye=dipuntilarakenipun:ditangani=dipuntangani[DIPUNASTANI]:berkurang=saya kirang:lestarikan=lestantunaken:orangorangnye=tiyang-tiyangipun:diwujudkan=dipunwujudaken:memasarkannye=masarakenipun:menyediakan=nyedhiyakaken:seakan=kadosipun:renang=nglangi:berenang=nglangi:renangnye=nglanginipun:tontonan=tetingalan:tontonannye=tetingalanipun:memperebutkan=rebatan:berenangnye=nglanginipun:bersalah=gadhah[KAGUNGAN] lepat:bermasalah=wonten masalah:dikunjungi=dipunkunjungi:bergandengan=gandengan:berjauhan=tebih-tebihan:berpikir=manahaken[NGGALIHAKEN]:terkecuali=kejawi:desanye=dhusunipun:desadesa=dhusun-dhusun:mengelola=ngelola:menguatkan=ngiyataken:dikemas=dipunkemas:menutup=nutup:membesar=saya ageng:disisihkan=dipuntirahaken:disisakan=dipuntirahaken:menyisakan=nirahaken:katakanlah=sanjangaken[ATURAKEN] lah:menjaganye=njaginipun:berlangsung=kedados:tergabung=kempal:menerbitkan=nerbitaken:dibangkitkan=dipunbangkitaken:berimbas=murugaken:kekayaan=kesugihan:kesemuanye=sedayanipun:bernuansa=gadhah nuansa:mengawasi=ngawasi:merusak=ngrisak:dirusak=dipunrisak:merusaknye=ngrisakipun:dirusaknye=dipunrisakipun:kerusakan=kerisakan:kerusakannye=kerisakanipun:merusakkan=ngrisakaken:mertuamu=marasepuh sampeyan[PANJENENGAN]:mertuaku=marasepuh kula:mertuanye=marasepuhipun:mertua=marasepuh:tangantangan=tangan-tangan[ASTA-ASTA]:tembangtembang=sekaran-sekaran:lagulagu=sekaran-sekaran:bungabunga=sekar-sekar:kembangkembang=sekar-sekar:melihatnye=nyumerepi[MRIKSANI]:daunnye=ron-ipun:menanam=nanem:lanjutan=lajengan:pelakupelaku=pelaku-pelaku:matang=mateng:melibatkan=nglibataken:mengoleksi=ngoleksi:direncanakan=dipunrencanakaken:dalamnye=lebetipun:mengoleksi=ngoleksi:dicapai=dipun-gayuh:terdaftar=kedaftar:bersinergi=gadhah[KAGUNGAN] kerjasami:bekerjasama=kerja sami:kerjasama=kerja sami:diusung=dipunusung:bertahap=mipil:beramai=rame:ramai=rame:beramairamai=rame-rame:kemahalan=kawisen:murahan=mirahan:kemurahan=kemirahan:murahmurah=mirah-mirah:mendasari=ndhasari:membahas=mbahas:mengerjakan=ngerjakaken:mengerjakannye=ngerjakakenipun:kerjakan=kerjakaken:dikerjakan=dipun-kerjakaken:dikerjakannye=dipun-kerjakakenipun:punyamu=gadhahipun[KAGUNGANIPUN] sampeyan[PANJENENGAN]:punyaku=gadhahipun[KAGUNGANIPUN] kula:anyanganyangan=awis-awisan:labanye=bathinipun:laba=bathi:ruginye=tuninipun:bungkuskan=bungkusaken:bentar=sekedhap:buatkan=damelaken:pindahan=pindhahan:papah=rama:mama=ibu:laper=luwe:dilihatlihat=dipuntingali[DIPUNPRIKSANI]:ngapain=napa[MENAPA]:menyusun=nyusun:kak=mas/jeng:dianjurkan=dipunanjuraken:ketidak=ke mboten:menyebarkan=nyebaraken:beritaberita=wartos-wartos:memposting=mosting:menjatuhkan=ndhawahaken:samain=samikaken:samakan=samikaken:pertamatama=pertami-tami:catat=serat:menyatat=nyathet:priyayi=priyantun:lautnye=segantenipun:tuku=tuku:menggambarkan=nggambaraken:diteliti=dipunteliti:saling=sami-sami:kesehatan=kesarasan[KESENGGANGAN]:kewarasan=kesarasan[KESENGGANGAN]:waras=saras[SENGGANG]:kepunyaannye=gadhahipun[KAGUNGANIPUN] piyambakipun[PANJENENGANIPUN]:likaliku=lika-liku:likuliku=liku-liku:sepenuhnye=sakebakipun:terjajah=kejajah:dirayakan=dipunrayakaken:merayakan=ngrayakaken:merencanakan=ngrencanakaken:menyinggung=nyinggung:utarakan=sanjangaken[ATURAKEN]:musim=mangsa:menuju=tumuju:selebihnye=langkungipun[WIYOSIPUN]:tama=tami:ulama=ulami:perkenankan=kengingaken[PARENGAKEN]:perbolehkan=kengingaken[PARENGAKEN]:memperkenankan=ngengingaken[MARENGAKEN]:memperbolehkan=ngengingaken[MARENGAKEN]:pertanggungjawaban=tanggel jawab:pertanggungjawabannye=tanggel jawabipun:doakan=dongakaken:berfoto=foto:didoakan=dipundongakaken:citacitakan=kajengaken:dicitacitakan=dipunkajengaken:mencitacitakan=nggayuhaken:citacita=gegayuhan:citacitanye=gegayuhanipun:pegal=pegel:pegalnye=pegelipun:pegalpegal=pegel-pegel:pegalpegalnye=pegel-pegelipun:dikabulkan=dipunkabulaken:kabulkan=kabulaken:mengabulkan=ngabulaken:pastian=mesthenan:tahuan=ngertosan:dengannye=kalih piyambakipun[PANJENENGANIPUN]:bersamanye=kalih piyambakipun[PANJENENGANIPUN]:tersindir=kesindir:apalah=punapa-lah[MENAPA lah]:menjauhiku=nebihi kula:lagian=saha:mengorbankan=ngorbanaken:mencoreti=nyoreti:menyoreti=nyoreti:menitipkannye=nitipaken:menitipkan=nitipaken:untuknye=kangge[KAGEM] piyambakipun[PANJENENGANIPUN]:menjauhinye=nebihi piyambakipun[PANJENENGANIPUN]:keesokan=ngenjing:kerudung=kudung:merahnye=abritipun:mengganjal=ngganjel:kepadaku=kalih kula:menghiburku=ngremenaken kula:menghibur=ngremenaken:menghiburmu=ngremenaken sampeyan[PANJENENGAN]:mimpimimpi=supena-supena:harihari=dinten-dinten:ditulisnye=dipunserat piyambakipun[PANJENENGANIPUN]:mengelompokan=merangaken:mengelompokkan=merangaken:dibedakan=dipunbentenaken:bedakan=bentenaken:tuh=niku:nih=niki:mencerminkan=nyerminaken:menyerminkan=nyerminaken:kembalikan=wangsulaken[KONDURAKEN]:mencampurkan=nyampuraken:dihina=dipun-ina:memengaruhi=mengaruhi:mengamalkan=ngamalaken:diperingati=dipunpengeti:tanggungjawab=tanggel jawab:dilindungi=dipunlindungi:membina=mbina:melindungi=nglindungi:diamanatkan=dipunamanataken:menanggapi=nanggepi:diwakilinye=dipunwakilinipun:didasarkan=dipundhasaraken:dimuat=dipunmuat:mendasarkan=ndhasaraken:masuknye=mlebetipun:sebaya=pantaran:kejadiannye=kedadosanipun:dipaksa=dipunpeksa:memaksa=meksa:diterima=dipuntampi:bawahnye=andhapipun:mempertanggungjawabkan=mertanggeljawabaken:ketinggian=keinggilan:lagilagi=malih-malih:berpesan=gadhah[KAGUNGAN] pesen:kucoba=kula cobi:kaucoba=sampeyan[PANJENENGAN] cobi:saneslainnye=sanes-sanesipun:kambingnye=mendanipun:kambingku=mendanipun kula:kambingmu=mendanipun sampeyan[PANJENENGAN]:tertata=ketata:menginspirasi=nginspirasi:mencontoh=nuladhani:menghiasi=ngiasi:tanahair=tanah air:menghindari=ngendhani:dibuatkan=dipundamelaken:berkunjung=dugi[RAWUH]:mengucapkanye=sanjangakenipun[NGATURAKENIPUN]:bantuan=rencangan:wingi=kala-wingi:kesusahan=kasisahan[KASEKELAN]:menyelesaikannye=ngrampungakenipun:meluangkan=luangaken:kerjaan=pandamelan:kerjaannye=pandamelanipun:alihkan=alihaken:janjikan=janjikaken[PUNAGIKAKEN]:terlalu=sanget-sanget:memaklumi=maklumi:berharihari=dinten-dintenan:depannye=ajengipun:kedepannye=dhateng ajengipun:bacabaca=maos-maos:membacabaca=maos-maos:ketemulah=kepanggiha:dikubur=dipunkubur[DIPUNPETAK]:dikuburkan=dipunkubur[DIPUNPETAK]:dimakamkan=dipunkubur[DIPUNPETAK]:makamkan=ngubur[METAK]:kuburkan=ngubur[METAK]:menguburkan=ngubur[METAK]:mengubur=ngubur[METAK]:meninggikan=nginggilaken:diandalkan=dipunandelaken:dimanfaatkan=dipunmanfaataken:mendekatkan=nyaketaken:diimbangi=dipunimbangi:disesuaikan=dipuntrepaken:diperbincangkan=dipun-ginemaken[DIPUN-NGENDIKAKAKEN]:diserap=dipunserap:memaksakan=meksakaken:dipaksakan=dipunpeksakaken:dipadankan=dipunsamikaken:terbalik=kuwangsul:terbaliknye=kuwangsulipun:dibalik=dipunwangsul:seperlunye=sabetahipun:bertetangga=tetanggan:tolongmenolong=tulung-tinulung:terekam=kerekam:penggunaanye=panganggenanipun[PANGAGEMANIPUN]:bertujuan=gadhah[KAGUNGAN] tujuwan:diingat=dipunemut-emut:diragukan=dipunragukaken:ragukan=ragukaken:meragukan=ngragukaken:baginye=kangge[KAGEM] piyambakipun[PANJENENGANIPUN]:menampilkan=nampilaken:terbaiknye=paling saenipun:menghadapinye=ngajenginipun:habishabisan=telas-telasan:mengamankan=ngamanaken:ditiru=dipuntulad:datangin=dugikaken[RAWUHAKEN]:datangkan=dugikaken[RAWUHAKEN]:diusir=dipun-usir:berkualitas=gadhah[KAGUNGAN] kualitas:angka=wicalan:gadhahipun=gadhahipun[KAGUNGANIPUN]:sangatlah=sanget-sanget:membedabedakan=mbenten-mbentenaken:menumbuhkan=nukulaken:kental=kenthel:gunakanlah=anggea[AGEMA]:pengurangan=pangirangan:keseringan=kaasringan:kembangkan=rembyakaken:sekeliling=saubengan:sekelilingnye=saubenganipun:memungkinkan=mungkinaken:lututnye=dhengkulipun[JENGKUNIPUN]:berkaitannye=sesambetanipun:berkaitan=sesambetan:menafsirkan=nafsiraken:membandingkan=nandhingaken:perbedaanperbedaan=kebentenan-kebentenan:persamaan=sami:kesamaan=sami:diperbandingkan=dipunbandingaken:terproduksi=keproduksi:terpengaruh=kepengaruh:terjadwal=kejadwal:lumpuhkan=lumpuhaken:melumpuhkan=nglumpuhaken:membantah=mbantah:terlambat=kantun:tenggara=kidul-wetan:tenggaranye=kidul-wetanipun:baratdaya=kidul-kilen:baratdayanye=kidul-kilenipun:baratlaut=ler-kilen:baratlautnye=ler-kilenipun:timurlaut=ler-wetan:timurlautnye=ler-wetanipun:menghafal=ngapalaken:menanggung=nanggung:menuntaskan=ngrampungaken:menuntaskannye=ngrampungakenipun:menyayangkan=nyayangaken:bertanggungjawab=tanggel jawab:diterimanye=dipuntampinipun:sepengetahuan=sangertos:berbadan=gadhah[KAGUNGAN] badan[SALIRA]:badan=badan[SALIRA]:bertubuh=gadhah[KAGUNGAN] badan[SALIRA]:temukan=panggihaken:terulangnye=kewangsulipun:menimpa=ndhawahi:menjatuhi=ndhawahi:terlupakan=kesupekaken:sekuatkuatnye=sekiyat-kiyatipun:sekuat=sekiyat:kuatnye=kiyatipun:menguat=ngiyat:kuatkan=kiyataken:beranggapan=nganggep:bergeser=geser:dipancing=dipunpancing:memancing=mancing:menyapa=aruh-aruh:pelestarian=palestantunan:bertutur=wicanten[NGENDIKA]:merangkai=ngrangkai:ketigga=ketiga:tanahnye=sitinipun:hitungan=etangan:hitungkan=etangaken:hitungannye=etanganipun:menghitung=ngetang:menghitungnye=ngetangipun:menghitungkan=ngetangaken:penyebutannye=panyebatanipun:penyebutan=panyebatan:penyebut=panyebat:dinilai=dipun-biji:sukasukanye=remen-remenipun:sukasuka=remen-remen:tersimpan=ke dekek:ditingkatkan=dipuntingkataken:dilalui=dipunlangkungi[DIPUNWIYOSI]:dilewati=dipunlangkungi[DIPUNWIYOSI]:saatnye=kalanipun:sejuta=sayuta:semiliar=samiliar:semilyar=samiliar:setriliun=satriliun:setrilyun=satriliun:lanjutin=lajengaken:seakanakan=kadosipun:memupus=mupus:mengancam=ngancem:memungut=mendhet[MUNDHUT]:diantisipasi=dipunantisipasi:menciptakan=ndamel:satusatunye=setunggal-setunggalipun:dimenit=nten menit:diamankan=dipunamanaken:terlampau=sanget-sanget:membongkar=mbingkar:tergerus=kegerus:dipertahankan=dipunpertahanaken:menghapus=mbusek:menggandeng=nggandeng:ciptaannye=damelanipun:ciptaanye=damelanipun:bertajuk=gadhah[KAGUNGAN] tajuk:melalang=nglanglang:melanglang=nglanglang:kelahirannye=wedalanipun[WIYOSANIPUN]:kelahiranye=wedalanipun[WIYOSANIPUN]:mencipta=ndamel:mengharumkan=ngarumaken:membukukan=mbukukaken:sekawann=kawan:dipertanyakan=dipuntakekaken[DIPUNPUNDHUTAKEN PRIKSA]:pastilah=mesthi lah:kenyataanye=kasunyatanipun:kenyataannye=kasunyatanipun:terucapkan=keginemaken[KENGENDIKAKAKEN]:diingatkan=dipunemutaken:kehatihatian=keatos-atosan:dibenarkan=dipunleresaken:mempertunjukkan=nedahaken:terwujud=kawujud:dirumuskan=dipunrumusaken:tampaknye=ketingalipun[KEPRIKSANIPUN]:dikombinasikan=dipunkombinasikaken:ditetapkan=dipuntetepaken:meletakkan=nyukani[MARINGI]:diatur=dipunatur:mengangkut=ngangkut:mengatur=ngatur:membahayakan=mbebayakaken:berbohong=dora:mengenalinye=nepangi:berguna=gadhah[KAGUNGAN] gina:membekas=mbekas:diperdengarkan=dipunpirengaken[DIPUNPIDHANGETAKEN]:berliku=menggak-menggok:berwarna=gadhah[KAGUNGAN] warni:mengubahnye=ngebahipun:merubahnye=ngebahipun:mengubahinye=ngebahinipun:merubahinye=ngebahinipun:mengubahi=ngebahi:merubahi=ngebahi:diterangkan=dipunterangaken:perhatikan=wigatosaken:dikombinasi=dipunkombinasi:kombinasikan=kombinasikaken:mengombinasikan=ngombinasikaken:mengkombinasikan=ngombinasikaken:mengaplikasikannye=ngaplikasikakenipun:nyonye=nyonya:kedepannye=mengajengipun:kedepanye=mengajengipun:keluarnye=medalipun[MIYOSIPUN]:mengusahakan=ngusahakaken:mengusahakannye=ngusahakakenipun:mengusahakanye=ngusahakakenipun:persawahan=tegalan:mengalir=mili:mengalirkan=milikaken:mengalirnye=milinipun:dialiri=dipunpilini:mengaliri=ngaliri:mengairi=ngairi:menyeberang=nyabrang:alirannye=ilenanipun:aliran=ilenan:alir=ilen:dialiri=dipun ileni:beraspal=aspalan:bernyali=gadhah[KAGUNGAN] nyali:menyusurinye=nyusurinipun:menyusuri=nyusuri:pandainye=pinteripun:pandai=pinter:meracik=ngracik:meramu=ngramu:terpendam=kependem[KEPETAK]:diputuskan=dipunputusaken:penghalang=pambengan:tahukan=ngertosaken:beritahu=sukani[PARINGI] ngertos:beritahukan=sukani[PARINGI] ngertos:enggk=mboten:panggilkan=ulemi[TIMBALI]:panggil=ulemi[TIMBALI]:memanggilkan=ngulemaken[NIMBALAKEN]:panggilan=uleman[TIMBALAN]:terlestarikannye=kelestantunakenipun:dibiasakan=dipunkulintenaken:biasakan=kulintenaken:menetapkan=netepaken:tergusur=kegusur:memasang=masang:fungsinye=ginanipun:terletak=papan:kedengaran=kepireng[KAPIDHANGET]:mengobrol=gineman[NGENDIKAN]:pernikahannye=emah-emahipun[KRAMANIPUN]:dinikahkan=dipunemah-emahaken[DIPUNKRAMAKAKEN]:dikawinkan=dipunemah-emahaken[DIPUNKRAMAKAKEN]:bertukar=lintunan:bercitacita=gadhah[KAGUNGAN] gegayuhan:disamping=nten sisi:samping=sisi:slamat=wilujeng[SUGENG]:tahuuu=ngertos:terpercaya=kepitados:menyerah=nyerah:akhirnye=pungkasanipun:menculik=nyulik:secepatnye=saenggalipun:menyiakan=nyia-nyiakaken:menyianyiakan=nyia-nyiakaken:mengumandangkan=ngumandangaken:membenarkan=ngleresaken:benarkan=leresaken:kian=saya:turunnye=mandhapipun[TEDHAKIPUN]:turunkan=ngandhapaken[NEDHAKAKEN]:rendahkan=ngandhapaken[NEDHAKAKEN]:menurunnye=mandhapipun[NEDHAKIPUN]:turunye=mandhapipun[TEDHAKIPUN]:menyertai=numuti[NDHEREKI]:diturunkan=dipunandhapaken[DIPUNTEDHAKAKEN]:melarang=nglarang:tahukannye=ngertosakenipun:tahukanye=ngertosakenipun:menyertakan=nyarengaken:mempersilahkan=nyumanggakaken:mempersilakan=nyumanggakaken:hapus=busek:kekeliruan=kelepatan:merelakan=nglilakaken:sinilah=mrikia:kesinilah=mrikia:tangannye=tanganipun[ASTANIPUN]:bermacammacam=pinten-pinten macem:berbarengan=sesarengan:senangnye=remenipun:tuanye=sepuhipun[YUSWANIPUN]:sayanye=kulanipun:sendirinye=piyambakipun[PANJENENGANIPUN]:akunye=akenipun:ngakunye=ngakenipun:mengakunye=ngakenipun:mengakuinye=ngakeni:berwudhu=wudhu:menyentuh=nyepeng:pakaian=rasukan[AGEMAN]:membawanye=mbektanipun[NGASTANIPUN]:letakkan=nyukani[MARINGI]:letakan=nyukani[MARINGI]:meletakan=nyukani[MARINGI]:becanda=gegujengan:sunnahkan=sunnahaken:sunahkan=sunahaken:disunnahkan=dipunsunnahaken:disunahkan=dipunsunahaken:utamakan=utamikaken:tempati=panggeni:menyembuhkan=mantunaken:terkekeh=nggujeng:heboh=geger:menghebohkan=nggegeraken:dihebohkan=dipun-gegeraken:hebohnye=gegeripun:mestinye=kedahipun:muliakan=mulyakaken:belumlah=derenga:tingkatkan=tingkataken:perjuangkan=perjuangaken:memasangnye=masangipun:tambahkan=tambahaken:diletakkan=dipunpapanaken:mengaitkan=ngaitaken:tunggulah=entosia:mendiskusikannye=ngrembagakenipun:diskusikan=rembagaken:mendiskusikan=ngrembagaken:didiskusikan=dipunrembagaken:berdiskusi=rembagan:bagaikan=kados:berjatuhan=sami dhawah:tumbuhkan=thukulaken:tumbuh=thukul:membangun=yasa:indonesiaku=indonesiaku:berpuluhpuluh=puluhan:beratusratus=atusan:beriburibu=ewonan:berjutajuta=yutanan:meluhurkan=ngluhuraken:orangtua=tiyang sepuh:pembuat=ingkang ndamel:sepelekan=sepelekaken:tertuang=ketuang:mendatangi=murugi[NGRAWUHI]:mendatanginye=murugi[NGRAWUHI]:satupun=setunggala:menguasainye=nguwaosinipun:menyurati=nyukani[MARINGI] serat:berpendapat=gadhah[KAGUNGAN] pendapat:pengajar=guru:gempabumi=lindhu:melanda=nglanda:terkuat=paling kiyat:memasarkan=masaraken:ikuti=tumuti[DEREKI]:berminat=minat:mendaftarkan=ndaftaraken:sebenarbenarnye=saleres-leresipun:sebenar=saleres:benarnye=leresipun:didaftarkan=dipundaftaraken:terpakai=kekengge[KEKAGEM]:dipotong=dipunpotong:menagih=nagih:terpenting=paling wigatos:dikonfirmasi=dipunkonfirmasi:duluan=rumiyin:disodorkan=dipunsodoraken:terparah=paling jahat:diperparah=dipunjahati:parah=jahat:reruntuhan=rerentahan:runtuhan=rentahan:dipulihkan=dipunpulihaken:pemiliknye=ingkang gadhahipun[KAGUNGANIPUN]:rumahrumah=griya-griya[DALEM-DALEM]:mengungsi=ngungsi:diutarakan=dipunutarakaken:disediakan=dipunwontenaken:sediakan=wontenaken:masihlah=taksiha:memprihatinkan=mrihatosaken:mengevakuasi=mindhahaken:gempa=lindhu:keluhkan=keluhaken:mengembangkannye=ngembangakenipun:mengembangkanye=ngembangakenipun:mengundurkan=ngunduraken:diulangi=dipunwangsuli:berkekuatan=gadhah[KAGUNGAN] kekiyatan:diterbitkan=dipunterbitaken:meninggaldunia=pejah[SEDA]:meninggaldunianye=pejahipun[SEDANIPUN]:penghitungan=pangetangan:mengandalkan=ngandelaken:andalkan=andelaken:ancaman=anceman:setinggi=sanginggil:setingginye=sanginggilipun:berdinas=dhines:dinas=dhines:berjarak=gadhah[KAGUNGAN] jarak:dipukul=dipun-gebag:memukul=nggebag:mengenali=nepangi:menebak=nebak:kedekatan=kecaketan:menebaknye=nebakipun:disalahartikan=dipunsalah-artosaken:mengakses=ngakses:dikenali=dipuntepangi:latihlah=latihana:mengajakmu=ngajak sampeyan[PANJENENGAN]:harapanku=pangajeng-ajeng kula:harapanmu=pangajeng-ajeng sampeyan[PANJENENGAN]:keinginanku=pangajeng-ajeng kula:keinginanmu=pangajeng-ajeng sampeyan[PANJENENGAN]:sawahku=sabin kula:sawahmu=sabin sampeyan[PANJENENGAN]:atasnye=inggilipun:harapan=pangajeng-ajeng:harapannye=pangajeng-ajengipun:diwartakan=dipunwartosaken:adab=unggah-ungguh:adabnye=unggah-ungguhe:dicobai=dipuncobi:diidamkan=dipunidamaken:terkini=paling enggal:mengejutkan=ngagetaken:menukangi=nukangi:sekurangnye=sekirangipun:merahputih=merah putih:serbabisa=sarwisaged:setengah=sapalih:berujar=sanjang[MATUR]:membela=mbela:penelitiannye=panalitenipun:penelitianpenelitian=panaliten-panaliten:penelitianpenelitiannye=panaliten-panalitenipun:diprediksi=dipunkintenaken:menumpuk=numpuk:intens=asring:diplot=dipunpanggenaken:ditempatkan=dipunpanggenaken:memenangi=menangaken:mengadopsi=ngadopsi:ketajaman=kelandhepan:kemampuannye=kesagahanipun:mengantar=ngater:penghormatan=pakurmatan:disematkannye=dipunsematakenipun:disematkan=dipunsemataken:diselamatkannye=dipunwilujengakenipun[DIPUNSUGENGAKENIPUN]:diselamatkan=dipunwilujengaken[DIPUNSUGENGAKEN]:seharga=saregi:berlarilari=mlajeng-mlajeng:cangkul=pacul:cangkulnye=paculipun:diciptakan=dipundamel:mengatasinye=nginggilinipun:atasan=inggilan:menerus=terusan:dilanda=dipunlanda:menghentikan=mendhelaken:niku=niku[MENIKA]:puniku=puniku[MENIKA]:tanyanye=taken[MUNDHUT PRIKSA] piyambakipun[PANJENENGANIPUN]:kehabisan=ketelasan:terampil=trampil:keinginannye=kekajenganipun:keinginanye=kekajenganipun:dituruti=dipunpuruni:menggerutu=ngambek:budayakan=budayakaken:dibudayakan=dipunbudayakaken:ketakutannye=keajrihanipun:ketakutanye=keajrihanipun:menyelenggarakan=ngawontenaken:memperingati=mengeti:memeringati=mengeti:peringatan=pengetan:kemerdekaan=kamardikan:pendopo=pandhapi:rumahsakit=griya sakit:memasrahkan=masrahaken:rebutan=rebatan:berebut=rebatan:raksasa=rasaksa:sabtu=setu:merepotkan=ngribetaken:mengagumi=ngaosi:dijelaskan=dipunjlentrehaken:mengharuskannye=ngedahakenipun:mengharuskanye=ngedahakenipun:bermental=gadhah[KAGUNGAN] mental:dipandang=dipuntingali[DIPUNPRIKSANI]:terbuang=kebucal:pelan=alon:menghaluskan=ngalusaken:menyambut=nyambut:dibajak=dipunbajak:menghalalkan=ngalalaken:mengabadikannye=nglestantunakenipun:merawatnye=ngreksanipun[ngrimatipun]:merawat=ngreksa[ngrimat]:lenyapnye=icalipun:keprihatinan=keprihatosan:memrihatinkan=mrihatosaken:menghidupkan=nggesangaken[NYUGENGAKEN]:hidupkan=gesangaken[SUGENGAKEN]:dikelola=dipunkelola:melupakannye=nyupekakenipun:melupakanye=nyupekakenipun:daluminggu=dalu ahad:luarbiasa=luar biasa:kawankawannye=kanca-kancanipun:membangkitkan=mbangkitaken:henti=mendel:hentihenti=mendel:diamdiam=mendel-mendel:siapasiapa=sinten-sinten:memompa=ngompa:memperingatkan=mengetaken:menggeber=nggeber:andalan=andelan:bermainnye=dolananipun[AMENG-AMENGIPUN]:sebenarbenar=saleres-leres:tibanye=duginipun[RAWUHIPUN]:hadir=dugi[RAWUH]:hadirnye=duginipun[RAWUHIPUN]:antarsuku=antarsuku:menjembatani=njembatani:dikembalikannye=dipunwangsulakenipun[DIPUNKONDURAKENIPIN]:memromosikan=mromosikaken:mewacanakan=wacanakaken:sukusuku=suku-suku:mengartikan=ngartosaken:diungkapkan=dipun-wedhar:diwacanakan=dipunwacanakaken:kamunye=sampeyanipun[PANJENENGANIPUN]:dianye=piyambakipun[PANJENENGANIPUN]:ianye=piyambakipun[PANJENENGANIPUN]:lagiii=lagi:lauk=lawuh:laukk=lauk:bakuu=baku:bakuunye=bakunipun:dipajang=dipunpajang:ditanggung=dipuntanggel:dipamerkan=dipunpameraken:disimpan=dipundekek:saking=sangkin:sukukata=wanda:ditunggui=dipuntenggani:secukupnye=sacekapipun:mengedit=ngewahi:beruntungnye=begjanipun:lisan=lesan:lisannye=lesanipun:kalimatkalimat=ukanten-ukanten:kepiting=jengjeng:ajaranajaran=wucalan-wucalan:seiring=sareng:mengoceh=ngoceh:apaan=punapa[MENAPA]:nyanyi=nyekar:mulu=mawon:hrusnye=kedahipun:iklan=pariwara:iklannye=pariwaranipun:kawin=emah-emah[KRAMA]:nikah=emah-emah[KRAMA]:dunia=donya:akui=akeni:harta=banda:besokbesok=mbenjing-mbenjing:gantinye=gantosipun:memunculkan=ngedalaken[MIYOSAKEN]:ditunggutunggu=dipunentosi:ditampilkan=dipuntampilaken:hafal=apal:berhatihati=ngatos-atos:menuduh=mastani:ngatain=mastani:menamai=mastani:hafalan=apalan:hapalan=apalan:memperdalam=nglebeti:mendalami=nglebeti:kejauhan=katebihan:demam=asrep-benter:menunjukan=nedahi[MARINGI PRIKSA]:penanye=tiyang ingkang taken[MUNDHUT PRIKSA]:beranak=gadhah[KAGUNGAN] lare[PUTRA]:kembalinye=wangsulipun[KONDURIPUN]:bersabar=kantos:dengarkan=pirengaken[PIDHANGETAKEN]:kemajuan=kemajengan:bertepatan=keleresan:terjemahkan=terjemakaken:kemanamana=dhateng pundi-pundi:dirumah=nten griya[DALEM]:berbuka=bikak:santan=santen:bersantan=santenan:menyaring=nyaring:dimasak=dipunmasak:bayam=bayem:kobis=kol:kubis=kol:kecambah=tauge:warungwarung=wande-wande:pembuatannye=pandamelanipun:bundar=bunder:menganjurkan=wantos-wantos:cicak=cecak:tergolong=kelebet:dimakan=dipuntedha[DIPUNDHAHAR]:menuduhkan=mastani:payudara=susu[PREMBAYUN]:bulumata=idep[IBING]:berpuasa=siyam:berkerja=nyambut damel:almari=lemantun:almarinye=lemantunipun:lemarinye=lemantunipun:laki=jaler[KAKUNG]:sanasini=mrika-mriki:dihasilkan=dipunkasilaken:ditambahkannye=dipuntambahakenipun:melakoni=nglampahaken[NINDAKAKEN]:melakoninye=nglampahakenipun[NINDAKAKENIPUN]:dilakoni=dipunlampahaken[DIPUNTINDAKAKEN]:dilakoninye=dipunlampahakenipun[DIPUNTINDAKAKENIPUN]:bertempat=gadhah[KAGUNGAN] panggenan:diteruskan=dipunlajengaken[DIPUNWIYOSAKEN]:dipikirkan=dipunpikiraken:dijerat=dipunjerat:beratnye=awratipun:keberatan=kawraten:ngikutin=numuti[NDEREKI]:ngikuti=numuti[NDEREKI]:seberat=se-awrat:kawankawan=kanca-kanca:karna=amargi:dijawablah=dipunwangsuli:wilayahwilayahnye=tlatah-tlatahipun:naiknye=minggahipun:dii=di:berjalanjalan=mlampah-mlampah:macam=macem:dibiarkan=dipunjoraken:letak=panggenan:menanamkan=nanemaken:berakhlak=gadhah[KAGUNGAN] akhlak:berwawasan=gadhah[KAGUNGAN] wawasan:berbudi=gadhah[KAGUNGAN] budi:berkarakter=gadhah[KAGUNGAN] karakter:menulisnye=nyeratipun:tertulisnye=kaseratipun:persamaannye=saminipun:kesamaannye=saminipun:mrikisini=mriki-mriki:mrikasana=mrika-mrika:mrikasini=mrika-mriki:mrikusitu=mriku-mriku:kesitusitu=mriku-mriku:kesanasana=mrika-mrika:kesinisini=mriki-mriki:kesanasini=mrika-mriki:kesanakesini=mrika-mriki:kesanakesana=mrika-mrika:kesinikesini=mriki-mriki:maknanye=artosipun:pemaknaannye=pangartosipun:mengunjungi=ndugini[NGRAWUHI]:sesering=sa-asring:kenali=tepangi:perlahan=alon-alon:lambat=alon:kirinye=kiwanipun:kanannye=tengenipun:tersenyum=nggujeng:senyum=gujeng:senyumnye=gujengipun:tawanye=gujengipun:tertawanye=nggujengipun:sekedar=namung[naming]:sekadar=namung[naming]:keabadian=kelestantunan:berkalung=kalungan:naiki=minggahi:suaranye=suwantenipun:ngaji=ngaos:pertemuan=pepanggihan:perjamuan=pasamuan:hal=bab:lawas=lawas[DANGU]:duduki=lenggahi[PINARAKI]:diduduki=dipunlenggahi[DIPUNPINARAKI]:menggeser=nggeser:negaranegara=nagari-nagari:negaranye=nagarinipun:berpenduduk=gadhah[KAGUNGAN] penduduk:teratas=paling inggil:mengatakannye=sanjangipun[MATURIPUN]:lebihnye=langkungipun[WIYOSIPUN]:bersihbersih=resik-resik:kehadiran=dugi[RAWUH]:butuhkan=betahaken:dipinta=dipuntedha[DIPUNSUWUN]:dipintanye=dipuntedhanipun[DIPUNSUWUNIPUN]:permasalahan=masalah:kerjanye=nyambut damelipun:selepas=salajeng:beliau=piyambakipun[PANJENENGANIPUN]:kutunggu=kula entosi:langkah=lampahan:melangkah=mlampah:langkahnye=lampahanipun:kesulitannye=sisahipun[SEKELIPUN]:berbahaya=mbebayani:menghancurkan=ngancuraken:berlainan=benten-benten:berlainlainan=benten-benten:diperintahkan=dipunkengken[DIPUNDHAWUHAKEN]:larinye=mlajengipun:dikemanakan=dipunpundikaken:berparas=gadhah[KAGUNGAN] praen[PASURYAN]:ayu=ajeng:digunain=dipunangge[DIPUNAGEM]:baguslah=saelah:umurmu=umur[YUSWA] sampeyan[PANJENENGAN]:mengabarkan=ngabaraken:kelanjutan=kelajengan:kelanjutannye=kelajenganipun:dinikmati=dipun-nikmati:menjawabnye=mangsuli:siapkan=siapaken:jawanye=jawinipun:seringsering=asring-asring:seringseringlah=asring-asringa:membagi=mbagi:ngumpulin=ngempalaken:ngeliatin=ningali[MRIKSANI]:kursii=kursi:yaudah=nggih sampun:pembawa=ingkang mbekta[NGASTA]:berperan=gadhah[KAGUNGAN] peran:kaya=sugih:bersanding=sandingan:terlengkap=paling jangkep:dilepas=dipuncopot[DIPUNLUKAR]:mudahnye=gampilipun:perihal=bab:dibekali=dipunsangoni:paparkan=medharaken:dipaparkan=dipunwedharaken:dirangkum=dipunrangkum:merabaraba=grayah-grayah:teruntuk=tumrap:dipasarkan=dipunpasaraken:judul=irah-irahan:berjudul=gadhah[KAGUNGAN] irah-irahan:menirukan=nuladhakaken:menirukannye=nuladhakaken:mengunggulkan=nginggilaken:diunggulkan=dipuninggilaken:didukung=dipunsengkuyung:dukungan=sengkuyungan:ditumbuhkan=dipunthukulaken:menentang=nentang:mereka=piyambakipun sedaya:merekanye=piyambakipun sedaya:terluas=paling wiyar:bepergian=kesah[TINDAK]:kegunaan=ginanipun:melunasi=nglunasi:bernafas=ambekan:dipisahkan=dipunpisahaken:perbatasan=wates:batas=wates:batasnye=watesipun:ditembus=dipuntembus:diliputi=dipunliputi:catatan=cathetan:hewan=kewan:terlepas=copot[LUKAR]:menyatukan=ngempalaken:beragamnye=warni-warni:diakibatkan=dipunamargikaken:terbentuknye=kawujudipun:terbentuk=kewujud:dibentuk=dipunbentuk:diisolasi=dipunisolasi:memisahkan=misahaken:dikarang=dipunkarang:dagangnye=sadenipun:berdagangnye=nyadenipun:menyinggahi=ngampiri[MINARAKI]:singgahi=ngampiri[MINARAKI]:berdatangan=sami dugi[RAWUH]:dipersembahkan=dipunpersembahaken:berambut=gadhah[KAGUNGAN] rambut[RIKMA]:mengelilingi=ngubengi:manusianye=manungsanipun:berkulit=gadhah[KAGUNGAN] kulit:lamanye=laminipun[DANGUNIPUN]:diselidiki=dipunslidiki:terpojoknye=kepojokipun:mengibarkan=ngibaraken:penggantian=panggantosan:dilangsungkan=dipunlampahaken[DIPUNTINDAKAKEN]:langsungkan=lampahaken[TINDAKAKEN]:meresmikan=ngresmikaken:pemerintahan=pamarintahan:luasnye=wiyaripun:digabungkan=dipunkempalaken:digabung=dipunkempalaken:turut=tumut[NDEREK]:perubahan=ebah:bagianbagian=perangan-perangan:bagianbagiannye=perangan-peranganipun:kenyataan=kasunyatan:pengetahuan=kawruh:pengetahuannye=kawruhipun:pengertianye=pangertosipun:pengertian=pangertosan:luarnye=jawinipun:jawanye=jawinipun:mauan=purunan[KERSANAN]:diumumin=dipunumumaken:diinfokan=dipunwartosaken:infokan=wartosaken:kerjabakti=gugur gunung:bawaan=bektan:terbawa=kebekta[KEASTA]:saneslain=sanes-sanes:disertai=dipuntumuti[DIPUNDEREKI]:diiringi=dipuntumuti[DIPUNDEREKI]:besarbesar=ageng-ageng:menyaksikannye=ningali[MRIKSANI]:disahkan=dipunsahaken:dialami=dipunalami:menanyai=nakeni[MUNDHUT PRIKSA]:cobaan=coban:temui=panggihi:jumpai=panggihi:bantuannye=rencanganipun:telanjang=lukar rasukan[AGEMAN]:disembuhkan=dipunmantunaken:dahinye=bathukipun[PALARAPANIPUN]:dahiku=bathuk[PALARAPAN] kula:dahimu=bathuk[PALARAPAN] sampeyan [PANJENENGAN]:sepotong=sapalih:adakah=napa[MENAPA] wonten:pipinye=pipinipun[PANGARASANIPUN]:pipiku=pipi[PANGARASAN] kula:pipimu=pipi[PANGARASAN] sampeyan[PANJENENGAN]:bertelur=nigan:rambutnye=rambutipun[RIKMANIPUN]:wayang=ringgit:wayangnye=ringgitipun:warga=wargi:warganye=warginipun:suasana=kawontenan:suasananye=kawontenanipun:menyenangkan=ngremenaken:menyenangi=ngremeni:senangi=remeni:sukai=remeni:alias=utawi:bertandang=mampir[PINARAK]:mencalonkan=nyalonaken:beragam=warni-warni:kue=jajan:pergunakan=ngangge[NGAGEM]:seraya=kalih:menjadwalkan=njadwalaken:sangetgus=ngiras:sekalian=sami:seadanye=sawontenipun:mengingatkannye=ngemutaken piyambakipun[PANJENENGANIPUN]:pembelajaran=pasinaon:lahirnye=wedalipun[WIYOSIPUN]:lahirkan=wedalaken[WIYOSAKEN]:kerasnye=atosipun|soranipun:kematian=kapejahan[KASEDAN]:diimbau=dipunwantos-wantos:dihimbau=dipunwantos-wantos:mengimbau=wantos-wantos:menghimbau=wantos-wantos:imbau=wantos-wantos:himbau=wantos-wantos:selesainye=bibaripun:terselesaikan=kerampungaken:mencintai=nresnani:pembalasan=piwangsulan:ikutikut=numuti[NDEREKI]:ingatlah=emuta:kepadamu=kalih sampeyan[PANJENENGAN]:membantunye=ngrencanginipun:kiranye=kintenipun:dipertimbangkan=dipunpertimbangaken:pertimbangkan=pertimbangaken:didapatkan=dipunangsal[DIPUNKEPARINGAN]:dilansir=dipunlansir:tekankan=petekaken:melangsungkan=nglampahaken[NINDAKAKEN]:melihatku=sumerep[PRIKSA] kula:melihatmu=sumerep[PRIKSA] sampeyan[PANJENENGAN]:menuduhku=mastani kula:menuduhmu=mastani sampeyan[PANJENENGAN]:menunjukku=nedah kula:menunjukmu=nedah sampeyan[PANJENENGAN]:sehabis=satelas:seharian=sadinten:menyesuaikan=nyamikaken:sesuai=cocog:bakar=besmi:dibakar=dipunbesmi:laksanakan=estokaken:rembug=rembag:usahakan=estokaken:sekedarnye=manda-manda:sekadarnye=manda-manda:berteman=kancan:musyawarah=rembag:menurun=mandhap[NEDHAK]:mengira=nginten:bacanye=waosipun:namamu=nami[ASMA] sampeyan[PANJENENGAN]:namaku=nami[ASMA] kula:membedakanmu=mbentenaken sampeyan[PANJENENGAN]:membedakanku=mbentenaken kula:tentangmu=bab sampeyan[PANJENENGAN]:tentangku=bab kula:anggap=anggep:juku=juku:bermimpi=nyupena:larimu=mlajengipun sampeyan[PANJENENGAN]:lariku=mlajengipun kula:diselesaikan=dipunrampungaken:berseragam=ngangge[NGAGEM] seragam:singkat=enggal:singkatnye=enggalipun:singkatmu=enggalipun sampeyan[PANJENENGAN]:singkatku=enggalipun kula:penegas=paneges:membuatmu=ndamel sampeyan[PANJENENGAN]:membuatku=ndamel kula:memikat=mikat:direstui=dipunrestui:memuncaki=nginggili:bergontaganti=gantos-gantos:anganangan=angen-angen:angan=angen:khayalan=angen-angen:juluki=wastani:semudah=sagampil:didahului=dipunrumiyini:berprilaku=gadhah[KAGUNGAN] lampahan[TINDAKAN]:dikenakannye=dipunanggenipun[DIPUNAGEMIPUN]:malumalu=lingsem:dahulukala=jaman semanten:sekalipun=sapisana:pemajuan=pamajengan:terbaru=paling enggal:dicatat=dipunserat:terbarunye=paling enggalipun:ngriku=ngriku:berkepala=gadhah[KAGUNGAN] sirah[MUSTAKA]:sepulang=sawangsul[SAKONDUR]:sesingkatsingkatnye=saenggal-enggalipun:membasahi=nelesi:dibasahi=dipuntelesi:mencicipi=nyicipi:bertekad=gadhah[KAGUNGAN] tekad:mengenai=ngengingi:terkena=kenging[KEPARENG]:mempercayainye=mitadosi:dipetik=dipunpetik:mengulanginye=mangsuli:dilirik=dipunlirik:ditebak=dipuntebak:merindukan=nresnani:rindu=tresna:dirindukan=dipuntresnani:tentang=bab:bertebaran=pating slebar:memperingatkannye=mengetaken:berserakan=pating slebar:terwujudlah=kewujud lah:terjatuh=dhawah:bermata=amata:menonjol=nonjol:ditemani=dipunkancani:tubuhnye=badanipun[SALIRANIPUN]:tahutahu=sumerep-sumerep:tahutahunye=sumerep-sumerep:menggunggah=ngunggah:terpancar=kepancar:ditangkap=dipuncepeng:beralih=ngalih:tersangkut=kesangkut:apik=sae:kalahnye=kawonipun:keberaniannye=kawantunanipun:keberanian=kawantunan:setahun=sawarsa:bagaimanakah=kados pundi:terpecah=kepecah:belahlah=belaha:jugalah=ugia:kebenaran=keleresan:tertukar=kelintu:beralih=pindhah[JENGKAR]:ditawari=dipuntawini:pertemuannye=pepanggihanipun:dipimpin=dipun pangangeng:meningkatnye=minggahipun:beritaberitanye=wartos-wartosipun:disunting=dipunsunting:terendah=paling andhap:kakaknye=kakangipun[RAKANIPUN]:kpd=kalih[kaliyan]:menurutku=midherek kula:menurutmu=midherek sampeyan[PANJENENGAN]:adikku=adhi[RAYI] kula:adikmu=adhi[RAYI] sampeyan[PANJENENGAN]:pergantian=panggantosan:ditempat=nten papan:rintangan=pambengan:menolak=nolak:ditolak=dipuntolak:dilantik=dipunlantik:membatasi=mbatesi:kesatu=kaping setunggal:besarbesaran=ageng-agengan:diikutinye=dipuntumuti[DIPUNDEREKI] piyambakipun[PANJENENGANIPUN]:diserahkan=dipunserahaken:dihadiri=dipundugini[DIPUNRAWUHI]:didatangi=dipundugini[DIPUNRAWUHI]:memberinye=nyukani[MARINGI] piyambakipun[PANJENENGANIPUN]:bahasanye=basanipun:dibawakan=dipunbektakaken[DIPUN-ASTAKAKEN]:perbuatannye=lampahanipun[TINDAKANIPUN]:alasannye=alesanipun:jalani=lampahi:jangankan=napa[MENAPA] malih:denganmu=kalih sampeyan[PANJENENGAN]:denganku=kalih kula:jawabanye=wangsulanipun:sampingnye=sisinipun:membiarkan=ngejoraken:meninggalkanmu=nilaraken sampeyan[PANJENENGAN]:meninggalkanku=nilaraken kula:mendekati=nyaketi:darimu=saking sampeyan[PANJENENGAN]:dariku=saking kula:dihubungi=dipunhubungi:hasilnye=kasilipun:diciduk=dipunciduk:ketersediaan=wontenipun:berganti=gumantos:terkalahkan=kekawonaken:tanamkan=tanemaken:nyali=kawantunan:rendahnye=andhapipun:diambillah=dipunpendhet[DIPUNPUNDHUT]:berkeinginan=gadhah[KAGUNGAN] kekajengan:orangwongtua=tiyang-tiyang sepuh:tidakkah=mbotena:itupun=puniku[MENIKA] nggih:memperbesar=ngagengi:perbesar=agengi:diperbesar=dipunagengi:diwakili=dipunwakili:selenggarakan=wontenaken:dirancang=dipunrancang:merumuskan=ngrumusaken:salahsatu=salah setunggal:direkayasa=dipunrekayasa:memesan=mesen:untukku=kangge kula:betapa=kepripunn:kotakota=kitha-kitha:dilayani=dipunlayani:merajut=ngrajut:memfasilitasi=masilitasi:terakhir=pungkasan:nomor=nomer:dipersilahkan=dipunsumanggakaken[DIPUNATURAKEN]:dipersilakan=dipunsumanggakaken[DIPUNATURAKEN]:persilakan=sumanggakaken[ATURAKEN]:persilahkan=sumanggakaken[ATURAKEN]:tukarkan=lintokaken:menukarkan=nglintokaken:perhatian=kawigatosan:perhatiannye=kawigatosanipun:diperhatikan=dipunwigatosaken:sesudahnye=sasampunipun:sesaat=sekedhap:diberangkatkan=dipunbidhalaken[DIPUNTINDAKAKEN]:berangkatkan=bidhalaken[TINDAKAKEN]:tersebar=kesebar:memimpin=mimpin:melayangkan=nglayangaken:disiarkan=dipunsiaraken:didampingi=dipundampingi:dibayangi=dipunbayangi:menyerap=rumesepi:berpeluang=gadhah[KAGUNGAN] peluang:melampaui=ngedali[MIYOSI]:keterkaitan=sesambetan:keterkaitannye=sesambetanipun:berjumlah=sacacah:batasan=batesan:kesehariannye=sadinten-dintenipun:mendidik=mucal[NGASTA]:terbatabata=klenta-klentu:bercampur=kekempal:menjamin=njamin:dididik=dipunwucal[DIPUNASTA]:salahsatunye=salah setunggalipun:meronta=ngrontal:duga=dugi:meruntuhkan=ngrentahaken:menghuni=manggeni:bisakah=punapa[MENAPA] saged:hnye=namung[naming]:diperlihatkan=dipuntingalaken[DIPUNPRIKSAKAKEN]:diperlihatkannye=dipuntingalakenipun[DIPUNPRIKSAKAKENIPUN]:disyukuri=dipunsyukuri:mengikatkan=nangsuli:mengikati=nangsuli:mengikat=nangsuli:melirik=nglirik:besarin=agengi:tautau=ngertos-ngertos:didasari=dipundhasari:ditekankan=dipunpetekaken:menekankan=metekaken:mencantumkan=nyantumaken:menyantumkan=nyantumaken:termutakhir=paling pungkasan:mengontak=ngontak:mengontaknye=ngontakipun:melontarkan=nglontaraken:benerbener=saestu:diselingi=dipunsambi:menyelingi=nyambi:selingi=sambi:diselinginye=dipunsambinipun:menyelinginye=nyambinipun:selinginye=sambinipun:menumbangkan=ngrebahaken:menghempaskan=ngawonaken:dijelasin=dipunjlentrehaken:incar=incer:diincar=dipunincer:mengincar=ngincer:dimaklumi=dipunmaklumi:suamiistri=jaler-estri[KAKUNG-PUTRI]:batubata=banon:itik=kambangan:pembicaraan=wicanten[NGENDIKA]:menggerogoti=nggragoti:disamakan=dipunsamikaken:membebani=mbebani:dipupuk=dipunpupuk:kuping=kuping[TALINGAN]:bisanye=sagedipun:inikan=puniki[MENIKA] kan:merugikan=ngrugikaken:melamar=nglamar:menghampiriku=murugi[NGRAWUHI] kula:menghampirimu=murugi[NGRAWUHI] sampeyan[PANJENENGAN]:menghadiri=ndugini[NGRAWUHI]:menyalahkan=nyalahaken:minumannye=wedangipun[UNJUKANIPUN]:semula=saderengipun:sebegitu=samekaten:hangat=anget:ruparupa=rupi-rupi:datangnye=duginipun[RAWUHIPUN]:beserta=kalih[kaliyan]:menjajakan=nawikaken:siangsiang=siyang-siyang:soresore=sonten-sonten:malammalam=ndalu-ndalu:kening=bathuk[PALARAPAN]:termahal=paling awis:saku=sak:apanye=punapa-nipun[MENAPA-NIPUN]:janda=randa:temuan=panggihan:temuannye=panggihanipun:mempraktikkannye=mraktekakenipun:mempraktikkan=mraktekaken:hafalkan=apal-aken:menunggumu=ngentosi sampeyan[PANJENENGAN]:menungguku=ngentosi kula:ngrikulah=ngrikua:berbahagia=bingah:bahagia=bingah:tanyai=takeni[MUNDHUT PRIKSA]:pengen=kajeng:pingin=kajeng:nawar=ngawis:dibuatnye=dipundamelipun:dibayangkan=dipunbayangaken:lanjutnye=lajengipun:menyimpan=nyimpen:sedemikian=sa-mekaten:dibukukan=dipunbukukaken:dibukukannye=dipunbukukakenipun:terbukti=kebukti:dikhususkan=dipunkhususaken:dimintai=dipuntedha[DIPUNSUWUN]:dipimpinnye=dipun pangangengipun:menyempurnakan=nyempurnakaken:disempurnakan=dipunsempurnakaken:engku=engku:sangetan=ngiras:menindaklanjutinye=nindak-lajengakenipun:menindaklanjuti=nindak-lajengaken:menyiapkan=nyiapaken:diluncurkannye=dipunluncurakenipun:diajari=dipunwucal:diajarin=dipunwucal:kuucapkan=kula sanjangaken[ATURAKEN]:kauucapkan=sampeyan[PANJENENGAN] sanjangaken[ATURAKEN]:perdesaan=padhusunan:pedesaan=padhusunan:tahunnye=warsanipun:dihubungkan=dipunhubungaken:hubungkan=hubungaken:menata=nata:warnawarni=warni-warni:menempel=nempel:menempelkan=nempelaken:berkelanjutan=gadhah[KAGUNGAN] lajenganipun:didalami=dipunlebeti:didalaminye=dipunlebetinipun:mendalaminye=nglebetinipun:penelitian=panaliten:menyermati=nyermati:diuntungkan=dipununtungaken:ditunjukkan=dipuntedahaken:mengindahkan=ngindahaken:meneliti=neliti:menyumbang=nyumbang:mengeringkan=ngakingaken:membakarnye=mbesmipun:memuji=muji:dibangun=dipunbangun:contohcontoh=tuladha-tuladha:barangsiapa=sinten tiyangipun:bilangin=sanjangaken[ATURAKEN]:mengendalikan=ngendalikaken:ginii=niki[MENIKA]:gituu=niku[MENIKA]:contohnye=tuladhanipun:bercukur=cukuran[PARASAN]:cukuran=cukuran[PARASAN]:huruf=aksara:berhuruf=gadhah[KAGUNGAN] aksara:berstatus=gadhah[KAGUNGAN] status:hasil=kasil:enggakenggak=mboten-mboten:enggaengga=mboten-mboten:tidaktidak=mboten-mboten:tetaplah=tetepa:menamainye=mastaninipun:berdekatan=celak/caket:bukanlain=sanes-sanes:mengetes=ngetes:berkuasa=gadhah[KAGUNGAN] kuwaos:lembut=alus:dikelompokkan=dipunperangaken:pekan=pena:jawabanmu=wangsulan sampeyan[PANJENENGAN]:jawabanku=wangsulan kula:jawabmu=wangsulan sampeyan[PANJENENGAN]:jawabku=wangsulan kula:membersihkannye=ngresekakenipun:bertugas=gadhah[KAGUNGAN] ayahan:tugaskan=kengken[DHAWUHAKEN]:perintahkan=kengken[DHAWUHAKEN]:keberadaanmu=kawontenan sampeyan[PANJENENGAN]:keberadaanku=kawontenan kula:pakenye=ngangge[NGAGEM]:baktinye=bektosipun:kerjabaktinye=gugur gunungipun:peralatannye=pirantosipun:peralatanperalatan=pirantos-pirantos:bermakna=gadhah[KAGUNGAN] makna:tertanam=ketanem:kandungan=kandhutan:terkandung=kekandhut:kehamilan=ngandhut[MBOBOT]:mengandung=ngandhut[MBOBOT]:dimandikan=dipun-adusi[DIPUNSIRAMI]:memandikan=ngadusi[NYIRAMI]:disiram=dipunsiram:dipakaikan=dipunanggeni[DIPUNAGEMI]:ketujuh=kaping pitu:pelaksanaan=lampahan[TINDAKAN]:hendaklah=kedahipun:mengotori=ngregedi:menyabet=nyabet:berturutturut=runtung-runtung:cowok=jaler[KAKUNG]:cewek=estri[PUTRI]:menekuni=nekuni:bulanan=wulanan:ngadain=ngawontenaken:doanye=donganipun:kegunaannye=ginanipun:gunanye=ginanipun:pundak=pundhak[PAMIDHANGAN]:puser=puser[TUNTUNAN]:udel=puser[NABI]:ajarkan=wucal:pisang=gedhang:pisangnye=gedhangipun:penemuan=pamanggihan:dimasukkannye=dipunlebetakenipun:dimasukannye=dipunlebetakenipun:kemasukan=kelebetan:berhadaphadapan=ajeng-ajengan:dieja=dipun-eja:manggil=ngulemi[NIMBALI]:memanggili=ngulemi[NIMBALI]:berantem=paben:pemberitahuan=wartos:menyuruhnye=ngengkenipun[NDAWUHIPUN]:memerintahnye=ngengkenipun[NDAWUHIPUN]:pertamanye=pertaminipun:mencatatkan=nyatetaken:dibatalkan=dipunwurungaken:dijalankannye=dipunlampahakenipun[DIPUNTINDAKAKENIPUN]:didapatkannye=dipunangsal[DIPUNKEPARINGAN] piyambakipun[PANJENENGANIPUN]:memberikannye=nyukani[MARINGAKEN] piyambakipun[PANJENENGANIPUN]:diakses=dipunakses:kalix=kaping:dikenai=dipunkenani:bertanding=tanding:kumpulannye=kempalanipun:dijatuhi=dipundhawahi:membunuh=mejahi[NYEDANI]:dipenjara=dipunpenjara:diunggahnye=dipun unggah ipun:menyampaikannye=sanjangakenipun[NGATURAKENIPUN]:beranggap=anggep:memojokkan=mojokaken:sangkutannye=sesambetanipun:bersangkutannye=sesambetanipun:bersangkutan=sesambetan:dipesan=dipunpesen:dipertaruhkan=dipun pertaruhaken:lewatkan=langkungi[WIYOSI]:melewatkan=langkungi[WIYOSI]:terdahulu=rumiyin:menyudutkan=nyudutaken:buktikan=buktikaken:pernikahan=emah-emah[KRAMA]:teuku=teuku:tengku=tengku:dibanjiri=dipunbenani:menjadikanmu=ndadosaken sampeyan[PANJENENGAN]:menjadikanku=ndadosaken kula:dijadwalkan=dipunjadwalaken:adiknye=adhinipun[RAYINIPUN]:diposisikan=dipunposisikaken:pentingpenting=wigatos-wigatos:terpeleset=kepleset:sejumlah=sacacah:disingkat=dipunsingkat:dicontoh=dipuntuladhani:beritakan=wartosaken:berlokasi=dumunung:daerah=laladan:daerahnye=laladanipun:nurani=manah[PANGGALIH]:nuraninye=manahipun[PANGGALIHIPUN]:pembahasan=wedharan:sesuatu=punapa-punapa[MENAPA-MENAPA]:beritakanlah=wartosakena:dibilang=dipunetang:dibilangin=dipunsukani[DIPUNPARINGI] ngertos:kucari=kula padosi:disambut=dipunsambut:adakan=wontenaken:tajuk=irah-irahan:bertajuk=gadhah[KAGUNGAN] irah-irahan:mengungkap=medhar:terungkap=kesingkab:tersingkap=kesingkab:mengarah=ngarah:kedatanganmu=duginipun[RAWUHIPUN] sampeyan[PANJENENGAN]:kedatanganku=duginipun[RAWUHIPUN] kula:sungkansungkan=pakewed:selebar=sawiyar:lebarnye=wiyaripun:tercepat=paling enggal:dicintai=dipuntresnani:mengetik=ngetik:dikutip=dipunkutip:dinobatkan=dipun nobataken:mengundangnye=ngulemi[NIMBALI] piyambakipun[PANJENENGANIPUN]:waspadai=waspaosi:diwaspadai=dipunwaspaosi:caricari=padosi:kucaricari=kula padosi:anakmu=lare[PUTRA] sampeyan[PANJENENGAN]:anakku=lare[PUTRA] kula:menggelapkan=metengaken:digelapkan=dipunpetengaken:gelapkan=petengaken:gelapnye=petengipun:gelap=peteng:diramaikan=dipunramekaken:pelestari=palestantun:kelestarian=kelestantunan:mengusulkan=ngusulaken:menuangkan=nuangaken:dimeriahkan=dipunramekaken:datanglah=dugia[RAWUHA]:belia=nem[TIMUR]:dikorbankan=dipunkorbanaken:minjamnye=nyambutipun[NGAMPILIPUN]:meminjamnye=nyambutipun[NGAMPILIPUN]:pinjamnye=nyambutipun[NGAMPILIPUN]:dipinjamnye=dipunsambutipun[DIPUNAMPILIPUN]:dipinjamkan=dipunsambutaken[DIPUNAMPILAKEN]:dipinjami=dipunsambuti[DIPUNAMPILI]:dipinjaminye=dipunsambuti[DIPUNAMPILI]:ditaruh=dipunsuka[DIPUNPARING]:menaruhnye=sukakakenipun[PARINGAKENIPUN]:kirimin=kintunaken:kirimkan=kintunaken:belajarin=sinauni:terbaca=kewaos:pegangan=cepengan:dikisahkan=dipuncriyosaken:meluaskan=miyari:mulutmu=cangkem[TUTUK] sampeyan[PANJENENGAN]:mulutku=cangkem[TUTUK] kula:bermulut=gadhah[KAGUNGAN] cangkem[TUTUK]:telingamu=kuping[TALINGAN] sampeyan[PANJENENGAN]:telingaku=kuping[TALINGAN] kula:telinganye=kupingipun[TALINGANIPUN]:tahun=warsa:jalanjalan={margi-margi, mlampah-mlampah}:diperolehnye=dipunangsal[DIPUNKEPARING] piyambakipun[PANJENENGANIPUN]:berkenalan=tetepangan:bergaul=tetepangan:ditunjuk=dipuntedah:ditentang=dipuntentang:yadnye=yadnya:ajukan=ajengaken:mengupah=nyukani[MARINGI] epah:pertahankan=pertahanaken:satusatu=setunggal-setunggal:adapula=wonten ugi:mengetikkan=ngetikaken:perlukan=betahaken:perkenalkanlah=tepangakena:kerana=amargi:tempatku=panggenan kula:tempatmu=panggenan sampeyan[PANJENENGAN]:gajahnye=limanipun:berhubung=amargi:tentu=tamtu:tentunye=tamtunipun:petunjuk=pitedah:petunjuknye=pitedahipun:sehubungan=sesambetan:mengamuk=ngamuk:disalahgunakan=dipunsalah-ginakaken:tungku=pawon:hadiri=dugi[RAWUHI]:sepeda=pit:mencarinye=madosinipun:berpengalaman=pengalaman:istriku=semah[GARWA] kula:istrimu=semah[GARWA] sampeyan[PANJENENGAN]:suamiku=semah[GARWA] kula:suamimu=semah[GARWA] sampeyan[PANJENENGAN]:kebiasaan=kalimrahan:biasanye=limrahipun:terburuburu=kesesa:keburu=kesesa:terburu=kesesa:keburuburu=kesesa:pelajarilah=sinaunia:pergunakanlah=anggea[AGEMA]:seingat=sa-emut:jatuhnye=dhawahipun:mengajarinye=mucalakenipun[NGASTAKAKENIPUN]:biarlah=napa kajengipun[MENAPA KERSANIPUN]:orangutan=orang utan:menantinanti=ngantos-antos:meluasi=miyar-aken:murahmurahan=mirah-mirahan:berbisul=wudunen[UNTAREN]:ajaran=wucalan:didikan=wucalan:komplit=jangkep:utuhnye=jangkepipun:komplitnye=jangkepipun:pusat=puser[TUNTUNAN]:perutnye=wetengipun[PADHARANIPUN]:perutku=weteng[PADHARAN] kula:perutmu=weteng[PADHARAN] sampeyan[PANJENENGAN]:kepalamu=sirah[MUSTAKA] sampeyan[PANJENENGAN]:kepalaku=sirah[MUSTAKA] kula:matanye=mripatipun[SOCANIPUN]:mataku=mripat[SOCA] kula:matamu=mripat[SOCA] sampeyan[PANJENENGAN]:hidungmu=irung[GRANA] sampeyan[PANJENENGAN]:hidungku=irung[GRANA] kula:hidungnye=irungipun[GRANANIPUN]:kerjamu=nyambut damelipun sampeyan[PANJENENGAN]:kerjaku=nyambut damelipun kula:menyirami=nyirami:semu=semu:kecelakaan=kacilakan:kerasan=kraos:kejatuhan=kedhawahan:tertimpa=kedhawahan:penghobi=pandhemen:jenis=jinis:pedas=pedhes:dasarnye=dhasaripun:dasar=dhasar:belajarlah=sinaua:kirikanannye=kiwa-tengenipun:kanankirinye=tengen-kiwanipun:berkurangnye=saya kirangipun:mempelajarinye=nyinaoni nipun:mengajakku=ngajak kula:mengajakmu=ngajak sampeyan[PANJENENGAN]:mengajaknye=ngajakipun:ditakuti=dipunajrihi:takuti=ajrihi:menakuti=ngajrih-ngajrihi:kudu=kedah:menakutnakuti=ngajrih-ngajrihi:bahaya=bebaya:pengajaran=piwucalan:beraneka=maneka:ndak=mboten:berapakah=sapinten:bolehkah=angsal[KEPARENG] mboten:balikan=wangsulan:diwarnai=dipunwarnani:setinggitingginye=sanginggil-inggilipun:dirapikan=dipunrapikaken:merapikan=ngrapikaken:menyingkat=nyingkat:ketiduran=ketileman[KESAREN]:nuraniku=manah[PANGGALIH] kula:nuranimu=manah[PANGGALIH] sampeyan[PANJENENGAN]:menambahi=nambahi:mengertinye=mangertosipun:mriku=mriku:tolong=tulung:menolong=nulung:keterangannye=katranganipun:keterangan=katrangan:memuatnye=ngewratipun:bersekolah=sekolah:disekolahkan=dipunsekolahaken:menyekolahkan=nyekolahaken:sekolahkan=sekolahaken:ditanami=dipuntanemi:baunye=mambetipun:tegak=jejeg:seluas=sa-wiyar:keselamatan=kawilujengan:terdekatnye=paling caketipun:memprotes=protes:sukar=sisah[SEKEL]:sukarnye=sisahipun[SEKELIPUN]:tergesa=kesesa:tergesagesa=kesesa:bolakbalik=wongsal-wangsul:dibolakbalik=dipunwongsal-wangsul:dibolakbaliknye=dipunwongsal-wangsulipun:berbantal=kajangan sirah:borgol=banda[BESTA]:borgolnye=bandanipun[BESTANIPUN]:diborgol=dipunbanda[DIPUNBESTA]:memborgol=mbanda[MBESTA]:buruburu=kesesa:melupakanmu=nyupekaken sampeyan[PANJENENGAN]:melupakanku=nyupekaken kula:hatiku=pamanah[PANGGALIH] kula:hatimu=pamanah[PANGGALIH] sampeyan[PANJENENGAN]:menyinari=nyinari:jawabnye=wangsulanipun:betulnye=leresipun:doank=mawon:mainmain=dolanan[AMENG-AMENG]:menanamnye=nanemipun:buatannye=damelanipun:pembuatnye=ingkang ndamel:menelan=nguntal/ngeleg:menyela=nyelani:penghujan=jawah:pepaya=kates:temanku=kanca kula:temanmu=kanca sampeyan[PANJENENGAN]:pepayanye=katesipun:kenyangkenyang=tuwuk-tuwuk:sekenyangnye=satuwukipun:sekenyangkenyangnye=satuwukipun:mencintaimu=nresnani sampeyan[PANJENENGAN]:menyintaiku=nresnani kula:menyintaimu=nresnani sampeyan[PANJENENGAN]:mencintaiku=nresnani kula:menyintai=nresnani:udang=urang:kuna=kina:bunyinye=ungelipun:tanganmu=tangan[ASTA] sampeyan[PANJENENGAN]:tanganku=tangan[ASTA] kula:sepinye=sepenipun:berasa=kraos:menahu=ngertos:kelakuan=lampahan[TINDAKAN]:kelakuannye=lampahanipun[TINDAKANIPUN]:tingkahlaku=lampahan[TINDAKAN]:tingkahlakunye=lampahanipun[TINDAKANIPUN]:anakanakmu=lare-lare[PEPUTRA] sampeyan[PANJENENGAN]:anakanakku=lare-lare[PEPUTRA] kula:lusa=mben:jemujemu=bosen-bosen:iku=iku:terpinggirkan=kesisihaken:makannye=nedha-nipun[DHAHARIPUN]:makanku=nedha[DHAHAR] kula:makanmu=nedha[DHAHAR] sampeyan[PANJENENGAN]:minumannye=ombenipun[UNJUKANIPUN]:minumanku=ombenipun[UNJUKANIPUN] kula:minumanmu=ombenipun[UNJUKANIPUN] sampeyan[PANJENENGAN]:minumnye=ombenipun[UNJUKIPUN]:minumku=ombenipun[UNJUKIPUN] kula:minummu=ombenipun[UNJUKIPUN] sampeyan[PANJENENGAN]:habisnye=telasipun:terserahlah=napa kajengipun[MENAPA KERSANIPUN] lah:biarlahlah=napa kajengipun[MENAPA KERSANIPUN]:dikaitkan=dipunkait-aken:puluhan=dasanan:dasaan=dasanan:duludulu=rumiyin:terdapatlah=wonten:biarin=napa kajengipun[MENAPA KERSANIPUN]:biarkan=napa kajengipun[MENAPA KERSANIPUN]:dilumpuhkan=dipunlumpuhaken:menembak=nembak:melambaikan=ngawe-awe:berbatasan=batesan:mengutuk=maiben:memicu=micu:bergerak=gerak:rahayu=rahajeng:berharga=aos:disayangkan=eman-eman:diurutkan=dipunurutaken:binatang=kewan:macammacam=macem-macem:menonjolkan=nonjolaken:memperhatikan=merhatikaken:terusmenerus=terusan:menyentuhnye=nyepengipun:dikirimi=dipunkintuni:mengirimi=ngintuni:dikomunikasikan=dipunkomunikasikaken:mencerna=nyerna:menyerna=nyerna:mengolah=ngolah:menuruti=midhereki:dimotivasikan=dipunmotivasikaken:menduniakan=ndonya aken:tersedia=wonten:sungainye=lepenipun:bersungai=gadhah[KAGUNGAN] lepen:biarkanlah:napa kajengipun[MENAPA KERSANIPUN]:tadinye=kala-waunipun:memangnye=saestunipun:bersepur=ngangge[NGAGEM] sepur:anjingnye=segawonipun:jawab=wangsuli:nulis=nyerat:tulisanmu=seratan sampeyan[PANJENENGAN]:tulisanku=seratan kula:kutulis=kula serat:kautulis=sampeyan[PANJENENGAN] serat:sangetpun=sapisana:sanasana=mrika-mrika:sinisini=mriki-mriki:situsitu=mriku-mriku:mahalan=awisan:maraknye=ramenipun:derasnye=deresipun:deras=deres:dibuatlah=dipundamela:kosakatakosakata=tembung-tembung:kosakata=tembung:berpengaruh=pengaruh:begitulah=mekatenlah:berpindah=pindhah[JENGKAR]:berkenaan=amargi:menyikapi=nyikapi:bukankah=sanes:kencang=kenceng:membuktikannye=mbuktikakenipun:terwariskan=dados tilaran:membunyikan=mungelaken:terbuka=kebikak:teropong=tropong:terakhirnye=pungkasanipun:digunakanlah=dipunangge[DIPUNAGEM]:ciptakan=damel:diciptakan=dipundamel:sekalikali=sapisan-pisan:kebanjiran=kabenan:kekecilan=kaliten:mendapatkannye=angsal[KEPARINGAN]:berjenis=jinis:pakek=angge[AGEM]:mengulas=ngulas:samasekali=babar pisan:berterbangan=sami mabur:pikirannye=pamanahipun[PANGGALIHIPUN]:pikiran=pamanah[PANGGALIH]:rembulan=wulan[CANDRA]:perasaan=pangraosan:berubahubah=ebah-ebah:anakbuah=rencang:bercocok=cocok:memeras=meres:dicinta=dipuntresna:dicintainye=dipuntresnanipun:terjadilah=kedados lah:tercapai=kelampahan:menjenguk=tuwi[SOWAN]:gagal=sande:kegagalan=sande:menjualnye=nyadenipun:persaudaraan=pasedherekan:pusingnye=ngelunipun[PUYENGIPUN]:menggebug=nggebag:digebug=digebag:gebug=gebag:sedap=eca:menggugah=nggigah:mengutip=ngutip:simpan=suka[PARING]:simpan=dekek:sejenak=sekedhap:giginye=untunipun[WAJA-NIPUN]:gigiku=untu[WAJA] kula:gigimu=untu[WAJA] sampeyan[PANJENENGAN]:mengenang=ngemut-emut:napa=napa[MENAPA]:penguasaan=panguwaosan:ketrampilan=katrampilan:keterampilan=katrampilan:ketrampilannye=katrampilanipun:keterampilannye=katrampilanipun:keterampilanmu=katrampilan sampeyan[PANJENENGAN]:keterampilanku=katrampilanipun kula:ketrampilanmu=katrampilan sampeyan[PANJENENGAN]:ketrampilanku=katrampilanipun kula:terpilihnye=kapilihipun:haruslah=kedah:jarinye=drijinipun[RACIKANIPUN]:keuletan=kaprigelan:ulet=prigel:uletnye=prigelipun:merakit=ngrakit:dirakit=dipunrakit:berhasil=kasil:berkompeten=kompeten:menyangkut=nyangkut:bilamana=kapan:dilambangkan=dipunlambangaken:lambangkan=lambangaken:berdialek=dialek:mencobacoba=nyobi-nyobi:judulnye=irah-irahanipun:tetanggatetangga=tangga-tangga:mengeluh=ngeluh:aluskan=alusaken:pendahuluan=bebuka:gaguna=mboten gina:dibahasa=dipunbasa:perginye=kesahipun[TINDAKIPUN]:kepergiannye=kesahipun[TINDAKIPUN]:tercantum=kacantum:terbarui=dipun-enggali:mencampuradukkan=nyampuradukaken:dikelirukan=dipunklentukaken:kelirunye=klentunipun:memeriksa=mriksa:menuding=nedah:belom=dereng:kalopun=sanadyan:salahkan=salahaken:disalahkan=dipunsalahaken:bersiap=siap:bersiapsiap=siap-siap:bersamamu=kalih sampeyan[PANJENENGAN]:bersamaku=kalih kula:harapkan=ajeng-ajeng:kuharapkan=kula ajeng-ajeng:kauharapkan=sampeyan[PANJENENGAN] ajeng-ajeng:harap=nedha[NYUWUN]:permohonan=panedha[PANYUWUN]:pesanpesan=pesen-pesen:hambatan=pambengan:hambatannye=pambenganipun:sejuk=isis:semilir=isis:dipertukarkan=dipunlintoni:kendala=pambengan:kendalanye=pambenganipun:secepat=saenggal:secepatcepatnye=saenggal-enggalipun:bisulan=wudunen[UNTAREN]:kedai=wande:kedainye=wandenipun:warungnye=wandenipun:himbauan=wantos-wantos:anjuran=wantos-wantos:daku=kula:siku=sikut:jenisnye=jinisipun:berdasar=adhedhasar:menyuburkan=nyuburaken:berlimpah=kathah:rintanganrintangan=pambengan-pambengan:hambatanhambatan=pambengan-pambengan:kendalakendala=pambengan-pambengan:rintanganrintangannye=pambengan-pambenganipun:hambatanhambatannye=pambengan-pambenganipun:kendalakendalanye=pambengan-pambenganipun:dikokohkan=dipunkiyataken:dikuatkan=dipunkiyataken:pembiasaan=ngulintenaken:orangtualah=tiyang sepuh lah:kewajaran=kalimrahan:biasa=limrah:wajar=limrah:umumnye=limrahipun:orangtuamu=tiyang sepuhipun sampeyan[PANJENENGAN]:orangtuaku=tiyang sepuhipun kula:mandinye=adusipun[SIRAMIPUN]:gantiin=gantosaken:kemarinnye=wingenanipun:berfikir=manah[NGGALIH]:kemarinye=mrikinipun:kesininye=mriki-nipun:kesananye=mrika-nipun:kesitunye=mriku-nipun:disininye=nten ngriki-nipun:disitunye=nten ngriku-nipun:disananye=nten ngrika-nipun:petunjukmu=pitedah sampeyan[PANJENENGAN]:petunjukku=pitedah kula:apinye=latunipun:kebiasaannye=kalimrahanipun:smoga=mugi:denger=mireng[MIDHANGET]:temennye=kancanipun:dirunut=dipunrunut:merunut=ngrunut:ditakdirkan=dipuntakdiraken:dicermati=dipuncermati:mendalam=lebet:dipermudah=dipungampili:halhal=bab-bab:terlambatnye=kantunipun:kosakatanye=tembungipun:daganganku=sadeanipun kula:daganganmu=sadeanipun sampeyan[PANJENENGAN]:jalanan=margi:kinerja=pandamelan:kinerjanye=pandamelanipun:pekerjaanku=pandamelanipun kula:pekerjaanmu=pandamelan sampeyan[PANJENENGAN]:terkhusus=mligi:perbuatanmu=lampahan[TINDAKAN] sampeyan[PANJENENGAN]:perbuatanku=lampahan[TINDAKAN] kula:kelakuanmu=lampahan[TINDAKAN] sampeyan[PANJENENGAN]:kelakuanku=lampahan[TINDAKAN] kula:tindakan=lampahan[TINDAKAN]:tindakannye=lampahanipun[TINDAKANIPUN]:tindakanmu=lampahan[TINDAKAN] sampeyan[PANJENENGAN]:tindakanku=lampahan[TINDAKAN] kula:dibahasakan=dipunbahasakaken:menerimanye=nampaninipun:kualalumpur=kuala lumpur:kesabaran=kantos:aroma=mambet:aromanye=mambetipun:sembuhnye=mantun-ipun:sembuhkan=mantunaken:disembuhkannye=dipunmantunakenipun:kesembuhan=mantun:seekor=setunggal:membimbingmu=mbimbing sampeyan[PANJENENGAN]:membimbingku=mbimbing kula:ketawa=nggujeng:pinjem=nyambut[NGAMPIL]:sayap=suwiwi:terarah=kearah:ninggalin=nilaraken:bukakan=bikakaken:menentu=temtu:sebab=amargi:sebabnye=amargi:bersepeda=ngepit:sepedaan=pit-pitan:dirawat=dipunreksa:kapanpun=kapana:kejujuran=jujur:kerugian=tuni:diujarkan=dipunsanjangaken[DIPUNATURAKEN]:dituturkan=dipunsanjangaken[DIPUNATURAKEN]:ujarkan=sanjangaken[ATURAKEN]:yach=nggih:modal=pawitan:modalnye=pawitanipun:sorga=suwarga[SUWARGI]:perhari=per dinten:selisih=kaot:selisihnye=kaotipun:permulaan=wiwitan:permulaannye=wiwitanipun:tinggalnye=manggenipun:barusan=nembeke:tunggui=tenggani:ditungguin=dipuntenggani:nungguin=nenggani:adek=adhi[RAYI]:diutus=dipun-utus:wisuhnye=wisuhipun[WIJIKIPUN]:wisuhku=kula wisuh[WIJIK]:wisuhmu=sampeyan[PANJENENGAN] wisuh[WIJIK]:rauppnye=raupipun[SURYANIPUN]:rauppku=kula raup[SURYAN]:rauppmu=sampeyan[PANJENENGAN] raup[SURYAN]:kijang=kidang:kijangnye=kidangipun:kecepatannye=enggalipun:menyombongkan=nyombongaken:pantasnye=patut ipun:serius=saestu:disucikan=dipunsucikaken:demikianlah=mekaten lah:permisi=permisi/amit[KULA NUWUN]:ketimur=ngetan:kebarat=ngilen:keutara=ngaler:keselatan=ngidul:numpang=nderek:canggung=pakewed:canggungnye=pakewedipun:batubatanye=banonipun:muntahan=luntakan:mengasyikkan=ngremenaken:fotokan=potokaken:mengakrabkan=ngakrabaken:nangis=nangis[MUWUN]:kayunye=kajengipun:kayumu=kajengipun sampeyan[PANJENENGAN]:kayuku=kajengipun kula:mengejarnye=mbujengipun:kukejar=kula bujeng:kaukejar=sampeyan[PANJENENGAN] bujeng:terkejar=kebujeng:mengejarmu=mbujeng sampeyan[PANJENENGAN]:mengejarku=mbujeng kula:berlarinye=mlajengipun:melihara=ngingah:buatnye=damelipun:membohongi=ndorani:mengelabui=ndorani:tersulit=paling sisah[SEKEL]:sulitnye=sisahipun[SEKELIPUN]:kesulitanku=kesisahanipun[KESEKELANIPUN] kula:kesulitanmu=kesisahanipun[KESEKELANIPUN] sampeyan[PANJENENGAN]:melarikan=mlajengaken:melarikannye=mlajengakenipun:melarikanku=mlajengaken kula:melarikanmu=mlajengaken sampeyan[PANJENENGAN]:menyebarluaskan=nyebarluasaken:disebarluaskan=dipunsebarluasaken:berpindahpindah=pindhah-pindhah:ajari=wucalaken[ASTAKAKEN]:dihapus=dipunbusek:mengarsipkan=ngarsipaken:cepet=enggal:menghapusnye=mbusekipun:dihapusnye=dipunbusekipun:jumpa=panggih:teranyar=paling enggal:lanjutkan=lajengaken:ayahnye=bapanipun[RAMANIPUN]:bersihkan=resiki:memecahkan=mecahaken:dicantumkan=dipuncantumaken:milikmu=gadhahipun[KAGUNGANIPUN] sampeyan[PANJENENGAN]:milikku=gadhahipun[KAGUNGANIPUN] kula:bawalah=bekta[ASTA] lah:kaubawa=sampeyan[PANJENENGAN] bekta[ASTA]:kubawa=kula bekta[ASTA]:kuambil=kula pendhet[PUNDHUT]:kauambil=sampeyan[PANJENENGAN] pendhet[PUNDHUT]:disepelekan=dipunanggep alitan:menyepelekan=nganggep alitan:sepele=alitan:berdampak=murugaken:bahagiakan=bingahaken:diperluas=dipunwiyari:berupaya=upados:mengejek=moyoki:teliti=tlatos:kemuliaan=kamulyan:bulan=sasi:menerbangkan=ngaburaken:diterbangkan=dipunaburaken:kukatakan=kula sanjangaken[ATURAKEN]:kaukatakan=sampeyan[PANJENENGAN] sanjangaken[ATURAKEN]:cantiknye=elokipun:biarkanlah=napa kajengipun[MENAPA KERSANIPUN]:bercampurnye=kekempalipun:eratnye=kencengipun:semisal=sa-upami:umpamanye=upaminipun:diusahakan=dipun-usahakaken:memeroleh=angsal[KEPARING]:memerolehnye=angsal[KEPARINGAN]:ngapangapain=pripun-pripunn:ngapa=napa[MENAPA]:diizinkan=dipunkengingaken[DIPUNPARENGAKEN]:masasih=napa[MENAPA] leres:terpaku=kepaku:tertentu=tertamtu:menyempatkan=nyempet aken:sempatkan=sempet aken:membantuku=ngrencangi kula:membantumu=ngrencangi sampeyan[PANJENENGAN]:lezat=eca:lezatnye=ecanipun:balaslah=wangsuli lah:menghargainye=ngaosi nipun:menghargaiku=ngaosi kula:menghargaimu=ngaosi sampeyan[PANJENENGAN]:berkalikali=kaping pinten-pinten:berkalikalinye=kaping pinten-pintenipun:membalasnye=mangsuli nipun:berulangulang=wongsal-wangsul:berulang=kewangsul:ulangi=wangsuli:keuntungan=untung:keuntungannye=untungipun:kerugiannye=tuni nipun:dong=oh:pengembalian=angsul-angsul:kubuat=kula damel:kaubuat=sampeyan[PANJENENGAN] damel:sobat=mitra:selamatkan=wilujengaken[SUGENGAKEN]:wajibkan=wajibaken:disuntikkan=dipunsuntikaken:disewakan=dipunsewakaken:dijangkau=dipuncawel:nyari=madosi:warisannye=tilaranipun:warisanku=tilaran kula:warisanmu=tilaran sampeyan[PANJENENGAN]:tertinggalnye=kantunipun:temantemanku=kanca-kanca kula:temantemanmu=kanca-kanca sampeyan[PANJENENGAN]:kepercayaannye=kapitadosanipun:keutuhan=wetahipun:konten=babagan:hubungan=sesambetan:hubungannye=sesambetanipun:memburuk=saya awon:dikau=sampeyan[PANJENENGAN]:berkeluarga=emah-emah[KRAMA]:kita=kita[KULA LAN PANJENENGAN]:menginput=mlebetaken:mengasihani=mesakaken:mendenda=ndenda";
      Tlanslator.dictionaryParse = function (dictionaryAsText) {
        var returnValue = {};
        var entriesAsStrings = dictionaryAsText.split(":");
        for (var i = 0; i < entriesAsStrings.length; i++) {
          var entryAsString = entriesAsStrings[i];
          var entryAsKeyAndValue = entryAsString.split("=");
          var key = entryAsKeyAndValue[0];
          var value = entryAsKeyAndValue[1];
          returnValue[key] = value;
        }
        return returnValue;
      };
      Tlanslator.prototype.translateAndInterleave = function (
        passageToTranslate,
        charsPerLine
      ) {
        var passageInterleaved = "";
        var TiT = passageToTranslate
          .toLowerCase()
          .split("a.")
          .join("a. ")
          .split("b.")
          .join("b. ")
          .split("c.")
          .join("c. ")
          .split("d.")
          .join("d. ")
          .split("e.")
          .join("e. ")
          .split("f.")
          .join("f. ")
          .split("g.")
          .join("g. ")
          .split("h.")
          .join("h. ")
          .split("i.")
          .join("i. ")
          .split("j.")
          .join("j. ")
          .split("k.")
          .join("k. ")
          .split("l.")
          .join("l. ")
          .split("m.")
          .join("m. ")
          .split("n.")
          .join("n. ")
          .split("o.")
          .join("o. ")
          .split("p.")
          .join("p. ")
          .split("q.")
          .join("q. ")
          .split("r.")
          .join("r. ")
          .split("s.")
          .join("s. ")
          .split("t.")
          .join("t. ")
          .split("u.")
          .join("u. ")
          .split("v.")
          .join("v. ")
          .split("w.")
          .join("w. ")
          .split("x.")
          .join("x. ")
          .split("y.")
          .join("y. ")
          .split("z.")
          .join("z. ")
          .split("a,")
          .join("a, ")
          .split("b,")
          .join("b, ")
          .split("c,")
          .join("c, ")
          .split("d,")
          .join("d, ")
          .split("e,")
          .join("e, ")
          .split("f,")
          .join("f, ")
          .split("g,")
          .join("g, ")
          .split("h,")
          .join("h, ")
          .split("i,")
          .join("i, ")
          .split("j,")
          .join("j, ")
          .split("k,")
          .join("k, ")
          .split("l,")
          .join("l, ")
          .split("m,")
          .join("m, ")
          .split("n,")
          .join("n, ")
          .split("o,")
          .join("o, ")
          .split("p,")
          .join("p, ")
          .split("q,")
          .join("q, ")
          .split("r,")
          .join("r, ")
          .split("s,")
          .join("s, ")
          .split("t,")
          .join("t, ")
          .split("u,")
          .join("u, ")
          .split("v,")
          .join("v, ")
          .split("w,")
          .join("w, ")
          .split("x,")
          .join("x, ")
          .split("y,")
          .join("y, ")
          .split("z,")
          .join("z, ")
          .split(".a")
          .join(". a")
          .split(".b")
          .join(". b")
          .split(".c")
          .join(". c")
          .split(".d")
          .join(". d")
          .split(".e")
          .join(". e")
          .split(".f")
          .join(". f")
          .split(".g")
          .join(". g")
          .split(".h")
          .join(". h")
          .split(".i")
          .join(". i")
          .split(".j")
          .join(". j")
          .split(".k")
          .join(". k")
          .split(".l")
          .join(". l")
          .split(".m")
          .join(". m")
          .split(".n")
          .join(". n")
          .split(".o")
          .join(". o")
          .split(".p")
          .join(". p")
          .split(".q")
          .join(". q")
          .split(".r")
          .join(". r")
          .split(".s")
          .join(". s")
          .split(".t")
          .join(". t")
          .split(".u")
          .join(". u")
          .split(".v")
          .join(". v")
          .split(".w")
          .join(". w")
          .split(".x")
          .join(". x")
          .split(".y")
          .join(". y")
          .split(".z")
          .join(". z")
          .split(",a")
          .join(", a")
          .split(",b")
          .join(", b")
          .split(",c")
          .join(", c")
          .split(",d")
          .join(", d")
          .split(",e")
          .join(", e")
          .split(",f")
          .join(", f")
          .split(",g")
          .join(", g")
          .split(",h")
          .join(", h")
          .split(",i")
          .join(", i")
          .split(",j")
          .join(", j")
          .split(",k")
          .join(", k")
          .split(",l")
          .join(", l")
          .split(",m")
          .join(", m")
          .split(",n")
          .join(", n")
          .split(",o")
          .join(", o")
          .split(",p")
          .join(", p")
          .split(",q")
          .join(", q")
          .split(",r")
          .join(", r")
          .split(",s")
          .join(", s")
          .split(",t")
          .join(", t")
          .split(",u")
          .join(", u")
          .split(",v")
          .join(", v")
          .split(",w")
          .join(", w")
          .split(",x")
          .join(", x")
          .split(",y")
          .join(", y")
          .split(",z")
          .join(", z")
          .split(" naiknya")
          .join(" naik")
          .split(" trima")
          .join(" terima")
          .split(" mula-mula")
          .join(" mulanya")
          .split(" tepian ")
          .join(" tepi ")
          .split("\r")
          .join(" ")
          .split("\n")
          .join(" ")
          .split("- ")
          .join("-")
          .split(/[ ]+/)
          .join(" ")
          .split(".")
          .join(" . ")
          .split(",")
          .join(" , ")
          .split(" . 0")
          .join(".0")
          .split(" . 1")
          .join(".1")
          .split(" . 2")
          .join(".2")
          .split(" . 3")
          .join(".3")
          .split(" . 4")
          .join(".4")
          .split(" . 5")
          .join(".5")
          .split(" . 6")
          .join(".6")
          .split(" . 7")
          .join(".7")
          .split(" . 8")
          .join(".8")
          .split(" . 9")
          .join(".9")
          .split(" , 0")
          .join(",0")
          .split(" , 1")
          .join(",1")
          .split(" , 2")
          .join(",2")
          .split(" , 3")
          .join(",3")
          .split(" , 4")
          .join(",4")
          .split(" , 5")
          .join(",5")
          .split(" , 6")
          .join(",6")
          .split(" , 7")
          .join(",7")
          .split(" , 8")
          .join(",8")
          .split(" , 9")
          .join(",9")
          .split("â€”")
          .join(" â€” ")
          .split("â€“")
          .join(" â€” ")
          .split("â€³")
          .join('"')
          .split("â€²")
          .join("'")
          .split("â€œ")
          .join('"')
          .split("â€")
          .join('"')
          .split("â€ž")
          .join('"')
          .split("â€˜")
          .join("'")
          .split("â€™")
          .join("'")
          .split("=")
          .join(" = ")
          .split("!")
          .join(" ! ")
          .split("'")
          .join(" ' ")
          .split('"')
          .join(' " ')
          .split("?")
          .join(" ? ")
          .split(":")
          .join(" : ")
          .split(")")
          .join(" ) ")
          .split("(")
          .join(" ( ")
          .split("/")
          .join(" / ")
          .split(";")
          .join(" ; ")
          .split("&")
          .join(" & ")
          .split("â€¦")
          .join(" â€¦ ")
          .split("$")
          .join(" $ ")
          .split("*")
          .join(" * ")
          .split("duapuluh")
          .join("dua puluh")
          .split("tigapuluh")
          .join("tiga puluh")
          .split("empatpuluh")
          .join("empat puluh")
          .split("limapuluh")
          .join("lima puluh")
          .split("enampuluh")
          .join("enam puluh")
          .split("tujuhpuluh")
          .join("tujuh puluh")
          .split("delapanpuluh")
          .join("delapan puluh")
          .split("sembilanpuluh")
          .join("sembilan puluh")
          .split(" keduanya ")
          .join(" kedua nye ")
          .split(" ketiganya ")
          .join(" ketiga nye ")
          .split(" keempatnya ")
          .join(" keempat nye ")
          .split(" kelimanya ")
          .join(" kelima nye ")
          .split(" keenamnya ")
          .join(" keenam nye ")
          .split(" ketujuhnya ")
          .join(" ketujuh nye ")
          .split(" kedelapannya ")
          .join(" kedelapan nye ")
          .split(" kesembilannya ")
          .join(" kesembilan nye ")
          .split(" duanya ")
          .join(" dua nye ")
          .split(" tiganya ")
          .join(" tiga nye ")
          .split(" empatnya ")
          .join(" empat nye ")
          .split(" limanya ")
          .join(" lima nye ")
          .split(" enamnya ")
          .join(" enam nye ")
          .split(" tujuhnya ")
          .join(" tujuh nye ")
          .split(" delapannya ")
          .join(" delapan nye ")
          .split(" sembilannya ")
          .join(" sembilan nye ")
          .split(" kedua ")
          .join(" kee dua ")
          .split(" ketiga ")
          .join(" kee tiga ")
          .split(" keempat ")
          .join(" kee empat ")
          .split(" kelima ")
          .join(" kee lima ")
          .split(" keenam ")
          .join(" kee enam ")
          .split(" ketujuh ")
          .join(" kee tujuh ")
          .split(" kedelapan ")
          .join(" kee delapan ")
          .split(" kesembilan ")
          .join(" kee sembilan ")
          .split(" ratusnya ")
          .join(" ratus nye ")
          .split(" ribunya ")
          .join(" ribu nye ")
          .split(" jutanya ")
          .join(" juta nye ")
          .split(" puluhnya ")
          .join(" puluh nye ")
          .split("milyar")
          .join("miliar")
          .split("trilyun")
          .join("triliun")
          .split(" miliarnya ")
          .join(" miliar nye ")
          .split(" triliunnya ")
          .join(" triliun nye ");
        var T0T = TiT.split("kanlah ")
          .join("kan lah ")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" seperti halnya ")
          .join(" seperti dene ")
          .split(" seperti hal ")
          .join(" seperti dene ")
          .split(" dewasa ini ")
          .join(" dewasaini ")
          .split(" nggak ")
          .join(" tidak ")
          .split(" tak ")
          .join(" tidak ")
          .split(" ngga ")
          .join(" tidak ")
          .split(" gak ")
          .join(" tidak ")
          .split(" ga ")
          .join(" tidak ")
          .split(" terlalu jelek")
          .join(" kawonen")
          .split(" terlalu matang")
          .join(" kedalon")
          .split(" thun ")
          .join(" tahun ")
          .split(" masa iya ")
          .join(" napa iya ")
          .split(" masa sih")
          .join(" masa-sih")
          .split(" cantik jelita")
          .join(" ayu moblong-moblong")
          .split(" tinggal di ")
          .join(" manggen di ")
          .split(" petak umpet ")
          .join(" umpet-umpet-madu ")
          .split(" kelapa muda ")
          .join(" dawegan ")
          .split(" pecahan kaca")
          .join(" beling")
          .split(" pecahan genteng")
          .join(" wingkah")
          .split("tahu plet")
          .join("tahuu plet")
          .split("mu alai")
          .join("mu'alai")
          .split("tiang penyangga")
          .join("saka panyanggi")
          .split("gunung meletus")
          .join("gunung mbledhug")
          .split("saat saat")
          .join("saat-saat")
          .split(" wayang kulit")
          .join(" ringgit purwa")
          .split(" main hakim ")
          .join(" maen hakim ")
          .split("pendengaran sedang")
          .join("pendengaran sedeng")
          .split(" sedang yaitu ")
          .join(" sedeng yaitu ")
          .split(" disekitar")
          .join(" di sekitar")
          .split("sedikit demi sedikit")
          .join("sedikit makin sedikit")
          .split("sedapat mungkin")
          .join("sebisa mungkinn")
          .split("sebaik mungkin")
          .join("sebaik mungkinn")
          .split(" lama sekali")
          .join(" lama sanget")
          .split("puji pujian")
          .join("puji-pujian")
          .split("pernah sekali")
          .join("pernah sapisan")
          .split(" jgn ")
          .join(" jangan ")
          .split(" sampe ")
          .join(" sampai ")
          .split("celana pendek")
          .join("sruwal cekak")
          .split(" kaus")
          .join(" kaos")
          .split(" alas kaki ")
          .join(" kasut ")
          .split(" sok cantik")
          .join(" kemajeng")
          .split(" sempet")
          .join(" sempat")
          .split(" sempat bertemu")
          .join(" menangi bertemu")
          .split(" tanpa alas kaki")
          .join(" nyeker")
          .split("asal palu")
          .join("asal paluu")
          .split("dari palu")
          .join("dari paluu")
          .split(" teramat ")
          .join(" sangat ")
          .split(" percaya sekali")
          .join(" percaya sanget")
          .split("6 lalu")
          .join("6 silam")
          .split("7 lalu")
          .join("7 silam")
          .split("8 lalu")
          .join("8 silam")
          .split("9 lalu")
          .join("9 silam")
          .split("tiba tiba")
          .join("tiba-tiba")
          .split(" lebih baik")
          .join(" lebih sae")
          .split(" ikat pinggang")
          .join(" sabuk")
          .split(" batu asah")
          .join(" wungkal")
          .split(" tebak tebakan")
          .join(" badek-badekan")
          .split(" benang kusut")
          .join(" benangrawud")
          .split("satu sama lain")
          .join("satu dengan bukan")
          .split("zaman")
          .join("jaman")
          .split("jaman dahulu")
          .join("jaman semanten")
          .split("jaman dulu")
          .join("jaman semanten")
          .split("dulu dulu")
          .join("duludulu")
          .split("dahulu kala")
          .join("dahulukala")
          .split("dulu kala")
          .join("dahulukala")
          .split("sodara")
          .join("saudara")
          .split(" baik bu,")
          .join(" baikk bu,")
          .split(" baik pak,")
          .join(" baikk pak,")
          .split(" pukul 1")
          .join(" jam 1")
          .split(" tanda lahir")
          .join(" toh")
          .split("]")
          .join(" ] ")
          .split("[")
          .join(" [ ")
          .split(" batang pisang")
          .join(" kedebog pisang")
          .split(" berpangku tangan")
          .join(" ngandelaken")
          .split(" berulang tahun")
          .join(" ulang tahun")
          .split(" halaman rumah")
          .join(" latar rumah")
          .split("sudah jinak")
          .join("sudah tutut")
          .split("uang saku")
          .join("sangu")
          .split(" jalan raya")
          .join(" margi ageng")
          .split(" tahi ")
          .join(" tai ")
          .split(" tai lalat")
          .join(" andeng-andeng")
          .split(" naik motor")
          .join(" menaiki motor")
          .split(" naik pesawat")
          .join(" menaiki pesawat")
          .split(" naik becak")
          .join(" menaiki becak")
          .split(" naik bus")
          .join(" menaiki bus")
          .split(" naik kereta")
          .join(" menaiki kereta")
          .split(" naik andong")
          .join(" menaiki andong")
          .split(" naik delman")
          .join(" menaiki delman")
          .split(" naik kuda")
          .join(" menaiki kuda")
          .split("ratus satu tril")
          .join("ratus setunggal tril")
          .split("ratus dua tril")
          .join("ratus kalih tril")
          .split("ratus tiga tril")
          .join("ratus tigaa tril")
          .split("ratus empat tril")
          .join("ratus sekawan tril")
          .split("ratus lima tril")
          .join("ratus gangsal tril")
          .split("ratus enam tril")
          .join("ratus enem tril")
          .split("ratus tujuh tril")
          .join("ratus pitu tril")
          .split("ratus delapan tril")
          .join("ratus wolu tril")
          .split("ratus sembilan tril")
          .join("ratus sanga tril")
          .split("ratus satu mil")
          .join("ratus setunggal mil")
          .split("ratus dua mil")
          .join("ratus kalih mil")
          .split("ratus tiga mil")
          .join("ratus tigaa mil")
          .split("ratus empat mil")
          .join("ratus sekawan mil")
          .split("ratus lima mil")
          .join("ratus gangsal mil")
          .split("ratus enam mil")
          .join("ratus enem mil")
          .split("ratus tujuh mil")
          .join("ratus pitu mil")
          .split("ratus delapan mil")
          .join("ratus wolu mil")
          .split("ratus sembilan mil")
          .join("ratus sanga mil")
          .split(" dua puluh satu")
          .join(" selikur")
          .split(" dua puluh dua")
          .join(" kalih likur")
          .split(" dua puluh tiga")
          .join(" tiga likur")
          .split(" dua puluh empat")
          .join(" sekawann likur")
          .split(" dua puluh lima")
          .join(" selangkung")
          .split(" dua puluh enam")
          .join(" nemlikur")
          .split(" dua puluh tujuh")
          .join(" pitulikur")
          .split(" dua puluh delapan")
          .join(" wolulikur")
          .split(" dua puluh sembilan")
          .join(" sangalikur")
          .split(" puluh satu tril")
          .join(" puluh setunggal tril")
          .split(" puluh dua tril")
          .join(" puluh kalih tril")
          .split(" puluh tiga tril")
          .join(" puluh tigaa tril")
          .split(" puluh empat tril")
          .join(" puluh sekawan tril")
          .split(" puluh lima tril")
          .join(" puluh gangsal tril")
          .split(" puluh enam tril")
          .join(" puluh enem tril")
          .split(" puluh tujuh tril")
          .join(" puluh pitu tril")
          .split(" puluh delapan tril")
          .join(" puluh wolu tril")
          .split(" puluh sembilan tril")
          .join(" puluh sanga tril")
          .split(" puluh satu mil")
          .join(" puluh setunggal mil")
          .split(" puluh dua mil")
          .join(" puluh kalih mil")
          .split(" puluh tiga mil")
          .join(" puluh tigaa mil")
          .split(" puluh empat mil")
          .join(" puluh sekawan mil")
          .split(" puluh lima mil")
          .join(" puluh gangsal mil")
          .split(" puluh enam mil")
          .join(" puluh enem mil")
          .split(" puluh tujuh mil")
          .join(" puluh pitu mil")
          .split(" puluh delapan mil")
          .join(" puluh wolu mil")
          .split(" puluh sembilan mil")
          .join(" puluh sanga mil")
          .split(" puluh satu juta")
          .join(" puluh setunggal juta")
          .split(" puluh dua juta")
          .join(" puluh kalih juta")
          .split(" puluh tiga juta")
          .join(" puluh tigaa juta")
          .split(" puluh empat juta")
          .join(" puluh sekawan juta")
          .split(" puluh lima juta")
          .join(" puluh gangsal juta")
          .split(" puluh enam juta")
          .join(" puluh enem juta")
          .split(" puluh tujuh juta")
          .join(" puluh pitu juta")
          .split(" puluh delapan juta")
          .join(" puluh wolu juta")
          .split(" puluh sembilan juta")
          .join(" puluh sanga juta")
          .split(" puluh satu ribu")
          .join(" puluh setunggal ribu")
          .split(" puluh dua ribu")
          .join(" puluh kalih ribu")
          .split(" puluh tiga ribu")
          .join(" puluh tigaa ribu")
          .split(" puluh empat ribu")
          .join(" puluh sekawan ribu")
          .split(" puluh lima ribu")
          .join(" puluh gangsal ribu")
          .split(" puluh enam ribu")
          .join(" puluh enem ribu")
          .split(" puluh tujuh ribu")
          .join(" puluh pitu ribu")
          .split(" puluh delapan ribu")
          .join(" puluh wolu ribu")
          .split(" puluh sembilan ribu")
          .join(" puluh sanga ribu")
          .split("ratus satu ribu")
          .join("ratus setunggal ribu")
          .split("ratus dua ribu")
          .join("ratus kalih ribu")
          .split("ratus tiga ribu")
          .join("ratus tigaa ribu")
          .split("ratus empat ribu")
          .join("ratus sekawan ribu")
          .split("ratus lima ribu")
          .join("ratus gangsal ribu")
          .split("ratus enam ribu")
          .join("ratus enem ribu")
          .split("ratus tujuh ribu")
          .join("ratus pitu ribu")
          .split("ratus delapan ribu")
          .join("ratus wolu ribu")
          .split("ratus sembilan ribu")
          .join("ratus sanga ribu")
          .split("ratus satu juta")
          .join("ratus setunggal juta")
          .split("ratus dua juta")
          .join("ratus kalih juta")
          .split("ratus tiga juta")
          .join("ratus tigaa juta")
          .split("ratus empat juta")
          .join("ratus sekawan juta")
          .split("ratus lima juta")
          .join("ratus gangsal juta")
          .split("ratus enam juta")
          .join("ratus enem juta")
          .split("ratus tujuh juta")
          .join("ratus pitu juta")
          .split("ratus delapan juta")
          .join("ratus wolu juta")
          .split("ratus sembilan juta")
          .join("ratus sanga juta")
          .split(" tiga puluh")
          .join(" tigang dasa")
          .split(" empat puluh")
          .join(" sekawann dasa")
          .split(" lima puluh")
          .join(" seket")
          .split(" enam puluh")
          .join(" sewidak")
          .split(" tujuh puluh")
          .join(" pitung dasa")
          .split(" delapan puluh")
          .join(" wolung dasa")
          .split(" sembilan puluh")
          .join(" sangang dasa")
          .split(" dua belas")
          .join(" kalih welas")
          .split(" tiga belas")
          .join(" tigaa welas")
          .split(" empat belas")
          .join(" sekawan welas")
          .split(" lima belas")
          .join(" gangsal welas")
          .split(" enam belas")
          .join(" nembelas")
          .split(" tujuh belas")
          .join(" pitu las")
          .split(" delapan belas")
          .join(" wolu las")
          .split(" sembilan belas")
          .join(" sanga las")
          .split(" dua puluh")
          .join(" kalih dasa")
          .split(" dua ratus")
          .join(" kalih ratus")
          .split(" tiga ratus")
          .join(" tigang ratus")
          .split(" empat ratus")
          .join(" sekawann ratus")
          .split(" lima ratus")
          .join(" gangsal ratus")
          .split(" enam ratus")
          .join(" nem ratus")
          .split(" tujuh ratus")
          .join(" pitung ratus")
          .split(" delapan ratus")
          .join(" wolung ratus")
          .split(" sembilan ratus")
          .join(" sangang ratus")
          .split(" dua ribu")
          .join(" kalih ribu")
          .split(" tiga ribu")
          .join(" tigang ribu")
          .split(" empat ribu")
          .join(" sekawann ribu")
          .split(" lima ribu")
          .join(" gangsal ribu")
          .split(" enam ribu")
          .join(" nem ribu")
          .split(" tujuh ribu")
          .join(" pitung ribu")
          .split(" delapan ribu")
          .join(" wolung ribu")
          .split(" sembilan ribu")
          .join(" sangang ribu")
          .split(" satu juta")
          .join(" setunggal juta")
          .split(" dua juta")
          .join(" kalih juta")
          .split(" tiga juta")
          .join(" tigang juta")
          .split(" empat juta")
          .join(" sekawann juta")
          .split(" lima juta")
          .join(" gangsal juta")
          .split(" enam juta")
          .join(" nem juta")
          .split(" tujuh juta")
          .join(" pitung juta")
          .split(" delapan juta")
          .join(" wolung juta")
          .split(" sembilan juta")
          .join(" sangang juta")
          .split(" satu mil")
          .join(" setunggal mil")
          .split(" dua mil")
          .join(" kalih mil")
          .split(" tiga mil")
          .join(" tigang mil")
          .split(" empat mil")
          .join(" sekawann mil")
          .split(" lima mil")
          .join(" gangsal mil")
          .split(" enam mil")
          .join(" nem mil")
          .split(" tujuh mil")
          .join(" pitung mil")
          .split(" delapan mil")
          .join(" wolung mil")
          .split(" sembilan mil")
          .join(" sangang mil")
          .split(" satu tril")
          .join(" setunggal tril")
          .split(" dua tril")
          .join(" kalih tril")
          .split(" tiga tril")
          .join(" tigang tril")
          .split(" empat tril")
          .join(" sekawann tril")
          .split(" lima tril")
          .join(" gangsal tril")
          .split(" enam tril")
          .join(" nem tril")
          .split(" tujuh tril")
          .join(" pitung tril")
          .split(" delapan tril")
          .join(" wolung tril")
          .split(" sembilan tril")
          .join(" sangang tril")
          .split("hari minggu")
          .join("hari  ahad")
          .split(", lalu")
          .join(", lajeng")
          .split(" tempat pensil")
          .join(" tepak")
          .split(" tempat sekolah")
          .join(" sekolanan")
          .split(" terbang jawa")
          .join(" terbangg jawa")
          .split(" pembawa acara")
          .join(" pranatacara");
        var TlT = T0T.split(" mahu ")
          .join(" mau ")
          .split(" model lama")
          .join(" model lawas")
          .split("jauh sekali")
          .join("jauh sanget")
          .split(" potong rambut")
          .join(" cukur")
          .split("3 lalu")
          .join("3 silam")
          .split(" tanda tangan")
          .join(" tandatangan")
          .split(" kita semua ")
          .join(" kita sami ")
          .split(" hati nurani")
          .join(" nurani")
          .split(" nomor satu ")
          .join(" nomor setunggal ")
          .split(" barat daya")
          .join(" barat-daya")
          .split(" barat laut")
          .join(" barat-laut")
          .split(" timur laut")
          .join(" timur-laut")
          .split(" bermacam macam")
          .join(" bermacam-macam")
          .split(" bermacam-macam sekali")
          .join(" werna-werni sanget")
          .split(" habis ke ")
          .join(" bibar ke ")
          .split("desa lain")
          .join("desa sanes")
          .split("teman lama")
          .join("teman lawas")
          .split("sahabat lama")
          .join("sahabat lawas")
          .split(" lama di")
          .join(" lawas di")
          .split(" film lama")
          .join(" film lawas")
          .split(" selama lamanya")
          .join(" selama-lamanya")
          .split(" buat kita")
          .join(" untuk kita")
          .split("g sadar")
          .join("g sadarr")
          .split("menaikan harga")
          .join("mindakaken harga")
          .split("menaikkan harga")
          .join("mindakaken harga")
          .split(" gak papa")
          .join(" tak apa apa")
          .split(" ga papa")
          .join(" tak apa apa")
          .split(" mau kasih ")
          .join(" mau memberi ")
          .split(" ketawa ketiwi")
          .join(" kikak kikik")
          .split(" bagi bagi")
          .join(" bagi-bagi")
          .split(" buat saya")
          .join(" untuk saya")
          .split(" bagi saya")
          .join(" untuk saya")
          .split(" tukar menukar")
          .join(" tukar-menukar")
          .split(" lalat buah")
          .join(" lalat-buah")
          .split(" malam minggu")
          .join(" daluminggu")
          .split(" jangan percaya")
          .join(" jangan percaya")
          .split(" akhir akhir")
          .join(" akhir-akhir")
          .split(" lalu waktu")
          .join(" lajengipun waktu")
          .split(" lalu saat")
          .join(" lajengipun saat")
          .split("uang logam")
          .join("uang kricik")
          .split("menarik sekali")
          .join("menarik sanget")
          .split("sederhana sekali")
          .join("sederhana sanget")
          .split(" lalu pergi")
          .join(" lajeng pergi")
          .split("senin lalu")
          .join("senin wingi")
          .split("cerdas sekali")
          .join("cerdas sanget")
          .split("guru bantu")
          .join("guru-bantu")
          .split(" sama orang")
          .join(" dengan orang")
          .split(" lalu jadi")
          .join(" lajeng jadi")
          .split(" punya siapa")
          .join(" gadhahipun siapa")
          .split(" tinggal serumah")
          .join(" manggen serumah")
          .split(" tinggal bareng")
          .join(" manggen bareng")
          .split("masing masing")
          .join("masing-masing")
          .split("kita masing-masing")
          .join("kita piyambak-piyambak")
          .split("kalau lagi")
          .join("kalau sedang")
          .split("kalo lagi")
          .join("kalo sedang")
          .split(" orang baru")
          .join(" orang enggal")
          .split(" enggak mau")
          .join(" mboten setuju")
          .split(" mau gak mau")
          .join(" setuju tidak setuju")
          .split(" kaki lima")
          .join(" kaki-lima")
          .split(" tempat tinggal")
          .join(" tempat manggen")
          .split(" nelen obat")
          .join(" ngeleg obat")
          .split(" yang lagi")
          .join(" yang lagii")
          .split(" buat yang")
          .join(" ngge yang")
          .split(" buat yang")
          .join(" ngge yang")
          .split(" lagi musim")
          .join(" lagii musim")
          .split(" mau sama ")
          .join(" mau dengan ")
          .split(" sayang sama ")
          .join(" sayang dengan ")
          .split(" ngeliat ")
          .join(" melihat ")
          .split(" melihat ke")
          .join(" lihat ke")
          .split("nurut sama ")
          .join("nurut dengan ")
          .split("orang tua")
          .join("wongtua")
          .split(" naik mobil")
          .join(" menaiki mobil")
          .split(" baru tahu")
          .join(" nembe tahu")
          .split(" buat apa")
          .join(" untuk apa")
          .split(" antar jemput")
          .join(" antar-jemput")
          .split("batu bata")
          .join("batu-bata")
          .split("janji sama ")
          .join("janji dengan ")
          .split(" sama si ")
          .join(" dengan si ")
          .split(" lalu tiba")
          .join(" lajeng tiba")
          .split(" sekali kali")
          .join(" sekali-kali")
          .split(" keluar air")
          .join(" ngetuk air")
          .split(" kali ini")
          .join(" hari ini")
          .split(" buat kamu")
          .join(" untuk kamu")
          .split(" buat kami")
          .join(" untuk kami")
          .split(" ingin sekali")
          .join(" ingin sanget")
          .split(". lalu, ")
          .join(". lajeng, ")
          .split(") lalu,")
          .join(") rumiyin,")
          .split(" lagi maha ")
          .join(" lagiii maha ")
          .split(" akan hal ")
          .join(" mengenai hal ")
          .split("tahun sekali")
          .join("tahun sapisan")
          .split("temu sama ")
          .join("temu dengan ")
          .split("mudah mudahan")
          .join("mudah-mudahan")
          .split(" lalu lalang")
          .join(" lalu-lalang")
          .split(" potongan tahu")
          .join(" potongan tahuu")
          .split(" buat hadapi")
          .join(" untuk hadapi")
          .split(" jadi mungkin")
          .join(" jadi mungkinn")
          .split("telanjang bulat")
          .join("telanjang bral")
          .split("masa lalu")
          .join("masa rumiyin")
          .split("ak bernama")
          .join("ak punya nama")
          .split(" krama halus")
          .join(" krama alus")
          .split("hancur lebur")
          .join("hancur lantak")
          .split(" ketupat ")
          .join(" kupat ")
          .split(" kupat tahu")
          .join(" kupat tahuu")
          .split(" turun temurun")
          .join(" turun-temurun")
          .split(" sama mereka")
          .join(" dengan mereka")
          .split("wilayah masing-masing")
          .join("wilayah piyambak-piyambak")
          .split("seneng")
          .join("senang")
          .split("kemaren")
          .join("kemarin")
          .split("uari lalu")
          .join("uari wingi")
          .split("maret lalu")
          .join("maret wingi")
          .split(" kali per")
          .join(" kaping per")
          .split(" kaya di ")
          .join(" kayaa di ")
          .split(" kaya mau ")
          .join(" kayaa mau ")
          .split("sana sana")
          .join("sana-sana")
          .split("sana sini")
          .join("sana-sini")
          .split("sini sini")
          .join("sini-sini")
          .split('"ke ')
          .join('" ke ')
          .split("'ke ")
          .join("' ke ")
          .split(" lalu apa")
          .join(" lajengipun apa")
          .split("untuk sekali")
          .join("untuk sapisan")
          .split("lama kelamaan")
          .join("lama-kelamaan")
          .split(" isteri")
          .join(" istri")
          .split(" sang suami")
          .join(" sing-lanang")
          .split(" sang istri")
          .join(" sing-wadon")
          .split(" seorang suami")
          .join(" sing-lanang")
          .split(" seorang istri")
          .join(" sing-wadon")
          .split("mu 'ala")
          .join("mu'ala")
          .split("baik sekali")
          .join("baik sanget")
          .split("bagus sekali")
          .join("bagus sanget")
          .split("kotor sekali")
          .join("kotor sanget")
          .split(" meminta izin")
          .join(" poyan")
          .split(" minta izin")
          .join(" taren")
          .split(" make up")
          .join(" paesan")
          .split(" segala gala")
          .join(" segala-gala")
          .split("ayah ibu")
          .join("ayah-ibu")
          .split(" tahu,")
          .join(" tahu,")
          .split(" tahu mentah")
          .join(" tahuu mentah")
          .split(" tahu di ")
          .join(" tahuuu di ")
          .split(" uang koin")
          .join(" uang receh")
          .split("goreng tahu")
          .join("goreng tahuu")
          .split(" kali lipat")
          .join(" kali lipatt")
          .split(" terang bulan")
          .join(" padang bulan")
          .split(" kosa kata")
          .join(" tembung")
          .split("telepon")
          .join("telpon")
          .split(" ke engganan")
          .join(" ke-engganan")
          .split("nya masing-masing")
          .join("nya piyambak-piyambak")
          .split("ampas tahu")
          .join("ampas tahuu")
          .split(" berapa kali")
          .join(" kaping berapa")
          .split(" di balik ")
          .join(" di belakang ")
          .split(" lalu siapa")
          .join(" lajengipun siapa")
          .split(" tinggal hitung")
          .join(" nggari hitung")
          .split("an masing-masing")
          .join("an piyambak-piyambak")
          .split(" naik kelas")
          .join(" minggah kelas")
          .split(" kenaikan kelas")
          .join(" inggah-inggahan kelas")
          .split(" tahu kuning")
          .join(" tahuu kuning")
          .split(" hanya sekali")
          .join(" hanya sapisan")
          .split(" cuma sekali")
          .join(" cuma sapisan")
          .split(" sudut pandang")
          .join(" sudutt pandang")
          .split(" gempa bumi")
          .join(" gempa-bumi")
          .split("rumah tua")
          .join("rumah suwung")
          .split(" tak berpenghuni")
          .join(" suwung")
          .split(" paku beling")
          .join(" sunggan")
          .split(" seumur hidup")
          .join(" saumur hidup")
          .split("terkena beling")
          .join(" kesungga beling")
          .split(" rabun senja")
          .join(" kotok ayam")
          .split(" kotoran ayam")
          .join(" tembelek ayam")
          .split("jalan jalan")
          .join("jalan-jalan")
          .split(" jalan-jalan kecil")
          .join(" dalan-dalan kecil")
          .split("jalan-jalan besar")
          .join("dalan-dalan besar")
          .split(" mengadu nasib")
          .join("ngadu nasib")
          .split("kali lipat")
          .join("kali lipatt")
          .split("waktu lalu")
          .join("waktu wingi")
          .split("minggu lalu")
          .join("minggu wingi")
          .split(" ubi jalar")
          .join(" boled")
          .split(" ubi kayu")
          .join(" bodin")
          .split(" pena-nya")
          .join(" pulpene")
          .split(" bagian timur")
          .join(" sisi timur")
          .split(" bagian selatan")
          .join(" sisi selatan")
          .split(" bagian barat")
          .join(" sisi barat")
          .split(" bagian utara")
          .join(" sisi utara")
          .split(" kerap kali")
          .join(" sering-kali")
          .split(" serabut kelapa")
          .join(" tepes kelapa")
          .split("kan kembali")
          .join("kan laggi")
          .split(" ruang tamu")
          .join(" mbale")
          .split(" berlalu lalang")
          .join(" lalu-lalang")
          .split(" terkena ranjau")
          .join(" kesungga")
          .split(" lantai 1")
          .join(" lante 1")
          .split(" lantai 2")
          .join(" lante 2")
          .split(" lantai 3")
          .join(" lante 3")
          .split(" lantai 4")
          .join(" lante 4")
          .split(" lantai 5")
          .join(" lante 5")
          .split(" lantai 6")
          .join(" lante 6")
          .split(" lantai 7")
          .join(" lante 7")
          .split(" lantai 8")
          .join(" lante 8")
          .split(" lantai 9")
          .join(" lante 9")
          .split(" suka cita")
          .join(" sukacita")
          .split(" oleh oleh")
          .join(" oleh-oleh")
          .split(" lalu ber")
          .join(" lajengipun ber")
          .split(" serta merta")
          .join(" serta-merta")
          .split(" hujan angin")
          .join(" hujan-angin")
          .split(" sekali teguk")
          .join(" sa-guk-an")
          .split(" sekali telan")
          .join(" sa-leg-an")
          .split(" keadaan mengandung")
          .join(" keadaan hamil")
          .split(" tali pusar")
          .join(" pusar")
          .split("panjang sekali")
          .join("panjang sanget")
          .split(" lalu kamu")
          .join(" lajeng kamu")
          .split(" lalu kau")
          .join(" lajeng kau")
          .split(" lalu kalian")
          .join(" lajeng kalian")
          .split(" lalu kita")
          .join(" lajeng kita")
          .split("kan sekali")
          .join("kan sanget")
          .split("0 lalu")
          .join("0 silam")
          .split(" habis itu")
          .join(" bibar itu")
          .split("sejak lama")
          .join("sejak dulu")
          .split(" malang melintang")
          .join(" malang-melintang")
          .split(" lebaran haji")
          .join(" badha ji")
          .split(" angkutan umum")
          .join(" embret")
          .split(" kendaraan umum")
          .join(" embret")
          .split(". lalu")
          .join(". lajeng")
          .split("di duri")
          .join("di durii")
          .split(" mulai ber")
          .join(" lekas ber")
          .split(" sampai sampai")
          .join(" sampai-sampai")
          .split(" kolam renang")
          .join(" kolam-renang")
          .split(" melimpah ruah")
          .join(" melimpah-ruah")
          .split("tidak jadi masalah")
          .join("tidak dadi masalah")
          .split("tak jadi masalah")
          .join("tak dadi masalah")
          .split(" masing-masing.")
          .join(" piyambak-piyambak.")
          .split("ramai sekali")
          .join("ramai sanget")
          .split(" habis dari ")
          .join(" bibar dari ")
          .split(" kalau seperti")
          .join(" bila seperti")
          .split("warna terang")
          .join("warna mencreng")
          .split(" bola lampu")
          .join(" bohlam")
          .split(" naik sepeda")
          .join(" menaiki sepeda")
          .split(" mata kuliah")
          .join(" mataa kuliah")
          .split(" meletusnya gunung")
          .join(" mbledhugipun gunung")
          .split("terdiri atas")
          .join("terdiri dari")
          .split(" lubang sampah")
          .join(" blumbang")
          .split(" mata pelajaran")
          .join(" mataa pelajaran")
          .split(" kan ? ")
          .join(" ya ? ")
          .split("wedang")
          .join("wedhang")
          .split(" wedhang teh manis")
          .join(" wedhang manis")
          .split(" teh manis")
          .join(" wedhang manis")
          .split(" anak istri")
          .join(" anak-istri")
          .split(" ke mari")
          .join(" kemari")
          .split("mobil tank")
          .join("mobil krapyak")
          .split("menadahkan tangan")
          .join("nodongaken tangan")
          .split("tahu isi")
          .join("tahuu isi")
          .split("jarang sekali")
          .join("jarang sanget")
          .split("mahasiswa lain")
          .join("mahasiswa sanes");
        var TuT = TlT.split(" tentang hal")
          .join(" mengenai hal")
          .split("sana sekali ")
          .join("sana sepisan ")
          .split("! lalu ")
          .join("! lajeng ")
          .split("? lalu ")
          .join("? lajeng ")
          .split("sekujur tubuh")
          .join("sabadan sakojor")
          .split("sekujur badan")
          .join("sabadan sakojor")
          .split(" lalu aku ")
          .join(" lajeng aku ")
          .split("gula jawa")
          .join("gula merah")
          .split("air kencing")
          .join("air uyuh")
          .split("tidak mahu")
          .join("tidak setuju")
          .split(" terlalu masak")
          .join(" kematengen")
          .split("adu domba")
          .join("adudomba")
          .split(" ragu ragu")
          .join(" ragu-ragu")
          .split("dingin sekali")
          .join("dingin sanget")
          .split("kotoran kambing")
          .join("tai mendil")
          .split("kotoran domba")
          .join("tai mendil")
          .split(" berapa lembar")
          .join(" pirang lembar")
          .split(" sering sekali")
          .join(" sering sanget")
          .split("tepuk tangan")
          .join("tepuk-tangan")
          .split("menyisihkan sedikit")
          .join("ngengah sedikit")
          .split("bunga hias")
          .join("bunga petetan")
          .split("tumbuhan hias")
          .join("tumbuhan petetan")
          .split(" di di ")
          .join(" di dii ")
          .split(" salat hari raya ")
          .join(" salat riyaya ")
          .split("arik benang merah")
          .join("arik benang-merah")
          .split("senyum simpul")
          .join("senyum mesem")
          .split("sebaik baik")
          .join("sebaik-baik")
          .split("tega sekali")
          .join("tega sanget")
          .split("malu sekali")
          .join("malu sanget")
          .split("tif sekali")
          .join("tif sanget")
          .split("kursi roda")
          .join("kursii roda")
          .split("kursi goyang")
          .join("kursii goyang")
          .split(" orang lain")
          .join(" orang bukan")
          .split("tidak berkesudahan")
          .join("tidak habis-habis")
          .split("tak berkesudahan")
          .join("tak habis-habis")
          .split(" mata kaki")
          .join(" kiyongan")
          .split(" kurus kering")
          .join(" kurus aking")
          .split(" sesak nafas")
          .join(" ambekanipun sesek")
          .split(" kemarin lusa")
          .join(" kala-wingenanipun")
          .split(" tempat siapa")
          .join(" nggoneng siapa")
          .split(" tempat mana")
          .join(" nggoneng mana")
          .split(" secepat kilat")
          .join(" sebanter kilat")
          .split("merah muda")
          .join("merah jambon")
          .split("hitam sekali")
          .join("hitam sanget")
          .split("hitam pekat")
          .join("hitam sanget")
          .split("jalan berbatu")
          .join("jalan rokel")
          .split("jalan yang berbatu")
          .join("jalan yang rokel")
          .split("jalan yg berbatu")
          .join("jalan yang rokel")
          .split(" darah tinggi")
          .join(" darah-tinggi")
          .split(" darah rendah")
          .join(" darah-rendah")
          .split(" kaya raya")
          .join(" kaya-raya")
          .split(" segitu gitu")
          .join(" samono-mono")
          .split(" baru ber")
          .join(" nembe ber")
          .split(" terang benderang")
          .join(" padang njinggrang")
          .split(" terang benerang")
          .join(" padang njinggrang")
          .split(" tahu siwil")
          .join(" tahuu siwil")
          .split(" tahu upil")
          .join(" tahuu upil")
          .split("bertolak belakang sama")
          .join("bertolak belakang dengan")
          .split("nikah sama")
          .join("nikah dengan")
          .split(" memukul kentongan")
          .join(" menthung kentongan")
          .split("sendal")
          .join("sandal")
          .split(" panik ")
          .join(" kedangdapan ")
          .split(" lapar sekali")
          .join(" lapar sanget")
          .split(" ketuk pintu")
          .join(" dogdog pintu")
          .split(" malam sekali")
          .join(" malam sanget")
          .split(" tinggal sisa")
          .join(" nggari sisa")
          .split(" mengusir ayam")
          .join(" nggusah ayam")
          .split(" ngusir ayam")
          .join(" nggusah ayam")
          .split(" masing masing")
          .join(" masing-masing")
          .split(" masing-masing orang")
          .join(" saben-saben orang")
          .split(" tulang punggung")
          .join(" tulang-punggung")
          .split(" teka teki")
          .join(" teka-teki")
          .split(" mondar mandir")
          .join(" mondar-mandir")
          .split(" terus bagaimana")
          .join(" toli bagaimana")
          .split(" terus gimana")
          .join(" toli gimana")
          .split(" terus mau")
          .join(" toli mau")
          .split(" terus akan")
          .join(" toli akan")
          .split(" bulir nasi")
          .join(" upa")
          .split(" anak ayam")
          .join(" kuthuk")
          .split(" terakhir kali")
          .join(" terakhir pisan")
          .split(" terahir kali")
          .join(" terahir pisan")
          .split(" belum sempat")
          .join(" belum kober")
          .split(" sapu tangan")
          .join(" sapu-tangan")
          .split("pada akhirnya")
          .join("pada-akhirnya")
          .split("timur tengah")
          .join("timur-tengah")
          .split(" kain basah")
          .join(" gombal basah")
          .split("4 lalu")
          .join("4 silam")
          .split("5 lalu")
          .join("5 silam")
          .split("sungguh sungguh")
          .join("sungguh-sungguh")
          .split("buru buru")
          .join("buru-buru")
          .split(" dalam rangka ")
          .join(" dalam ")
          .split(" pernah di")
          .join(" nate di")
          .split("pintar sekali")
          .join("pintar sanget")
          .split("nikmat sekali")
          .join("nikmat sanget")
          .split("telur busuk")
          .join("telur kuwuk")
          .split("mau jalan-jalan")
          .join("mau mlaku-mlaku")
          .split("mau jalan2")
          .join("mau mlaku2")
          .split("selasa lalu")
          .join("selasa wingi")
          .split("sering kali")
          .join("sering-kali")
          .split("i ekor")
          .join("i buntut")
          .split("tidak lain dan tidak bukan")
          .join("tidak beda dan tidak bukan")
          .split("tak lain dan tak bukan")
          .join("tidak beda dan tidak bukan")
          .split(" baik dari")
          .join(" baikk dari")
          .split("mulutnya terbuka")
          .join("mulutnya mangap")
          .split("mulutnya yang terbuka")
          .join("mulutnya yang mangap")
          .split("mulut terbuka")
          .join("mulut mangap")
          .split(" tanah lapang")
          .join(" lemah-lapang")
          .split(" dipundhut")
          .join(" diipundhut")
          .split(" dipundut")
          .join(" diipundhut")
          .split("pripun")
          .join("pripunn")
          .split(" berbulan bulan")
          .join(" berbulan-bulan")
          .split("rabu lalu")
          .join("rabu wingi")
          .split(" lalu lintas")
          .join(" lalu-lintas")
          .split(" kata orang")
          .join(" trose orang")
          .split("efek samping")
          .join("efek-samping")
          .split(" lambaikan tangan")
          .join(" dadah-dadah tangan")
          .split(" lambaian tangan")
          .join(" dadah-dadah tangan")
          .split(" kasih tau")
          .join(" memberi tahu")
          .split("kamis lalu")
          .join("kamis wingi")
          .split("sakit keras")
          .join("sakit parah")
          .split(" padang rumput")
          .join(" ara-ara")
          .split(" xxx ")
          .join(" xxx ")
          .split(" salah kaprah")
          .join(" keliru")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" mengambil alih")
          .join(" mengambil-alih")
          .split(" selamat hari")
          .join(" sugeng hari")
          .split(" selamat pagi")
          .join(" sugeng pagi")
          .split(" selamat siang")
          .join(" sugeng siang")
          .split(" selamat sore")
          .join(" sugeng sore")
          .split(" selamat malam")
          .join(" sugeng malam")
          .split(" selamat ber")
          .join(" sugeng ber")
          .split(" mau saja")
          .join(" gelem saja")
          .split(" idul fitri ")
          .join(" riyadi ")
          .split(" sudah sampai")
          .join(" sudah nyampe")
          .split(" asing lain ")
          .join(" asing sanes ")
          .split(" kasih sayang")
          .join(" welas asih")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split(" xxx ")
          .join(" xxx ")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" xxx ")
          .join(" xxx ")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split(" omong kosong")
          .join(" dedora")
          .split(" bak mandi")
          .join(" kolam")
          .split(" tulang kering")
          .join(" gares")
          .split(" buang air besar")
          .join(" ngising")
          .split(" buang air kecil")
          .join(" nguyuh")
          .split(" menggosok gigi")
          .join(" sikatan gigi")
          .split(" menyikat gigi")
          .join(" sikatan gigi")
          .split(" berbincang bincang")
          .join(" berbincang-bincang")
          .split(" keong sawah")
          .join(" kraca")
          .split(" kali lipat")
          .join(" kali lipatt")
          .split("tidak mau")
          .join("tidak setuju")
          .split(" berjalan sangat cepat")
          .join(" ngenceg")
          .split(" bahu membahu")
          .join(" bahu-membahu")
          .split(" sangat terang")
          .join(" padang njinggrang")
          .split(" kasih kesempatan")
          .join(" memberi kesempatan")
          .split("es campur")
          .join("es campurr")
          .split(" padahal tidak")
          .join(" akalen tidak")
          .split(" padahal tak")
          .join(" akalen tak")
          .split(" padahal ngga")
          .join(" akalen ngga")
          .split(" jalanan yang tidak rata")
          .join(" jalanan yang rokel")
          .split(" jalan yang tidak rata")
          .join(" jalan yang rokel")
          .split("an yang tidak rata")
          .join("an yang rokel")
          .split(" berkeluh kesah")
          .join(" ngresula")
          .split(" keluh kesah")
          .join(" ngresula")
          .split("untuk persediaan")
          .join("untuk pranti")
          .split(" buat persediaan")
          .join(" untuk pranti")
          .split(" sendok sayur")
          .join(" irus")
          .split(" sendok nasi")
          .join(" centong")
          .split(" musim kemarau")
          .join(" musim ketigga")
          .split(" tidak jadi")
          .join(" tidak sida")
          .split(" tak jadi")
          .join(" tak sida")
          .split(" kembang api")
          .join(" kembang-api")
          .split(" sewaktu di ")
          .join(" sedang di ")
          .split(" waktu di ")
          .join(" sedang di ")
          .split(" sampai sekarang")
          .join(" ngantos sekarang")
          .split(" mata keranjang")
          .join(" tukmis");
        var TleT = TuT.split("industri")
          .join("QVindustriVQ")
          .split("teknologi")
          .join("QVteknologiVQ")
          .split("jaringan")
          .join("QVjaringanVQ")
          .split("suntingan")
          .join("QVsuntinganVQ")
          .split("layar")
          .join("QVlayarVQ")
          .split("panggung")
          .join("QVpanggungVQ")
          .split("televisi")
          .join("QVtelevisiVQ")
          .split("ruko")
          .join("QVrukoVQ")
          .split("kios")
          .join("QVkiosVQ")
          .split("toko")
          .join("QVtokoVQ")
          .split("huruf")
          .join("QVhurufVQ")
          .split("kalimat")
          .join("QVkalimatVQ")
          .split("kata")
          .join("QVkataVQ")
          .split(" ia")
          .join(" QVia")
          .split("kalian")
          .join("QVkalian")
          .split("mereka")
          .join("QVmereka")
          .split("kamar")
          .join("QVkamarVQ")
          .split("bumi")
          .join("QVbumiVQ")
          .split("komunitas")
          .join("QVkomunitasVQ")
          .split("pikiran")
          .join("QVpikiranVQ")
          .split("televisi")
          .join("QVtelevisiVQ")
          .split("pohon")
          .join("QVpohonVQ")
          .split("buah")
          .join("QVbuahVQ")
          .split("warna")
          .join("QVwarnaVQ")
          .split("macam")
          .join("QVmacam")
          .split("jenis")
          .join("QVjenisVQ")
          .split("ekor")
          .join("QVekor")
          .split("kilo")
          .join("QVkilo")
          .split("waktu")
          .join("QVwaktuVQ")
          .split("meter")
          .join("QVmeter")
          .split("menit")
          .join("QVmenitVQ")
          .split("detik")
          .join("QVdetikVQ")
          .split("unit")
          .join("QVunitVQ")
          .split("gram")
          .join("QVgram")
          .split("porsi")
          .join("QVporsiVQ")
          .split("pilihan")
          .join("QVpilihanVQ")
          .split("cerita")
          .join("QVceritaVQ")
          .split("gelas")
          .join("QVgelasVQ")
          .split("tanah")
          .join("QVtanahVQ")
          .split("tiang")
          .join("QVtiangVQ")
          .split("hati")
          .join("QVhati")
          .split("cinta")
          .join("QVcintaVQ")
          .split("mata")
          .join("QVmataVQ")
          .split("rumah")
          .join("QVrumahVQ")
          .split("langit")
          .join("QVlangit")
          .split(" berbahasa")
          .join(" QV berbahasa")
          .split("kota")
          .join("QVkotaVQ")
          .split("abad")
          .join("QVabadVQ")
          .split("bukti")
          .join("QVbuktiVQ")
          .split("wilayah")
          .join("QVwilayahVQ")
          .split("barang")
          .join("QVbarangVQ")
          .split("ruangan")
          .join("QVruanganVQ")
          .split("film")
          .join("QVfilmVQ")
          .split("sahabat")
          .join("QVsahabatVQ")
          .split("teman")
          .join("QVtemanVQ")
          .split("desa")
          .join("QVdesaVQ")
          .split("model")
          .join("QVmodelVQ")
          .split("naskah")
          .join("QVnaskahVQ")
          .split("baju")
          .join("QVbajuVQ")
          .split("sepatu")
          .join("QVsepatuVQ")
          .split("sandal")
          .join("QVsandalVQ")
          .split("kompor")
          .join("QVkomporVQ")
          .split("meja")
          .join("QVmejaVQ")
          .split("kursi")
          .join("QVkursiVQ")
          .split("lampu")
          .join("QVlampuVQ")
          .split("radio")
          .join("QVradioVQ")
          .split("celana")
          .join("QVcelanaVQ")
          .split("sekolah")
          .join("QVsekolahVQ")
          .split("kasur")
          .join("QVkasurVQ")
          .split("mahasiswa")
          .join("QVmahasiswaVQ")
          .split("siswa")
          .join("QVsiswaVQ")
          .split("kelas")
          .join("QVkelasVQ")
          .split("kota")
          .join("QVkotaVQ")
          .split("kabupaten")
          .join("QVkabupatenVQ")
          .split("negara")
          .join("QVnegaraVQ")
          .split("kasus")
          .join("QVkasusVQ")
          .split("strategi")
          .join("QVstrategiVQ")
          .split("planet")
          .join("QVplanetVQ")
          .split(" sisi")
          .join(" sisiVQ")
          .split("pihak")
          .join("QVpihakVQ")
          .split("daerah")
          .join("QVdaerahVQ")
          .split("media")
          .join("QVmediaVQ")
          .split("individu")
          .join("QVindividuVQ")
          .split("pemain")
          .join("QVpemainVQ")
          .split("tempat")
          .join("QVtempatVQ")
          .split("pulau")
          .join("QVpulauVQ")
          .split("musik")
          .join("QVmusikVQ")
          .split("hari")
          .join("QVhariVQ")
          .split("ruang")
          .join("QVruangVQ")
          .split("petisi")
          .join("QVpetisiVQ")
          .split("pria")
          .join("QVpriaVQ")
          .split("wanita")
          .join("QVwanitaVQ")
          .split("gadis")
          .join("QVgadisVQ")
          .split(" yang")
          .join(" yangVQ")
          .split(" yg")
          .join(" ygVQ")
          .split("baris")
          .join("QVbarisVQ")
          .split("fungsi")
          .join("QVfungsiVQ")
          .split(" antara")
          .join(" antaraVQ")
          .split("kerbau")
          .join("QVkerbauVQ")
          .split("kucing")
          .join("QVkucingVQ")
          .split("kambing")
          .join("QVkambingVQ")
          .split("pintu")
          .join("QVpintuVQ")
          .split("jendela")
          .join("QVjendelaVQ")
          .split("motor")
          .join("QVmotorVQ")
          .split("sepeda")
          .join("QVsepedaVQ")
          .split("anjing")
          .join("QVanjingVQ")
          .split("binatang")
          .join("QVbinatangVQ")
          .split("dimensi")
          .join("QVdimensiVQ")
          .split("perut")
          .join("QVperutVQ")
          .split("kepala")
          .join("QVkepalaVQ")
          .split("mulut")
          .join("QVmulutVQ")
          .split("kesempatan")
          .join("QVkesempatanVQ")
          .split("stasiun")
          .join("QVstasiunVQ")
          .split("terminal")
          .join("QVterminalVQ")
          .split("dialek")
          .join("QVdialekVQ")
          .split("bentuk")
          .join("QVbentukVQ")
          .split("tahun")
          .join("QVtahunVQ")
          .split(" hidup")
          .join(" QVhidup")
          .split("artikel")
          .join("QVartikelVQ")
          .split("bahasa")
          .join("QVbahasaVQ")
          .split("orang")
          .join("QVorangVQ")
          .split("pelatih")
          .join("QVpelatihVQ")
          .split("lemari")
          .join("QVlemariVQ")
          .split("laci")
          .join("QVlaciVQ")
          .split("dukungan")
          .join("QVdukunganVQ")
          .split("kekuatan")
          .join("QVkekuatanVQ")
          .split("tindakan")
          .join("QVtindakanVQ")
          .split("nasihat")
          .join("QVnasihatVQ")
          .split("sore")
          .join("QVsoreVQ")
          .split(" per")
          .join(" QVper")
          .split(" udara")
          .join(" QVudara")
          .split("pesawat")
          .join("QVpesawatVQ")
          .split("sastra")
          .join("QVsastraVQ")
          .split("wan ")
          .join("wanVQ ")
          .split(" harta")
          .join(" QVhartaVQ")
          .split(" api")
          .join(" QVapi")
          .split(" air")
          .join(" QVair")
          .split(" ayah")
          .join(" QVayahVQ")
          .split("ibu")
          .join("QVibuVQ")
          .split("bandara")
          .join("QVbandaraVQ")
          .split("sudut")
          .join("QVsudutVQ")
          .split("hewan")
          .join("QVhewanVQ")
          .split("jawaban")
          .join("QVjawabanVQ")
          .split("bibi")
          .join("QVbibiVQ")
          .split("bola")
          .join("QVbolaVQ")
          .split("pisang")
          .join("QVpisangVQ")
          .split("burung")
          .join("QVburungVQ")
          .split("buku")
          .join("QVbukuVQ")
          .split("otak")
          .join("QVotakVQ")
          .split("roti")
          .join("QVrotiVQ")
          .split("saudara")
          .join("QVsaudaraVQ")
          .split("mobil")
          .join("QVmobilVQ")
          .split("ayam")
          .join("QVayamVQ")
          .split("anak")
          .join("QVanakVQ")
          .split("masjid")
          .join("QVmasjidVQ")
          .split("gereja")
          .join("QVgerejaVQ")
          .split("gempuran")
          .join("QVgempuranVQ")
          .split("wihara")
          .join("QVwiharaVQ")
          .split("rokok")
          .join("QVrokokVQ")
          .split("lingkaran")
          .join("QVlingkaranVQ")
          .split("sapi")
          .join("QVsapiVQ")
          .split("alat")
          .join("QValatVQ")
          .split("makan")
          .join("QVmakan")
          .split("arah")
          .join("QVarahVQ")
          .split("bencana")
          .join("QVbencanaVQ")
          .split("penyakit")
          .join("QVpenyakitVQ")
          .split("boneka")
          .join("QVbonekaVQ")
          .split("supir")
          .join("QVsupirVQ")
          .split("gempa")
          .join("QVgempaVQ")
          .split("pendidik")
          .join("QVpendidikVQ")
          .split("mesin")
          .join("QVmesinVQ")
          .split("hiburan")
          .join("QVhiburanVQ")
          .split("keluarga")
          .join("QVkeluargaVQ")
          .split("petani")
          .join("QVpetaniVQ")
          .split("lapangan")
          .join("QVlapanganVQ")
          .split("bendera")
          .join("QVbenderaVQ")
          .split("bunga")
          .join("QVbungaVQ")
          .split(" sepak bola")
          .join(" QVsepak bolaVQ")
          .split("katak")
          .join("QVkatakVQ")
          .split(" pem")
          .join(" QVpem")
          .split("sampah")
          .join("QVsampahVQ")
          .split("hantu")
          .join("QVhantuVQ")
          .split("kakek")
          .join("QVkakekVQ")
          .split("nenek")
          .join("QVnenekVQ")
          .split("rumput")
          .join("QVrumputVQ")
          .split("senjata")
          .join("QVsenjataVQ")
          .split(" aula")
          .join(" QVaulaVQ")
          .split(" kese")
          .join(" QVkese")
          .split(" jantung")
          .join(" QVjantungVQ")
          .split("bukit")
          .join("QVbukitVQ")
          .split("sejarah")
          .join("QVsejarahVQ")
          .split(" liburan")
          .join(" QVliburanVQ")
          .split("pekerja")
          .join("QVpekerjaVQ")
          .split(" madu")
          .join(" QVmaduVQ")
          .split("kuda")
          .join("QVkudaVQ")
          .split("panas")
          .join("QVpanasVQ")
          .split(" pen")
          .join(" QVpen")
          .split(" keme")
          .join(" QVkeme")
          .split(" memer")
          .join(" QVmemer")
          .split("serangga")
          .join("QVseranggaVQ")
          .split("lelucon")
          .join("QVleluconVQ")
          .split("kerajaan")
          .join("QVkerajaanVQ")
          .split("layang")
          .join("QVlayang")
          .split("bayang")
          .join("QVbayang")
          .split("danau")
          .join("QVdanauVQ")
          .split("hukum")
          .join("QVhukumVQ")
          .split("majalah")
          .join("QVmajalahVQ")
          .split("manusia")
          .join("QVmanusiaVQ")
          .split("topeng")
          .join("QVtopengVQ")
          .split(" matematika")
          .join(" QVmatematikaVQ")
          .split(" tengah malam")
          .join(" QVtengah malamVQ")
          .split(" susu")
          .join(" QVsusuVQ")
          .split("pagi")
          .join("QVpagiVQ")
          .split("siang")
          .join("QVsiangVQ")
          .split("malam")
          .join("QVmalamVQ")
          .split(" alam")
          .join(" QValamVQ")
          .split("berita")
          .join("QVberitaVQ")
          .split(" qur")
          .join(" QVqur")
          .split(" al-")
          .join(" QVal-")
          .split(" al ")
          .join(" QVal ")
          .split("kitab")
          .join("QVkitabVQ")
          .split("koran")
          .join("QVkoranVQ")
          .split(" laut")
          .join(" QVlautVQ")
          .split("kantor")
          .join("QVkantorVQ")
          .split("kertas")
          .join("QVkertasVQ")
          .split(" kepribadian")
          .join(" QVkepribadianVQ")
          .split("gambar")
          .join("QVgambarVQ")
          .split("kelinci")
          .join("QVkelinciVQ")
          .split("sungai")
          .join("QVsungaiVQ")
          .split("jalan")
          .join("QVjalanVQ")
          .split("ilmu")
          .join("QVilmuVQ")
          .split("ular")
          .join("QVularVQ")
          .split(" masyarakat")
          .join(" QVmasyarakatVQ")
          .split("lagu")
          .join("QVlaguVQ")
          .split("gula")
          .join("QVgulaVQ")
          .split("musim")
          .join("QVmusimVQ")
          .split("guru")
          .join("QVguruVQ")
          .split("pakaian")
          .join("QVpakaianVQ")
          .split(" sayur")
          .join(" QVsayurVQ")
          .split("kendaraan")
          .join("QVkendaraanVQ")
          .split("kekayaan")
          .join("QVkekayaan")
          .split(" cuaca")
          .join(" QVcuacaVQ")
          .split("istri")
          .join("QVistriVQ")
          .split(" suami")
          .join(" QVsuamiVQ")
          .split("isteri")
          .join("QVisteriVQ")
          .split("kayu")
          .join("QVkayuVQ")
          .split(" dunia")
          .join(" QVduniaVQ")
          .split(" semesta")
          .join(" QVsemestaVQ")
          .split("hitungan")
          .join("QVhitunganVQ")
          .split("rindu")
          .join("QVrinduVQ");
        var TuIT = TleT.split("rupiah")
          .join("QVrupiah")
          .split("kurikulum")
          .join("QVkurikulumVQ")
          .split("gedung")
          .join("QVgedungVQ")
          .split(" naungan")
          .join(" QVnaunganVQ")
          .split("kebiasaan")
          .join("QVkebiasaanVQ")
          .split("logo")
          .join("QVlogoVQ")
          .split("kapal")
          .join("QVkapalVQ")
          .split("provinsi")
          .join("QVprovinsiVQ")
          .split("sidang")
          .join("QVsidangVQ")
          .split("konstitusi")
          .join("QVkonstitusiVQ")
          .split("minggu")
          .join("QVmingguVQ")
          .split("orde")
          .join("QVordeVQ")
          .split("pasal")
          .join("QVpasalVQ")
          .split("shalawat")
          .join("QVshalawatVQ")
          .split(" kereta ")
          .join(" QVkeretaVQ ")
          .split(" warung")
          .join(" QVwarungVQ")
          .split(" bengawan")
          .join(" QVbengawanVQ")
          .split(" proses")
          .join(" QVprosesVQ")
          .split("bangsa")
          .join("QVbangsaVQ")
          .split("kecamatan")
          .join("QVkecamatanVQ")
          .split("puisi")
          .join("QVpuisiVQ")
          .split(" sejarah")
          .join(" QVsejarah")
          .split(" kami ")
          .join(" QVkamiVQ ")
          .split("administrasi ")
          .join("QVadministrasi ")
          .split("jaman")
          .join("QVjamanVQ")
          .split("partai")
          .join("QVpartaiVQ")
          .split("komunikasi")
          .join("QVkomunikasi")
          .split(" kita ")
          .join(" QVkitaVQ ")
          .split(" menanggapi")
          .join(" QVmenanggapi")
          .split(" bidang")
          .join(" QVbidangVQ")
          .split("berQVjalanVQ")
          .join("berjalan")
          .split("aku")
          .join("QVaku")
          .split(" tas")
          .join(" QVtas")
          .split("wikipedia")
          .join("QVwikipediaVQ")
          .split("dia")
          .join("QVdiaVQ")
          .split("pengguna")
          .join("QVpenggunaVQ")
          .split("kamu")
          .join("QVkamu")
          .split("saya")
          .join("QVsaya")
          .split(" keber")
          .join(" QVkeber")
          .split(" budaya")
          .join(" QVbudayaVQ")
          .split(" kalender")
          .join(" QVkalenderVQ")
          .split(" novel")
          .join(" QVnovelVQ")
          .split(" kesalahan")
          .join(" QVkesalahan")
          .split(" salah")
          .join(" QVsalah")
          .split(" kalangan")
          .join(" QVkalanganVQ")
          .split("pura")
          .join("QVpuraVQ")
          .split(" kesukaran")
          .join(" QVkesukaran")
          .split(" kesalahan")
          .join(" QVkesalahan")
          .split(" karya")
          .join(" QVkaryaVQ")
          .split(" momen")
          .join(" QVmomen")
          .split(" blog")
          .join(" QVblogVQ")
          .split(" koper")
          .join(" QVkoperVQ")
          .split(" tataran")
          .join(" QVtataranVQ")
          .split("tradisi")
          .join("QVtradisiVQ")
          .split("keraton")
          .join("QVkeratonVQ")
          .split("kraton")
          .join("QVkratonVQ")
          .split("raja")
          .join("QVrajaVQ")
          .split(" parkiran")
          .join(" QVparkiranVQ")
          .split(" keanekaragaman")
          .join(" QVkeanekaragamanVQ")
          .split(" keragaman")
          .join(" QVkeragamanVQ")
          .split(" contoh")
          .join(" QVcontohVQ")
          .split(" hutan")
          .join(" QVhutanVQ")
          .split(" sawah")
          .join(" QVsawahVQ")
          .split(" bisnis")
          .join(" QVbisnisVQ")
          .split(" bursa")
          .join(" QVbursa")
          .split(" teks")
          .join(" QVteksVQ")
          .split(" kerupuk")
          .join(" QVkerupukVQ")
          .split(" sambal")
          .join(" QVsambalVQ")
          .split("kelompok")
          .join("QVkelompokVQ")
          .split("pendapat")
          .join("QVpendapatVQ")
          .split(" batin")
          .join(" QVbatin")
          .split(" uang")
          .join(" QVuangVQ")
          .split("suku")
          .join("QVsukuVQ")
          .split("pasar")
          .join("QVpasarVQ")
          .split("konteks")
          .join("QVkonteksVQ")
          .split("merek")
          .join("QVmerekVQ")
          .split("merk")
          .join("QVmerkVQ")
          .split("grup")
          .join("QVgrupVQ")
          .split("hal")
          .join("QVhalVQ")
          .split("bab")
          .join("QVbabVQ")
          .split(" nasi ")
          .join(" QVnasi ")
          .split(" garam ")
          .join(" QVgaram ")
          .split(" botol ")
          .join(" QVbotolVQ ")
          .split(" bantal ")
          .join(" QVbantalVQ ")
          .split(" seprei ")
          .join(" QVsepreiVQ ")
          .split(" bulan ")
          .join(" QVbulanVQ ")
          .split(" gunung ")
          .join(" QVgunungVQ ")
          .split("bagian")
          .join("QVbagianVQ")
          .split("sistem")
          .join("QVsistemVQ")
          .split("garis")
          .join("QVgarisVQ")
          .split(" selimut ")
          .join(" QVselimutVQ ")
          .split(" kaca ")
          .join(" QVkacaVQ ")
          .split(" bedak ")
          .join(" QVbedakVQ ")
          .split("acara")
          .join("QVacaraVQ")
          .split(" basa ")
          .join(" QVbasa ")
          .split(" ber")
          .join(" QXber")
          .split(" mem")
          .join(" QXmem")
          .split("VQ lain")
          .join(" sanes")
          .split("VQ sini ")
          .join(" ngriki ")
          .split("VQ situ ")
          .join(" ngriku ")
          .split("VQ sana ")
          .join(" ngrika ")
          .split("VQ baru")
          .join(" enggal")
          .split("VQ")
          .join("")
          .split(" lawasran")
          .join(" lamaran");
        var TrT = TuIT.split("triliun sembilan QV")
          .join("triliun sanga ")
          .split("triliun delapan QV")
          .join("triliun wolu ")
          .split("triliun tujuh QV")
          .join("triliun pitu ")
          .split("triliun enam QV")
          .join("triliun enem ")
          .split("triliun lima QV")
          .join("triliun gangsal ")
          .split("triliun empat QV")
          .join("triliun sekawan ")
          .split("triliun tiga QV")
          .join("triliun tigaa ")
          .split("triliun dua QV")
          .join("triliun kalih ")
          .split("triliun satu QV")
          .join("triliun setunggal ")
          .split("miliar sembilan QV")
          .join("miliar sanga ")
          .split("miliar delapan QV")
          .join("miliar wolu ")
          .split("miliar tujuh QV")
          .join("miliar pitu ")
          .split("miliar enam QV")
          .join("miliar enem ")
          .split("miliar lima QV")
          .join("miliar gangsal ")
          .split("miliar empat QV")
          .join("miliar sekawan ")
          .split("miliar tiga QV")
          .join("miliar tigaa ")
          .split("miliar dua QV")
          .join("miliar kalih ")
          .split("miliar satu QV")
          .join("miliar setunggal ")
          .split("juta sembilan QV")
          .join("juta sanga ")
          .split("juta delapan QV")
          .join("juta wolu ")
          .split("juta tujuh QV")
          .join("juta pitu ")
          .split("juta enam QV")
          .join("juta enem ")
          .split("juta lima QV")
          .join("juta gangsal ")
          .split("juta empat QV")
          .join("juta sekawan ")
          .split("juta tiga QV")
          .join("juta tigaa ")
          .split("juta dua QV")
          .join("juta kalih ")
          .split("juta satu QV")
          .join("juta setunggal ")
          .split("ribu sembilan QV")
          .join("ribu sanga ")
          .split("ribu delapan QV")
          .join("ribu wolu ")
          .split("ribu tujuh QV")
          .join("ribu pitu ")
          .split("ribu enam QV")
          .join("ribu enem ")
          .split("ribu lima QV")
          .join("ribu gangsal ")
          .split("ribu empat QV")
          .join("ribu sekawan ")
          .split("ribu tiga QV")
          .join("ribu tigaa ")
          .split("ribu dua QV")
          .join("ribu kalih ")
          .split("ribu satu QV")
          .join("ribu setunggal ")
          .split("ratus sembilan QV")
          .join("ratus sanga ")
          .split("ratus delapan QV")
          .join("ratus wolu ")
          .split("ratus tujuh QV")
          .join("ratus pitu ")
          .split("ratus enam QV")
          .join("ratus enem ")
          .split("ratus lima QV")
          .join("ratus gangsal ")
          .split("ratus empat QV")
          .join("ratus sekawan ")
          .split("ratus tiga QV")
          .join("ratus tigaa ")
          .split("ratus dua QV")
          .join("ratus kalih ")
          .split("ratus satu QV")
          .join("ratus setunggal ")
          .split("dasa sembilan QV")
          .join("dasa sanga ")
          .split("dasa delapan QV")
          .join("dasa wolu ")
          .split("dasa tujuh QV")
          .join("dasa pitu ")
          .split("dasa enam QV")
          .join("dasa enem ")
          .split("dasa lima QV")
          .join("dasa gangsal ")
          .split("dasa empat QV")
          .join("dasa sekawan ")
          .split("dasa tiga QV")
          .join("dasa tigaa ")
          .split("dasa dua QV")
          .join("dasa kalih ")
          .split("dasa satu QV")
          .join("dasa setunggal ")
          .split("seket sembilan QV")
          .join("seket sanga ")
          .split("seket delapan QV")
          .join("seket wolu ")
          .split("seket tujuh QV")
          .join("seket pitu ")
          .split("seket enam QV")
          .join("seket enem ")
          .split("seket lima QV")
          .join("seket gangsal ")
          .split("seket empat QV")
          .join("seket sekawan ")
          .split("seket tiga QV")
          .join("seket tigaa ")
          .split("seket dua QV")
          .join("seket kalih ")
          .split("seket satu QV")
          .join("seket setunggal ")
          .split("sawidak sembilan QV")
          .join("sawidak sanga ")
          .split("sawidak delapan QV")
          .join("sawidak wolu ")
          .split("sawidak tujuh QV")
          .join("sawidak pitu ")
          .split("sawidak enam QV")
          .join("sawidak enem ")
          .split("sawidak lima QV")
          .join("sawidak gangsal ")
          .split("sawidak empat QV")
          .join("sawidak sekawan ")
          .split("sawidak tiga QV")
          .join("sawidak tigaa ")
          .split("sawidak dua QV")
          .join("sawidak kalih ")
          .split("sawidak satu QV")
          .join("sawidak setunggal ")
          .split(" satu QV")
          .join(" sa ")
          .split(" dua QV")
          .join(" kalih ")
          .split(" tiga QV")
          .join(" tigang ")
          .split(" empat QV")
          .join(" sekawann ")
          .split(" lima QV")
          .join(" gangsal ")
          .split(" enam QV")
          .join(" nem ")
          .split(" tujuh QV")
          .join(" pitung ")
          .split(" delapan QV")
          .join(" wolung ")
          .split(" sembilan QV")
          .join(" sangang ")
          .split(" timurnya QV")
          .join(" wetaning ")
          .split(" timur QV")
          .join(" wetaning ")
          .split(" tenggaranya QV")
          .join(" kidul-wetaning ")
          .split(" tenggara QV")
          .join(" kidul-wetaning ")
          .split(" selatannya QV")
          .join(" kiduling ")
          .split(" selatan QV")
          .join(" kiduling ")
          .split(" barat-dayanya QV")
          .join(" kidul-kilening ")
          .split(" barat-daya QV")
          .join(" kidul-kilening ")
          .split(" baratnya QV")
          .join(" kilening ")
          .split(" barat QV")
          .join(" kilening ")
          .split(" barat-lautnya QV")
          .join(" ler-kilening ")
          .split(" barat-laut QV")
          .join(" ler-kilening ")
          .split(" utaranya QV")
          .join(" lering ")
          .split(" utara QV")
          .join(" lering ")
          .split(" timur-lautnya QV")
          .join(" ler-wetaning ")
          .split(" timur-laut QV")
          .join(" ler-wetaning ")
          .split(" rangkaian QV")
          .join(" rangkeyaning ")
          .split(" QVjenis-QVjenisnya QV")
          .join(" jinis-jinising ")
          .split(" QVjenis-QVjenis QV")
          .join(" jinis-jinising ")
          .split(" seQVjenis QV")
          .join(" sajinising ")
          .split(" QVjenisnya QV")
          .join(" jinising ")
          .split(" QVjenis QV")
          .join(" jinising ")
          .split(" sebalik QV")
          .join(" sawangsuling ")
          .split(" balik QV")
          .join(" wangsuling ")
          .split(" sekitarnya QV")
          .join(" antawising ")
          .split(" sekitar QV")
          .join(" antawising ")
          .split(" semuanya QV")
          .join(" sadayaning ")
          .split(" semua QV")
          .join(" sadayaning ")
          .split(" seluruhnya QV")
          .join(" sadayaning ")
          .split(" seluruh QV")
          .join(" sadayaning ")
          .split(" sebelahnya QV")
          .join(" iringaning ")
          .split(" sebelah QV")
          .join(" iringaning ")
          .split(" sisinya QV")
          .join(" iringaning ")
          .split(" sisi QV")
          .join(" iringaning ")
          .split(" tengahnya QV")
          .join(" tengahing ")
          .split(" tengah QV")
          .join(" tengahing ")
          .split(" bawahnya QV")
          .join(" andhaping ")
          .split(" bawah QV")
          .join(" andhaping ")
          .split(" sampingnya QV")
          .join(" iringaning ")
          .split(" samping QV")
          .join(" iringaning ")
          .split(" belakangnya QV")
          .join(" wingkinging ")
          .split(" belakang QV")
          .join(" wingkinging ")
          .split(" depannya QV")
          .join(" ngajenging ")
          .split(" depan QV")
          .join(" ngajenging ")
          .split(" seisinya QV")
          .join(" saisining ")
          .split(" seisi QV")
          .join(" saisining ")
          .split(" isinya QV")
          .join(" isining ")
          .split(" belahan QV")
          .join(" welahaning ")
          .split(" dalam QV")
          .join(" lebeting ")
          .split(" berjalannya QV")
          .join(" mlampahing ")
          .split(" berjalan QV")
          .join(" mlampahing ")
          .split(" luarnya QV")
          .join(" jawining ")
          .split(" luar QV")
          .join(" jawining ")
          .split(" awalnya QV")
          .join(" wiwiting ")
          .split(" mulainya QV")
          .join(" wiwiting ")
          .split(" awal QV")
          .join(" wiwiting ")
          .split(" sejak QV")
          .join(" wiwiting ")
          .split(" sekejapnya QV")
          .join(" sakedheping ")
          .split(" sekejap QV")
          .join(" sakedheping ")
          .split(" jumlahnya QV")
          .join(" cacahing ")
          .split(" jumlah QV")
          .join(" cacahing ")
          .split(" atasnya QV")
          .join(" inggiling ")
          .split(" atas QV")
          .join(" inggiling ")
          .split(" tepi QV")
          .join(" tepining ")
          .split(" nama QV")
          .join(" namaning[ASMANING] ")
          .split(" lewat QV")
          .join(" medal ")
          .split(" melalui QV")
          .join(" medal ")
          .split(" puncak QV")
          .join(" pucuking ")
          .split(" kumpulannya QV")
          .join(" kempalaning ")
          .split(" kumpulan QV")
          .join(" kempalaning ")
          .split(" pinggir QV")
          .join(" pinggiring ")
          .split(" adabnya QV")
          .join(" unggah-ungguhing ")
          .split(" adab QV")
          .join(" unggah-ungguhing ")
          .split(" unggah-ungguhnya QV")
          .join(" unggah-ungguhing ")
          .split(" unggah-ungguh QV")
          .join(" unggah-ungguhing ")
          .split(" sama QV")
          .join(" dengan ")
          .split(" semua QV")
          .join(" sadayaning ")
          .split(" kemajuannya QV")
          .join(" kamajenganing ")
          .split(" kemajuan QV")
          .join(" kamajenganing ")
          .split(" majunya QV")
          .join(" majenging ")
          .split(" pangkuan QV")
          .join(" pangkoning ")
          .split(" lama QV")
          .join(" setunggaling ")
          .split(" salah satu QV")
          .join(" setunggaling ")
          .split(" kesatu QV")
          .join(" kaping setunggal ")
          .split(" kaping rong QV")
          .join(" kaping kalih ")
          .split(" kaping tiga QV")
          .join(" kaping tigaa ")
          .split(" kaping patang QV")
          .join(" kaping papat ")
          .split(" kaping limang QV")
          .join(" kaping lima ")
          .split(" kaping nem QV")
          .join(" kaping enem ")
          .split(" kaping pitung QV")
          .join(" kaping pitu ")
          .split(" kaping wolung QV")
          .join(" kaping wolu ")
          .split(" kaping sangang QV")
          .join(" kaping sanga ")
          .split(" bagi QV")
          .join(" untuk ")
          .split(" di dalam QX")
          .join(" salebeting ")
          .split(" dalam QX")
          .join(" lebeting ")
          .split(" adab QX")
          .join(" unggah-ungguhing ")
          .split("QX")
          .join("")
          .split("QV")
          .join("");
        var TIrT = TrT.split(" mengobrol")
          .join(" VVmengobrol")
          .split(" ngobrol")
          .join(" VVngobrol")
          .split(" makan")
          .join(" VVmakan")
          .split(" minum")
          .join(" VVminum")
          .split(" pergi")
          .join(" VVpergi")
          .split(" malas")
          .join(" VVmalas")
          .split(" mandi")
          .join(" VVmandi")
          .split(" lagi VV")
          .join(" sedang ")
          .split(" tinggal VV")
          .join(" kantun ")
          .split("VV")
          .join("");
        var TjT = TIrT.split(" sama ")
          .join(" CCsama ")
          .split(" dengan ")
          .join(" CCdengan ")
          .split(" bersama ")
          .join(" CCbersama ")
          .split(" tinggal CC")
          .join(" manggen ")
          .split("CC")
          .join("");
        var TliT = TjT.split(" terbatas")
          .join(" terbatasVZ")
          .split(" lama")
          .join(" lamaVZ")
          .split(" percaya")
          .join(" percayaVZ")
          .split(" jauh")
          .join(" jauhVZ")
          .split(" bermacam-macam")
          .join(" bermacam-macamVZ")
          .split(" menarik")
          .join(" menarikVZ")
          .split(" sederhana")
          .join(" sederhanaVZ")
          .split(" cerdas")
          .join(" cerdasVZ")
          .split(" ingin")
          .join(" inginVZ")
          .split(" baik")
          .join(" baikVZ")
          .split(" bagus")
          .join(" bagusVZ")
          .split(" kotor")
          .join(" kotorVZ")
          .split(" panjang")
          .join(" panjangVZ")
          .split(" ramai")
          .join(" ramaiVZ")
          .split(" jarang")
          .join(" jarangVZ")
          .split(" dingin")
          .join(" dinginVZ")
          .split(" sering")
          .join(" seringVZ")
          .split(" tega")
          .join(" tegaVZ")
          .split(" malu")
          .join(" maluVZ")
          .split(" hitam")
          .join(" hitamVZ")
          .split(" lapar")
          .join(" laparVZ")
          .split(" malam")
          .join(" malamVZ")
          .split(" pintar")
          .join(" pintarVZ")
          .split(" nikmat")
          .join(" nikmatVZ")
          .split(" santun")
          .join(" santunVZ")
          .split(" hebat")
          .join(" hebatVZ")
          .split(" susah")
          .join(" susahVZ")
          .split(" gawat")
          .join(" gawatVZ")
          .split(" kagum")
          .join(" kagumVZ")
          .split(" pengap")
          .join(" pengapVZ")
          .split(" ironis")
          .join(" ironisVZ")
          .split(" sombong")
          .join(" sombongVZ")
          .split(" berat")
          .join(" beratVZ")
          .split(" buruk")
          .join(" burukVZ")
          .split(" cantik")
          .join(" cantikVZ")
          .split(" dekat")
          .join(" dekatVZ")
          .split(" lelah")
          .join(" lelahVZ")
          .split(" senang")
          .join(" senangVZ")
          .split(" mirip")
          .join(" miripVZ")
          .split(" berbeda")
          .join(" berbedaVZ")
          .split(" beda")
          .join(" bedaVZ")
          .split(" jorok")
          .join(" jorokVZ")
          .split(" cepat")
          .join(" cepatVZ")
          .split(" terutama")
          .join(" terutamaVZ")
          .split(" sayang")
          .join(" sayangVZ")
          .split("dikit")
          .join("dikitVZ")
          .split(" jarang")
          .join(" jarangVZ")
          .split(" ajar")
          .join(" ajarVZ")
          .split(" banyak")
          .join(" banyakVZ")
          .split(" besar")
          .join(" besarVZ")
          .split(" suka")
          .join(" sukaVZ")
          .split(" marah")
          .join(" marahVZ")
          .split(" benci")
          .join(" benciVZ")
          .split(" kangen")
          .join(" kangenVZ")
          .split(" rindu")
          .join(" rinduVZ")
          .split(" cinta")
          .join(" cintaVZ")
          .split(" hancur")
          .join(" hancurVZ")
          .split(" asyik")
          .join(" asyikVZ")
          .split(" pandai")
          .join(" pandaiVZ")
          .split(" panas")
          .join(" panasVZ")
          .split(" bingung")
          .join(" bingungVZ")
          .split("ramah")
          .join("ramahVZ")
          .split(" tahu")
          .join(" tahuVZ")
          .split(" setuju")
          .join(" setujuVZ")
          .split("akut")
          .join("akutVZ")
          .split("malas")
          .join("malasVZ")
          .split(" heran")
          .join(" heranVZ")
          .split(" mantap")
          .join(" mantapVZ")
          .split(" suka")
          .join(" sukaVZ")
          .split(" berani")
          .join(" beraniVZ")
          .split(" mau")
          .join(" mauVZ")
          .split(" hampir")
          .join(" hampirVZ")
          .split(" tinggi")
          .join(" tinggiVZ")
          .split(" rendah")
          .join(" rendahVZ")
          .split(" empuk")
          .join(" empukVZ")
          .split(" keras")
          .join(" kerasVZ")
          .split(" dalam")
          .join(" dalamVZ")
          .split(" luar")
          .join(" luarVZ")
          .split(" gemar")
          .join(" gemarVZ")
          .split(" miskin")
          .join(" miskinVZ")
          .split(" hina")
          .join(" hinaVZ")
          .split(" bermanfaat")
          .join(" bermanfaatVZ")
          .split(" berkhasiat")
          .join(" berkhasiatVZ")
          .split(" manjur")
          .join(" manjurVZ")
          .split(" kaya")
          .join(" kayaVZ")
          .split(" rajin")
          .join(" rajinVZ")
          .split(" ganteng")
          .join(" gantengVZ")
          .split(" gagah")
          .join(" gagahVZ")
          .split(" manis")
          .join(" manisVZ")
          .split(" pahit")
          .join(" pahitVZ")
          .split(" miring")
          .join(" miringVZ")
          .split(" haus")
          .join(" hausVZ")
          .split(" mengantuk")
          .join(" mengantukVZ")
          .split(" jelek")
          .join(" jelekVZ")
          .split(" kontras")
          .join(" kontrasVZ")
          .split(" kencang")
          .join(" kencangVZ")
          .split(" konyol")
          .join(" konyolVZ")
          .split(" merdu")
          .join(" merduVZ")
          .split(" lezat")
          .join(" lezatVZ")
          .split(" muda")
          .join(" mudaVZ")
          .split(" tua")
          .join(" tuaVZ")
          .split(" cemas")
          .join(" cemasVZ")
          .split(" lebar")
          .join(" lebarVZ")
          .split(" putih")
          .join(" putihVZ")
          .split(" basah")
          .join(" basahVZ")
          .split(" lemah")
          .join(" lemahVZ")
          .split(" terlantar")
          .join(" terlantarVZ")
          .split(" kasihan")
          .join(" kasihanVZ")
          .split(" tepat")
          .join(" tepatVZ")
          .split(" masam")
          .join(" masamVZ")
          .split(" serasi")
          .join(" serasiVZ")
          .split(" menakjubkan")
          .join(" menakjubkanVZ")
          .split(" lucu")
          .join(" lucuVZ")
          .split(" geli")
          .join(" geliVZ")
          .split(" kuno")
          .join(" kunoVZ")
          .split(" gelisah")
          .join(" gelisahVZ")
          .split(" mengagumkan")
          .join(" mengagumkanVZ")
          .split(" mengerikan")
          .join(" mengerikanVZ")
          .split(" indah")
          .join(" indahVZ")
          .split(" bermanfaat")
          .join(" bermanfaatVZ")
          .split(" aneh")
          .join(" anehVZ")
          .split(" biru")
          .join(" biruVZ")
          .split(" berani")
          .join(" beraniVZ")
          .split(" singkat")
          .join(" singkatVZ")
          .split(" luas")
          .join(" luasVZ")
          .split(" rusak")
          .join(" rusakVZ")
          .split(" tenang")
          .join(" tenangVZ")
          .split(" cermat")
          .join(" cermatVZ")
          .split(" murah")
          .join(" murahVZ")
          .split(" mahal")
          .join(" mahalVZ")
          .split(" tembem")
          .join(" tembemVZ")
          .split(" berkelas")
          .join(" berkelasVZ")
          .split(" bersih")
          .join(" bersihVZ")
          .split(" jernih")
          .join(" jernihVZ")
          .split(" ceroboh")
          .join(" cerobohVZ")
          .split(" nyaman")
          .join(" nyamanVZ")
          .split(" umum")
          .join(" umumVZ")
          .split(" lengkap")
          .join(" lengkapVZ")
          .split(" keren")
          .join(" kerenVZ")
          .split(" menyeramkan")
          .join(" menyeramkanVZ")
          .split(" menyedihkan")
          .join(" menyedihkanVZ")
          .split(" kejam")
          .join(" kejamVZ")
          .split(" keriting")
          .join(" keritingVZ")
          .split(" imut")
          .join(" imutVZ")
          .split(" berbahaya")
          .join(" berbahayaVZ")
          .split(" gelap")
          .join(" gelapVZ")
          .split(" halus")
          .join(" halusVZ")
          .split("enangkan")
          .join("enangkanVZ")
          .split(" jahat")
          .join(" jahatVZ")
          .split("tis ")
          .join("tisVZ ")
          .split(" kering")
          .join(" keringVZ")
          .split(" berdebu")
          .join(" berdebuVZ")
          .split(" dinamis")
          .join(" dinamisVZ")
          .split(" awal")
          .join(" awalVZ")
          .split(" mudah")
          .join(" mudahVZ")
          .split(" elegan")
          .join(" eleganVZ")
          .split(" menghibur")
          .join(" menghiburVZ")
          .split(" unggul")
          .join(" unggulVZ")
          .split(" eksklusif")
          .join(" eksklusifVZ")
          .split(" eksotis")
          .join(" eksotisVZ")
          .split(" adil")
          .join(" adilVZ")
          .split(" setia")
          .join(" setiaVZ")
          .split(" akrab")
          .join(" akrabVZ")
          .split(" terkenal")
          .join(" terkenalVZ")
          .split("stis ")
          .join("stisVZ ")
          .split(" irit")
          .join(" iritVZ")
          .split(" datar")
          .join(" datarVZ")
          .split(" pelupa")
          .join(" pelupaVZ")
          .split("untung")
          .join("untungVZ")
          .split(" rapuh")
          .join(" rapuhVZ")
          .split(" bebas")
          .join(" bebasVZ")
          .split("beku")
          .join("bekuVZ")
          .split(" segar")
          .join(" segarVZ")
          .split(" lembut")
          .join(" lembutVZ")
          .split(" berbakat")
          .join(" berbakatVZ")
          .split(" glamor")
          .join(" glamorVZ")
          .split(" boros")
          .join(" borosVZ")
          .split(" anggun")
          .join(" anggunVZ")
          .split(" berminyak")
          .join(" berminyakVZ")
          .split(" serakah")
          .join(" serakahVZ")
          .split(" hijau")
          .join(" hijauVZ")
          .split(" pemarah")
          .join(" pemarahVZ")
          .split(" tampan")
          .join(" tampanVZ")
          .split(" berdaya")
          .join(" berdayaVZ")
          .split(" riang")
          .join(" riangVZ")
          .split(" menyeluruh")
          .join(" menyeluruhVZ")
          .split(" bebal")
          .join(" bebalVZ")
          .split(" sakit")
          .join(" sakitVZ")
          .split(" sopan")
          .join(" sopanVZ")
          .split(" penting")
          .join(" pentingVZ")
          .split(" mungkin")
          .join(" mungkinVZ")
          .split(" meyakinkan")
          .join(" meyakinkanVZ")
          .split("biasa")
          .join("biasaVZ")
          .split("bahayakan")
          .join("bahayakanVZ")
          .split(" gatal")
          .join(" gatalVZ")
          .split("buru")
          .join("buruVZ")
          .split(" berair")
          .join(" berairVZ")
          .split("kenal")
          .join("kenalVZ")
          .split(" timpang")
          .join(" timpangVZ")
          .split("akhir")
          .join("akhirVZ")
          .split("lambat")
          .join("lambatVZ")
          .split(" lincah")
          .join(" lincahVZ")
          .split(" longgar")
          .join(" longgarVZ")
          .split(" mewah")
          .join(" mewahVZ")
          .split(" sakti")
          .join(" saktiVZ")
          .split(" ajaib")
          .join(" ajaibVZ")
          .split("besaran")
          .join("besaranVZ")
          .split(" cair")
          .join(" cairVZ")
          .split(" kacau")
          .join(" kacauVZ")
          .split(" berantakan")
          .join(" berantakanVZ")
          .split(" modern")
          .join(" modernVZ")
          .split(" lembek")
          .join(" lembekVZ")
          .split(" misterius")
          .join(" misteriusVZ")
          .split(" naif")
          .join(" naifVZ")
          .split(" sempit")
          .join(" sempitVZ")
          .split(" mini")
          .join(" miniVZ")
          .split("iah")
          .join("iahVZ")
          .split(" nakal")
          .join(" nakalVZ")
          .split(" perlu")
          .join(" perluVZ")
          .split(" gugup")
          .join(" gugupVZ")
          .split(" berisik")
          .join(" berisikVZ")
          .split(" normal")
          .join(" normalVZ")
          .split(" bergizi")
          .join(" bergiziVZ")
          .split(" taat")
          .join(" taatVZ")
          .split(" gemuk")
          .join(" gemukVZ")
          .split(" gendut")
          .join(" gendutVZ")
          .split(" kuna")
          .join(" kunaVZ")
          .split("lebihan")
          .join("lebihanVZ")
          .split(" menyakitkan")
          .join(" menyakitkanVZ")
          .split(" panik")
          .join(" panikVZ")
          .split(" sempurna")
          .join(" sempurnaVZ")
          .split("kecil")
          .join("kecilVZ")
          .split("mungil")
          .join("mungilVZ")
          .split(" polos")
          .join(" polosVZ")
          .split(" berarti")
          .join(" berartiVZ")
          .split("kuasa")
          .join("kuasaVZ")
          .split(" bangga")
          .join(" banggaVZ")
          .split("banggakan")
          .join("banggakanVZ")
          .split("diam")
          .join("diamVZ")
          .split(" unik")
          .join(" unikVZ")
          .split(" lega")
          .join(" legaVZ")
          .split(" menjijikan")
          .join(" menjijikanVZ")
          .split(" busuk")
          .join(" busukVZ")
          .split(" bulat")
          .join(" bulatVZ")
          .split(" pedesaan")
          .join(" pedesaanVZ")
          .split(" perkotaan")
          .join(" perkotaanVZ")
          .split(" aman")
          .join(" amanVZ")
          .split(" asin")
          .join(" asinVZ")
          .split(" memuaskan")
          .join(" memuaskanVZ")
          .split(" egois")
          .join(" egoisVZ")
          .split(" dangkal")
          .join(" dangkalVZ");
        var TrIT = TliT.split(" buncit")
          .join(" buncitVZ")
          .split("kilau")
          .join("kilauVZ")
          .split(" pendek")
          .join(" pendekVZ")
          .split(" bodoh")
          .join(" bodohVZ")
          .split(" mahir")
          .join(" mahirVZ")
          .split(" kurus")
          .join(" kurusVZ")
          .split(" padat")
          .join(" padatVZ")
          .split(" kotak")
          .join(" kotakVZ")
          .split(" curam")
          .join(" curamVZ")
          .split(" lengket")
          .join(" lengketVZ")
          .split(" lurus")
          .join(" lurusVZ")
          .split(" kuat")
          .join(" kuatVZ")
          .split(" hambar")
          .join(" hambarVZ")
          .split(" tegang")
          .join(" tegangVZ")
          .split(" tipis")
          .join(" tipisVZ")
          .split(" muak")
          .join(" muakVZ")
          .split("uakkan ")
          .join("uakkanVZ ")
          .split("pikirkan ")
          .join("pikirkanVZ ")
          .split(" mengamcam")
          .join(" mengancamVZ")
          .split(" sulit")
          .join(" sulitVZ")
          .split("sulitkan ")
          .join("sulitkanVZ ")
          .split(" khas")
          .join(" khasVZ")
          .split(" mampu")
          .join(" mampuVZ")
          .split(" rata")
          .join(" rataVZ")
          .split(" tertarik")
          .join(" tertarikVZ")
          .split(" berguna")
          .join(" bergunaVZ")
          .split("jaya")
          .join("jayaVZ")
          .split(" hangat")
          .join(" hangatVZ")
          .split(" kuning")
          .join(" kuningVZ")
          .split("luruh")
          .join("luruhVZ")
          .split(" jenaka")
          .join(" jenakaVZ")
          .split(" berguna")
          .join(" bergunaVZ")
          .split(" tersinggung")
          .join(" tersinggungVZ")
          .split(" bersalah")
          .join(" bersalahVZ")
          .split(" jelas")
          .join(" jelasVZ")
          .split(" bandel")
          .join(" bandelVZ")
          .split("buas ")
          .join("buasVZ ")
          .split("ragu")
          .join("raguVZ")
          .split("VZ sekali")
          .join(" banget")
          .split("VZ ")
          .join(" ")
          .split("VZ")
          .join("");
        var TeT = TrIT.split(" daun melinjo")
          .join(" so")
          .split(" es batu")
          .join(" es-batu")
          .split(" batu es ")
          .join(" batu-es ")
          .split(" baru paham")
          .join(" nembe paham")
          .split(" baru faham")
          .join(" nembe paham")
          .split(" baru me")
          .join(" nembe me")
          .split(" baru sadar")
          .join(" nembe sadar")
          .split(" lalu langsung")
          .join(" lajeng langsung")
          .split(" pencukur rambut")
          .join(" tukang cukur rambut")
          .split(" tas plastik")
          .join(" tas kresek")
          .split("air mata")
          .join("air-mata")
          .split("lebih lebih")
          .join("lebih-lebih")
          .split("terlebih lagi")
          .join("napa malih")
          .split(" cuci tangan")
          .join(" wisuh")
          .split(" akan beredar")
          .join(" akan dijual")
          .split(" belum beredar")
          .join(" belum dijual")
          .split(" kamar kecil")
          .join(" wingking")
          .split(" ganti baju")
          .join(" salin")
          .split(" ganti pakaian")
          .join(" salin")
          .split(" ya all")
          .join(" ya-all")
          .split("quran")
          .join("qur'an")
          .split("alqur'an")
          .join("al-qur'an")
          .split(" baca qur'an")
          .join(" nderes qur'an")
          .split(" membaca al-qur'an")
          .join(" nderes al-qur'an")
          .split(" membaca qur'an")
          .join(" nderes qur'an")
          .split(" baca al-qur'an")
          .join(" nderes al-qur'an")
          .split("tanggung jawab")
          .join("tanggung-jawab")
          .split(" tingkatan bertutur")
          .join(" unggah-ungguh bertutur")
          .split(" tingkatan bahasa")
          .join(" unggah-ungguh bahasa")
          .split(" memberitahu")
          .join(" memberi tahu")
          .split(" diberitahu")
          .join(" diberi tahu")
          .split(" sama sekaligus")
          .join(" sama sisan")
          .split(" ulang tahun")
          .join(" ambal tahun")
          .split(" selamat jalan")
          .join(" selamat berjalan")
          .split(" bersenda gurau")
          .join(" bercanda")
          .split(" bersendau gurau")
          .join(" bercanda")
          .split(" meninggal dunia")
          .join(" meninggal-dunia")
          .split(" pukul 0")
          .join(" jam 0")
          .split(" pukul 2")
          .join(" jam 2")
          .split(" pukul 3 ")
          .join(" jam 3 ")
          .split(" pukul 4 ")
          .join(" jam 4 ")
          .split(" pukul 5 ")
          .join(" jam 5 ")
          .split(" pukul 6 ")
          .join(" jam 6 ")
          .split(" pukul 7 ")
          .join(" jam 7 ")
          .split(" pukul 8 ")
          .join(" jam 8 ")
          .split(" pukul 9 ")
          .join(" jam 9 ")
          .split(" santun sekali")
          .join(" santun sanget")
          .split(" hebat sekali")
          .join(" hebat sanget")
          .split(" susah sekali")
          .join(" susah sanget")
          .split(" gawat sekali")
          .join(" gawat sanget")
          .split(" kagum sekali")
          .join(" kagum sanget")
          .split(" ketidak")
          .join(" ketidak ")
          .split(" pengap sekali")
          .join(" pengap sanget")
          .split(" buruk sekali")
          .join(" buruk sanget")
          .split(" cantik sekali")
          .join(" cantik sanget")
          .split(" dekat sekali")
          .join(" dekat sanget")
          .split(" bilang sama ")
          .join(" bilang dengan ")
          .split(" baru kelihatan")
          .join(" nembe kelihatan")
          .split(" bahan baku")
          .join(" bahan bakuu")
          .split(" bersama sama")
          .join(" bersama-sama")
          .split(" suku kata")
          .join(" suku-kata")
          .split(" lelah sekali")
          .join(" lelah sanget")
          .split(" belum biasa")
          .join(" belum terbiasa")
          .split(" mahu?")
          .join(" purun?")
          .split(" mau?")
          .join(" purun?")
          .split(" mau tidak?")
          .join(" purun tidak?")
          .split(" mau apa tidak?")
          .join(" purun apa tidak?")
          .split(" habis ini")
          .join(" setelah ini")
          .split(" bulu mata")
          .join(" bulu-mata")
          .split(" apa kabar")
          .join(" kepripunn kabar")
          .split(" bersama sama")
          .join(" bersama-sama")
          .split(" berjalan jalan")
          .join(" berjalan-jalan")
          .split(" ke sana")
          .join(" mrika")
          .split(" di sana")
          .join(" di ngrika")
          .split(" ke sini")
          .join(" mriki")
          .split(" di sini")
          .join(" di ngriki")
          .split(" ke situ")
          .join(" mriku")
          .split(" di situ")
          .join(" di ngriku")
          .split(" dari sana")
          .join(" dari ngrika")
          .split(" dari sini")
          .join(" dari ngriki")
          .split(" dari situ")
          .join(" dari ngriku")
          .split(" nenek moyang")
          .join(" mbah moyang")
          .split(" lahir dan batin")
          .join(" lair dan batin")
          .split("siswa lain")
          .join("siswa sanes")
          .split("kelas lain")
          .join("kelas sanes")
          .split("kota lain")
          .join("kota sanes")
          .split("kabupaten lain")
          .join("kabupaten sanes")
          .split("negara lain")
          .join("negara sanes")
          .split("planet lain")
          .join("planet sanes")
          .split(" mereka semua")
          .join(" mereka")
          .split("ak tahuu")
          .join("ak tahu")
          .split("lain lain")
          .join("lain-lain")
          .split("sisi lain")
          .join("sisi sanes")
          .split("pihak lain")
          .join("pihak sanes")
          .split(" luar jawa")
          .join(" luarnya jawa")
          .split("kan lain")
          .join("kan sanes")
          .split(" teng sini")
          .join(" teng ngriki")
          .split(" teng sana")
          .join(" teng ngrika")
          .split(" teng situ")
          .join(" teng ngriku")
          .split(" lahir batin")
          .join(" lair batin")
          .split("daerah lain")
          .join("daerah sanes")
          .split("media lain")
          .join("media sanes")
          .split(" salah satu")
          .join(" salah-satu")
          .split(") lalu.")
          .join(") kepengker.")
          .split(" ya rob")
          .join(" ya-rob")
          .split("kasus lain")
          .join("kasus bukan")
          .split(" pekan lalu")
          .join(" pekan kepengker")
          .split(" terdapat di ")
          .join(" wonten ")
          .split(" tadi malam")
          .join(" wau malam")
          .split("hal tentang ")
          .join("hal mengenai ")
          .split(" sama siapa")
          .join(" dengan siapa")
          .split("1 kali ")
          .join("1 kalix ")
          .split("2 kali ")
          .join("2 kalix ")
          .split("3 kali ")
          .join("3 kalix ")
          .split("4 kali ")
          .join("4 kalix ")
          .split("5 kali ")
          .join("5 kalix ")
          .split("6 kali ")
          .join("6 kalix ")
          .split("7 kali ")
          .join("7 kalix ")
          .split("8 kali ")
          .join("8 kalix ")
          .split("9 kali ")
          .join("9 kalix ")
          .split("0 kali ")
          .join("0 kalix ")
          .split(" lagi di ")
          .join(" sedang di ")
          .split(" edisi lalu")
          .join(" edisi silam")
          .split(" sangat lah ")
          .join(" sangat-lah ")
          .split(" sekitar sini")
          .join(" sekitar ngriki")
          .split(" sekitar situ")
          .join(" sekitar ngriku")
          .split("sebelah sana")
          .join("sebelah ngrika")
          .split("sebelah sini")
          .join("sebelah ngriki")
          .split("sebelah situ")
          .join("sebelah ngriku")
          .split("bagian sana")
          .join("bagian ngrika")
          .split("bagian sini")
          .join("bagian ngriki")
          .split("bagian situ")
          .join("bagian ngriku")
          .split(" keburu nafsu")
          .join(" keburu-nafsu")
          .split(" orang utan")
          .join(" orang-utan")
          .split(" peran serta")
          .join(" peran-serta")
          .split(" ada pun ")
          .join(" ada-pun ")
          .split(" tergesa gesa")
          .join(" tergesa-gesa")
          .split(" air bah ")
          .join(" bena ")
          .split("bolak balik")
          .join("bolak-balik")
          .split(" tahu menahu")
          .join(" menahu")
          .split(" anak cicak")
          .join(" sawiyah")
          .split(" ayam jantan")
          .join(" sawung")
          .split(" anak kerbau")
          .join(" gudel")
          .split(" tidak mengapa")
          .join(" tidak apa-apa")
          .split(" biar saja")
          .join(" biarlah saja")
          .split(" sudahlah biar")
          .join(" sudahlah biarlah")
          .split(" terus menerus")
          .join(" terus-menerus")
          .split(" individu lain")
          .join(" individu bukan")
          .split(" baik bu ")
          .join(" baikk bu ")
          .split(" baik pak ")
          .join(" baikk pak ")
          .split(" terlalu jauh")
          .join(" katebihen")
          .split(" tidak terlalu")
          .join(" tidak patos")
          .split(" tak terlalu")
          .join(" tak patos")
          .split(" gak terlalu")
          .join(" tidak patos")
          .split(" sekali lagi,")
          .join(" sepindah lagi,")
          .split(" sekarang ini ")
          .join(" sekarang ")
          .split(" cerita pendek")
          .join(" cerita cekak")
          .split("belanda")
          .join("walandi")
          .split(" belum begitu ")
          .join(" dereng patos ")
          .split(" maka dari itu")
          .join(" pramila")
          .split(" oleh karena itu")
          .join(" pramila")
          .split(" oleh sebab itu")
          .join(" pramila ")
          .split(" oleh karenanya")
          .join(" pramila")
          .split(" oleh sebabnya")
          .join(" pramila")
          .split(" oleh sebab")
          .join(" pramila")
          .split(" oleh karena")
          .join(" pramila")
          .split(" pramila maka")
          .join(" pramila")
          .split(" lagi ngapa")
          .join(" sedang ngapa")
          .split(" hal hal ")
          .join(" hal-hal ")
          .split(" habis diajak")
          .join(" bibar diajak")
          .split(" yang empunya")
          .join(" ingkang punya")
          .split(" yg empunya")
          .join(" ingkang punya")
          .split(" tidak lain ")
          .join(" tidak bukan ")
          .split(" lagi dirawat")
          .join(" sedang dirawat")
          .split(" pemain lain")
          .join(" pemain bukan")
          .split(" strategi lain")
          .join(" strategi bukan")
          .split(" jadi pergi")
          .join(" sida pergi")
          .split(" ke timur")
          .join(" ngetan")
          .split(" ke selatan")
          .join(" ngidul")
          .split(" ke barat")
          .join(" ngilen")
          .split(" ke utara")
          .join(" ngaler")
          .split("tempat lain")
          .join("tempat sanes")
          .split(" mau tak")
          .join(" gelem tak")
          .split("pulau lain")
          .join("pulau sanes")
          .split("musik lain")
          .join("musik sanes")
          .split("ulang ulang")
          .join("ulang-ulang")
          .split(" berulang-ulang kali ")
          .join(" kaping pinten-pinten ")
          .split("hari lain")
          .join("hari sanes")
          .split("an lain")
          .join("an sanes")
          .split("ruang lain")
          .join("ruang sanes")
          .split("petisi lain")
          .join("petisi sanes")
          .split("laki lain")
          .join("laki sanes")
          .split("pria lain")
          .join("pria sanes")
          .split("wanita lain")
          .join("wanita sanes")
          .split("gadis lain")
          .join("gadis sanes")
          .split("yg lain")
          .join("yg sanes")
          .split(" kembali meng")
          .join(" malih meng")
          .split("kumpul kembali ")
          .join("kumpul malih ")
          .split(" pemuda pemud")
          .join(" pemuda-pemud")
          .split(" bahwasannya ")
          .join(" kalau sebenarnya ")
          .split(" bahwasanya ")
          .join(" kalau sebenarnya ")
          .split(" terlalu banyak")
          .join(" kakathahen")
          .split(" tinggal dahulu")
          .join(" tilar dahulu")
          .split(" tinggal dulu")
          .join(" tilar dulu")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx")
          .split("xxx")
          .join("xxx");
        var ToT = TeT.split("april lalu")
          .join("april wingi")
          .split("mei lalu")
          .join("mei wingi")
          .split("juni lalu")
          .join("juni wingi")
          .split("juli lalu")
          .join("juli wingi")
          .split("stus lalu")
          .join("stus wingi")
          .split("mber lalu")
          .join("mber wingi")
          .split("ober lalu")
          .join("ober wingi")
          .split(" cikal bakal")
          .join(" cikalbakal")
          .split(" berlaku untuk")
          .join(" berlaku ngge")
          .split(" anak anak ")
          .join(" anak-anak ")
          .split("yang lain dari")
          .join("yang beda dari")
          .split("yang lain")
          .join("yang bukan")
          .split(" atau tidak")
          .join(" apa tidak")
          .split("senang sekali")
          .join("senang sanget")
          .split("mirip sekali")
          .join("mirip sanget")
          .split("berbeda sekali")
          .join("berbeda sanget")
          .split("beda sekali")
          .join("beda sanget")
          .split("pada pukul ")
          .join("pada jam ")
          .split(" amat ")
          .join(" banget ")
          .split(", lalu di")
          .join(", lajengipun di")
          .split("tiada duanya ")
          .join("tiada samanya ")
          .split(" robiul ")
          .join(" rabiul ")
          .split("jorok sekali ")
          .join("jorok sanget ")
          .split(" berumah tangga")
          .join(" berumah-tangga")
          .split(" tdk ")
          .join(" tak ")
          .split(" kaca mata")
          .join(" kaca-mata")
          .split(" sedang.")
          .join("sedeng.")
          .split(" sedang,")
          .join("sedeng,")
          .split("perorang")
          .join("per orang")
          .split(" atas segala ")
          .join(" atas semua ")
          .split(" di jemur ")
          .join(" dijemur ")
          .split(" lha wong ")
          .join(" dadah ")
          .split(" piring kecil ")
          .join(" pisin ")
          .split(" berikut ini")
          .join(" berikut-ini")
          .split(" mengeroyok")
          .join(" ngroyok")
          .split(" keroyok")
          .join(" kroyok")
          .split(" berjalan kaki")
          .join(" mlampah")
          .split(" jalan kaki")
          .join(" mlampah")
          .split(" ini baru ")
          .join(" ini nembe ")
          .split("lompat lompat")
          .join("lompat-lompat")
          .split("pasta gigi")
          .join("odol")
          .split(" kamar mandi")
          .join(" belakang")
          .split("sandaran")
          .join("sendehan")
          .split(" minyak goreng")
          .join(" minyak klentik")
          .split(" baru saja")
          .join(" nembe saja")
          .split(" kasih bocoran")
          .join(" memberi bocoran")
          .split(" daun bawang")
          .join(" kuncar")
          .split(" bunga bawang")
          .join(" lengeng")
          .split(" kapak")
          .join(" prekul")
          .split(" suami istri")
          .join(" suami-istri")
          .split(" suami isteri")
          .join(" suami-istri")
          .split(" tidak berubah")
          .join(" ajeg")
          .split(" buat guru")
          .join(" untuk guru")
          .split(" yang lalu")
          .join(" yang rumiyin")
          .split(" rabiul awal")
          .join(" mulud")
          .split(" rabiul akhir")
          .join(" bakdamulud")
          .split(" jumadil awal")
          .join(" jumadilawal")
          .split(" jumadil akhir")
          .join(" jumadilakir")
          .split(" sya ' ban")
          .join(" ruwah")
          .split(" besar atau sedang ")
          .join(" besar atau sedeng ")
          .split("luar biasa")
          .join("luarbiasa")
          .split(" cuci gudang")
          .join(" cucii gudang")
          .split(" mengada ada")
          .join(" mengada-ada")
          .split(" salah seorang")
          .join(" salahh seorang")
          .split(" anak sekolah")
          .join(" bocah sekola")
          .split("sekali lagi")
          .join("sapisan lagi")
          .split(" saya marahi")
          .join(" tak omongi")
          .split(" lemah lembut")
          .join(" tanah lembut")
          .split(" baru sampai")
          .join(" baru tiba")
          .split(" sampai di ")
          .join(" tiba di ")
          .split(" lalu gimana")
          .join(" lajengipun gimana")
          .split("lalu bagaimana")
          .join("lajengipun pripunn")
          .split(" kerja bakti")
          .join(" kerja-bakti")
          .split(" tahu kuping")
          .join(" tahuu kuping")
          .split(" tinggal minta")
          .join(" nggari minta")
          .split(" tinggal meminta")
          .join(" nggari minta")
          .split(" kasih tahu")
          .join(" memberi tahu")
          .split("baru kemudian")
          .join("baru lajengipun")
          .split("kalau begitu")
          .join("kalo begitu")
          .split(" lauk pauk")
          .join(" laukk pauk")
          .split(" jadi ikut")
          .join(" sida ikut")
          .split(" jadi ke ")
          .join(" sida ke ")
          .split("bergandengan tangan")
          .join("pedangan tangan")
          .split("menggandeng tangan")
          .join("medang tangan")
          .split("bergandeng tangan")
          .join("pedangan tangan")
          .split(" saya kira")
          .join(" takk kira")
          .split(" tahu sumedang")
          .join(" tahuu sumedang")
          .split(" tahu aci")
          .join(" tahuu aci")
          .split(" tolak ukur")
          .join(" tolok ukur")
          .split(" anak kecil")
          .join(" bocah kecil")
          .split(" sama aku")
          .join(" kalih aku")
          .split(" sama kamu")
          .join(" kalih kamu")
          .split(" sama dia")
          .join(" kalih dia")
          .split(" sama saya")
          .join(" kalih saya")
          .split(" mana mungkin")
          .join(" tidak mungkin")
          .split(" baru berjalan")
          .join(" nembe mlaku")
          .split(" baru jalan")
          .join(" nembe mlaku")
          .split("baik itu")
          .join("baikk itu")
          .split(" sebelah utara")
          .join(" sisi utara")
          .split(" sebelah barat")
          .join(" sisi barat")
          .split(" sebelah selatan")
          .join(" sisi selatan")
          .split(" sebelah timur")
          .join(" sisi timur")
          .split(" lalu jam")
          .join(" lajengipun jam")
          .split(" lalu diarahkan")
          .join(" lajengipun diarahkan")
          .split("jumat lalu")
          .join("jumat wingi")
          .split("sabtu lalu")
          .join("sabtu wingi")
          .split(" membukakan pintu")
          .join(" ngeblegna pintu")
          .split("jum'at lalu")
          .join("jumat wingi")
          .split("belum sampai")
          .join("belum tiba")
          .split("1 lalu")
          .join("1 silam")
          .split("cepat sekali")
          .join("enggal sanget")
          .split("urusan belakangan")
          .join("urusan mburi-mburian")
          .split(" ya tuhan ")
          .join(" ya-allah ")
          .split(" ya allah")
          .join(" ya-allah")
          .split("bertelanjang dada")
          .join("lukar baju")
          .split("telanjang dada")
          .join("lukar baju")
          .split(" kalau kata")
          .join(" kalo trose")
          .split(" hujan lebat")
          .join(" hujan gemerot")
          .split("kereta kuda")
          .join("dokar")
          .split("gula batu")
          .join("gulabatu")
          .split(" belajar naik")
          .join(" genau menaiki")
          .split(" belajar menaiki")
          .join(" genau menaiki")
          .split(" tak mau")
          .join(" tidak setuju")
          .split(" baru datang")
          .join(" nembe datang")
          .split(" baru tiba")
          .join(" nembe datang")
          .split(" melainkan karena")
          .join(" ananging karena")
          .split(" di mulai")
          .join(" dilekasi")
          .split(" minyak sayur")
          .join(" minyak klentik")
          .split(" minyak tanah")
          .join(" minyak gas")
          .split("terutama sekali")
          .join("terutama sanget")
          .split(" mandi keringat")
          .join(" keringatnya byuk-byukan")
          .split(" bermandikan keringat")
          .join(" keringatnya byuk-byukan")
          .split(" bersimbah keringat")
          .join(" keringatnya byuk-byukan")
          .split(" pertama kali")
          .join(" kaping sapisan")
          .split(" tahun lalu")
          .join(" tahun wingi")
          .split("bulan lalu")
          .join("bulan wingi")
          .split("minggu lalu")
          .join("minggu wingi")
          .split(" sebelah ler")
          .join(" sisi ler")
          .split(" sebelah kidul")
          .join(" sisi kidul")
          .split(" sebelah wetan")
          .join(" sisi wetan")
          .split(" sebelah kilen")
          .join(" sisi kilen")
          .split(" dan juga")
          .join(" saha")
          .split(" baikk daripada")
          .join(" baik daripada")
          .split(" mencuci baju")
          .join(" nggirahi baju")
          .split(" cuci baju")
          .join(" nggirahi baju")
          .split(" mencuci pakaian")
          .join(" nggirahi pakaian")
          .split(" cuci pakaian")
          .join(" nggirahi pakaian")
          .split(" mencuci piring")
          .join(" isah-isah piring")
          .split(" cuci piring")
          .join(" isah-isah piring")
          .split(" cuci muka")
          .join(" raupp")
          .split("2 lalu")
          .join("2 silam")
          .split("sebulan sekali")
          .join("sebulan sapisan")
          .split(" kakak beradik")
          .join(" kakang adi")
          .split(" bukan main ")
          .join(" por sanget ")
          .split(" abu bakar")
          .join(" abubakar")
          .split(" bulu tangkis")
          .join(" minton")
          .split("tanah liat")
          .join("lempung")
          .split(" sepeda motor")
          .join(" motor")
          .split(" naik bis")
          .join(" menaiki bis")
          .split("pesawat terbang")
          .join("montor terbang")
          .split("pesawat udara")
          .join("montor terbang")
          .split(" naik angkot")
          .join(" nitih angkot")
          .split("mencuci muka")
          .join("raupp")
          .split("sayang sekali")
          .join("eman-eman sanget")
          .split(" sepak bolanya")
          .join(" bal-balane")
          .split(" gak mau")
          .join(" tidak setuju")
          .split(" berulang kali ")
          .join(" kaping pinten-pinten ")
          .split(" dua kali ")
          .join(" kaping dua ")
          .split(" tiga kali ")
          .join(" kaping tiga ")
          .split(" beberapa kali ")
          .join(" ping pinten-pinten ")
          .split(" membabi buta")
          .join(" mbabi buta")
          .split("membuat tahu")
          .join("membuat tahuu")
          .split(" musim lalu")
          .join(" musim kala-wingi")
          .split(" hari lalu")
          .join(" hari wingi")
          .split(" selamat tahun")
          .join(" sugeng tahun")
          .split("sedikit sekali")
          .join("sedikit sanget")
          .split(" abad lalu")
          .join(" abad rumiyin")
          .split(" bulan sekali")
          .join(" wulan sapisan")
          .split(" bertingkah laku")
          .join(" bertingkah lakuu")
          .split(" tingkah laku")
          .join(" tingkah-laku")
          .split("tempe tahu")
          .join("tempe tahuu")
          .split(" jarang sekali")
          .join(" jarang sanget")
          .split(" ajar sekali")
          .join(" ajar sanget")
          .split(" di karenakan")
          .join(" amargi")
          .split(" sepak bola")
          .join(" bal-balan")
          .split("tanah air")
          .join("tanah-air")
          .split("kereta api")
          .join("sepur")
          .split(" naik sepur")
          .join(" menaiki sepur")
          .split(" sama sekali")
          .join(" babar pisan")
          .split(" keras kepala")
          .join(" tambeng")
          .split("fungsi lain")
          .join("fungsi sanes")
          .split(" tak ada ")
          .join(" tidak ada ")
          .split("xxx")
          .join("xxx")
          .split(" kaya gini")
          .join(" kayak ginii")
          .split(" kaya gitu")
          .join(" kayak gituu")
          .split(" dari pada")
          .join(" daripada")
          .split("terima kasih")
          .join("terima-kasih")
          .split("jangan mau")
          .join("jangan setuju")
          .split(" nggak mau")
          .join(" tidak setuju")
          .split(" ngga mau")
          .join(" tidak setuju")
          .split(" tak kan ")
          .join(" tak akan ")
          .split("kuala lumpur")
          .join("kuala-lumpur")
          .split(" jam segini")
          .join(" wanci segini")
          .split("naik daun")
          .join("naikdaun")
          .split("kerja keras")
          .join("kerjakeras")
          .split("ikan asin")
          .join("gesekk")
          .split("pandai berbicara")
          .join("ladak")
          .split("papan tulis")
          .join("blabag")
          .split(" di antara")
          .join(" ing antara")
          .split(" tak mengapa")
          .join(" tak apa-apa")
          .split("antara lain")
          .join("antara bukan")
          .split("dulu kala")
          .join("dulu sanget")
          .split("dahulu kala")
          .join("dahulu sanget")
          .split("di jalan")
          .join("di ratan")
          .split("banyak sekali")
          .join("banyak sanget")
          .split(" akan tetapi")
          .join(" ananging")
          .split("kebanyakan gaya")
          .join("ngaksi")
          .split(" tuh kan ")
          .join(" kweh ya ")
          .split(" tawar menawar")
          .join(" anyang-anyangan")
          .split("ukuran sedang")
          .join("ukuran sedeng")
          .split("babi hutan")
          .join("celeng")
          .split(" unjuk gigi")
          .join(" unjukgigi")
          .split(" mau tidak")
          .join(" setuju tidak")
          .split(" mau ga")
          .join(" setuju ga")
          .split("kerja sama")
          .join("kerjasama")
          .split("rumah sakit")
          .join("rumah-sakit")
          .split("sifat santai ")
          .join("sifat tidak resmi ")
          .split(" fakir miskin")
          .join(" fakirmiskin")
          .split("lain sebagainya")
          .join("lain-sebagainya")
          .split("mu ")
          .join("muâ™¦ ")
          .split("ku ")
          .join("kuâ™¦ ")
          .split("nya ")
          .join("nyeâ™¦ ")
          .split(" nyeâ™¦")
          .join("nyeâ™¦")
          .split(" ");
        var charsInCurrentLine = 0;
        var lineToTranslateCurrent = "";
        var lineTranslatedCurrent = "";
        for (var i = 0; i < ToT.length; i++) {
          var wordToTranslate = ToT[i].toLowerCase();
          if (ToT[i] == "mau")
            if (ToT[i + 2] == "tidak")
              if (ToT[i + 3] == "?") {
                ToT[i] = "gelem";
              }
          if (ToT[i] == "mau")
            if (ToT[i + 3] == "tidak")
              if (ToT[i + 4] == "?") {
                ToT[i] = "gelem";
              }
          if (ToT[i] == "lahir")
            if (ToT[i + 2] == "batin") {
              ToT[i] = "lair";
            }
          if (ToT[i] == "lahir")
            if (ToT[i + 3] == "batin") {
              ToT[i] = "lair";
            }
          if (ToT[i] == "di")
            if (ToT[i + 2] == "sini") {
              ToT[i + 2] = "ngriki";
            }
          if (ToT[i] == "di")
            if (ToT[i + 2] == "situ") {
              ToT[i + 2] = "ngriku";
            }
          if (ToT[i] == "di")
            if (ToT[i + 2] == "sana") {
              ToT[i + 2] = "ngrika";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 2] == "dan") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 3] == "dan") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 4] == "dan") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 5] == "dan") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 6] == "dan") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 2] == "atau") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 2] == "maupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 2] == "ataupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 3] == "atau") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 3] == "maupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 3] == "ataupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 4] == "atau") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 4] == "maupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 4] == "ataupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 5] == "atau") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 5] == "maupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 5] == "ataupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 6] == "atau") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 6] == "maupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 6] == "ataupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 7] == "atau") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 7] == "maupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 7] == "ataupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 8] == "atau") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 8] == "maupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 8] == "ataupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 9] == "atau") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 9] == "maupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "baik")
            if (ToT[i + 9] == "ataupun") {
              ToT[i] = "baikk";
            }
          if (ToT[i] == "ke") {
            ToT[i] = "dhateng";
          } else if (ToT[i].split(/[!-?]+/).join("") == "ke") {
            ToT[i] = "kee" + ToT[i].split(/[a-z]+/).join("");
          }
          if (ToT[i] == ToT[i])
            if (ToT[i + 1] == "kalix") {
              ToT[i + 1] = ToT[i];
              ToT[i] = " kalix ";
            }
          if (ToT[i] == "sangat")
            if (ToT[i + 1] == null) {
              ToT[i] = wordToTranslate;
            } else {
              ToT[i] = ToT[i + 1].split(/[!-?]+/).join("");
              ToT[i + 1] = "sanget" + ToT[i + 1].split(/[a-zâ™¦]+/).join("");
            }
          if (ToT[i] == "sanget")
            if (ToT[i + 1] == null) {
              ToT[i] = wordToTranslate;
            } else if (ToT[i + 1].split(/[!-?]+/).join("") == "sekali") {
              ToT[i] = "";
              ToT[i + 1] = "sanget" + ToT[i + 1].split(/[a-z]+/).join("");
            }
          if (ToT[i] == "sanget")
            if (ToT[i + 1] == null) {
              ToT[i] = wordToTranslate;
            } else if (ToT[i + 1].split(/[!-?]+/).join("") == "sanget") {
              ToT[i] = "";
              ToT[i + 1] = "sanget" + ToT[i + 1].split(/[a-z]+/).join("");
            }
          if (ToT[i] == "tidak")
            if (ToT[i + 1] == "sanget")
              if (ToT[i + 2] == null) {
                ToT[i] = "tidak";
                ToT[i + 1] = "sanget" + ToT[i + 1].split(/[a-zâ™¦]+/).join("");
              } else {
                ToT[i] = "tidak";
                ToT[i + 1] = ToT[i + 2].split(/[!-?]+/).join("");
                ToT[i + 2] = "sanget" + ToT[i + 2].split(/[a-zâ™¦]+/).join("");
              }
          var wordToTranslate = ToT[i];
          var wordToTranslateAsKey = wordToTranslate
            .toLowerCase()
            .split(/[â€â€,â€¦,â€™â€™,â€œâ€œ!-?`â™¦â€¢ )~ "â€˜â€™]+/)
            .join("");
          var charlast = wordToTranslate
            .toLowerCase()
            .split(/[-a-zâ™¦]+/)
            .join("");
          var wordtanslated = this.dictionary[wordToTranslateAsKey];
          var wordTranslated = wordtanslated + charlast;
          if (wordtanslated == null) {
            wordTranslated = wordToTranslate
              .split("amuâ™¦")
              .join("anipun sampeyan[PANJENENGAN]")
              .split("imuâ™¦")
              .join("inipun sampeyan[PANJENENGAN]")
              .split("umuâ™¦")
              .join("unipun sampeyan[PANJENENGAN]")
              .split("emuâ™¦")
              .join("enipun sampeyan[PANJENENGAN]")
              .split("omuâ™¦")
              .join("onipun sampeyan[PANJENENGAN]")
              .split("muâ™¦")
              .join("ipun sampeyan[PANJENENGAN]")
              .split("akuâ™¦")
              .join("anipun kula")
              .split("ikuâ™¦")
              .join("inipun kula")
              .split("ukuâ™¦")
              .join("unipun kula")
              .split("ekuâ™¦")
              .join("enipun kula")
              .split("okuâ™¦")
              .join("onipun kula")
              .split("kuâ™¦")
              .join("ipun kula")
              .split("anyeâ™¦")
              .join("anipun")
              .split("inyeâ™¦")
              .join("inipun")
              .split("unyeâ™¦")
              .join("unipun")
              .split("enyeâ™¦")
              .join("enipun")
              .split("onyeâ™¦")
              .join("onipun")
              .split("nyeâ™¦")
              .join("ipun");
          }
          var wordToTranslateLength = wordToTranslate.length;
          var wordTranslatedLength = wordTranslated.length;
          {
            String.prototype.padRight = function (
              charToPadWith,
              lengthToPadTo
            ) {
              var returnValue = this;
              while (returnValue.length < lengthToPadTo) {
                returnValue += charToPadWith;
              }
              return returnValue;
            };
          }
          var wordLengthGreater = Math.max(
            wordToTranslateLength,
            wordTranslatedLength
          );
          var wordTranslatedPadded = wordTranslated.padRight(
            " ",
            wordLengthGreater
          );
          charsInCurrentLine += 1 + wordLengthGreater;
          if (charsInCurrentLine >= charsPerLine) {
            passageInterleaved += lineTranslatedCurrent;
            lineTranslatedCurrent = wordTranslatedPadded + " ";
            charsInCurrentLine = wordLengthGreater;
          } else {
            lineTranslatedCurrent += wordTranslatedPadded + " ";
          }
        }
        passageInterleaved += lineTranslatedCurrent;
        return passageInterleaved;
      };
    }
    var dictionaryAsLookup = Tlanslator.dictionaryParse(dictionaryAsText);
    var teranslator = new Tlanslator(dictionaryAsLookup);
    var textTranslatedAndInterleaved1 = teranslator.translateAndInterleave(
      passageToTranslate,
      charsPerLine
    );
    var textTranslatedAndInterleaved = textTranslatedAndInterleaved1
      .split("a ipun ")
      .join("a nipun ")
      .split("i ipun ")
      .join("i nipun ")
      .split("u ipun ")
      .join("u nipun ")
      .split("e ipun ")
      .join("e nipun ")
      .split("o ipun ")
      .join("o nipun ")
      .split("ipun  . ")
      .join("ipun . ");
    if (krama == 2) {
      var translateJawakompiwin_translate_bahasa_jawa =
        textTranslatedAndInterleaved
          .split(" kalix kee")
          .join(" dhateng kaping")
          .split(" kalix ")
          .join(" ping ")
          .split("lanipun sampeyan[PANJENENGAN]")
          .join("lamu")
          .split(" ngrikus")
          .join(" situs")
          .split(" lepat sa ")
          .join(" salah satunggaling ")
          .split(" wonten wonten mawon")
          .join(" wonten-wonten mawon")
          .split(" wonten wonten ")
          .join(" wonten ing ")
          .split(" ngangge[NGAGEM] angge-angge ")
          .join(" angge-angge ")
          .split(" diipundhut")
          .join(" dipundhut")
          .split(" wonten nten ")
          .join(" wonten ing ")
          .split(" nten ")
          .join(" wonten ")
          .split("pripunn")
          .join("pripun");
    }
    if (krama == 1) {
      var translateJawakompiwin_translate_bahasa_jawa =
        textTranslatedAndInterleaved
          .split("kala punapa[KALA MENAPA]")
          .join("kala napa")
          .split(" bibar saking ")
          .join(" bar saking ")
          .split(" tegal ")
          .join(" tegil ")
          .split(" tangga ")
          .join(" tanggi ")
          .split(" riyadi ")
          .join(" riyadin ")
          .split(" cina ")
          .join(" cinten ")
          .split("piyambak")
          .join("kiyambak")
          .split(" ajrih")
          .join(" wedos")
          .split("ngajrih")
          .join("medos")
          .split("sampun")
          .join(" empun")
          .split(" amargin")
          .join(" keranten")
          .split(" amargi")
          .join(" keranten")
          .split("PRIKSA")
          .join("PIRSA")
          .split("MRIKSA")
          .join("MIRSA")
          .split(" punapa-nipun[MENAPA-NIPUN]")
          .join(" napa ne")
          .split("sapunika[SAMENIKA]")
          .join("saniki[SAMENIKA]")
          .split("sanadyan")
          .join("senajan")
          .split(" kalix kee")
          .join(" dhateng kaping")
          .split(" kalix ")
          .join(" ping ")
          .split("lanipun sampeyan[PANJENENGAN]")
          .join("lamu")
          .split(" ngrikus")
          .join(" situs")
          .split(" lepat sa ")
          .join(" salah satunggaling ")
          .split(" wonten wonten mawon")
          .join(" wonten-wonten mawon")
          .split(" wonten wonten ")
          .join(" wonten ing ")
          .split(" wonten ing ")
          .join(" wonten teng ")
          .split(" ngangge[NGAGEM] angge-angge ")
          .join(" angge-angge ")
          .split("[DIPUN")
          .join("[DI")
          .split(" dipun")
          .join(" di")
          .split("nipun[")
          .join("ne[")
          .split("nipun ")
          .join("ne ")
          .split("ipun[")
          .join("e[")
          .split("ipun ")
          .join("e ")
          .split("NIPUN]")
          .join("NE]")
          .split("IPUN]")
          .join("E]")
          .split(" puniki[MENIKA]")
          .join(" niki")
          .split(" puniku[MENIKA]")
          .join(" niku")
          .split(" pangapunten")
          .join(" ngapunten")
          .split(" inggih punika[MENIKA]")
          .join(" inggih menika")
          .split(" punika[MENIKA]")
          .join(" nika")
          .split(" dhateng ")
          .join(" teng ")
          .split(" punapa[MENAPA]")
          .join(" napa")
          .split(" napa[MENAPA]")
          .join(" napa")
          .split(" punapa-punapa[MENAPA-MENAPA]")
          .join(" napa-napa")
          .split("PANJENENGAN")
          .join("NJENENGAN")
          .split(" diipundhut")
          .join(" dipundhut")
          .split(" nten ")
          .join(" teng ")
          .split("pripunn")
          .join("pripun")
          .split("kancanipun")
          .join("rencangipun")
          .split(" kanca-")
          .join(" rencang-")
          .split(" kanca-kanca ")
          .join(" rencang-rencang ")
          .split("kancani ")
          .join("rencangi ")
          .split(" kancan ")
          .join(" rencangan ")
          .split("kancane ")
          .join("rencange ")
          .split("kanca ")
          .join("rencang ")
          .split("en wonten ")
          .join("en enten ");
    }
    if (krama == 0) {
      var translateJawakompiwin_translate_bahasa_jawa =
        textTranslatedAndInterleaved
          .split(" kalix kee")
          .join(" dhateng kaping")
          .split(" kalix ")
          .join(" ping ")
          .split("lanipun sampeyan[PANJENENGAN]")
          .join("lamu")
          .split(" ngrikus")
          .join(" situs")
          .split(" lepat sa ")
          .join(" salah satunggaling ")
          .split(" wonten wonten mawon")
          .join(" wonten-wonten mawon")
          .split(" wonten wonten ")
          .join(" wonten ing ")
          .split(" ngangge[NGAGEM] angge-angge ")
          .join(" angge-angge ")
          .split("[DIPUN")
          .join("[DI")
          .split(" dipun")
          .join(" di")
          .split("nipun[")
          .join("ne[")
          .split("nipun ")
          .join("ne ")
          .split("ipun[")
          .join("e[")
          .split("ipun ")
          .join("e ")
          .split("NIPUN]")
          .join("NE]")
          .split("IPUN]")
          .join("E]")
          .split(" puniki[MENIKA]")
          .join(" puniki")
          .split(" puniku[MENIKA]")
          .join(" puniku")
          .split(" xxx")
          .join(" xxx")
          .split(" inggih punika[MENIKA]")
          .join(" inggih menika")
          .split(" punika[MENIKA]")
          .join(" punika")
          .split(" xxx ")
          .join(" xxx ")
          .split(" punapa[MENAPA]")
          .join(" punapa")
          .split(" napa[MENAPA]")
          .join(" punapa")
          .split(" punapa-punapa[MENAPA-MENAPA]")
          .join(" punapa-punapa")
          .split(" diipundhut")
          .join(" dipundhut")
          .split(" nten ")
          .join(" ing ")
          .split("pripunn")
          .join("pripun")
          .split(" diaken")
          .join(" diakeN")
          .split(" ngaken")
          .join(" ngakeN")
          .split(" kaken")
          .join(" kakeN")
          .split(" baken")
          .join(" bakeN")
          .split(" taken")
          .join(" takeN")
          .split("aken ")
          .join("ake ")
          .split("aken[")
          .join("ake[")
          .split("AKEN]")
          .join("AKE]")
          .split("diakeN")
          .join("diaken")
          .split("ngakeN")
          .join("ngaken")
          .split("kakeN")
          .join("kaken")
          .split("takeN")
          .join("taken")
          .split("bakeN")
          .join("baken");
    }
    if (krama == 4) {
      var translateJawakompiwin_translate_bahasa_jawa =
        textTranslatedAndInterleaved
          .split(" kalix kee")
          .join(" dhateng kaping")
          .split(" kalix ")
          .join(" ping ")
          .split("lanipun sampeyan[PANJENENGAN]")
          .join("lamu")
          .split(" ngrikus")
          .join(" situs")
          .split(" lepat sa ")
          .join(" salah satunggaling ")
          .split(" wonten wonten mawon")
          .join(" wonten-wonten mawon")
          .split(" wonten nten ")
          .join(" wonten ing ")
          .split(" ngangge[NGAGEM] angge-angge ")
          .join(" angge-angge ")
          .split(" diipundhut")
          .join(" dipundhut")
          .split(" nten ")
          .join(" ing ")
          .split("pripunn")
          .join("pripun")
          .split(/[A-Z]+/)
          .join("")
          .split("[   ]")
          .join("")
          .split("[  ]")
          .join("")
          .split("[ ]")
          .join("")
          .split("[]")
          .join("")
          .split("[ - ]")
          .join("")
          .split("[-]")
          .join("");
    }

    hasilFungsiGan = translateJawakompiwin_translate_bahasa_jawa
      .split(" sa per setunggal ")
      .join(" setunggal per setunggal ")
      .split(' " ')
      .join('"')
      .split(" ( ")
      .join("(")
      .split(" ) ")
      .join(")")
      .split(" / ")
      .join("/")
      .split(" ! ")
      .join("!")
      .split(" ? ")
      .join("?")
      .split(" : ")
      .join(":")
      .split(" ; ")
      .join(";")
      .split(" ' ")
      .join("'")
      .split(" . ")
      .join(".")
      .split(" , ")
      .join(",")
      .split(". .")
      .join("..")
      .split(", ,")
      .join(",,");
  }
  return hasilFungsiGan.trim();
};

module.exports = terjemahan;
